"use strict";
(self["webpackChunk_N_E"] = self["webpackChunk_N_E"] || []).push([[410],{

/***/ 6573:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "h": function() { return /* binding */ Header; }
/* harmony export */ });
/* harmony import */ var react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(5893);
/* harmony import */ var next_link__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(1664);
/* harmony import */ var next_router__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(1163);
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(7294);
/* harmony import */ var _headlessui_react__WEBPACK_IMPORTED_MODULE_8__ = __webpack_require__(9196);
/* harmony import */ var _headlessui_react__WEBPACK_IMPORTED_MODULE_9__ = __webpack_require__(5220);
/* harmony import */ var _headlessui_react__WEBPACK_IMPORTED_MODULE_11__ = __webpack_require__(9706);
/* harmony import */ var _heroicons_react_outline__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(3801);
/* harmony import */ var _heroicons_react_solid__WEBPACK_IMPORTED_MODULE_5__ = __webpack_require__(3153);
/* harmony import */ var _auth0_nextjs_auth0__WEBPACK_IMPORTED_MODULE_6__ = __webpack_require__(4713);
/* harmony import */ var lodash__WEBPACK_IMPORTED_MODULE_7__ = __webpack_require__(6486);
/* harmony import */ var lodash__WEBPACK_IMPORTED_MODULE_7___default = /*#__PURE__*/__webpack_require__.n(lodash__WEBPACK_IMPORTED_MODULE_7__);
/* harmony import */ var _utils_classnames__WEBPACK_IMPORTED_MODULE_10__ = __webpack_require__(1864);

/* eslint-disable @next/next/no-img-element */ 








var adminNavigation = [
    {
        name: 'Serie',
        href: function(seriesId) {
            return "/admin/series/".concat(seriesId, "/");
        },
        icon: _heroicons_react_outline__WEBPACK_IMPORTED_MODULE_4__/* .ViewListIcon */ ._Dm,
        current: function(pathname) {
            return pathname === "/admin/series/[series_id]";
        }
    },
    {
        name: 'Hantera',
        href: function(seriesId) {
            return "/admin/series/".concat(seriesId, "/manage");
        },
        icon: _heroicons_react_outline__WEBPACK_IMPORTED_MODULE_4__/* .CogIcon */ .IEm,
        current: function(pathname) {
            return (0,lodash__WEBPACK_IMPORTED_MODULE_7__.includes)(pathname, '/manage');
        }
    },
    {
        name: 'Match-verktyg',
        href: function(seriesId) {
            return "/admin/series/".concat(seriesId, "/match-breakdown");
        },
        icon: _heroicons_react_outline__WEBPACK_IMPORTED_MODULE_4__/* .BeakerIcon */ .uOV,
        current: function(pathname) {
            return (0,lodash__WEBPACK_IMPORTED_MODULE_7__.includes)(pathname, '/match-breakdown');
        }
    }, 
];
var Header = function(param1) {
    var sidebarOpen = param1.sidebarOpen, setSidebarOpen = param1.setSidebarOpen, incomingSeriesId = param1.incomingSeriesId, seriesContext = param1.seriesContext;
    var navigation = [
        {
            name: 'Tabell',
            href: function(seriesId) {
                return "https://app.natverkspadel.se/series/gCBrLGHmUulvQgEUbY6P";
            },
            type: 'external',
            icon: _heroicons_react_outline__WEBPACK_IMPORTED_MODULE_4__/* .TableIcon */ .$eq,
            current: function(pathname) {
                return (0,lodash__WEBPACK_IMPORTED_MODULE_7__.includes)(pathname, '/team/standings');
            },
            validTypes: [
                'team'
            ]
        },
        {
            name: 'Spelare',
            href: function(seriesId) {
                return "https://app.natverkspadel.se/series/gCBrLGHmUulvQgEUbY6P";
            },
            icon: _heroicons_react_outline__WEBPACK_IMPORTED_MODULE_4__/* .UserIcon */ .tBG,
            type: 'external',
            current: function(pathname) {
                return (0,lodash__WEBPACK_IMPORTED_MODULE_7__.includes)(pathname, '/player/standings');
            },
            validTypes: [
                'team',
                'single_player'
            ]
        },
        {
            name: 'Turnering',
            href: function(seriesId) {
                return "/series/".concat(seriesId, "/tournament/standings");
            },
            icon: _heroicons_react_outline__WEBPACK_IMPORTED_MODULE_4__/* .CubeTransparentIcon */ .auR,
            type: 'internal',
            current: function(pathname) {
                return (0,lodash__WEBPACK_IMPORTED_MODULE_7__.includes)(pathname, '/tournament/standings');
            },
            validTypes: [
                'tournament'
            ]
        },
        {
            name: 'Omg\xe5ngar',
            href: function(seriesId) {
                return "/series/".concat(seriesId, "/rounds");
            },
            icon: _heroicons_react_outline__WEBPACK_IMPORTED_MODULE_4__/* .CalendarIcon */ .Que,
            type: 'internal',
            current: function(pathname) {
                return (0,lodash__WEBPACK_IMPORTED_MODULE_7__.includes)(pathname, '/rounds');
            },
            validTypes: [
                'team',
                'single_player',
                'tournament'
            ]
        },
        {
            name: 'Matcher',
            href: function(seriesId) {
                return "/series/".concat(seriesId, "/matches");
            },
            icon: _heroicons_react_outline__WEBPACK_IMPORTED_MODULE_4__/* .CheckCircleIcon */ .rE2,
            type: 'internal',
            current: function(pathname) {
                return (0,lodash__WEBPACK_IMPORTED_MODULE_7__.includes)(pathname, '/matches');
            },
            validTypes: [
                'team',
                'single_player',
                'tournament'
            ]
        }, 
    ];
    var ref = (0,react__WEBPACK_IMPORTED_MODULE_3__.useState)(navigation), navItems = ref[0], setNavItems = ref[1];
    (0,react__WEBPACK_IMPORTED_MODULE_3__.useEffect)(function() {
        if (seriesContext) {
            setNavItems(navigation.filter(function(item) {
                return seriesContext ? item.validTypes.includes(seriesContext.type) : true;
            }));
        }
    }, [
        seriesContext
    ]);
    var ref1 = (0,_auth0_nextjs_auth0__WEBPACK_IMPORTED_MODULE_6__/* .useUser */ .aF)(), user = ref1.user, isLoading = ref1.isLoading, error = ref1.error;
    var ref2 = (0,next_router__WEBPACK_IMPORTED_MODULE_2__.useRouter)(), query = ref2.query, pathname1 = ref2.pathname;
    var seriesId1 = incomingSeriesId || (0,lodash__WEBPACK_IMPORTED_MODULE_7__.get)(query, 'id', null);
    if (!seriesId1) return null;
    if (typeof seriesId1 !== 'string') return null;
    var isAdmin = !isLoading && !error && user && user.email && (0,lodash__WEBPACK_IMPORTED_MODULE_7__.includes)([
        'joel@vihyr.com',
        'gabriel@vihyr.com'
    ], user.email);
    return(/*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)(react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.Fragment, {
        children: [
            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_headlessui_react__WEBPACK_IMPORTED_MODULE_8__/* .Transition.Root */ .u.Root, {
                show: sidebarOpen,
                as: react__WEBPACK_IMPORTED_MODULE_3__.Fragment,
                children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)(_headlessui_react__WEBPACK_IMPORTED_MODULE_9__/* .Dialog */ .V, {
                    as: "div",
                    className: "fixed inset-0 z-40 flex lg:hidden",
                    onClose: setSidebarOpen,
                    children: [
                        /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_headlessui_react__WEBPACK_IMPORTED_MODULE_8__/* .Transition.Child */ .u.Child, {
                            as: react__WEBPACK_IMPORTED_MODULE_3__.Fragment,
                            enter: "transition-opacity ease-linear duration-300",
                            enterFrom: "opacity-0",
                            enterTo: "opacity-100",
                            leave: "transition-opacity ease-linear duration-300",
                            leaveFrom: "opacity-100",
                            leaveTo: "opacity-0",
                            children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_headlessui_react__WEBPACK_IMPORTED_MODULE_9__/* .Dialog.Overlay */ .V.Overlay, {
                                className: "fixed inset-0 bg-gray-600 bg-opacity-75"
                            })
                        }),
                        /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_headlessui_react__WEBPACK_IMPORTED_MODULE_8__/* .Transition.Child */ .u.Child, {
                            as: react__WEBPACK_IMPORTED_MODULE_3__.Fragment,
                            enter: "transition ease-in-out duration-300 transform",
                            enterFrom: "-translate-x-full",
                            enterTo: "translate-x-0",
                            leave: "transition ease-in-out duration-300 transform",
                            leaveFrom: "translate-x-0",
                            leaveTo: "-translate-x-full",
                            children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("div", {
                                className: "relative flex w-full max-w-xs flex-1 flex-col bg-white pt-5 pb-4",
                                children: [
                                    /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_headlessui_react__WEBPACK_IMPORTED_MODULE_8__/* .Transition.Child */ .u.Child, {
                                        as: react__WEBPACK_IMPORTED_MODULE_3__.Fragment,
                                        enter: "ease-in-out duration-300",
                                        enterFrom: "opacity-0",
                                        enterTo: "opacity-100",
                                        leave: "ease-in-out duration-300",
                                        leaveFrom: "opacity-100",
                                        leaveTo: "opacity-0",
                                        children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("div", {
                                            className: "absolute top-0 right-0 -mr-12 pt-2",
                                            children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("button", {
                                                type: "button",
                                                className: "ml-1 flex h-10 w-10 items-center justify-center rounded-full focus:outline-none focus:ring-2 focus:ring-inset focus:ring-white",
                                                onClick: function() {
                                                    return setSidebarOpen(false);
                                                },
                                                children: [
                                                    /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("span", {
                                                        className: "sr-only",
                                                        children: "Close sidebar"
                                                    }),
                                                    /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_heroicons_react_outline__WEBPACK_IMPORTED_MODULE_4__/* .XIcon */ .b0D, {
                                                        className: "h-6 w-6 text-white",
                                                        "aria-hidden": "true"
                                                    })
                                                ]
                                            })
                                        })
                                    }),
                                    /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("div", {
                                        className: "flex flex-shrink-0 items-center px-4",
                                        children: [
                                            seriesContext ? /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("p", {
                                                className: "text-md font-medium leading-6 text-gray-900",
                                                children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(next_link__WEBPACK_IMPORTED_MODULE_1__["default"], {
                                                    href: "/",
                                                    passHref: true,
                                                    children: seriesContext.name
                                                })
                                            }) : null,
                                            !seriesContext ? /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(next_link__WEBPACK_IMPORTED_MODULE_1__["default"], {
                                                href: "/",
                                                passHref: true,
                                                children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("img", {
                                                    className: "h-8 w-auto",
                                                    src: "/logo/onp-text-logo-800x500.svg",
                                                    alt: "ONP logo"
                                                })
                                            }) : null
                                        ]
                                    }),
                                    /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("div", {
                                        className: "mt-5 h-0 flex-1 overflow-y-auto",
                                        children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("nav", {
                                            className: "px-2",
                                            children: [
                                                /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("div", {
                                                    className: "space-y-1",
                                                    children: navItems.map(function(item) {
                                                        var seriesUrl = "".concat(item.href(seriesId1));
                                                        if (item.type === 'external') {
                                                            return(/*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("a", {
                                                                href: item.href(''),
                                                                target: "_blank",
                                                                rel: "noreferrer noopener",
                                                                className: (0,_utils_classnames__WEBPACK_IMPORTED_MODULE_10__/* .classNames */ .A)(item.current(pathname1) ? 'bg-gray-100 text-gray-900' : 'text-gray-600 hover:bg-gray-50 hover:text-gray-900', 'group flex items-center rounded-md px-2 py-2 text-base font-medium leading-5'),
                                                                "aria-current": item.current(pathname1) ? 'page' : undefined,
                                                                children: [
                                                                    /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(item.icon, {
                                                                        className: (0,_utils_classnames__WEBPACK_IMPORTED_MODULE_10__/* .classNames */ .A)(item.current(pathname1) ? 'text-gray-500' : 'text-gray-400 group-hover:text-gray-500', 'mr-3 h-6 w-6 flex-shrink-0'),
                                                                        "aria-hidden": "true"
                                                                    }),
                                                                    item.name
                                                                ]
                                                            }, item.name));
                                                        } else {
                                                            return(/*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(next_link__WEBPACK_IMPORTED_MODULE_1__["default"], {
                                                                href: seriesUrl,
                                                                children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("a", {
                                                                    className: (0,_utils_classnames__WEBPACK_IMPORTED_MODULE_10__/* .classNames */ .A)(item.current(pathname1) ? 'bg-gray-100 text-gray-900' : 'text-gray-600 hover:bg-gray-50 hover:text-gray-900', 'group flex items-center rounded-md px-2 py-2 text-base font-medium leading-5'),
                                                                    "aria-current": item.current(pathname1) ? 'page' : undefined,
                                                                    children: [
                                                                        /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(item.icon, {
                                                                            className: (0,_utils_classnames__WEBPACK_IMPORTED_MODULE_10__/* .classNames */ .A)(item.current(pathname1) ? 'text-gray-500' : 'text-gray-400 group-hover:text-gray-500', 'mr-3 h-6 w-6 flex-shrink-0'),
                                                                            "aria-hidden": "true"
                                                                        }),
                                                                        item.name
                                                                    ]
                                                                })
                                                            }, item.name));
                                                        }
                                                    })
                                                }),
                                                isAdmin ? /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("div", {
                                                    className: "mt-8",
                                                    children: [
                                                        /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("h3", {
                                                            className: "px-3 text-xs font-semibold uppercase tracking-wider text-gray-500",
                                                            id: "desktop-admin-links-headline",
                                                            children: "Administrat\xf6r"
                                                        }),
                                                        /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("div", {
                                                            className: "space-y-1",
                                                            children: adminNavigation.map(function(item) {
                                                                var seriesUrl = "".concat(item.href(seriesId1));
                                                                return(/*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(next_link__WEBPACK_IMPORTED_MODULE_1__["default"], {
                                                                    href: seriesUrl,
                                                                    children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("a", {
                                                                        className: (0,_utils_classnames__WEBPACK_IMPORTED_MODULE_10__/* .classNames */ .A)(item.current(pathname1) ? 'bg-gray-100 text-gray-900' : 'text-gray-600 hover:bg-gray-50 hover:text-gray-900', 'group flex items-center rounded-md px-2 py-2 text-base font-medium leading-5'),
                                                                        "aria-current": item.current(pathname1) ? 'page' : undefined,
                                                                        children: [
                                                                            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(item.icon, {
                                                                                className: (0,_utils_classnames__WEBPACK_IMPORTED_MODULE_10__/* .classNames */ .A)(item.current(pathname1) ? 'text-gray-500' : 'text-gray-400 group-hover:text-gray-500', 'mr-3 h-6 w-6 flex-shrink-0'),
                                                                                "aria-hidden": "true"
                                                                            }),
                                                                            item.name
                                                                        ]
                                                                    })
                                                                }, item.name));
                                                            })
                                                        })
                                                    ]
                                                }) : null
                                            ]
                                        })
                                    })
                                ]
                            })
                        }),
                        /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("div", {
                            className: "w-14 flex-shrink-0",
                            "aria-hidden": "true"
                        })
                    ]
                })
            }),
            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("div", {
                className: "hidden lg:flex lg:flex-shrink-0",
                children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("div", {
                    className: "flex w-64 flex-col border-r border-gray-200 bg-gray-100 pt-5 pb-4",
                    children: [
                        /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("div", {
                            className: "flex flex-shrink-0 items-center px-6",
                            children: [
                                seriesContext ? /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("p", {
                                    className: "text-lg font-medium leading-6 text-gray-900",
                                    children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(next_link__WEBPACK_IMPORTED_MODULE_1__["default"], {
                                        href: "/",
                                        passHref: true,
                                        children: seriesContext.name
                                    })
                                }) : null,
                                !seriesContext ? /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(next_link__WEBPACK_IMPORTED_MODULE_1__["default"], {
                                    href: "/",
                                    passHref: true,
                                    children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("img", {
                                        className: "h-8 w-auto",
                                        src: "/logo/onp-text-logo-800x500.svg",
                                        alt: "ONP logo"
                                    })
                                }) : null
                            ]
                        }),
                        /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("div", {
                            className: "mt-6 flex h-0 flex-1 flex-col overflow-y-auto",
                            children: [
                                /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)(_headlessui_react__WEBPACK_IMPORTED_MODULE_11__/* .Menu */ .v, {
                                    as: "div",
                                    className: "relative inline-block px-3 text-left",
                                    children: [
                                        !isLoading && !error && user ? /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("div", {
                                            children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_headlessui_react__WEBPACK_IMPORTED_MODULE_11__/* .Menu.Button */ .v.Button, {
                                                className: "group w-full rounded-md bg-gray-100 px-3.5 py-2 text-left text-sm font-medium text-gray-700 hover:bg-gray-200 focus:outline-none focus:ring-2 focus:ring-purple-500 focus:ring-offset-2 focus:ring-offset-gray-100",
                                                children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("span", {
                                                    className: "flex w-full items-center justify-between",
                                                    children: [
                                                        /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("span", {
                                                            className: "flex min-w-0 items-center justify-between space-x-3",
                                                            children: [
                                                                user.picture ? // eslint-disable-next-line @next/next/no-img-element
                                                                /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("img", {
                                                                    className: "h-10 w-10 flex-shrink-0 rounded-full bg-gray-300",
                                                                    src: user.picture,
                                                                    alt: user.name || 'User profile avatar'
                                                                }) : null,
                                                                /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("span", {
                                                                    className: "flex min-w-0 flex-1 flex-col",
                                                                    children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("span", {
                                                                        className: "truncate text-sm font-medium text-gray-900",
                                                                        children: user.name || user.email
                                                                    })
                                                                })
                                                            ]
                                                        }),
                                                        /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_heroicons_react_solid__WEBPACK_IMPORTED_MODULE_5__/* .SelectorIcon */ .Ta4, {
                                                            className: "h-5 w-5 flex-shrink-0 text-gray-400 group-hover:text-gray-500",
                                                            "aria-hidden": "true"
                                                        })
                                                    ]
                                                })
                                            })
                                        }) : null,
                                        /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_headlessui_react__WEBPACK_IMPORTED_MODULE_8__/* .Transition */ .u, {
                                            as: react__WEBPACK_IMPORTED_MODULE_3__.Fragment,
                                            enter: "transition ease-out duration-100",
                                            enterFrom: "transform opacity-0 scale-95",
                                            enterTo: "transform opacity-100 scale-100",
                                            leave: "transition ease-in duration-75",
                                            leaveFrom: "transform opacity-100 scale-100",
                                            leaveTo: "transform opacity-0 scale-95",
                                            children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_headlessui_react__WEBPACK_IMPORTED_MODULE_11__/* .Menu.Items */ .v.Items, {
                                                className: "absolute right-0 left-0 z-10 mx-3 mt-1 origin-top divide-y divide-gray-200 rounded-md bg-white shadow-lg ring-1 ring-black ring-opacity-5 focus:outline-none",
                                                children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("div", {
                                                    className: "py-1",
                                                    children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_headlessui_react__WEBPACK_IMPORTED_MODULE_11__/* .Menu.Item */ .v.Item, {
                                                        children: function(param) {
                                                            var active = param.active;
                                                            /*#__PURE__*/ return (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(next_link__WEBPACK_IMPORTED_MODULE_1__["default"], {
                                                                href: "/api/auth/logout",
                                                                children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("a", {
                                                                    className: (0,_utils_classnames__WEBPACK_IMPORTED_MODULE_10__/* .classNames */ .A)(active ? 'bg-gray-100 text-gray-900' : 'text-gray-700', 'block px-4 py-2 text-sm'),
                                                                    children: "Logga ut"
                                                                })
                                                            });
                                                        }
                                                    })
                                                })
                                            })
                                        })
                                    ]
                                }),
                                /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("nav", {
                                    className: "mt-6 px-3",
                                    children: [
                                        /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("div", {
                                            className: "space-y-1",
                                            children: navItems.map(function(item) {
                                                if (item.type === 'external') {
                                                    return(/*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("a", {
                                                        href: item.href(''),
                                                        target: "_blank",
                                                        rel: "noreferrer noopener",
                                                        className: (0,_utils_classnames__WEBPACK_IMPORTED_MODULE_10__/* .classNames */ .A)(item.current(pathname1) ? 'bg-gray-100 text-gray-900' : 'text-gray-600 hover:bg-gray-50 hover:text-gray-900', 'group flex items-center rounded-md px-2 py-2 text-base font-medium leading-5'),
                                                        "aria-current": item.current(pathname1) ? 'page' : undefined,
                                                        children: [
                                                            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(item.icon, {
                                                                className: (0,_utils_classnames__WEBPACK_IMPORTED_MODULE_10__/* .classNames */ .A)(item.current(pathname1) ? 'text-gray-500' : 'text-gray-400 group-hover:text-gray-500', 'mr-3 h-6 w-6 flex-shrink-0'),
                                                                "aria-hidden": "true"
                                                            }),
                                                            item.name
                                                        ]
                                                    }, item.name));
                                                } else {
                                                    return(/*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(next_link__WEBPACK_IMPORTED_MODULE_1__["default"], {
                                                        href: "".concat(item.href(seriesId1)),
                                                        children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("a", {
                                                            className: (0,_utils_classnames__WEBPACK_IMPORTED_MODULE_10__/* .classNames */ .A)(item.current(pathname1) ? 'bg-gray-200 text-gray-900' : 'text-gray-700 hover:bg-gray-50 hover:text-gray-900', 'group flex items-center rounded-md px-2 py-2 text-sm font-medium'),
                                                            "aria-current": item.current(pathname1) ? 'page' : undefined,
                                                            children: [
                                                                /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(item.icon, {
                                                                    className: (0,_utils_classnames__WEBPACK_IMPORTED_MODULE_10__/* .classNames */ .A)(item.current(pathname1) ? 'text-gray-500' : 'text-gray-400 group-hover:text-gray-500', 'mr-3 h-6 w-6 flex-shrink-0'),
                                                                    "aria-hidden": "true"
                                                                }),
                                                                item.name
                                                            ]
                                                        })
                                                    }, item.name));
                                                }
                                            })
                                        }),
                                        isAdmin ? /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("div", {
                                            className: "mt-8",
                                            children: [
                                                /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("h3", {
                                                    className: "px-3 text-xs font-semibold uppercase tracking-wider text-gray-500",
                                                    id: "desktop-admin-links-headline",
                                                    children: "Administrat\xf6r"
                                                }),
                                                /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("div", {
                                                    className: "mt-1 space-y-1",
                                                    "aria-labelledby": "desktop-admin-links-headline",
                                                    children: adminNavigation.map(function(item) {
                                                        /*#__PURE__*/ return (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(next_link__WEBPACK_IMPORTED_MODULE_1__["default"], {
                                                            href: "".concat(item.href(seriesId1)),
                                                            children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("a", {
                                                                className: (0,_utils_classnames__WEBPACK_IMPORTED_MODULE_10__/* .classNames */ .A)(item.current(pathname1) ? 'bg-gray-200 text-gray-900' : 'text-gray-700 hover:bg-gray-50 hover:text-gray-900', 'group flex items-center rounded-md px-2 py-2 text-sm font-medium'),
                                                                "aria-current": item.current(pathname1) ? 'page' : undefined,
                                                                children: [
                                                                    /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(item.icon, {
                                                                        className: (0,_utils_classnames__WEBPACK_IMPORTED_MODULE_10__/* .classNames */ .A)(item.current(pathname1) ? 'text-gray-500' : 'text-gray-400 group-hover:text-gray-500', 'mr-3 h-6 w-6 flex-shrink-0'),
                                                                        "aria-hidden": "true"
                                                                    }),
                                                                    item.name
                                                                ]
                                                            })
                                                        }, item.name);
                                                    })
                                                })
                                            ]
                                        }) : null
                                    ]
                                })
                            ]
                        })
                    ]
                })
            })
        ]
    }));
};


/***/ }),

/***/ 6235:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {


// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  "s": function() { return /* binding */ SearchHeader; }
});

// EXTERNAL MODULE: ./node_modules/react/jsx-runtime.js
var jsx_runtime = __webpack_require__(5893);
// EXTERNAL MODULE: ./node_modules/@heroicons/react/outline/esm/index.js + 230 modules
var esm = __webpack_require__(3801);
// EXTERNAL MODULE: ./node_modules/next/link.js
var next_link = __webpack_require__(1664);
// EXTERNAL MODULE: ./node_modules/react/index.js
var react = __webpack_require__(7294);
// EXTERNAL MODULE: ./node_modules/@headlessui/react/dist/components/menu/menu.esm.js + 1 modules
var menu_esm = __webpack_require__(9706);
// EXTERNAL MODULE: ./node_modules/@headlessui/react/dist/components/transitions/transition.esm.js + 3 modules
var transition_esm = __webpack_require__(9196);
// EXTERNAL MODULE: ./node_modules/@auth0/nextjs-auth0/dist/index.browser.js
var index_browser = __webpack_require__(4713);
// EXTERNAL MODULE: ./utils/classnames.ts
var classnames = __webpack_require__(1864);
;// CONCATENATED MODULE: ./components/ds/03-organisms/app-layout/profile-dropdown.tsx

/* eslint-disable @next/next/no-img-element */ 




var ProfileDropdown = function() {
    var ref = (0,index_browser/* useUser */.aF)(), user = ref.user, isLoading = ref.isLoading, error = ref.error;
    return(/*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
        className: "flex items-center",
        children: !isLoading && !error && user ? /*#__PURE__*/ (0,jsx_runtime.jsxs)(menu_esm/* Menu */.v, {
            as: "div",
            className: "ml-3 relative",
            children: [
                /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                    children: /*#__PURE__*/ (0,jsx_runtime.jsxs)(menu_esm/* Menu.Button */.v.Button, {
                        className: "max-w-xs bg-white flex items-center text-sm rounded-full focus:outline-none focus:ring-2 focus:ring-offset-2 focus:ring-purple-500",
                        children: [
                            /*#__PURE__*/ (0,jsx_runtime.jsx)("span", {
                                className: "sr-only",
                                children: "Open user menu"
                            }),
                            user.picture ? /*#__PURE__*/ (0,jsx_runtime.jsx)("img", {
                                className: "h-8 w-8 rounded-full",
                                src: user.picture,
                                alt: user.name ? user.name : 'user avatar'
                            }) : null
                        ]
                    })
                }),
                /*#__PURE__*/ (0,jsx_runtime.jsx)(transition_esm/* Transition */.u, {
                    as: react.Fragment,
                    enter: "transition ease-out duration-100",
                    enterFrom: "transform opacity-0 scale-95",
                    enterTo: "transform opacity-100 scale-100",
                    leave: "transition ease-in duration-75",
                    leaveFrom: "transform opacity-100 scale-100",
                    leaveTo: "transform opacity-0 scale-95",
                    children: /*#__PURE__*/ (0,jsx_runtime.jsx)(menu_esm/* Menu.Items */.v.Items, {
                        className: "origin-top-right absolute right-0 mt-2 w-48 rounded-md shadow-lg bg-white ring-1 ring-black ring-opacity-5 divide-y divide-gray-200 focus:outline-none",
                        children: /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                            className: "py-1",
                            children: /*#__PURE__*/ (0,jsx_runtime.jsx)(menu_esm/* Menu.Item */.v.Item, {
                                children: function(param) {
                                    var active = param.active;
                                    /*#__PURE__*/ return (0,jsx_runtime.jsx)(next_link["default"], {
                                        href: "/api/auth/logout",
                                        children: /*#__PURE__*/ (0,jsx_runtime.jsx)("a", {
                                            className: (0,classnames/* classNames */.A)(active ? 'bg-gray-100 text-gray-900' : 'text-gray-700', 'block px-4 py-2 text-sm'),
                                            children: "Logga ut"
                                        })
                                    });
                                }
                            })
                        })
                    })
                })
            ]
        }) : null
    }));
};

;// CONCATENATED MODULE: ./components/ds/03-organisms/app-layout/search-header.tsx



var SearchHeader = function(param) {
    var setSidebarOpen = param.setSidebarOpen;
    return(/*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
        className: "relative z-10 flex-shrink-0 flex h-16 bg-white border-b border-gray-200 lg:hidden",
        children: [
            /*#__PURE__*/ (0,jsx_runtime.jsxs)("button", {
                type: "button",
                className: "px-4 border-r border-gray-200 text-gray-500 focus:outline-none focus:ring-2 focus:ring-inset focus:ring-purple-500 lg:hidden",
                onClick: function() {
                    return setSidebarOpen(true);
                },
                children: [
                    /*#__PURE__*/ (0,jsx_runtime.jsx)("span", {
                        className: "sr-only",
                        children: "Open sidebar"
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)(esm/* MenuAlt1Icon */.crV, {
                        className: "h-6 w-6",
                        "aria-hidden": "true"
                    })
                ]
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                className: "flex-1 flex justify-between px-4 sm:px-6 lg:px-8",
                children: /*#__PURE__*/ (0,jsx_runtime.jsx)(ProfileDropdown, {})
            })
        ]
    }));
};


/***/ }),

/***/ 7524:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {


// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  "PR": function() { return /* reexport */ AdminCreateRoundTemplate; },
  "ac": function() { return /* reexport */ AdminCreateTeamTemplate; },
  "tJ": function() { return /* reexport */ AdminInviteTeamToRoundTemplate; },
  "AB": function() { return /* reexport */ AdminManageSeriesTemplate; },
  "R6": function() { return /* reexport */ AdminMatchResultList; },
  "gM": function() { return /* reexport */ AdminPlayerMatcherTable; },
  "cR": function() { return /* reexport */ AdminRoundSignupDetailsTemplate; },
  "z0": function() { return /* reexport */ AdminRoundsList; },
  "ph": function() { return /* reexport */ AdminSeriesRoundDetailsTemplate; },
  "LO": function() { return /* reexport */ AdminSeriesRoundTemplate; },
  "rv": function() { return /* reexport */ CreateMatchModal; },
  "b4": function() { return /* reexport */ CreateTeamMemberModal; },
  "hW": function() { return /* reexport */ ErrorAlert; },
  "$_": function() { return /* reexport */ Footer; },
  "Fb": function() { return /* reexport */ Head; },
  "h4": function() { return /* reexport */ Header; },
  "Uv": function() { return /* reexport */ HomePage; },
  "Lc": function() { return /* reexport */ ManageMatchModal; },
  "Yb": function() { return /* reexport */ MatchEditResultForm; },
  "IR": function() { return /* reexport */ MatchPage; },
  "Qr": function() { return /* reexport */ MatchResultFormPage; },
  "rb": function() { return /* reexport */ MatchResultList; },
  "lB": function() { return /* reexport */ MatchResultReportPage; },
  "al": function() { return /* reexport */ MatchResultSummary; },
  "$t": function() { return /* reexport */ MatchResultsPage; },
  "M6": function() { return /* reexport */ PlayerStandingsPage; },
  "_Y": function() { return /* reexport */ RankedPlayer; },
  "S3": function() { return /* reexport */ RankingList; },
  "xN": function() { return /* reexport */ RankingRowItem; },
  "AH": function() { return /* reexport */ ResultH21Page; },
  "wx": function() { return /* reexport */ ResultV22Page; },
  "B0": function() { return /* reexport */ RoundBreadcrumbs; },
  "id": function() { return /* reexport */ RoundDetailsPanel; },
  "at": function() { return /* reexport */ RoundPage; },
  "Kc": function() { return /* reexport */ RoundsList; },
  "vz": function() { return /* reexport */ RoundsPage; },
  "EU": function() { return /* reexport */ SignupBreadcrumbs; },
  "Gk": function() { return /* reexport */ SignupDetails; },
  "VH": function() { return /* reexport */ SignupPage; },
  "Ck": function() { return /* reexport */ SignupsList; },
  "Ik": function() { return /* reexport */ SuccessAlert; },
  "Xy": function() { return /* reexport */ TeamDetailsPage; },
  "eQ": function() { return /* reexport */ TeamStandingsPage; },
  "q": function() { return /* reexport */ UserDetailsPage; }
});

// UNUSED EXPORTS: AdminMatchResult, AdminMatchResultRowItem, AdminMatchResultRows, AdminPlayerBreakdownRows, AdminPlayerMatcherTableRowItem, AdminRound, AdminRoundRowItem, AdminRoundRows, Breakdown, MatchResult, MatchResultRowItem, MatchResultRows, PlayerStandingRow, PlayerStandingRows, RankedPlayers, Round, RoundDetails, RoundDetailsCard, RoundRowItem, RoundRows, Signup, SignupRowItem, SignupRows, TeamInformation, TeamStandingRow, TeamStandingRows, UserInformation

// EXTERNAL MODULE: ./node_modules/react/jsx-runtime.js
var jsx_runtime = __webpack_require__(5893);
// EXTERNAL MODULE: ./node_modules/next/head.js
var head = __webpack_require__(9008);
// EXTERNAL MODULE: ./node_modules/next/router.js
var next_router = __webpack_require__(1163);
// EXTERNAL MODULE: ./types/index.ts
var types = __webpack_require__(8507);
// EXTERNAL MODULE: ./utils/locale.ts
var utils_locale = __webpack_require__(1895);
;// CONCATENATED MODULE: ./components/ds/02-molecules/head.tsx





var Head = function(props) {
    var router = (0,next_router.useRouter)();
    var locale = (0,utils_locale/* makeLocale */.W)(router.locale, router.defaultLocale);
    var title = props.title ? props.title : locale === types/* Locale.sv */.g.sv ? '\xd6-vik N\xe4tverkspadel' : '\xd6-vik Network Padel';
    var description = props.description ? props.description : locale === types/* Locale.sv */.g.sv ? 'En samling padelentusiaster som samlas f\xf6r att spela och n\xe4tverka.' : 'A collection of padel enthusiasts who gather to play and network.';
    var ogImage = props.ogImage ? props.ogImage : '/og-image-default.jpg';
    var baseUrl = locale === types/* Locale.sv */.g.sv ? 'https://natverkspadel.se' : 'https://natverkspadel.com';
    var canonicalUrl = props.canonicalSpecific ? "".concat(baseUrl).concat(router.pathname) : baseUrl;
    return(/*#__PURE__*/ (0,jsx_runtime.jsxs)(head["default"], {
        children: [
            /*#__PURE__*/ (0,jsx_runtime.jsx)("meta", {
                charSet: "UTF-8"
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)("title", {
                children: title
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)("meta", {
                name: "description",
                content: description
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)("meta", {
                name: "viewport",
                content: "width=device-width, initial-scale=1"
            }, "viewport"),
            /*#__PURE__*/ (0,jsx_runtime.jsx)("link", {
                rel: "canonical",
                href: canonicalUrl
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)("link", {
                rel: "alternate",
                hrefLang: locale,
                href: "".concat(baseUrl).concat(router.pathname)
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)("meta", {
                property: "og:title",
                content: title
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)("meta", {
                property: "og:description",
                content: description
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)("meta", {
                property: "og:type",
                content: "website"
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)("meta", {
                property: "og:url",
                content: canonicalUrl
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)("meta", {
                name: "twitter:creator",
                content: "@jrbaudin"
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)("meta", {
                name: "twitter:title",
                content: title
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)("meta", {
                name: "twitter:description",
                content: description
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)("meta", {
                name: "twitter:card",
                content: "summary_large_image"
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)("meta", {
                property: "og:image",
                content: "".concat(baseUrl).concat(ogImage)
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)("meta", {
                property: "og:image:width",
                content: "1200"
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)("meta", {
                property: "og:image:height",
                content: "628"
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)("meta", {
                property: "og:site_name",
                content: title
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)("link", {
                rel: "apple-touch-icon",
                sizes: "180x180",
                href: "/apple-touch-icon.png"
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)("link", {
                rel: "icon",
                type: "image/png",
                sizes: "32x32",
                href: "/favicon-32x32.png"
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)("link", {
                rel: "icon",
                type: "image/png",
                sizes: "16x16",
                href: "/favicon-16x16.png"
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)("link", {
                rel: "manifest",
                href: "/site.webmanifest"
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)("link", {
                rel: "mask-icon",
                href: "/safari-pinned-tab.svg",
                color: "#5bbad5"
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)("meta", {
                name: "msapplication-TileColor",
                content: "#da532c"
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)("meta", {
                name: "theme-color",
                content: "#ffffff"
            })
        ]
    }));
};

;// CONCATENATED MODULE: ./components/ds/02-molecules/alerts/success.tsx

var SuccessAlert = function(param) {
    var translations = param.translations, reset = param.reset;
    return(/*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
        className: "pb-5",
        children: /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
            className: "rounded-md bg-green-50 p-4",
            children: /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                className: "flex",
                children: [
                    /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                        className: "flex-shrink-0",
                        children: /*#__PURE__*/ (0,jsx_runtime.jsx)("svg", {
                            className: "h-5 w-5 text-green-400",
                            xmlns: "http://www.w3.org/2000/svg",
                            viewBox: "0 0 20 20",
                            fill: "currentColor",
                            "aria-hidden": "true",
                            children: /*#__PURE__*/ (0,jsx_runtime.jsx)("path", {
                                fillRule: "evenodd",
                                d: "M10 18a8 8 0 100-16 8 8 0 000 16zm3.707-9.293a1 1 0 00-1.414-1.414L9 10.586 7.707 9.293a1 1 0 00-1.414 1.414l2 2a1 1 0 001.414 0l4-4z",
                                clipRule: "evenodd"
                            })
                        })
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                        className: "ml-3",
                        children: /*#__PURE__*/ (0,jsx_runtime.jsx)("p", {
                            className: "text-sm font-medium text-green-800",
                            children: translations.headline
                        })
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                        className: "ml-auto pl-3",
                        children: /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                            className: "-mx-1.5 -my-1.5",
                            children: /*#__PURE__*/ (0,jsx_runtime.jsxs)("button", {
                                className: "inline-flex bg-green-50 rounded-md p-1.5 text-green-500 hover:bg-green-100 focus:outline-none focus:ring-2 focus:ring-offset-2 focus:ring-offset-green-50 focus:ring-green-600",
                                onClick: reset,
                                children: [
                                    /*#__PURE__*/ (0,jsx_runtime.jsx)("span", {
                                        className: "sr-only",
                                        children: "Dismiss"
                                    }),
                                    /*#__PURE__*/ (0,jsx_runtime.jsx)("svg", {
                                        className: "h-5 w-5",
                                        xmlns: "http://www.w3.org/2000/svg",
                                        viewBox: "0 0 20 20",
                                        fill: "currentColor",
                                        "aria-hidden": "true",
                                        children: /*#__PURE__*/ (0,jsx_runtime.jsx)("path", {
                                            fillRule: "evenodd",
                                            d: "M4.293 4.293a1 1 0 011.414 0L10 8.586l4.293-4.293a1 1 0 111.414 1.414L11.414 10l4.293 4.293a1 1 0 01-1.414 1.414L10 11.414l-4.293 4.293a1 1 0 01-1.414-1.414L8.586 10 4.293 5.707a1 1 0 010-1.414z",
                                            clipRule: "evenodd"
                                        })
                                    })
                                ]
                            })
                        })
                    })
                ]
            })
        })
    }));
};

;// CONCATENATED MODULE: ./components/ds/02-molecules/alerts/error.tsx

var ErrorAlert = function(param) {
    var error = param.error, translations = param.translations, reset = param.reset;
    return(/*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
        className: "pb-5",
        children: /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
            className: "rounded-md bg-red-50 p-4",
            children: /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                className: "flex",
                children: [
                    /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                        className: "flex-shrink-0",
                        children: /*#__PURE__*/ (0,jsx_runtime.jsx)("svg", {
                            className: "h-5 w-5 text-red-400",
                            xmlns: "http://www.w3.org/2000/svg",
                            viewBox: "0 0 20 20",
                            fill: "currentColor",
                            "aria-hidden": "true",
                            children: /*#__PURE__*/ (0,jsx_runtime.jsx)("path", {
                                fillRule: "evenodd",
                                d: "M10 18a8 8 0 100-16 8 8 0 000 16zM8.707 7.293a1 1 0 00-1.414 1.414L8.586 10l-1.293 1.293a1 1 0 101.414 1.414L10 11.414l1.293 1.293a1 1 0 001.414-1.414L11.414 10l1.293-1.293a1 1 0 00-1.414-1.414L10 8.586 8.707 7.293z",
                                clipRule: "evenodd"
                            })
                        })
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                        className: "ml-3",
                        children: [
                            /*#__PURE__*/ (0,jsx_runtime.jsx)("h3", {
                                className: "text-sm font-medium text-red-800",
                                children: translations.headline
                            }),
                            /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                className: "mt-2 text-sm text-red-700",
                                children: /*#__PURE__*/ (0,jsx_runtime.jsx)("ul", {
                                    className: "list-disc pl-5 space-y-1",
                                    children: error.message
                                })
                            })
                        ]
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                        className: "ml-auto pl-3",
                        children: /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                            className: "-mx-1.5 -my-1.5",
                            children: /*#__PURE__*/ (0,jsx_runtime.jsxs)("button", {
                                className: "inline-flex bg-red-50 rounded-md p-1.5 text-red-500 hover:bg-red-100 focus:outline-none focus:ring-2 focus:ring-offset-2 focus:ring-offset-red-50 focus:ring-red-600",
                                onClick: reset,
                                children: [
                                    /*#__PURE__*/ (0,jsx_runtime.jsx)("span", {
                                        className: "sr-only",
                                        children: "Dismiss"
                                    }),
                                    /*#__PURE__*/ (0,jsx_runtime.jsx)("svg", {
                                        className: "h-5 w-5",
                                        xmlns: "http://www.w3.org/2000/svg",
                                        viewBox: "0 0 20 20",
                                        fill: "currentColor",
                                        "aria-hidden": "true",
                                        children: /*#__PURE__*/ (0,jsx_runtime.jsx)("path", {
                                            fillRule: "evenodd",
                                            d: "M4.293 4.293a1 1 0 011.414 0L10 8.586l4.293-4.293a1 1 0 111.414 1.414L11.414 10l4.293 4.293a1 1 0 01-1.414 1.414L10 11.414l-4.293 4.293a1 1 0 01-1.414-1.414L8.586 10 4.293 5.707a1 1 0 010-1.414z",
                                            clipRule: "evenodd"
                                        })
                                    })
                                ]
                            })
                        })
                    })
                ]
            })
        })
    }));
};

;// CONCATENATED MODULE: ./components/ds/02-molecules/alerts/index.ts



// EXTERNAL MODULE: ./node_modules/next/link.js
var next_link = __webpack_require__(1664);
// EXTERNAL MODULE: ./node_modules/luxon/build/cjs-browser/luxon.js
var luxon = __webpack_require__(9490);
// EXTERNAL MODULE: ./utils/classnames.ts
var classnames = __webpack_require__(1864);
// EXTERNAL MODULE: ./node_modules/io-ts/es6/index.js + 4 modules
var es6 = __webpack_require__(3730);
// EXTERNAL MODULE: ./node_modules/io-ts-types/es6/UUID.js
var UUID = __webpack_require__(298);
;// CONCATENATED MODULE: ./components/ds/02-molecules/match-result-row-item/types.ts


var Winner = es6/* union */.G0([
    es6/* literal */.i0('home'),
    es6/* literal */.i0('away'),
    es6/* literal */.i0('draw'),
    es6/* literal */.i0('unknown'), 
]);
var MatchTeam = es6/* type */.dt({
    team_name: es6/* string */.Z_,
    player_name: es6/* string */.Z_
});
var MatchResult = es6/* intersection */.jV([
    es6/* type */.dt({
        match_id: es6/* number */.pk,
        match_public_id: UUID/* UUID */.h,
        round_name: es6/* string */.Z_,
        round_start: es6/* string */.Z_,
        series_id: es6/* string */.Z_,
        home_teams: es6/* array */.IX(MatchTeam),
        away_teams: es6/* array */.IX(MatchTeam),
        match_location_name: es6/* string */.Z_,
        match_location_adress: es6/* string */.Z_,
        match_location_zipcode: es6/* string */.Z_,
        match_location_city: es6/* string */.Z_,
        match_location_country: es6/* string */.Z_,
        match_court_name: es6/* string */.Z_,
        is_upcoming_match: es6/* boolean */.O7,
        home_total_games: es6/* number */.pk,
        home_set_one_games: es6/* number */.pk,
        home_set_two_games: es6/* number */.pk,
        home_set_three_games: es6/* number */.pk,
        away_total_games: es6/* number */.pk,
        away_set_one_games: es6/* number */.pk,
        away_set_two_games: es6/* number */.pk,
        away_set_three_games: es6/* number */.pk,
        winner: Winner,
        winning_points: es6/* number */.pk,
        loosing_points: es6/* number */.pk,
        tiebreak: es6/* boolean */.O7,
        home_tiebreak_points: es6/* number */.pk,
        away_tiebreak_points: es6/* number */.pk
    }),
    es6/* partial */.r$({
        current_team_is: es6/* string */.Z_
    }), 
]);

// EXTERNAL MODULE: ./node_modules/@heroicons/react/solid/esm/index.js + 230 modules
var esm = __webpack_require__(3153);
;// CONCATENATED MODULE: ./components/ds/02-molecules/match-result-row-item/index.tsx







var getParticipantName = function(matchTeam, seriesContext) {
    switch(seriesContext.type){
        case 'team':
            return(/*#__PURE__*/ (0,jsx_runtime.jsxs)(jsx_runtime.Fragment, {
                children: [
                    matchTeam.team_name,
                    " (",
                    /*#__PURE__*/ (0,jsx_runtime.jsx)("span", {
                        className: "font-bold",
                        children: matchTeam.player_name
                    }),
                    ")"
                ]
            }));
        case 'tournament':
        case 'single_player':
            return(/*#__PURE__*/ (0,jsx_runtime.jsx)(jsx_runtime.Fragment, {
                children: /*#__PURE__*/ (0,jsx_runtime.jsx)("span", {
                    className: "font-bold",
                    children: matchTeam.player_name
                })
            }));
        default:
            return null;
    }
};
var MatchResultRowItem = function(param) {
    var match = param.match, seriesContext = param.seriesContext;
    var winner1st = match.home_set_one_games > match.away_set_one_games ? 'home' : match.home_set_one_games < match.away_set_one_games ? 'away' : 'undetermined';
    var winner2nd = match.home_set_two_games > match.away_set_two_games ? 'home' : match.home_set_two_games < match.away_set_two_games ? 'away' : 'undetermined';
    var winner3rd = match.home_set_three_games > match.away_set_three_games ? 'home' : match.home_set_three_games < match.away_set_three_games ? 'away' : 'undetermined';
    var winnerTiebreak = match.home_tiebreak_points > match.away_tiebreak_points ? 'home' : match.home_tiebreak_points < match.away_tiebreak_points ? 'away' : 'undetermined';
    var dtStart = luxon/* DateTime.fromISO */.ou.fromISO(match.round_start);
    var matchResultBoxClasses = "px-3 py-2 text-center font-mono";
    return(/*#__PURE__*/ (0,jsx_runtime.jsx)("li", {
        className: "block bg-white hover:bg-gray-50",
        children: /*#__PURE__*/ (0,jsx_runtime.jsx)(next_link["default"], {
            href: "/series/".concat(seriesContext.id, "/match/").concat(match.match_public_id),
            children: /*#__PURE__*/ (0,jsx_runtime.jsx)("a", {
                children: /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                    className: "flex items-center bg-white px-4 py-4 font-light hover:bg-gray-50 sm:px-6",
                    children: /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                        className: "min-w-0 flex-1 sm:flex sm:items-center sm:justify-between",
                        children: [
                            /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                                className: "border-b border-gray-200 pb-5 pt-3 sm:border-0 sm:px-6",
                                children: [
                                    /*#__PURE__*/ (0,jsx_runtime.jsxs)("h3", {
                                        className: "text-base font-medium leading-6 text-gray-900",
                                        children: [
                                            match.round_name,
                                            " @ ",
                                            match.match_location_name
                                        ]
                                    }),
                                    /*#__PURE__*/ (0,jsx_runtime.jsx)("p", {
                                        className: "mt-1 text-sm text-gray-500",
                                        children: dtStart.setLocale('sv').toLocaleString(luxon/* DateTime.DATETIME_MED_WITH_WEEKDAY */.ou.DATETIME_MED_WITH_WEEKDAY)
                                    })
                                ]
                            }),
                            /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                                children: [
                                    /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                                        className: "mt-4 grid grid-cols-8 grid-rows-2 items-center gap-x-2 py-1 text-xs font-light",
                                        children: [
                                            /*#__PURE__*/ (0,jsx_runtime.jsx)("p", {
                                                className: "col-span-1 row-span-2 rounded-md border border-solid border-gray-200 px-2 py-2 text-center font-bold",
                                                children: "L1"
                                            }),
                                            /*#__PURE__*/ (0,jsx_runtime.jsx)("p", {
                                                className: (0,classnames/* classNames */.A)('col-span-7 py-0'),
                                                children: getParticipantName(match.home_teams[0], seriesContext)
                                            }),
                                            /*#__PURE__*/ (0,jsx_runtime.jsx)("p", {
                                                className: (0,classnames/* classNames */.A)('col-span-7 py-0'),
                                                children: getParticipantName(match.home_teams[1], seriesContext)
                                            })
                                        ]
                                    }),
                                    /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                                        className: "grid grid-cols-8 grid-rows-2 items-center gap-x-2 py-1 text-xs font-light",
                                        children: [
                                            /*#__PURE__*/ (0,jsx_runtime.jsx)("p", {
                                                className: "col-span-1 row-span-2 rounded-md border border-solid border-gray-200 px-2 py-2 text-center font-bold",
                                                children: "L2"
                                            }),
                                            /*#__PURE__*/ (0,jsx_runtime.jsx)("p", {
                                                className: (0,classnames/* classNames */.A)('col-span-7 py-0'),
                                                children: getParticipantName(match.away_teams[0], seriesContext)
                                            }),
                                            /*#__PURE__*/ (0,jsx_runtime.jsx)("p", {
                                                className: (0,classnames/* classNames */.A)('col-span-7 py-0'),
                                                children: getParticipantName(match.away_teams[1], seriesContext)
                                            })
                                        ]
                                    })
                                ]
                            }),
                            /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                                className: (0,classnames/* classNames */.A)(match.tiebreak ? 'grid-cols-7' : 'grid-cols-6', 'mt-4 grid grid-rows-3 items-center divide-x-2 divide-y-2 rounded-md border border-solid border-gray-200 text-xs font-light'),
                                children: [
                                    /*#__PURE__*/ (0,jsx_runtime.jsx)("p", {}),
                                    /*#__PURE__*/ (0,jsx_runtime.jsx)("p", {
                                        title: "Set 1",
                                        className: (0,classnames/* classNames */.A)('font-bold', matchResultBoxClasses),
                                        children: "1"
                                    }),
                                    /*#__PURE__*/ (0,jsx_runtime.jsx)("p", {
                                        title: "Set 2",
                                        className: (0,classnames/* classNames */.A)('font-bold', matchResultBoxClasses),
                                        children: "2"
                                    }),
                                    /*#__PURE__*/ (0,jsx_runtime.jsx)("p", {
                                        title: "Set 3",
                                        className: (0,classnames/* classNames */.A)('font-bold', matchResultBoxClasses),
                                        children: "3"
                                    }),
                                    /*#__PURE__*/ (0,jsx_runtime.jsx)("p", {
                                        title: "Totalt antal gem",
                                        className: (0,classnames/* classNames */.A)('font-bold', matchResultBoxClasses),
                                        children: "T"
                                    }),
                                    match.tiebreak ? /*#__PURE__*/ (0,jsx_runtime.jsx)("p", {
                                        title: "Tiebreak",
                                        className: (0,classnames/* classNames */.A)('font-bold', matchResultBoxClasses),
                                        children: "TB"
                                    }) : null,
                                    /*#__PURE__*/ (0,jsx_runtime.jsx)("p", {
                                        title: "Po\xe4ng",
                                        className: (0,classnames/* classNames */.A)('font-bold', matchResultBoxClasses),
                                        children: "P"
                                    }),
                                    /*#__PURE__*/ (0,jsx_runtime.jsx)("p", {
                                        className: (0,classnames/* classNames */.A)('font-bold', matchResultBoxClasses),
                                        children: "L1"
                                    }),
                                    /*#__PURE__*/ (0,jsx_runtime.jsx)("p", {
                                        className: (0,classnames/* classNames */.A)(winner1st === 'home' ? 'bg-green-100' : 'bg-red-100', matchResultBoxClasses),
                                        children: match.home_set_one_games
                                    }),
                                    /*#__PURE__*/ (0,jsx_runtime.jsx)("p", {
                                        className: (0,classnames/* classNames */.A)(winner2nd === 'home' ? 'bg-green-100' : 'bg-red-100', matchResultBoxClasses),
                                        children: match.home_set_two_games
                                    }),
                                    /*#__PURE__*/ (0,jsx_runtime.jsx)("p", {
                                        className: (0,classnames/* classNames */.A)(winner3rd === 'home' ? 'bg-green-100' : 'bg-red-100', matchResultBoxClasses),
                                        children: match.home_set_three_games
                                    }),
                                    /*#__PURE__*/ (0,jsx_runtime.jsx)("p", {
                                        className: (0,classnames/* classNames */.A)(match.winner === 'home' ? 'bg-green-100 font-extrabold' : 'bg-red-100', matchResultBoxClasses),
                                        children: match.home_total_games
                                    }),
                                    match.tiebreak ? /*#__PURE__*/ (0,jsx_runtime.jsx)("p", {
                                        className: (0,classnames/* classNames */.A)(winnerTiebreak === 'home' ? 'bg-green-100' : 'bg-red-100', matchResultBoxClasses),
                                        children: match.home_tiebreak_points
                                    }) : null,
                                    /*#__PURE__*/ (0,jsx_runtime.jsx)("p", {
                                        className: (0,classnames/* classNames */.A)(match.winner === 'home' ? 'bg-green-100 font-extrabold' : 'bg-red-100', matchResultBoxClasses),
                                        children: match.winner === 'home' ? match.winning_points : match.loosing_points
                                    }),
                                    /*#__PURE__*/ (0,jsx_runtime.jsx)("p", {
                                        className: (0,classnames/* classNames */.A)('font-bold', matchResultBoxClasses),
                                        children: "L2"
                                    }),
                                    /*#__PURE__*/ (0,jsx_runtime.jsx)("p", {
                                        className: (0,classnames/* classNames */.A)(winner1st === 'away' ? 'bg-green-100' : 'bg-red-100', matchResultBoxClasses),
                                        children: match.away_set_one_games
                                    }),
                                    /*#__PURE__*/ (0,jsx_runtime.jsx)("p", {
                                        className: (0,classnames/* classNames */.A)(winner2nd === 'away' ? 'bg-green-100' : 'bg-red-100', matchResultBoxClasses),
                                        children: match.away_set_two_games
                                    }),
                                    /*#__PURE__*/ (0,jsx_runtime.jsx)("p", {
                                        className: (0,classnames/* classNames */.A)(winner3rd === 'away' ? 'bg-green-100' : 'bg-red-100', matchResultBoxClasses),
                                        children: match.away_set_three_games
                                    }),
                                    /*#__PURE__*/ (0,jsx_runtime.jsx)("p", {
                                        className: (0,classnames/* classNames */.A)(match.winner === 'away' ? 'bg-green-100 font-extrabold' : 'bg-red-100', matchResultBoxClasses),
                                        children: match.away_total_games
                                    }),
                                    match.tiebreak ? /*#__PURE__*/ (0,jsx_runtime.jsx)("p", {
                                        className: (0,classnames/* classNames */.A)(winnerTiebreak === 'away' ? 'bg-green-100' : 'bg-red-100', matchResultBoxClasses),
                                        children: match.away_tiebreak_points
                                    }) : null,
                                    /*#__PURE__*/ (0,jsx_runtime.jsx)("p", {
                                        className: (0,classnames/* classNames */.A)(match.winner === 'away' ? 'bg-green-100 font-extrabold' : 'bg-red-100', matchResultBoxClasses),
                                        children: match.winner === 'away' ? match.winning_points : match.loosing_points
                                    })
                                ]
                            }),
                            /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                className: "hidden sm:block",
                                children: /*#__PURE__*/ (0,jsx_runtime.jsx)(esm/* ChevronRightIcon */.XCv, {
                                    className: "h-5 w-5 text-gray-400",
                                    "aria-hidden": "true"
                                })
                            })
                        ]
                    })
                })
            })
        })
    }, match.match_id));
};

;// CONCATENATED MODULE: ./components/ds/02-molecules/match-result-summary/players.tsx

/* This example requires Tailwind CSS v2.0+ */ var people = [
    {
        name: 'Michael Foster',
        role: 'Co-Founder / CTO',
        imageUrl: 'https://images.unsplash.com/photo-1519244703995-f4e0f30006d5?ixlib=rb-=eyJhcHBfaWQiOjEyMDd9&auto=format&fit=facearea&facepad=8&w=1024&h=1024&q=80'
    }
];
var TeamPlayers = function(param) {
    var players = param.players;
    /*#__PURE__*/ return (0,jsx_runtime.jsx)("div", {
        className: "grid grid-cols-2 gap-x-2 justify-center items-center",
        children: players.map(function(player) {
            /*#__PURE__*/ return (0,jsx_runtime.jsxs)("div", {
                className: "space-y-4",
                children: [
                    /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                        className: "mx-auto h-12 w-12 rounded-full lg:w-16 lg:h-16 bg-gradient-to-r from-purple-600 to-blue-600 flex items-center justify-center text-white text-xs",
                        children: player.name.split(' ')[0]
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                        className: "space-y-2",
                        children: /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                            className: "text-xs font-medium lg:text-sm truncate",
                            children: [
                                /*#__PURE__*/ (0,jsx_runtime.jsx)("h3", {
                                    children: player.name.split(' ')[1]
                                }),
                                /*#__PURE__*/ (0,jsx_runtime.jsx)("p", {
                                    className: "text-indigo-600 truncate",
                                    children: player.company
                                })
                            ]
                        })
                    })
                ]
            }, player.name);
        })
    });
};
var Players = function(param) {
    var home = param.home, away = param.away;
    return(/*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
        className: "bg-white",
        children: /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
            className: "max-w-7xl mx-auto py-12 px-4 text-center sm:px-6 lg:px-8 lg:py-24",
            children: /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                className: "space-y-4 sm:space-y-6",
                children: [
                    /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                        className: "relative",
                        children: [
                            /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                className: "absolute inset-0 flex items-center",
                                "aria-hidden": "true",
                                children: /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                    className: "w-full border-t border-gray-300"
                                })
                            }),
                            /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                className: "relative flex justify-center",
                                children: /*#__PURE__*/ (0,jsx_runtime.jsx)("span", {
                                    className: "px-2 bg-white text-sm text-gray-500",
                                    children: "Spelare"
                                })
                            })
                        ]
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                        className: "mx-auto grid grid-cols-2 gap-x-2 gap-y-8 md:gap-x-6 lg:max-w-5xl lg:gap-x-8 lg:gap-y-12",
                        children: [
                            /*#__PURE__*/ (0,jsx_runtime.jsx)("p", {
                                children: "Lag A"
                            }),
                            /*#__PURE__*/ (0,jsx_runtime.jsx)("p", {
                                children: "Lag B"
                            })
                        ]
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                        className: "mx-auto grid grid-cols-2 divide-x-2 divide-solid divide-gray-300 gap-x-2 gap-y-8 md:gap-x-6 lg:max-w-5xl lg:gap-x-8 lg:gap-y-12",
                        children: [
                            /*#__PURE__*/ (0,jsx_runtime.jsx)(TeamPlayers, {
                                players: home
                            }),
                            /*#__PURE__*/ (0,jsx_runtime.jsx)(TeamPlayers, {
                                players: away
                            })
                        ]
                    })
                ]
            })
        })
    }));
};

;// CONCATENATED MODULE: ./components/ds/02-molecules/match-result-summary/result.tsx




var Result = function(param) {
    var match = param.match, seriesContext = param.seriesContext;
    var winner1st = match.home_set_one_games > match.away_set_one_games ? 'home' : match.home_set_one_games < match.away_set_one_games ? 'away' : 'undetermined';
    var winner2nd = match.home_set_two_games > match.away_set_two_games ? 'home' : match.home_set_two_games < match.away_set_two_games ? 'away' : 'undetermined';
    var winner3rd = match.home_set_three_games > match.away_set_three_games ? 'home' : match.home_set_three_games < match.away_set_three_games ? 'away' : 'undetermined';
    var winnerTiebreak = match.home_tiebreak_points > match.away_tiebreak_points ? 'home' : match.home_tiebreak_points < match.away_tiebreak_points ? 'away' : 'undetermined';
    var matchResultBoxClasses = "px-3 py-2 text-center font-mono";
    return(/*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
        className: "bg-white",
        children: /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
            className: "mx-auto max-w-7xl py-12 px-4 text-center sm:px-6 lg:px-8 lg:py-24",
            children: /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                className: "space-y-4 sm:space-y-6",
                children: [
                    /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                        className: "relative",
                        children: [
                            /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                className: "absolute inset-0 flex items-center",
                                "aria-hidden": "true",
                                children: /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                    className: "w-full border-t border-gray-300"
                                })
                            }),
                            /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                className: "relative flex justify-center",
                                children: /*#__PURE__*/ (0,jsx_runtime.jsx)("span", {
                                    className: "relative z-0 inline-flex -space-x-px rounded-md shadow-sm",
                                    children: /*#__PURE__*/ (0,jsx_runtime.jsx)(next_link["default"], {
                                        href: "/series/".concat(seriesContext.id, "/match/").concat(match.match_public_id, "/result/edit"),
                                        children: /*#__PURE__*/ (0,jsx_runtime.jsxs)("a", {
                                            className: "relative inline-flex items-center rounded-l-md border border-gray-300 bg-white px-4 py-2 text-sm font-medium text-gray-400 hover:bg-gray-50 focus:z-10 focus:border-indigo-500 focus:outline-none focus:ring-1 focus:ring-indigo-500",
                                            children: [
                                                /*#__PURE__*/ (0,jsx_runtime.jsx)("span", {
                                                    className: "sr-only",
                                                    children: "\xc4ndra"
                                                }),
                                                /*#__PURE__*/ (0,jsx_runtime.jsx)(esm/* PencilIcon */.vdY, {
                                                    className: "h-5 w-5",
                                                    "aria-hidden": "true"
                                                })
                                            ]
                                        })
                                    })
                                })
                            })
                        ]
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                        className: "flex items-center px-4 py-4 font-light sm:px-6",
                        children: /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                            className: "w-full min-w-0 flex-1 sm:flex sm:items-center sm:justify-center",
                            children: /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                                className: (0,classnames/* classNames */.A)(match.tiebreak ? 'grid-cols-7' : 'grid-cols-6', 'grid grid-rows-3 items-center divide-x-2 divide-y-2 rounded-md border border-solid border-gray-200 text-xs font-light sm:w-10/12'),
                                children: [
                                    /*#__PURE__*/ (0,jsx_runtime.jsx)("p", {}),
                                    /*#__PURE__*/ (0,jsx_runtime.jsx)("p", {
                                        title: "Set 1",
                                        className: (0,classnames/* classNames */.A)('font-bold', matchResultBoxClasses),
                                        children: "1"
                                    }),
                                    /*#__PURE__*/ (0,jsx_runtime.jsx)("p", {
                                        title: "Set 2",
                                        className: (0,classnames/* classNames */.A)('font-bold', matchResultBoxClasses),
                                        children: "2"
                                    }),
                                    /*#__PURE__*/ (0,jsx_runtime.jsx)("p", {
                                        title: "Set 3",
                                        className: (0,classnames/* classNames */.A)('font-bold', matchResultBoxClasses),
                                        children: "3"
                                    }),
                                    /*#__PURE__*/ (0,jsx_runtime.jsx)("p", {
                                        title: "Totalt antal gem",
                                        className: (0,classnames/* classNames */.A)('font-bold', matchResultBoxClasses),
                                        children: "T"
                                    }),
                                    match.tiebreak ? /*#__PURE__*/ (0,jsx_runtime.jsx)("p", {
                                        title: "Tiebreak",
                                        className: (0,classnames/* classNames */.A)('font-bold', matchResultBoxClasses),
                                        children: "TB"
                                    }) : null,
                                    /*#__PURE__*/ (0,jsx_runtime.jsx)("p", {
                                        title: "Po\xe4ng",
                                        className: (0,classnames/* classNames */.A)('font-bold', matchResultBoxClasses),
                                        children: "P"
                                    }),
                                    /*#__PURE__*/ (0,jsx_runtime.jsx)("p", {
                                        className: (0,classnames/* classNames */.A)('font-bold', matchResultBoxClasses),
                                        children: "A"
                                    }),
                                    /*#__PURE__*/ (0,jsx_runtime.jsx)("p", {
                                        className: (0,classnames/* classNames */.A)(winner1st === 'home' ? 'bg-green-100' : 'bg-red-100', matchResultBoxClasses),
                                        children: match.home_set_one_games
                                    }),
                                    /*#__PURE__*/ (0,jsx_runtime.jsx)("p", {
                                        className: (0,classnames/* classNames */.A)(winner2nd === 'home' ? 'bg-green-100' : 'bg-red-100', matchResultBoxClasses),
                                        children: match.home_set_two_games
                                    }),
                                    /*#__PURE__*/ (0,jsx_runtime.jsx)("p", {
                                        className: (0,classnames/* classNames */.A)(winner3rd === 'home' ? 'bg-green-100' : 'bg-red-100', matchResultBoxClasses),
                                        children: match.home_set_three_games
                                    }),
                                    /*#__PURE__*/ (0,jsx_runtime.jsx)("p", {
                                        className: (0,classnames/* classNames */.A)(match.winner === 'home' ? 'bg-green-100 font-extrabold' : 'bg-red-100', matchResultBoxClasses),
                                        children: match.home_total_games
                                    }),
                                    match.tiebreak ? /*#__PURE__*/ (0,jsx_runtime.jsx)("p", {
                                        className: (0,classnames/* classNames */.A)(winnerTiebreak === 'home' ? 'bg-green-100' : 'bg-red-100', matchResultBoxClasses),
                                        children: match.home_tiebreak_points
                                    }) : null,
                                    /*#__PURE__*/ (0,jsx_runtime.jsx)("p", {
                                        className: (0,classnames/* classNames */.A)(match.winner === 'home' ? 'bg-green-100 font-extrabold' : 'bg-red-100', matchResultBoxClasses),
                                        children: match.winner === 'home' ? match.winning_points : match.loosing_points
                                    }),
                                    /*#__PURE__*/ (0,jsx_runtime.jsx)("p", {
                                        className: (0,classnames/* classNames */.A)('font-bold', matchResultBoxClasses),
                                        children: "B"
                                    }),
                                    /*#__PURE__*/ (0,jsx_runtime.jsx)("p", {
                                        className: (0,classnames/* classNames */.A)(winner1st === 'away' ? 'bg-green-100' : 'bg-red-100', matchResultBoxClasses),
                                        children: match.away_set_one_games
                                    }),
                                    /*#__PURE__*/ (0,jsx_runtime.jsx)("p", {
                                        className: (0,classnames/* classNames */.A)(winner2nd === 'away' ? 'bg-green-100' : 'bg-red-100', matchResultBoxClasses),
                                        children: match.away_set_two_games
                                    }),
                                    /*#__PURE__*/ (0,jsx_runtime.jsx)("p", {
                                        className: (0,classnames/* classNames */.A)(winner3rd === 'away' ? 'bg-green-100' : 'bg-red-100', matchResultBoxClasses),
                                        children: match.away_set_three_games
                                    }),
                                    /*#__PURE__*/ (0,jsx_runtime.jsx)("p", {
                                        className: (0,classnames/* classNames */.A)(match.winner === 'away' ? 'bg-green-100 font-extrabold' : 'bg-red-100', matchResultBoxClasses),
                                        children: match.away_total_games
                                    }),
                                    match.tiebreak ? /*#__PURE__*/ (0,jsx_runtime.jsx)("p", {
                                        className: (0,classnames/* classNames */.A)(winnerTiebreak === 'away' ? 'bg-green-100' : 'bg-red-100', matchResultBoxClasses),
                                        children: match.away_tiebreak_points
                                    }) : null,
                                    /*#__PURE__*/ (0,jsx_runtime.jsx)("p", {
                                        className: (0,classnames/* classNames */.A)(match.winner === 'away' ? 'bg-green-100 font-extrabold' : 'bg-red-100', matchResultBoxClasses),
                                        children: match.winner === 'away' ? match.winning_points : match.loosing_points
                                    })
                                ]
                            })
                        })
                    })
                ]
            })
        })
    }));
};

;// CONCATENATED MODULE: ./components/ds/02-molecules/match-result-summary/information.tsx


var Information = function(param) {
    var match = param.match;
    var dtStart = luxon/* DateTime.fromISO */.ou.fromISO(match.round_start);
    return(/*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
        className: "bg-white",
        children: /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
            className: "max-w-7xl mx-auto py-12 px-4 sm:px-6 lg:px-8 lg:py-24",
            children: /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                className: "space-y-4 sm:space-y-6",
                children: [
                    /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                        className: "relative",
                        children: [
                            /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                className: "absolute inset-0 flex items-center",
                                "aria-hidden": "true",
                                children: /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                    className: "w-full border-t border-gray-300"
                                })
                            }),
                            /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                className: "relative flex justify-center",
                                children: /*#__PURE__*/ (0,jsx_runtime.jsx)("span", {
                                    className: "px-2 bg-white text-sm text-gray-500",
                                    children: "Information"
                                })
                            })
                        ]
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                        className: "px-4 py-4",
                        children: /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                            className: "mt-5",
                            children: /*#__PURE__*/ (0,jsx_runtime.jsxs)("dl", {
                                className: "sm:divide-y sm:divide-gray-200",
                                children: [
                                    /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                                        className: "py-4 sm:py-5 sm:grid sm:grid-cols-3 sm:gap-4",
                                        children: [
                                            /*#__PURE__*/ (0,jsx_runtime.jsx)("dt", {
                                                className: "text-sm font-medium text-gray-500",
                                                children: "Plats"
                                            }),
                                            /*#__PURE__*/ (0,jsx_runtime.jsxs)("dd", {
                                                className: "mt-1 text-sm text-gray-900 sm:mt-0 sm:col-span-2",
                                                children: [
                                                    match.match_location_name,
                                                    /*#__PURE__*/ (0,jsx_runtime.jsx)("br", {}),
                                                    match.match_location_adress,
                                                    ", ",
                                                    match.match_location_zipcode,
                                                    /*#__PURE__*/ (0,jsx_runtime.jsx)("br", {}),
                                                    match.match_location_city,
                                                    ", ",
                                                    match.match_location_country
                                                ]
                                            })
                                        ]
                                    }),
                                    /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                                        className: "py-4 sm:py-5 sm:grid sm:grid-cols-3 sm:gap-4",
                                        children: [
                                            /*#__PURE__*/ (0,jsx_runtime.jsx)("dt", {
                                                className: "text-sm font-medium text-gray-500",
                                                children: "Bana"
                                            }),
                                            /*#__PURE__*/ (0,jsx_runtime.jsx)("dd", {
                                                className: "mt-1 text-sm text-gray-900 sm:mt-0 sm:col-span-2",
                                                children: match.match_court_name
                                            })
                                        ]
                                    }),
                                    /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                                        className: "py-4 sm:py-5 sm:grid sm:grid-cols-3 sm:gap-4",
                                        children: [
                                            /*#__PURE__*/ (0,jsx_runtime.jsx)("dt", {
                                                className: "text-sm font-medium text-gray-500",
                                                children: "Datum & tid"
                                            }),
                                            /*#__PURE__*/ (0,jsx_runtime.jsx)("dd", {
                                                className: "mt-1 text-sm text-gray-900 sm:mt-0 sm:col-span-2",
                                                children: dtStart.setLocale('sv').toLocaleString(luxon/* DateTime.DATETIME_MED_WITH_WEEKDAY */.ou.DATETIME_MED_WITH_WEEKDAY)
                                            })
                                        ]
                                    })
                                ]
                            })
                        })
                    })
                ]
            })
        })
    }));
};

;// CONCATENATED MODULE: ./components/ds/02-molecules/match-header/index.tsx


var MatchHeader = function(param) {
    var match = param.match, seriesContext = param.seriesContext;
    var dtStart = luxon/* DateTime.fromISO */.ou.fromISO(match.round_start);
    return(/*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
        className: "bg-white px-4 pb-2 pt-10 sm:px-6",
        children: /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
            className: "flex space-x-3",
            children: [
                /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                    className: "flex-shrink-0",
                    children: /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                        className: "h-10 w-10 rounded-full bg-gradient-to-r from-purple-600 to-blue-600 text-white flex items-center justify-center",
                        children: /*#__PURE__*/ (0,jsx_runtime.jsxs)("svg", {
                            xmlns: "http://www.w3.org/2000/svg",
                            className: "h-6 w-6",
                            fill: "none",
                            viewBox: "0 0 24 24",
                            stroke: "currentColor",
                            children: [
                                /*#__PURE__*/ (0,jsx_runtime.jsx)("path", {
                                    strokeLinecap: "round",
                                    strokeLinejoin: "round",
                                    strokeWidth: 2,
                                    d: "M17.657 18.657A8 8 0 016.343 7.343S7 9 9 10c0-2 .5-5 2.986-7C14 5 16.09 5.777 17.656 7.343A7.975 7.975 0 0120 13a7.975 7.975 0 01-2.343 5.657z"
                                }),
                                /*#__PURE__*/ (0,jsx_runtime.jsx)("path", {
                                    strokeLinecap: "round",
                                    strokeLinejoin: "round",
                                    strokeWidth: 2,
                                    d: "M9.879 16.121A3 3 0 1012.015 11L11 14H9c0 .768.293 1.536.879 2.121z"
                                })
                            ]
                        })
                    })
                }),
                /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                    className: "min-w-0 flex-1",
                    children: [
                        /*#__PURE__*/ (0,jsx_runtime.jsxs)("p", {
                            className: "text-sm font-medium text-gray-900",
                            children: [
                                /*#__PURE__*/ (0,jsx_runtime.jsx)("strong", {
                                    children: match.round_name
                                }),
                                " i ",
                                seriesContext.name
                            ]
                        }),
                        /*#__PURE__*/ (0,jsx_runtime.jsx)("p", {
                            className: "text-sm text-gray-500",
                            children: dtStart.setLocale('sv-SE').toLocaleString(luxon/* DateTime.DATETIME_MED_WITH_WEEKDAY */.ou.DATETIME_MED_WITH_WEEKDAY)
                        })
                    ]
                })
            ]
        })
    }));
};

;// CONCATENATED MODULE: ./components/ds/02-molecules/match-result-summary/breadcrumbs.tsx



var MatchBreadcrumbs = function(param) {
    var match = param.match, seriesContext = param.seriesContext;
    return(/*#__PURE__*/ (0,jsx_runtime.jsx)("nav", {
        className: "bg-white border-b border-gray-200 flex",
        "aria-label": "Breadcrumb",
        children: /*#__PURE__*/ (0,jsx_runtime.jsxs)("ol", {
            role: "list",
            className: "max-w-screen-xl w-full mx-auto px-4 flex space-x-4 sm:px-6 lg:px-8",
            children: [
                /*#__PURE__*/ (0,jsx_runtime.jsx)("li", {
                    className: "flex",
                    children: /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                        className: "flex items-center",
                        children: /*#__PURE__*/ (0,jsx_runtime.jsx)(next_link["default"], {
                            href: "/series/".concat(seriesContext.id, "/matches"),
                            children: /*#__PURE__*/ (0,jsx_runtime.jsxs)("a", {
                                className: "text-gray-400 hover:text-gray-500",
                                children: [
                                    /*#__PURE__*/ (0,jsx_runtime.jsx)(esm/* HomeIcon */.tvw, {
                                        className: "flex-shrink-0 h-5 w-5",
                                        "aria-hidden": "true"
                                    }),
                                    /*#__PURE__*/ (0,jsx_runtime.jsx)("span", {
                                        className: "sr-only",
                                        children: "Matcher"
                                    })
                                ]
                            })
                        })
                    })
                }),
                /*#__PURE__*/ (0,jsx_runtime.jsx)("li", {
                    className: "flex",
                    children: /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                        className: "flex items-center",
                        children: [
                            /*#__PURE__*/ (0,jsx_runtime.jsx)("svg", {
                                className: "flex-shrink-0 w-6 h-full text-gray-200",
                                viewBox: "0 0 24 44",
                                preserveAspectRatio: "none",
                                fill: "currentColor",
                                xmlns: "http://www.w3.org/2000/svg",
                                "aria-hidden": "true",
                                children: /*#__PURE__*/ (0,jsx_runtime.jsx)("path", {
                                    d: "M.293 0l22 22-22 22h1.414l22-22-22-22H.293z"
                                })
                            }),
                            /*#__PURE__*/ (0,jsx_runtime.jsx)(next_link["default"], {
                                href: "/series/".concat(seriesContext.id, "/match/").concat(match.match_public_id),
                                children: /*#__PURE__*/ (0,jsx_runtime.jsx)("a", {
                                    className: "ml-4 text-sm font-medium text-gray-500 hover:text-gray-700",
                                    "aria-current": true,
                                    children: match.round_name
                                })
                            })
                        ]
                    })
                })
            ]
        })
    }));
};

;// CONCATENATED MODULE: ./components/ds/02-molecules/match-result-summary/index.tsx






var MatchResultSummary = function(param) {
    var match = param.match, seriesContext = param.seriesContext;
    var homePlayers = [
        {
            name: match.home_teams[0].player_name,
            company: match.home_teams[0].team_name
        },
        {
            name: match.home_teams[1].player_name,
            company: match.home_teams[1].team_name
        }, 
    ];
    var awayPlayers = [
        {
            name: match.away_teams[0].player_name,
            company: match.away_teams[0].team_name
        },
        {
            name: match.away_teams[1].player_name,
            company: match.away_teams[1].team_name
        }, 
    ];
    return(/*#__PURE__*/ (0,jsx_runtime.jsxs)(jsx_runtime.Fragment, {
        children: [
            /*#__PURE__*/ (0,jsx_runtime.jsx)(MatchBreadcrumbs, {
                match: match,
                seriesContext: seriesContext
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)(MatchHeader, {
                match: match,
                seriesContext: seriesContext
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)(Players, {
                home: homePlayers,
                away: awayPlayers
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)(Result, {
                match: match,
                seriesContext: seriesContext
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)(Information, {
                match: match
            })
        ]
    }));
};

// EXTERNAL MODULE: ./node_modules/next/dist/compiled/regenerator-runtime/runtime.js
var runtime = __webpack_require__(4051);
var runtime_default = /*#__PURE__*/__webpack_require__.n(runtime);
// EXTERNAL MODULE: ./node_modules/yup/es/index.js + 25 modules
var es = __webpack_require__(4231);
// EXTERNAL MODULE: ./node_modules/formik/dist/formik.esm.js + 121 modules
var formik_esm = __webpack_require__(2580);
// EXTERNAL MODULE: ./node_modules/react/index.js
var react = __webpack_require__(7294);
;// CONCATENATED MODULE: ./components/ds/02-molecules/match-edit-result-form/types.ts
var translations = {
    sv: {
        fields: {
            first_name: {
                label: 'F\xf6rnamn',
                placeholder: 'Skriv spelarens f\xf6rnamn',
                validation: {
                    short: 'F\xf6rnamnet \xe4r f\xf6r kort',
                    long: 'F\xf6rnamnet \xe4r f\xf6r l\xe5ngt',
                    required: 'F\xf6rnamnet saknas'
                }
            },
            last_name: {
                label: 'Efternman',
                placeholder: 'Skriv spelarens efternman',
                validation: {
                    short: 'Efternamnet \xe4r f\xf6r kort',
                    long: 'Efternamnet \xe4r f\xf6r l\xe5ngt',
                    required: 'Efternamnet saknas'
                }
            },
            email_adress: {
                label: 'E-postadress',
                placeholder: 'Skriv spelarens e-postadress',
                validation: {
                    short: 'E-postadressen \xe4r f\xf6r kort',
                    long: 'E-postadressen \xe4r f\xf6r l\xe5ng',
                    format: 'E-postadressen har ogiltigt format',
                    required: 'E-postadressen saknas'
                }
            },
            phone_number: {
                label: 'Telefonnummer',
                placeholder: 'Skriv spelarens telefonummer',
                validation: {
                    short: 'Telefonnumret \xe4r f\xf6r kort',
                    long: 'Telefonnumret \xe4r f\xf6r l\xe5ngt',
                    required: 'Telefonnumret saknas'
                }
            }
        },
        button: {
            text: 'Spara'
        },
        error: {
            headline: 'Det var ett problem med att spara matchresultatet.'
        },
        success: {
            headline: 'Tack f\xf6r du rapporterat matchresultatet.'
        }
    },
    en: {
        fields: {
            first_name: {
                label: 'F\xf6rnamn',
                placeholder: 'Skriv spelarens f\xf6rnamn',
                validation: {
                    short: 'F\xf6rnamnet \xe4r f\xf6r kort',
                    long: 'F\xf6rnamnet \xe4r f\xf6r l\xe5ngt',
                    required: 'F\xf6rnamnet saknas'
                }
            },
            last_name: {
                label: 'Efternman',
                placeholder: 'Skriv spelarens efternman',
                validation: {
                    short: 'Efternamnet \xe4r f\xf6r kort',
                    long: 'Efternamnet \xe4r f\xf6r l\xe5ngt',
                    required: 'Efternamnet saknas'
                }
            },
            email_adress: {
                label: 'E-postadress',
                placeholder: 'Skriv spelarens e-postadress',
                validation: {
                    short: 'E-postadressen \xe4r f\xf6r kort',
                    long: 'E-postadressen \xe4r f\xf6r l\xe5ng',
                    format: 'E-postadressen har ogiltigt format',
                    required: 'E-postadressen saknas'
                }
            },
            phone_number: {
                label: 'Telefonnummer',
                placeholder: 'Skriv spelarens telefonummer',
                validation: {
                    short: 'Telefonnumret \xe4r f\xf6r kort',
                    long: 'Telefonnumret \xe4r f\xf6r l\xe5ngt',
                    required: 'Telefonnumret saknas'
                }
            }
        },
        button: {
            text: 'Spara'
        },
        error: {
            headline: 'Det var ett problem med att spara matchresultatet.'
        },
        success: {
            headline: 'Tack f\xf6r du rapporterat matchresultatet.'
        }
    }
};

;// CONCATENATED MODULE: ./components/ds/02-molecules/match-edit-result-form/custom-success-alert.tsx



var CustomSuccessAlert = function(param) {
    var translations = param.translations, reset = param.reset, match = param.match, seriesContext = param.seriesContext;
    return(/*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
        className: "rounded-md bg-green-50 p-4",
        children: /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
            className: "flex",
            children: [
                /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                    className: "flex-shrink-0",
                    children: /*#__PURE__*/ (0,jsx_runtime.jsx)(esm/* CheckCircleIcon */.rE2, {
                        className: "h-5 w-5 text-green-400",
                        "aria-hidden": "true"
                    })
                }),
                /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                    className: "ml-3",
                    children: [
                        /*#__PURE__*/ (0,jsx_runtime.jsx)("h3", {
                            className: "text-sm font-medium text-green-800",
                            children: translations.headline
                        }),
                        /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                            className: "mt-4",
                            children: /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                                className: "-mx-2 -my-1.5 flex",
                                children: [
                                    /*#__PURE__*/ (0,jsx_runtime.jsx)(next_link["default"], {
                                        href: "/series/".concat(seriesContext.id, "/match/").concat(match.match_public_id),
                                        children: /*#__PURE__*/ (0,jsx_runtime.jsx)("a", {
                                            type: "button",
                                            className: "bg-green-50 px-2 py-1.5 rounded-md text-sm font-medium text-green-800 hover:bg-green-100 focus:outline-none focus:ring-2 focus:ring-offset-2 focus:ring-offset-green-50 focus:ring-green-600",
                                            children: "G\xe5 tillbaka"
                                        })
                                    }),
                                    /*#__PURE__*/ (0,jsx_runtime.jsx)("button", {
                                        type: "button",
                                        className: "ml-3 bg-green-50 px-2 py-1.5 rounded-md text-sm font-medium text-green-800 hover:bg-green-100 focus:outline-none focus:ring-2 focus:ring-offset-2 focus:ring-offset-green-50 focus:ring-green-600",
                                        onClick: reset,
                                        children: "St\xe4ng"
                                    })
                                ]
                            })
                        })
                    ]
                })
            ]
        })
    }));
};

;// CONCATENATED MODULE: ./components/ds/02-molecules/match-edit-result-form/index.tsx












function asyncGeneratorStep(gen, resolve, reject, _next, _throw, key, arg) {
    try {
        var info = gen[key](arg);
        var value = info.value;
    } catch (error) {
        reject(error);
        return;
    }
    if (info.done) {
        resolve(value);
    } else {
        Promise.resolve(value).then(_next, _throw);
    }
}
function _asyncToGenerator(fn) {
    return function() {
        var self = this, args = arguments;
        return new Promise(function(resolve, reject) {
            var gen = fn.apply(self, args);
            function _next(value) {
                asyncGeneratorStep(gen, resolve, reject, _next, _throw, "next", value);
            }
            function _throw(err) {
                asyncGeneratorStep(gen, resolve, reject, _next, _throw, "throw", err);
            }
            _next(undefined);
        });
    };
}
function _defineProperty(obj, key, value) {
    if (key in obj) {
        Object.defineProperty(obj, key, {
            value: value,
            enumerable: true,
            configurable: true,
            writable: true
        });
    } else {
        obj[key] = value;
    }
    return obj;
}
function _instanceof(left, right) {
    if (right != null && typeof Symbol !== "undefined" && right[Symbol.hasInstance]) {
        return right[Symbol.hasInstance](left);
    } else {
        return left instanceof right;
    }
}
function _objectSpread(target) {
    for(var i = 1; i < arguments.length; i++){
        var source = arguments[i] != null ? arguments[i] : {};
        var ownKeys = Object.keys(source);
        if (typeof Object.getOwnPropertySymbols === "function") {
            ownKeys = ownKeys.concat(Object.getOwnPropertySymbols(source).filter(function(sym) {
                return Object.getOwnPropertyDescriptor(source, sym).enumerable;
            }));
        }
        ownKeys.forEach(function(key) {
            _defineProperty(target, key, source[key]);
        });
    }
    return target;
}
var MatchEditResultForm = function(param1) {
    var match = param1.match, seriesContext = param1.seriesContext;
    var ref = (0,react.useState)(), error = ref[0], setError = ref[1];
    var ref1 = (0,react.useState)(), status = ref1[0], setStatus = ref1[1];
    var router = (0,next_router.useRouter)();
    var locale = (0,utils_locale/* makeLocale */.W)(router.locale, router.defaultLocale) || 'sv';
    var translation = translations[locale];
    var initialValues = {
        home_set_one: match.home_set_one_games || 0,
        home_set_two: match.home_set_two_games || 0,
        home_set_three: match.home_set_three_games || 0,
        home_tiebreak: match.home_tiebreak_points || 0,
        away_set_one: match.away_set_one_games || 0,
        away_set_two: match.away_set_two_games || 0,
        away_set_three: match.away_set_three_games || 0,
        away_tiebreak: match.away_tiebreak_points || 0
    };
    var reset = function() {
        setError(undefined);
        setStatus('pristine');
    };
    var ValidationSchema = es/* object */.Ry().shape({
        home_set_one: es/* number */.Rx().min(0, 'M\xe5ste vara minst 0').max(7, 'Du kan bara vinna som mest 7 gem').required('Detta f\xe4lt m\xe5ste ha ett v\xe4rde'),
        home_set_two: es/* number */.Rx().min(0, 'M\xe5ste vara minst 0').max(7, 'Du kan bara vinna som mest 7 gem').required('Detta f\xe4lt m\xe5ste ha ett v\xe4rde'),
        home_set_three: es/* number */.Rx().min(0, 'M\xe5ste vara minst 0').max(7, 'Du kan bara vinna som mest 7 gem').required('Detta f\xe4lt m\xe5ste ha ett v\xe4rde'),
        home_tiebreak: es/* number */.Rx().min(0, 'M\xe5ste vara minst 0').max(7, 'Du kan bara vinna som mest 7 gem'),
        away_set_one: es/* number */.Rx().min(0, 'M\xe5ste vara minst 0').max(7, 'Du kan bara vinna som mest 7 gem').required('Detta f\xe4lt m\xe5ste ha ett v\xe4rde'),
        away_set_two: es/* number */.Rx().min(0, 'M\xe5ste vara minst 0').max(7, 'Du kan bara vinna som mest 7 gem').required('Detta f\xe4lt m\xe5ste ha ett v\xe4rde'),
        away_set_three: es/* number */.Rx().min(0, 'M\xe5ste vara minst 0').max(7, 'Du kan bara vinna som mest 7 gem').required('Detta f\xe4lt m\xe5ste ha ett v\xe4rde'),
        away_tiebreak: es/* number */.Rx().min(0, 'M\xe5ste vara minst 0').max(7, 'Du kan bara vinna som mest 7 gem')
    });
    return(/*#__PURE__*/ (0,jsx_runtime.jsxs)(jsx_runtime.Fragment, {
        children: [
            /*#__PURE__*/ (0,jsx_runtime.jsx)(MatchHeader, {
                match: match,
                seriesContext: seriesContext
            }),
            status === 'ok' ? /*#__PURE__*/ (0,jsx_runtime.jsx)(CustomSuccessAlert, {
                translations: {
                    headline: translation.success.headline
                },
                reset: reset,
                match: match,
                seriesContext: seriesContext
            }) : null,
            status === 'not_ok' && error ? /*#__PURE__*/ (0,jsx_runtime.jsx)(ErrorAlert, {
                translations: {
                    headline: translation.error.headline
                },
                error: error,
                reset: reset
            }) : null,
            /*#__PURE__*/ (0,jsx_runtime.jsx)(formik_esm/* Formik */.J9, {
                initialValues: initialValues,
                validationSchema: ValidationSchema,
                enableReinitialize: true,
                onSubmit: function() {
                    var _ref = _asyncToGenerator(runtime_default().mark(function _callee(values, actions) {
                        var isTiebreak, requestBody, ReportGameResultRes, ReportGameResultResData;
                        return runtime_default().wrap(function _callee$(_ctx) {
                            while(1)switch(_ctx.prev = _ctx.next){
                                case 0:
                                    _ctx.prev = 0;
                                    if (!confirm('\xc4r du s\xe4ker p\xe5 att du vill rapportera detta matchresultat?')) {
                                        _ctx.next = 17;
                                        break;
                                    }
                                    isTiebreak = values.home_tiebreak > 0 || values.away_tiebreak > 0;
                                    requestBody = {
                                        type: match.is_upcoming_match ? 'create' : 'update',
                                        matchPublicId: match.match_public_id,
                                        tiebreak: isTiebreak,
                                        sendNotifications: true,
                                        homeResultSet: {
                                            set_one: values.home_set_one,
                                            set_two: values.home_set_two,
                                            set_three: values.home_set_three,
                                            tiebreak: isTiebreak && values.home_tiebreak ? values.home_tiebreak : 0
                                        },
                                        awayResultSet: {
                                            set_one: values.away_set_one,
                                            set_two: values.away_set_two,
                                            set_three: values.away_set_three,
                                            tiebreak: isTiebreak && values.away_tiebreak ? values.away_tiebreak : 0
                                        }
                                    };
                                    _ctx.next = 6;
                                    return fetch('/api/match/report', {
                                        method: 'POST',
                                        body: JSON.stringify(requestBody),
                                        headers: {
                                            'Content-Type': 'application/json'
                                        }
                                    });
                                case 6:
                                    ReportGameResultRes = _ctx.sent;
                                    if (!(ReportGameResultRes.status !== 200)) {
                                        _ctx.next = 13;
                                        break;
                                    }
                                    setStatus('not_ok');
                                    setError(new Error('Non 200 response from backend'));
                                    actions.resetForm();
                                    actions.setSubmitting(false);
                                    return _ctx.abrupt("return");
                                case 13:
                                    _ctx.next = 15;
                                    return ReportGameResultRes.json();
                                case 15:
                                    ReportGameResultResData = _ctx.sent;
                                    if (!ReportGameResultResData.success) {
                                        setStatus('not_ok');
                                        setError(new Error(ReportGameResultResData.code));
                                        actions.resetForm();
                                        actions.setSubmitting(false);
                                    } else {
                                        actions.resetForm();
                                        actions.setSubmitting(false);
                                        setStatus('ok');
                                        router.replace(router.asPath);
                                    }
                                case 17:
                                    _ctx.next = 25;
                                    break;
                                case 19:
                                    _ctx.prev = 19;
                                    _ctx.t0 = _ctx["catch"](0);
                                    setStatus('not_ok');
                                    if (_instanceof(_ctx.t0, Error)) {
                                        setError(_ctx.t0);
                                    } else {
                                        setError(new Error('Report game result failed due to a unknown error'));
                                    }
                                    actions.resetForm();
                                    actions.setSubmitting(false);
                                case 25:
                                case "end":
                                    return _ctx.stop();
                            }
                        }, _callee, null, [
                            [
                                0,
                                19
                            ]
                        ]);
                    }));
                    return function(values, actions) {
                        return _ref.apply(this, arguments);
                    };
                }(),
                children: function(formikBag) {
                    return(/*#__PURE__*/ (0,jsx_runtime.jsxs)(formik_esm/* Form */.l0, {
                        children: [
                            /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                className: "py-5",
                                children: /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                                    children: [
                                        /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                                            className: "flex gap-x-2",
                                            children: [
                                                /*#__PURE__*/ (0,jsx_runtime.jsx)("p", {
                                                    className: "col-span-6 block w-full rounded-md border-gray-300 text-center shadow-sm sm:col-span-3 sm:text-sm",
                                                    children: "Set 1"
                                                }),
                                                /*#__PURE__*/ (0,jsx_runtime.jsx)("p", {
                                                    className: "col-span-6 block w-full rounded-md border-gray-300 text-center shadow-sm sm:col-span-3 sm:text-sm",
                                                    children: "Set 2"
                                                }),
                                                /*#__PURE__*/ (0,jsx_runtime.jsx)("p", {
                                                    className: "col-span-6 block w-full rounded-md border-gray-300 text-center shadow-sm sm:col-span-3 sm:text-sm",
                                                    children: "Set 3"
                                                }),
                                                /*#__PURE__*/ (0,jsx_runtime.jsx)("p", {
                                                    className: "col-span-6 block w-full rounded-md border-gray-300 text-center shadow-sm sm:col-span-3 sm:text-sm",
                                                    children: "Tiebreak"
                                                })
                                            ]
                                        }),
                                        /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                                            className: "flex gap-x-2",
                                            children: [
                                                /*#__PURE__*/ (0,jsx_runtime.jsx)(formik_esm/* Field */.gN, {
                                                    name: "home_set_one",
                                                    children: function(param) {
                                                        var field = param.field, meta = param.meta;
                                                        /*#__PURE__*/ return (0,jsx_runtime.jsxs)("div", {
                                                            className: "col-span-6 block w-full sm:col-span-3",
                                                            children: [
                                                                /*#__PURE__*/ (0,jsx_runtime.jsx)("label", {
                                                                    htmlFor: "home_set_one",
                                                                    className: "sr-only",
                                                                    children: "Hemma set 1"
                                                                }),
                                                                /*#__PURE__*/ (0,jsx_runtime.jsx)("input", _objectSpread({}, field, {
                                                                    required: true,
                                                                    type: "number",
                                                                    className: "mt-1 block w-full rounded-md border-gray-300 text-center shadow-sm focus:border-indigo-500 focus:ring-indigo-500 sm:text-sm"
                                                                })),
                                                                meta.touched && meta.error && /*#__PURE__*/ (0,jsx_runtime.jsx)("p", {
                                                                    className: "pt-2 text-xs italic text-red-500",
                                                                    children: meta.error
                                                                })
                                                            ]
                                                        });
                                                    }
                                                }),
                                                /*#__PURE__*/ (0,jsx_runtime.jsx)(formik_esm/* Field */.gN, {
                                                    name: "home_set_two",
                                                    children: function(param) {
                                                        var field = param.field, meta = param.meta;
                                                        /*#__PURE__*/ return (0,jsx_runtime.jsxs)("div", {
                                                            className: "col-span-6 block w-full sm:col-span-3",
                                                            children: [
                                                                /*#__PURE__*/ (0,jsx_runtime.jsx)("label", {
                                                                    htmlFor: "home_set_two",
                                                                    className: "sr-only",
                                                                    children: "Hemma set 2"
                                                                }),
                                                                /*#__PURE__*/ (0,jsx_runtime.jsx)("input", _objectSpread({}, field, {
                                                                    required: true,
                                                                    type: "number",
                                                                    className: "mt-1 block w-full rounded-md border-gray-300 text-center shadow-sm focus:border-indigo-500 focus:ring-indigo-500 sm:text-sm"
                                                                })),
                                                                meta.touched && meta.error && /*#__PURE__*/ (0,jsx_runtime.jsx)("p", {
                                                                    className: "pt-2 text-xs italic text-red-500",
                                                                    children: meta.error
                                                                })
                                                            ]
                                                        });
                                                    }
                                                }),
                                                /*#__PURE__*/ (0,jsx_runtime.jsx)(formik_esm/* Field */.gN, {
                                                    name: "home_set_three",
                                                    children: function(param) {
                                                        var field = param.field, meta = param.meta;
                                                        /*#__PURE__*/ return (0,jsx_runtime.jsxs)("div", {
                                                            className: "col-span-6 block w-full sm:col-span-3",
                                                            children: [
                                                                /*#__PURE__*/ (0,jsx_runtime.jsx)("label", {
                                                                    htmlFor: "home_set_three",
                                                                    className: "sr-only",
                                                                    children: "Hemma set 3"
                                                                }),
                                                                /*#__PURE__*/ (0,jsx_runtime.jsx)("input", _objectSpread({}, field, {
                                                                    required: true,
                                                                    type: "number",
                                                                    className: "mt-1 block w-full rounded-md border-gray-300 text-center shadow-sm focus:border-indigo-500 focus:ring-indigo-500 sm:text-sm"
                                                                })),
                                                                meta.touched && meta.error && /*#__PURE__*/ (0,jsx_runtime.jsx)("p", {
                                                                    className: "pt-2 text-xs italic text-red-500",
                                                                    children: meta.error
                                                                })
                                                            ]
                                                        });
                                                    }
                                                }),
                                                /*#__PURE__*/ (0,jsx_runtime.jsx)(formik_esm/* Field */.gN, {
                                                    name: "home_tiebreak",
                                                    children: function(param) {
                                                        var field = param.field, meta = param.meta;
                                                        /*#__PURE__*/ return (0,jsx_runtime.jsxs)("div", {
                                                            className: "col-span-6 block w-full sm:col-span-3",
                                                            children: [
                                                                /*#__PURE__*/ (0,jsx_runtime.jsx)("label", {
                                                                    htmlFor: "home_tiebreak",
                                                                    className: "sr-only",
                                                                    children: "Hemma tiebreak"
                                                                }),
                                                                /*#__PURE__*/ (0,jsx_runtime.jsx)("input", _objectSpread({}, field, {
                                                                    required: true,
                                                                    type: "number",
                                                                    className: "mt-1 block w-full rounded-md border-gray-300 text-center shadow-sm focus:border-indigo-500 focus:ring-indigo-500 sm:text-sm"
                                                                })),
                                                                meta.touched && meta.error && /*#__PURE__*/ (0,jsx_runtime.jsx)("p", {
                                                                    className: "pt-2 text-xs italic text-red-500",
                                                                    children: meta.error
                                                                })
                                                            ]
                                                        });
                                                    }
                                                })
                                            ]
                                        }),
                                        /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                                            className: "flex gap-x-2",
                                            children: [
                                                /*#__PURE__*/ (0,jsx_runtime.jsx)(formik_esm/* Field */.gN, {
                                                    name: "away_set_one",
                                                    children: function(param) {
                                                        var field = param.field, meta = param.meta;
                                                        /*#__PURE__*/ return (0,jsx_runtime.jsxs)("div", {
                                                            className: "col-span-6 block w-full sm:col-span-3",
                                                            children: [
                                                                /*#__PURE__*/ (0,jsx_runtime.jsx)("label", {
                                                                    htmlFor: "away_set_one",
                                                                    className: "sr-only",
                                                                    children: "Borta set 1"
                                                                }),
                                                                /*#__PURE__*/ (0,jsx_runtime.jsx)("input", _objectSpread({}, field, {
                                                                    required: true,
                                                                    type: "number",
                                                                    className: "mt-1 block w-full rounded-md border-gray-300 text-center shadow-sm focus:border-indigo-500 focus:ring-indigo-500 sm:text-sm"
                                                                })),
                                                                meta.touched && meta.error && /*#__PURE__*/ (0,jsx_runtime.jsx)("p", {
                                                                    className: "pt-2 text-xs italic text-red-500",
                                                                    children: meta.error
                                                                })
                                                            ]
                                                        });
                                                    }
                                                }),
                                                /*#__PURE__*/ (0,jsx_runtime.jsx)(formik_esm/* Field */.gN, {
                                                    name: "away_set_two",
                                                    children: function(param) {
                                                        var field = param.field, meta = param.meta;
                                                        /*#__PURE__*/ return (0,jsx_runtime.jsxs)("div", {
                                                            className: "col-span-6 block w-full sm:col-span-3",
                                                            children: [
                                                                /*#__PURE__*/ (0,jsx_runtime.jsx)("label", {
                                                                    htmlFor: "away_set_two",
                                                                    className: "sr-only",
                                                                    children: "Borta set 2"
                                                                }),
                                                                /*#__PURE__*/ (0,jsx_runtime.jsx)("input", _objectSpread({}, field, {
                                                                    required: true,
                                                                    type: "number",
                                                                    className: "mt-1 block w-full rounded-md border-gray-300 text-center shadow-sm focus:border-indigo-500 focus:ring-indigo-500 sm:text-sm"
                                                                })),
                                                                meta.touched && meta.error && /*#__PURE__*/ (0,jsx_runtime.jsx)("p", {
                                                                    className: "pt-2 text-xs italic text-red-500",
                                                                    children: meta.error
                                                                })
                                                            ]
                                                        });
                                                    }
                                                }),
                                                /*#__PURE__*/ (0,jsx_runtime.jsx)(formik_esm/* Field */.gN, {
                                                    name: "away_set_three",
                                                    children: function(param) {
                                                        var field = param.field, meta = param.meta;
                                                        /*#__PURE__*/ return (0,jsx_runtime.jsxs)("div", {
                                                            className: "col-span-6 block w-full sm:col-span-3",
                                                            children: [
                                                                /*#__PURE__*/ (0,jsx_runtime.jsx)("label", {
                                                                    htmlFor: "away_set_three",
                                                                    className: "sr-only",
                                                                    children: "Borta set 3"
                                                                }),
                                                                /*#__PURE__*/ (0,jsx_runtime.jsx)("input", _objectSpread({}, field, {
                                                                    required: true,
                                                                    type: "number",
                                                                    className: "mt-1 block w-full rounded-md border-gray-300 text-center shadow-sm focus:border-indigo-500 focus:ring-indigo-500 sm:text-sm"
                                                                })),
                                                                meta.touched && meta.error && /*#__PURE__*/ (0,jsx_runtime.jsx)("p", {
                                                                    className: "pt-2 text-xs italic text-red-500",
                                                                    children: meta.error
                                                                })
                                                            ]
                                                        });
                                                    }
                                                }),
                                                /*#__PURE__*/ (0,jsx_runtime.jsx)(formik_esm/* Field */.gN, {
                                                    name: "away_tiebreak",
                                                    children: function(param) {
                                                        var field = param.field, meta = param.meta;
                                                        /*#__PURE__*/ return (0,jsx_runtime.jsxs)("div", {
                                                            className: "col-span-6 block w-full sm:col-span-3",
                                                            children: [
                                                                /*#__PURE__*/ (0,jsx_runtime.jsx)("label", {
                                                                    htmlFor: "away_tiebreak",
                                                                    className: "sr-only",
                                                                    children: "Borta tiebreak"
                                                                }),
                                                                /*#__PURE__*/ (0,jsx_runtime.jsx)("input", _objectSpread({}, field, {
                                                                    required: true,
                                                                    type: "number",
                                                                    className: "mt-1 block w-full rounded-md border-gray-300 text-center shadow-sm focus:border-indigo-500 focus:ring-indigo-500 sm:text-sm"
                                                                })),
                                                                meta.touched && meta.error && /*#__PURE__*/ (0,jsx_runtime.jsx)("p", {
                                                                    className: "pt-2 text-xs italic text-red-500",
                                                                    children: meta.error
                                                                })
                                                            ]
                                                        });
                                                    }
                                                })
                                            ]
                                        })
                                    ]
                                })
                            }),
                            /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                                className: "py-3 text-right",
                                children: [
                                    /*#__PURE__*/ (0,jsx_runtime.jsx)(next_link["default"], {
                                        href: "/series/".concat(seriesContext.id, "/match/").concat(match.match_public_id),
                                        children: /*#__PURE__*/ (0,jsx_runtime.jsx)("a", {
                                            className: "mr-2 rounded-md border border-transparent bg-indigo-50 py-2 px-4 text-sm font-medium text-indigo-900 shadow-sm hover:bg-indigo-100 focus:outline-none focus:ring-2 focus:ring-indigo-500 focus:ring-offset-2 focus:ring-offset-gray-50",
                                            children: "Avbryt"
                                        })
                                    }),
                                    /*#__PURE__*/ (0,jsx_runtime.jsx)("button", {
                                        type: "submit",
                                        className: "inline-flex justify-center rounded-md border border-transparent bg-indigo-600 py-2 px-4 text-sm font-medium text-white shadow-sm hover:bg-indigo-700 focus:outline-none focus:ring-2 focus:ring-indigo-500 focus:ring-offset-2",
                                        disabled: formikBag.isSubmitting || !formikBag.isValid,
                                        children: translation.button.text
                                    })
                                ]
                            })
                        ]
                    }));
                }
            })
        ]
    }));
};

;// CONCATENATED MODULE: ./components/ds/02-molecules/admin-signup-row-item/types.ts


var SignupState = es6/* union */.G0([
    es6/* literal */.i0('created'),
    es6/* literal */.i0('sent'),
    es6/* literal */.i0('accepted'),
    es6/* literal */.i0('rejected'),
    es6/* literal */.i0('reminder_sent'), 
]);
var Signup = es6/* intersection */.jV([
    es6/* type */.dt({
        invitation_public_id: UUID/* UUID */.h,
        team_name: es6/* string */.Z_,
        team_id: UUID/* UUID */.h,
        series_round_id: es6/* number */.pk,
        series_round_name: es6/* string */.Z_,
        series_name: es6/* string */.Z_,
        series_round_start: es6/* string */.Z_,
        series_round_end: es6/* string */.Z_,
        team_series_group: es6/* string */.Z_,
        team_series_length: es6/* string */.Z_,
        invite_link: es6/* string */.Z_,
        reminder_text: es6/* string */.Z_
    }),
    es6/* partial */.r$({
        signup_id: es6/* union */.G0([
            es6/* null */.lB,
            es6/* number */.pk
        ]),
        signup_public_id: es6/* union */.G0([
            es6/* null */.lB,
            UUID/* UUID */.h
        ]),
        signup_additional_answers: es6/* union */.G0([
            es6/* null */.lB,
            es6/* UnknownRecord */.mI
        ]),
        signup_created_at: es6/* union */.G0([
            es6/* null */.lB,
            es6/* string */.Z_
        ]),
        signup_state: es6/* union */.G0([
            es6/* null */.lB,
            SignupState
        ]),
        signup_comment: es6/* union */.G0([
            es6/* null */.lB,
            es6/* string */.Z_
        ]),
        user_name: es6/* union */.G0([
            es6/* null */.lB,
            es6/* string */.Z_
        ]),
        user_id: es6/* union */.G0([
            es6/* null */.lB,
            UUID/* UUID */.h
        ]),
        team_member_id: es6/* union */.G0([
            es6/* null */.lB,
            es6/* number */.pk
        ])
    }), 
]);

// EXTERNAL MODULE: ./node_modules/lodash/lodash.js
var lodash = __webpack_require__(6486);
// EXTERNAL MODULE: ./node_modules/@heroicons/react/outline/esm/index.js + 230 modules
var outline_esm = __webpack_require__(3801);
;// CONCATENATED MODULE: ./components/ds/02-molecules/admin-signup-details/index.tsx







function admin_signup_details_asyncGeneratorStep(gen, resolve, reject, _next, _throw, key, arg) {
    try {
        var info = gen[key](arg);
        var value = info.value;
    } catch (error) {
        reject(error);
        return;
    }
    if (info.done) {
        resolve(value);
    } else {
        Promise.resolve(value).then(_next, _throw);
    }
}
function admin_signup_details_asyncToGenerator(fn) {
    return function() {
        var self = this, args = arguments;
        return new Promise(function(resolve, reject) {
            var gen = fn.apply(self, args);
            function _next(value) {
                admin_signup_details_asyncGeneratorStep(gen, resolve, reject, _next, _throw, "next", value);
            }
            function _throw(err) {
                admin_signup_details_asyncGeneratorStep(gen, resolve, reject, _next, _throw, "throw", err);
            }
            _next(undefined);
        });
    };
}
var ClipboardCopy = function(param) {
    var copyText = param.copyText, type = param.type;
    var ref = (0,react.useState)(false), isCopied = ref[0], setIsCopied = ref[1];
    function copyTextToClipboard(text) {
        return _copyTextToClipboard.apply(this, arguments);
    }
    function _copyTextToClipboard() {
        _copyTextToClipboard = // This is the function we wrote earlier
        admin_signup_details_asyncToGenerator(runtime_default().mark(function _callee(text) {
            return runtime_default().wrap(function _callee$(_ctx) {
                while(1)switch(_ctx.prev = _ctx.next){
                    case 0:
                        if (!('clipboard' in navigator)) {
                            _ctx.next = 6;
                            break;
                        }
                        _ctx.next = 3;
                        return navigator.clipboard.writeText(text);
                    case 3:
                        return _ctx.abrupt("return", _ctx.sent);
                    case 6:
                        return _ctx.abrupt("return", document.execCommand('copy', true, text));
                    case 7:
                    case "end":
                        return _ctx.stop();
                }
            }, _callee);
        }));
        return _copyTextToClipboard.apply(this, arguments);
    }
    // onClick handler function for the copy button
    var handleCopyClick = function() {
        // Asynchronously call copyTextToClipboard
        copyTextToClipboard(copyText).then(function() {
            // If successful, update the isCopied state value
            setIsCopied(true);
            setTimeout(function() {
                setIsCopied(false);
            }, 1500);
        }).catch(function(err) {
            console.log(err);
        });
    };
    return(/*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
        className: "flex gap-x-2 py-4 w-full items-end",
        children: [
            type === 'input' ? /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                className: "relative border border-gray-300 rounded-md px-3 py-2 shadow-sm focus-within:ring-1 focus-within:ring-indigo-600 focus-within:border-indigo-600",
                children: [
                    /*#__PURE__*/ (0,jsx_runtime.jsx)("label", {
                        htmlFor: "name",
                        className: "absolute -top-2 left-2 -mt-px inline-block px-1 bg-white text-xs font-medium text-gray-900",
                        children: "L\xe4nk till inbjudan"
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)("input", {
                        type: "text",
                        value: copyText,
                        className: "block w-full border-0 p-0 text-gray-900 placeholder-gray-500 focus:ring-0 sm:text-sm",
                        readOnly: true
                    })
                ]
            }) : null,
            type === 'textarea' ? /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                children: [
                    /*#__PURE__*/ (0,jsx_runtime.jsx)("label", {
                        htmlFor: "comment",
                        className: "block text-sm font-medium text-gray-700",
                        children: "Kopiera och skicka"
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                        className: "mt-1",
                        children: /*#__PURE__*/ (0,jsx_runtime.jsx)("textarea", {
                            rows: 4,
                            className: "shadow-sm focus:ring-indigo-500 focus:border-indigo-500 block w-full sm:text-sm border-gray-300 rounded-md",
                            value: copyText,
                            readOnly: true
                        })
                    })
                ]
            }) : null,
            /*#__PURE__*/ (0,jsx_runtime.jsx)("button", {
                onClick: handleCopyClick,
                className: "inline-flex items-center px-4 py-2 border border-transparent text-sm font-medium rounded-md shadow-sm text-white bg-indigo-600 hover:bg-indigo-700 focus:outline-none focus:ring-2 focus:ring-offset-2 focus:ring-indigo-500",
                children: /*#__PURE__*/ (0,jsx_runtime.jsx)("span", {
                    children: isCopied ? 'Kopierad!' : /*#__PURE__*/ (0,jsx_runtime.jsx)("svg", {
                        xmlns: "http://www.w3.org/2000/svg",
                        className: "h-5 w-5",
                        fill: "none",
                        viewBox: "0 0 24 24",
                        stroke: "currentColor",
                        children: /*#__PURE__*/ (0,jsx_runtime.jsx)("path", {
                            strokeLinecap: "round",
                            strokeLinejoin: "round",
                            strokeWidth: 2,
                            d: "M8 5H6a2 2 0 00-2 2v12a2 2 0 002 2h10a2 2 0 002-2v-1M8 5a2 2 0 002 2h2a2 2 0 002-2M8 5a2 2 0 012-2h2a2 2 0 012 2m0 0h2a2 2 0 012 2v3m2 4H10m0 0l3-3m-3 3l3 3"
                        })
                    })
                })
            })
        ]
    }));
};
var SignupDetails = function(param) {
    var signup = param.signup, round = param.round, series = param.series, _expanded = param.expanded, expanded = _expanded === void 0 ? false : _expanded;
    var signupState = signup && signup.signup_created_at ? /*#__PURE__*/ (0,jsx_runtime.jsxs)(jsx_runtime.Fragment, {
        children: [
            "Anm\xe4lde sig",
            ' ',
            /*#__PURE__*/ (0,jsx_runtime.jsx)("time", {
                dateTime: luxon/* DateTime.fromISO */.ou.fromISO(signup.signup_created_at).toISODate(),
                children: luxon/* DateTime.fromISO */.ou.fromISO(signup.signup_created_at).setLocale('sv').toLocaleString(luxon/* DateTime.DATETIME_SHORT */.ou.DATETIME_SHORT)
            })
        ]
    }) : signup && signup.signup_state === 'rejected' ? /*#__PURE__*/ (0,jsx_runtime.jsxs)(jsx_runtime.Fragment, {
        children: [
            "Kommentar:",
            ' ',
            /*#__PURE__*/ (0,jsx_runtime.jsx)("i", {
                children: signup.signup_comment ? signup.signup_comment : 'Ingen l\xe4mnad vid avanm\xe4lan.'
            })
        ]
    }) : /*#__PURE__*/ (0,jsx_runtime.jsx)(jsx_runtime.Fragment, {
        children: "Har inte anm\xe4lt sig \xe4nnu."
    });
    var groupBadge = function() {
        switch(signup.team_series_group){
            case 'morning':
                return(/*#__PURE__*/ (0,jsx_runtime.jsx)("span", {
                    className: "inline-flex items-center px-2 py-0.5 rounded text-xs font-medium bg-blue-100 text-blue-800",
                    children: "Frukost"
                }));
            case 'lunch':
                return(/*#__PURE__*/ (0,jsx_runtime.jsx)("span", {
                    className: "inline-flex items-center px-2 py-0.5 rounded text-xs font-medium bg-green-100 text-green-800",
                    children: "Lunch"
                }));
            case 'any':
                return(/*#__PURE__*/ (0,jsx_runtime.jsx)("span", {
                    className: "inline-flex items-center px-2 py-0.5 rounded text-xs font-medium bg-purple-100 text-purple-800",
                    children: "G\xe4st"
                }));
            default:
                return(/*#__PURE__*/ (0,jsx_runtime.jsx)("span", {
                    className: "inline-flex items-center px-2 py-0.5 rounded text-xs font-medium bg-purple-100 text-purple-800",
                    children: "G\xe4st"
                }));
        }
    };
    var stateBadge = function() {
        switch(signup.signup_state){
            case 'created':
                return(/*#__PURE__*/ (0,jsx_runtime.jsx)("span", {
                    className: "inline-flex items-center px-2 py-0.5 rounded text-xs font-medium bg-gray-100 text-gray-800",
                    children: "Skapad"
                }));
            case 'sent':
                return(/*#__PURE__*/ (0,jsx_runtime.jsx)("span", {
                    className: "inline-flex items-center px-2 py-0.5 rounded text-xs font-medium bg-yellow-100 text-yellow-800",
                    children: "Skickat"
                }));
            case 'accepted':
                return(/*#__PURE__*/ (0,jsx_runtime.jsx)("span", {
                    className: "inline-flex items-center px-2 py-0.5 rounded text-xs font-medium bg-green-100 text-green-800",
                    children: "Accepterat"
                }));
            case 'rejected':
                return(/*#__PURE__*/ (0,jsx_runtime.jsx)("span", {
                    className: "inline-flex items-center px-2 py-0.5 rounded text-xs font-medium bg-red-100 text-red-800",
                    children: "Tackat nej (ingen ers\xe4ttare)"
                }));
            case 'reminder_sent':
                return(/*#__PURE__*/ (0,jsx_runtime.jsx)("span", {
                    className: "inline-flex items-center px-2 py-0.5 rounded text-xs font-medium bg-purple-100 text-purple-800",
                    children: "P\xe5minnelse skickad"
                }));
            default:
                return(/*#__PURE__*/ (0,jsx_runtime.jsx)("span", {
                    className: "inline-flex items-center px-2 py-0.5 rounded text-xs font-medium bg-pink-100 text-pink-800",
                    children: "Ov\xe4ntad status"
                }));
        }
    };
    var answers = (0,lodash.get)(signup, 'signup_additional_answers.answers', []);
    return(/*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
        className: "flex items-center px-4 py-4 sm:px-6",
        children: [
            /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                className: "min-w-0 flex-1 flex items-center",
                children: /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                    className: "min-w-0 flex-1 px-4 md:grid md:grid-cols-2 md:gap-4",
                    children: [
                        /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                            children: [
                                /*#__PURE__*/ (0,jsx_runtime.jsx)("p", {
                                    className: "text-sm font-medium text-indigo-600 truncate",
                                    children: signup.user_name
                                }),
                                /*#__PURE__*/ (0,jsx_runtime.jsxs)("p", {
                                    className: "mt-2 flex items-center text-sm text-gray-500",
                                    children: [
                                        /*#__PURE__*/ (0,jsx_runtime.jsx)(outline_esm/* LinkIcon */.xPt, {
                                            className: "flex-shrink-0 mr-1.5 h-5 w-5 text-gray-400",
                                            "aria-hidden": "true"
                                        }),
                                        /*#__PURE__*/ (0,jsx_runtime.jsx)("span", {
                                            className: "truncate",
                                            children: signup.team_name
                                        })
                                    ]
                                })
                            ]
                        }),
                        /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                            className: "".concat(expanded ? 'block' : 'hidden md:block'),
                            children: /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                                className: "flex flex-col gap-y-2 pt-2",
                                children: [
                                    /*#__PURE__*/ (0,jsx_runtime.jsx)("p", {
                                        className: "text-sm text-gray-900",
                                        children: signupState
                                    }),
                                    /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                                        className: "flex gap-x-1",
                                        children: [
                                            /*#__PURE__*/ (0,jsx_runtime.jsx)("p", {
                                                className: "mt-2 flex items-center text-sm text-gray-500",
                                                children: stateBadge()
                                            }),
                                            /*#__PURE__*/ (0,jsx_runtime.jsx)("p", {
                                                className: "mt-2 flex items-center text-sm text-gray-500",
                                                children: groupBadge()
                                            })
                                        ]
                                    }),
                                    answers.filter(function(a) {
                                        return a.answer;
                                    }).map(function(answer) {
                                        /*#__PURE__*/ return (0,jsx_runtime.jsxs)("p", {
                                            className: "mt-2 flex items-center gap-x-2 text-sm text-gray-500 bg-gray-50 p-2",
                                            children: [
                                                /*#__PURE__*/ (0,jsx_runtime.jsx)("strong", {
                                                    children: answer.question
                                                }),
                                                /*#__PURE__*/ (0,jsx_runtime.jsx)("span", {
                                                    children: answer.answer
                                                })
                                            ]
                                        }, answer.question);
                                    }),
                                    signup && (signup.signup_state === 'sent' || signup.signup_state === 'created' || signup.signup_state === 'reminder_sent' || signup.signup_state === 'accepted') ? /*#__PURE__*/ (0,jsx_runtime.jsx)(ClipboardCopy, {
                                        copyText: signup.invite_link,
                                        type: "input"
                                    }) : null,
                                    signup && (signup.signup_state === 'sent' || signup.signup_state === 'reminder_sent') ? /*#__PURE__*/ (0,jsx_runtime.jsx)("p", {
                                        className: "mt-2 flex items-center gap-x-2 text-sm text-gray-500",
                                        children: /*#__PURE__*/ (0,jsx_runtime.jsx)(ClipboardCopy, {
                                            copyText: signup.reminder_text,
                                            type: "textarea"
                                        })
                                    }) : null
                                ]
                            })
                        })
                    ]
                })
            }),
            signup && signup.user_id && !expanded ? /*#__PURE__*/ (0,jsx_runtime.jsx)(next_link["default"], {
                href: "/admin/series/".concat(series.id, "/round/").concat(round.round_public_id, "/signup/").concat(signup.signup_public_id, "/view"),
                children: /*#__PURE__*/ (0,jsx_runtime.jsx)(outline_esm/* ChevronRightIcon */.XCv, {
                    className: "h-5 w-5 text-gray-400",
                    "aria-hidden": "true"
                })
            }) : null
        ]
    }));
};

;// CONCATENATED MODULE: ./components/ds/02-molecules/admin-signup-row-item/index.tsx





var SignupRowItem = function(param) {
    var signup = param.signup, round = param.round, series = param.series;
    return(/*#__PURE__*/ (0,jsx_runtime.jsx)("li", {
        className: "".concat(signup && signup.signup_state === 'rejected' ? 'bg-red-50' : 'bg-white', " hover:bg-gray-50"),
        children: /*#__PURE__*/ (0,jsx_runtime.jsx)(SignupDetails, {
            signup: signup,
            round: round,
            series: series,
            expanded: (0,lodash.isEmpty)(signup.signup_public_id)
        })
    }));
};

;// CONCATENATED MODULE: ./components/ds/02-molecules/admin-round-row-item/types.ts


var RoundStatus = es6/* union */.G0([
    es6/* literal */.i0('current'),
    es6/* literal */.i0('next_week'),
    es6/* literal */.i0('upcoming'),
    es6/* literal */.i0('past'),
    es6/* literal */.i0('unknown'),
    es6/* literal */.i0('dynamic'), 
]);
var RoundGroup = es6/* union */.G0([
    es6/* literal */.i0('morning'),
    es6/* literal */.i0('lunch'),
    es6/* literal */.i0('unknown'),
    es6/* literal */.i0('dynamic'), 
]);
var AdminRound = es6/* type */.dt({
    series_id: UUID/* UUID */.h,
    series_name: es6/* string */.Z_,
    round_id: es6/* number */.pk,
    round_public_id: UUID/* UUID */.h,
    round_name: es6/* string */.Z_,
    round_start: es6/* string */.Z_,
    round_end: es6/* string */.Z_,
    start_hour: es6/* number */.pk,
    start_minute: es6/* number */.pk,
    start_week: es6/* number */.pk,
    current_week: es6/* number */.pk,
    status: RoundStatus,
    group: RoundGroup,
    no_of_accepted_signups: es6/* number */.pk,
    no_of_rejected_signups: es6/* number */.pk,
    no_of_pending_invitations: es6/* number */.pk
});

;// CONCATENATED MODULE: ./components/ds/02-molecules/admin-round-row-item/index.tsx






var AdminRoundRowItem = function(param) {
    var round = param.round;
    var groupBadge = function() {
        switch(round.group){
            case 'morning':
                return(/*#__PURE__*/ (0,jsx_runtime.jsx)("span", {
                    className: "inline-flex items-center px-2 py-0.5 rounded text-xs font-medium bg-blue-100 text-blue-800",
                    children: "Morgon"
                }));
            case 'lunch':
                return(/*#__PURE__*/ (0,jsx_runtime.jsx)("span", {
                    className: "inline-flex items-center px-2 py-0.5 rounded text-xs font-medium bg-purple-100 text-purple-800",
                    children: "Lunch"
                }));
            case 'dynamic':
                return(/*#__PURE__*/ (0,jsx_runtime.jsx)("span", {
                    className: "inline-flex items-center px-2 py-0.5 rounded text-xs font-medium bg-yellow-100 text-yellow-800",
                    children: "Dynamiskt"
                }));
            default:
                return(/*#__PURE__*/ (0,jsx_runtime.jsx)("span", {
                    className: "inline-flex items-center px-2 py-0.5 rounded text-xs font-medium bg-pink-100 text-pink-800",
                    children: "Ov\xe4ntad status"
                }));
        }
    };
    var dtStart = luxon/* DateTime.fromISO */.ou.fromISO(round.round_start);
    var dtEnd = luxon/* DateTime.fromISO */.ou.fromISO(round.round_end);
    var rowContent = /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
        className: "flex items-center px-4 py-4 sm:px-6",
        children: [
            /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                className: "min-w-0 flex-1 flex items-center",
                children: /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                    className: "min-w-0 flex-1 px-4 md:grid md:grid-cols-2 md:gap-4",
                    children: [
                        /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                            children: /*#__PURE__*/ (0,jsx_runtime.jsxs)("p", {
                                className: "text-sm font-medium text-indigo-600 truncate inline-flex gap-x-3",
                                children: [
                                    /*#__PURE__*/ (0,jsx_runtime.jsx)("span", {
                                        children: round.round_name
                                    }),
                                    /*#__PURE__*/ (0,jsx_runtime.jsxs)("span", {
                                        className: "flex gap-x-2",
                                        children: [
                                            /*#__PURE__*/ (0,jsx_runtime.jsx)(outline_esm/* DotsCircleHorizontalIcon */.Gp6, {
                                                className: "h-5 w-5 text-yellow-400",
                                                "aria-hidden": "true"
                                            }),
                                            round.no_of_pending_invitations
                                        ]
                                    }),
                                    /*#__PURE__*/ (0,jsx_runtime.jsxs)("span", {
                                        className: "flex gap-x-2",
                                        children: [
                                            /*#__PURE__*/ (0,jsx_runtime.jsx)(outline_esm/* CheckCircleIcon */.rE2, {
                                                className: "h-5 w-5 text-green-400",
                                                "aria-hidden": "true"
                                            }),
                                            round.no_of_accepted_signups
                                        ]
                                    }),
                                    /*#__PURE__*/ (0,jsx_runtime.jsxs)("span", {
                                        className: "flex gap-x-2",
                                        children: [
                                            /*#__PURE__*/ (0,jsx_runtime.jsx)(outline_esm/* StopIcon */.wNq, {
                                                className: "h-5 w-5 text-red-400",
                                                "aria-hidden": "true"
                                            }),
                                            round.no_of_rejected_signups
                                        ]
                                    })
                                ]
                            })
                        }),
                        /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                            className: "hidden md:block",
                            children: [
                                /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                    children: /*#__PURE__*/ (0,jsx_runtime.jsx)("p", {
                                        className: "mt-2 flex items-center text-sm text-gray-500",
                                        children: groupBadge()
                                    })
                                }),
                                /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                    children: /*#__PURE__*/ (0,jsx_runtime.jsx)("p", {
                                        className: "mt-2 flex items-center text-sm text-gray-500",
                                        children: dtStart.setLocale('sv').toLocaleString(luxon/* DateTime.DATE_MED_WITH_WEEKDAY */.ou.DATE_MED_WITH_WEEKDAY)
                                    })
                                }),
                                /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                    children: /*#__PURE__*/ (0,jsx_runtime.jsxs)("p", {
                                        className: "mt-2 flex items-center text-sm text-gray-500",
                                        children: [
                                            dtStart.setLocale('sv').toLocaleString(luxon/* DateTime.TIME_24_SIMPLE */.ou.TIME_24_SIMPLE),
                                            " till",
                                            ' ',
                                            dtEnd.setLocale('sv').toLocaleString(luxon/* DateTime.TIME_24_SIMPLE */.ou.TIME_24_SIMPLE)
                                        ]
                                    })
                                })
                            ]
                        })
                    ]
                })
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                children: /*#__PURE__*/ (0,jsx_runtime.jsx)(outline_esm/* ChevronRightIcon */.XCv, {
                    className: "h-5 w-5 text-gray-400",
                    "aria-hidden": "true"
                })
            })
        ]
    });
    return(/*#__PURE__*/ (0,jsx_runtime.jsx)("li", {
        children: /*#__PURE__*/ (0,jsx_runtime.jsx)(next_link["default"], {
            href: "/admin/series/".concat(round.series_id, "/round/").concat(round.round_public_id),
            children: /*#__PURE__*/ (0,jsx_runtime.jsx)("a", {
                className: "block hover:bg-gray-50",
                children: rowContent
            })
        })
    }));
};

;// CONCATENATED MODULE: ./components/ds/02-molecules/admin-round-details-card/types.ts


var types_RoundStatus = es6/* union */.G0([
    es6/* literal */.i0('current'),
    es6/* literal */.i0('next_week'),
    es6/* literal */.i0('upcoming'),
    es6/* literal */.i0('past'),
    es6/* literal */.i0('unknown'),
    es6/* literal */.i0('dynamic'), 
]);
var types_RoundGroup = es6/* union */.G0([
    es6/* literal */.i0('morning'),
    es6/* literal */.i0('lunch'),
    es6/* literal */.i0('unknown'),
    es6/* literal */.i0('dynamic'), 
]);
var RoundDetails = es6/* type */.dt({
    series_id: UUID/* UUID */.h,
    series_name: es6/* string */.Z_,
    round_id: es6/* number */.pk,
    round_public_id: UUID/* UUID */.h,
    round_name: es6/* string */.Z_,
    round_start: es6/* string */.Z_,
    round_end: es6/* string */.Z_,
    start_hour: es6/* number */.pk,
    start_minute: es6/* number */.pk,
    start_week: es6/* number */.pk,
    current_week: es6/* number */.pk,
    status: types_RoundStatus,
    group: types_RoundGroup,
    invitations: es6/* number */.pk,
    accepted: es6/* number */.pk,
    declined: es6/* number */.pk,
    pending: es6/* number */.pk
});

;// CONCATENATED MODULE: ./components/ds/02-molecules/admin-round-details-card/generate-matches-button.tsx






function generate_matches_button_asyncGeneratorStep(gen, resolve, reject, _next, _throw, key, arg) {
    try {
        var info = gen[key](arg);
        var value = info.value;
    } catch (error) {
        reject(error);
        return;
    }
    if (info.done) {
        resolve(value);
    } else {
        Promise.resolve(value).then(_next, _throw);
    }
}
function generate_matches_button_asyncToGenerator(fn) {
    return function() {
        var self = this, args = arguments;
        return new Promise(function(resolve, reject) {
            var gen = fn.apply(self, args);
            function _next(value) {
                generate_matches_button_asyncGeneratorStep(gen, resolve, reject, _next, _throw, "next", value);
            }
            function _throw(err) {
                generate_matches_button_asyncGeneratorStep(gen, resolve, reject, _next, _throw, "throw", err);
            }
            _next(undefined);
        });
    };
}

var GenerateMatchesButton = function(param) {
    var round = param.round, series = param.series;
    var ref = (0,react.useState)(false), loading = ref[0], setLoading = ref[1];
    var router = (0,next_router.useRouter)();
    var generateMatches = function() {
        var _ref = generate_matches_button_asyncToGenerator(runtime_default().mark(function _callee() {
            var GenerateMatchRes, GenerateMatchesResData;
            return runtime_default().wrap(function _callee$(_ctx) {
                while(1)switch(_ctx.prev = _ctx.next){
                    case 0:
                        if (!confirm('\xc4r du s\xe4ker p\xe5 att du vill generera matcher?')) {
                            _ctx.next = 19;
                            break;
                        }
                        setLoading(true);
                        _ctx.next = 4;
                        return fetch("/api/admin/series/".concat(series.id, "/round/").concat(round.round_public_id, "/generate-matches"), {
                            method: 'POST',
                            headers: {
                                'Content-Type': 'application/json'
                            }
                        });
                    case 4:
                        GenerateMatchRes = _ctx.sent;
                        if (!(GenerateMatchRes.status !== 200)) {
                            _ctx.next = 9;
                            break;
                        }
                        setLoading(false);
                        console.error("Got a non 200 response from the backend.", {
                            GenerateMatchRes: GenerateMatchRes
                        });
                        return _ctx.abrupt("return");
                    case 9:
                        _ctx.next = 11;
                        return GenerateMatchRes.json();
                    case 11:
                        GenerateMatchesResData = _ctx.sent;
                        if (GenerateMatchesResData.success) {
                            _ctx.next = 18;
                            break;
                        }
                        setLoading(false);
                        console.error("Got a non success response from the backend ".concat(GenerateMatchesResData.code, "."), {
                            GenerateMatchesResData: GenerateMatchesResData
                        });
                        return _ctx.abrupt("return");
                    case 18:
                        {
                            alert("Skapade ".concat(GenerateMatchesResData.matches, " matcher."));
                            setLoading(false);
                            router.replace(router.asPath);
                        }
                    case 19:
                    case "end":
                        return _ctx.stop();
                }
            }, _callee);
        }));
        return function generateMatches() {
            return _ref.apply(this, arguments);
        };
    }();
    return(/*#__PURE__*/ (0,jsx_runtime.jsxs)("button", {
        type: "button",
        className: "inline-flex items-center px-4 py-2 border border-transparent shadow-sm text-sm font-medium rounded-md text-white bg-blue-600 hover:bg-blue-700 focus:outline-none focus:ring-2 focus:ring-offset-2 focus:ring-blue-500",
        onClick: generateMatches,
        disabled: round.accepted < 1,
        children: [
            /*#__PURE__*/ (0,jsx_runtime.jsx)(esm/* CogIcon */.IEm, {
                className: "-ml-1 mr-2 h-5 w-5",
                "aria-hidden": "true"
            }),
            "Generera matcher",
            loading ? /*#__PURE__*/ (0,jsx_runtime.jsxs)("svg", {
                className: "animate-spin -mr-1 ml-3 h-5 w-5 text-white",
                xmlns: "http://www.w3.org/2000/svg",
                fill: "none",
                viewBox: "0 0 24 24",
                children: [
                    /*#__PURE__*/ (0,jsx_runtime.jsx)("circle", {
                        className: "opacity-25",
                        cx: "12",
                        cy: "12",
                        r: "10",
                        stroke: "currentColor",
                        strokeWidth: "4"
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)("path", {
                        className: "opacity-75",
                        fill: "currentColor",
                        d: "M4 12a8 8 0 018-8V0C5.373 0 0 5.373 0 12h4zm2 5.291A7.962 7.962 0 014 12H0c0 3.042 1.135 5.824 3 7.938l3-2.647z"
                    })
                ]
            }) : null
        ]
    }));
};

;// CONCATENATED MODULE: ./components/ds/02-molecules/admin-round-details-card/index.tsx









function admin_round_details_card_asyncGeneratorStep(gen, resolve, reject, _next, _throw, key, arg) {
    try {
        var info = gen[key](arg);
        var value = info.value;
    } catch (error) {
        reject(error);
        return;
    }
    if (info.done) {
        resolve(value);
    } else {
        Promise.resolve(value).then(_next, _throw);
    }
}
function admin_round_details_card_asyncToGenerator(fn) {
    return function() {
        var self = this, args = arguments;
        return new Promise(function(resolve, reject) {
            var gen = fn.apply(self, args);
            function _next(value) {
                admin_round_details_card_asyncGeneratorStep(gen, resolve, reject, _next, _throw, "next", value);
            }
            function _throw(err) {
                admin_round_details_card_asyncGeneratorStep(gen, resolve, reject, _next, _throw, "throw", err);
            }
            _next(undefined);
        });
    };
}

var RoundDetailsCard = function(param) {
    var round = param.round, series = param.series;
    var ref = (0,react.useState)(false), loading = ref[0], setLoading = ref[1];
    var ref1 = (0,react.useState)(false), createMatchLoading = ref1[0], setCreateMatchLoading = ref1[1];
    var router = (0,next_router.useRouter)();
    var statusBadge = function() {
        switch(round.status){
            case 'current':
                return(/*#__PURE__*/ (0,jsx_runtime.jsxs)("span", {
                    className: "inline-flex items-center px-2 py-0.5 rounded text-xs font-medium bg-purple-100 text-purple-800",
                    children: [
                        "Sker denna vecka (",
                        round.start_week,
                        ")"
                    ]
                }));
            case 'next_week':
                return(/*#__PURE__*/ (0,jsx_runtime.jsxs)("span", {
                    className: "inline-flex items-center px-2 py-0.5 rounded text-xs font-medium bg-yellow-100 text-yellow-800",
                    children: [
                        "Sker n\xe4sta vecka (",
                        round.start_week,
                        ")"
                    ]
                }));
            case 'upcoming':
                return(/*#__PURE__*/ (0,jsx_runtime.jsx)("span", {
                    className: "inline-flex items-center px-2 py-0.5 rounded text-xs font-medium bg-blue-100 text-blue-800",
                    children: "Sker under kommande veckor"
                }));
            case 'past':
                return(/*#__PURE__*/ (0,jsx_runtime.jsx)("span", {
                    className: "inline-flex items-center px-2 py-0.5 rounded text-xs font-medium bg-green-100 text-green-800",
                    children: "Har genomf\xf6rts"
                }));
            case 'dynamic':
                return(/*#__PURE__*/ (0,jsx_runtime.jsx)("span", {
                    className: "inline-flex items-center px-2 py-0.5 rounded text-xs font-medium bg-yellow-100 text-yellow-800",
                    children: "Dynamiskt"
                }));
            default:
                return(/*#__PURE__*/ (0,jsx_runtime.jsx)("span", {
                    className: "inline-flex items-center px-2 py-0.5 rounded text-xs font-medium bg-pink-100 text-pink-800",
                    children: "Ov\xe4ntad status"
                }));
        }
    };
    var groupBadge = function() {
        switch(round.group){
            case 'morning':
                return(/*#__PURE__*/ (0,jsx_runtime.jsx)("span", {
                    className: "inline-flex items-center px-2 py-0.5 rounded text-xs font-medium bg-blue-100 text-blue-800",
                    children: "Morgon"
                }));
            case 'lunch':
                return(/*#__PURE__*/ (0,jsx_runtime.jsx)("span", {
                    className: "inline-flex items-center px-2 py-0.5 rounded text-xs font-medium bg-purple-100 text-purple-800",
                    children: "Lunch"
                }));
            case 'dynamic':
                return(/*#__PURE__*/ (0,jsx_runtime.jsx)("span", {
                    className: "inline-flex items-center px-2 py-0.5 rounded text-xs font-medium bg-yellow-100 text-yellow-800",
                    children: "Dynamiskt"
                }));
            default:
                return(/*#__PURE__*/ (0,jsx_runtime.jsx)("span", {
                    className: "inline-flex items-center px-2 py-0.5 rounded text-xs font-medium bg-pink-100 text-pink-800",
                    children: "Ov\xe4ntad status"
                }));
        }
    };
    var dtStart = luxon/* DateTime.fromISO */.ou.fromISO(round.round_start);
    var dtEnd = luxon/* DateTime.fromISO */.ou.fromISO(round.round_end);
    var sendInvitations = function() {
        var _ref = admin_round_details_card_asyncToGenerator(runtime_default().mark(function _callee() {
            var requestBody, SendInvitationRes, SendInvitationResData;
            return runtime_default().wrap(function _callee$(_ctx) {
                while(1)switch(_ctx.prev = _ctx.next){
                    case 0:
                        if (!confirm('\xc4r du s\xe4ker p\xe5 att du vill skicka ut inbjudningar?')) {
                            _ctx.next = 20;
                            break;
                        }
                        setLoading(true);
                        requestBody = {
                            sendEmail: true
                        };
                        _ctx.next = 5;
                        return fetch("/api/admin/series/".concat(series.id, "/round/").concat(round.round_public_id, "/create-and-send-invitations"), {
                            method: 'POST',
                            body: JSON.stringify(requestBody),
                            headers: {
                                'Content-Type': 'application/json'
                            }
                        });
                    case 5:
                        SendInvitationRes = _ctx.sent;
                        if (!(SendInvitationRes.status !== 200)) {
                            _ctx.next = 10;
                            break;
                        }
                        setLoading(false);
                        console.error("Got a non 200 response from the backend.", {
                            SendInvitationRes: SendInvitationRes
                        });
                        return _ctx.abrupt("return");
                    case 10:
                        _ctx.next = 12;
                        return SendInvitationRes.json();
                    case 12:
                        SendInvitationResData = _ctx.sent;
                        if (SendInvitationResData.success) {
                            _ctx.next = 19;
                            break;
                        }
                        setLoading(false);
                        console.error("Got a non success response from the backend ".concat(SendInvitationResData.code, "."), {
                            SendInvitationResData: SendInvitationResData
                        });
                        return _ctx.abrupt("return");
                    case 19:
                        {
                            alert("Skickade ".concat(SendInvitationResData.emails, " inbjudningar(r)."));
                            setLoading(false);
                            router.replace(router.asPath);
                        }
                    case 20:
                    case "end":
                        return _ctx.stop();
                }
            }, _callee);
        }));
        return function sendInvitations() {
            return _ref.apply(this, arguments);
        };
    }();
    var sendReminders = function() {
        var _ref = admin_round_details_card_asyncToGenerator(runtime_default().mark(function _callee() {
            var SendReminderRes, SendReminderResData;
            return runtime_default().wrap(function _callee$(_ctx) {
                while(1)switch(_ctx.prev = _ctx.next){
                    case 0:
                        if (!confirm('\xc4r du s\xe4ker p\xe5 att du vill skicka p\xe5minnelser?')) {
                            _ctx.next = 19;
                            break;
                        }
                        setLoading(true);
                        _ctx.next = 4;
                        return fetch("/api/admin/series/".concat(series.id, "/round/").concat(round.round_public_id, "/send-reminders"), {
                            method: 'POST',
                            headers: {
                                'Content-Type': 'application/json'
                            }
                        });
                    case 4:
                        SendReminderRes = _ctx.sent;
                        if (!(SendReminderRes.status !== 200)) {
                            _ctx.next = 9;
                            break;
                        }
                        setLoading(false);
                        console.error("Got a non 200 response from the backend.", {
                            SendReminderRes: SendReminderRes
                        });
                        return _ctx.abrupt("return");
                    case 9:
                        _ctx.next = 11;
                        return SendReminderRes.json();
                    case 11:
                        SendReminderResData = _ctx.sent;
                        if (SendReminderResData.success) {
                            _ctx.next = 18;
                            break;
                        }
                        setLoading(false);
                        console.error("Got a non success response from the backend ".concat(SendReminderResData.code, "."), {
                            SendReminderResData: SendReminderResData
                        });
                        return _ctx.abrupt("return");
                    case 18:
                        {
                            alert("Skickade ".concat(SendReminderResData.emails, " p\xe5minnelse(r)."));
                            setLoading(false);
                            router.replace(router.asPath);
                        }
                    case 19:
                    case "end":
                        return _ctx.stop();
                }
            }, _callee);
        }));
        return function sendReminders() {
            return _ref.apply(this, arguments);
        };
    }();
    var generateMatches = function() {
        var _ref = admin_round_details_card_asyncToGenerator(runtime_default().mark(function _callee() {
            var GenerateMatchRes, GenerateMatchesResData;
            return runtime_default().wrap(function _callee$(_ctx) {
                while(1)switch(_ctx.prev = _ctx.next){
                    case 0:
                        if (!confirm('\xc4r du s\xe4ker p\xe5 att du vill generera matcher?')) {
                            _ctx.next = 19;
                            break;
                        }
                        setLoading(true);
                        _ctx.next = 4;
                        return fetch("/api/admin/series/".concat(series.id, "/round/").concat(round.round_public_id, "/send-reminders"), {
                            method: 'POST',
                            headers: {
                                'Content-Type': 'application/json'
                            }
                        });
                    case 4:
                        GenerateMatchRes = _ctx.sent;
                        if (!(GenerateMatchRes.status !== 200)) {
                            _ctx.next = 9;
                            break;
                        }
                        setLoading(false);
                        console.error("Got a non 200 response from the backend.", {
                            GenerateMatchRes: GenerateMatchRes
                        });
                        return _ctx.abrupt("return");
                    case 9:
                        _ctx.next = 11;
                        return GenerateMatchRes.json();
                    case 11:
                        GenerateMatchesResData = _ctx.sent;
                        if (GenerateMatchesResData.success) {
                            _ctx.next = 18;
                            break;
                        }
                        setLoading(false);
                        console.error("Got a non success response from the backend ".concat(GenerateMatchesResData.code, "."), {
                            GenerateMatchesResData: GenerateMatchesResData
                        });
                        return _ctx.abrupt("return");
                    case 18:
                        {
                            alert("Skapade ".concat(GenerateMatchesResData.matches, " matcher."));
                            setLoading(false);
                            router.replace(router.asPath);
                        }
                    case 19:
                    case "end":
                        return _ctx.stop();
                }
            }, _callee);
        }));
        return function generateMatches() {
            return _ref.apply(this, arguments);
        };
    }();
    return(/*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
        className: "bg-white shadow overflow-hidden sm:rounded-lg sm:m-6",
        children: [
            /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                className: "px-4 py-5 sm:px-6",
                children: [
                    /*#__PURE__*/ (0,jsx_runtime.jsxs)("h3", {
                        className: "text-lg leading-6 font-medium text-gray-900",
                        children: [
                            round.round_name,
                            " av ",
                            round.series_name
                        ]
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsxs)("p", {
                        className: "mt-1 max-w-2xl text-sm text-gray-500",
                        children: [
                            dtStart.setLocale('sv').toLocaleString(luxon/* DateTime.DATE_MED_WITH_WEEKDAY */.ou.DATE_MED_WITH_WEEKDAY),
                            ' ',
                            dtStart.setLocale('sv').toLocaleString(luxon/* DateTime.TIME_24_SIMPLE */.ou.TIME_24_SIMPLE),
                            " till",
                            ' ',
                            dtEnd.setLocale('sv').toLocaleString(luxon/* DateTime.TIME_24_SIMPLE */.ou.TIME_24_SIMPLE)
                        ]
                    })
                ]
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                className: "border-t border-gray-200 px-4 py-5 sm:p-0",
                children: /*#__PURE__*/ (0,jsx_runtime.jsxs)("dl", {
                    className: "sm:divide-y sm:divide-gray-200",
                    children: [
                        /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                            className: "py-4 sm:py-5 sm:grid sm:grid-cols-3 sm:gap-4 sm:px-6",
                            children: [
                                /*#__PURE__*/ (0,jsx_runtime.jsx)("dt", {
                                    className: "text-sm font-medium text-gray-500",
                                    children: "Grupp"
                                }),
                                /*#__PURE__*/ (0,jsx_runtime.jsx)("dd", {
                                    className: "mt-1 text-sm text-gray-900 sm:mt-0 sm:col-span-2",
                                    children: groupBadge()
                                })
                            ]
                        }),
                        /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                            className: "py-4 sm:py-5 sm:grid sm:grid-cols-3 sm:gap-4 sm:px-6",
                            children: [
                                /*#__PURE__*/ (0,jsx_runtime.jsx)("dt", {
                                    className: "text-sm font-medium text-gray-500",
                                    children: "Status"
                                }),
                                /*#__PURE__*/ (0,jsx_runtime.jsx)("dd", {
                                    className: "mt-1 text-sm text-gray-900 sm:mt-0 sm:col-span-2",
                                    children: statusBadge()
                                })
                            ]
                        }),
                        /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                            className: "py-4 sm:py-5 sm:grid sm:grid-cols-3 sm:gap-4 sm:px-6",
                            children: [
                                /*#__PURE__*/ (0,jsx_runtime.jsx)("dt", {
                                    className: "text-sm font-medium text-gray-500",
                                    children: "Inbjudningar skickade"
                                }),
                                /*#__PURE__*/ (0,jsx_runtime.jsx)("dd", {
                                    className: "mt-1 text-sm text-gray-900 sm:mt-0 sm:col-span-2",
                                    children: round.invitations
                                })
                            ]
                        }),
                        /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                            className: "py-4 sm:py-5 sm:grid sm:grid-cols-3 sm:gap-4 sm:px-6",
                            children: [
                                /*#__PURE__*/ (0,jsx_runtime.jsx)("dt", {
                                    className: "text-sm font-medium text-gray-500",
                                    children: "Accepterat"
                                }),
                                /*#__PURE__*/ (0,jsx_runtime.jsx)("dd", {
                                    className: "mt-1 text-sm text-gray-900 sm:mt-0 sm:col-span-2",
                                    children: round.accepted
                                })
                            ]
                        }),
                        /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                            className: "py-4 sm:py-5 sm:grid sm:grid-cols-3 sm:gap-4 sm:px-6",
                            children: [
                                /*#__PURE__*/ (0,jsx_runtime.jsx)("dt", {
                                    className: "text-sm font-medium text-gray-500",
                                    children: "Tackat nej"
                                }),
                                /*#__PURE__*/ (0,jsx_runtime.jsx)("dd", {
                                    className: "mt-1 text-sm text-gray-900 sm:mt-0 sm:col-span-2",
                                    children: round.declined
                                })
                            ]
                        }),
                        /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                            className: "py-4 sm:py-5 sm:grid sm:grid-cols-3 sm:gap-4 sm:px-6",
                            children: [
                                /*#__PURE__*/ (0,jsx_runtime.jsx)("dt", {
                                    className: "text-sm font-medium text-gray-500",
                                    children: "Ej svarat"
                                }),
                                /*#__PURE__*/ (0,jsx_runtime.jsx)("dd", {
                                    className: "mt-1 text-sm text-gray-900 sm:mt-0 sm:col-span-2",
                                    children: round.pending
                                })
                            ]
                        }),
                        /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                            className: "py-4 sm:py-5 sm:grid sm:grid-cols-3 sm:gap-4 sm:px-6 items-center",
                            children: [
                                /*#__PURE__*/ (0,jsx_runtime.jsx)("dt", {
                                    className: "text-sm font-medium text-gray-500",
                                    children: "Skicka inbjudningar"
                                }),
                                /*#__PURE__*/ (0,jsx_runtime.jsx)("dd", {
                                    className: "mt-1 text-sm text-gray-900 sm:mt-0 sm:col-span-2",
                                    children: /*#__PURE__*/ (0,jsx_runtime.jsxs)("button", {
                                        type: "button",
                                        className: "inline-flex items-center px-4 py-2 border border-transparent shadow-sm text-sm font-medium rounded-md text-white bg-green-600 hover:bg-green-700 focus:outline-none focus:ring-2 focus:ring-offset-2 focus:ring-green-500",
                                        onClick: sendInvitations,
                                        disabled: round.invitations > 0,
                                        children: [
                                            /*#__PURE__*/ (0,jsx_runtime.jsx)(esm/* MailIcon */.bV6, {
                                                className: "-ml-1 mr-2 h-5 w-5",
                                                "aria-hidden": "true"
                                            }),
                                            "Skicka inbjudningar",
                                            loading ? /*#__PURE__*/ (0,jsx_runtime.jsxs)("svg", {
                                                className: "animate-spin -mr-1 ml-3 h-5 w-5 text-white",
                                                xmlns: "http://www.w3.org/2000/svg",
                                                fill: "none",
                                                viewBox: "0 0 24 24",
                                                children: [
                                                    /*#__PURE__*/ (0,jsx_runtime.jsx)("circle", {
                                                        className: "opacity-25",
                                                        cx: "12",
                                                        cy: "12",
                                                        r: "10",
                                                        stroke: "currentColor",
                                                        strokeWidth: "4"
                                                    }),
                                                    /*#__PURE__*/ (0,jsx_runtime.jsx)("path", {
                                                        className: "opacity-75",
                                                        fill: "currentColor",
                                                        d: "M4 12a8 8 0 018-8V0C5.373 0 0 5.373 0 12h4zm2 5.291A7.962 7.962 0 014 12H0c0 3.042 1.135 5.824 3 7.938l3-2.647z"
                                                    })
                                                ]
                                            }) : null
                                        ]
                                    })
                                })
                            ]
                        }),
                        /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                            className: "py-4 sm:py-5 sm:grid sm:grid-cols-3 sm:gap-4 sm:px-6 items-center",
                            children: [
                                /*#__PURE__*/ (0,jsx_runtime.jsx)("dt", {
                                    className: "text-sm font-medium text-gray-500",
                                    children: "Skicka p\xe5minnelser"
                                }),
                                /*#__PURE__*/ (0,jsx_runtime.jsx)("dd", {
                                    className: "mt-1 text-sm text-gray-900 sm:mt-0 sm:col-span-2",
                                    children: /*#__PURE__*/ (0,jsx_runtime.jsxs)("button", {
                                        type: "button",
                                        className: "inline-flex items-center px-4 py-2 border border-transparent shadow-sm text-sm font-medium rounded-md text-white bg-yellow-600 hover:bg-yellow-700 focus:outline-none focus:ring-2 focus:ring-offset-2 focus:ring-yellow-500",
                                        onClick: sendReminders,
                                        disabled: round.invitations < 1,
                                        children: [
                                            /*#__PURE__*/ (0,jsx_runtime.jsx)(esm/* MailIcon */.bV6, {
                                                className: "-ml-1 mr-2 h-5 w-5",
                                                "aria-hidden": "true"
                                            }),
                                            "Skicka p\xe5minnelser",
                                            loading ? /*#__PURE__*/ (0,jsx_runtime.jsxs)("svg", {
                                                className: "animate-spin -mr-1 ml-3 h-5 w-5 text-white",
                                                xmlns: "http://www.w3.org/2000/svg",
                                                fill: "none",
                                                viewBox: "0 0 24 24",
                                                children: [
                                                    /*#__PURE__*/ (0,jsx_runtime.jsx)("circle", {
                                                        className: "opacity-25",
                                                        cx: "12",
                                                        cy: "12",
                                                        r: "10",
                                                        stroke: "currentColor",
                                                        strokeWidth: "4"
                                                    }),
                                                    /*#__PURE__*/ (0,jsx_runtime.jsx)("path", {
                                                        className: "opacity-75",
                                                        fill: "currentColor",
                                                        d: "M4 12a8 8 0 018-8V0C5.373 0 0 5.373 0 12h4zm2 5.291A7.962 7.962 0 014 12H0c0 3.042 1.135 5.824 3 7.938l3-2.647z"
                                                    })
                                                ]
                                            }) : null
                                        ]
                                    })
                                })
                            ]
                        }),
                        /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                            className: "py-4 sm:py-5 sm:grid sm:grid-cols-3 sm:gap-4 sm:px-6 items-center",
                            children: [
                                /*#__PURE__*/ (0,jsx_runtime.jsx)("dt", {
                                    className: "text-sm font-medium text-gray-500",
                                    children: "Generera matcher"
                                }),
                                /*#__PURE__*/ (0,jsx_runtime.jsx)("dd", {
                                    className: "mt-1 text-sm text-gray-900 sm:mt-0 sm:col-span-2",
                                    children: /*#__PURE__*/ (0,jsx_runtime.jsx)(GenerateMatchesButton, {
                                        round: round,
                                        series: series
                                    })
                                })
                            ]
                        }),
                        /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                            className: "py-4 sm:py-5 sm:grid sm:grid-cols-3 sm:gap-4 sm:px-6 items-center",
                            children: [
                                /*#__PURE__*/ (0,jsx_runtime.jsx)("dt", {
                                    className: "text-sm font-medium text-gray-500",
                                    children: "Bjud in extra lag"
                                }),
                                /*#__PURE__*/ (0,jsx_runtime.jsx)("dd", {
                                    className: "mt-1 text-sm text-gray-900 sm:mt-0 sm:col-span-2",
                                    children: /*#__PURE__*/ (0,jsx_runtime.jsx)(next_link["default"], {
                                        href: "/admin/series/".concat(round.series_id, "/round/").concat(round.round_public_id, "/invite"),
                                        children: /*#__PURE__*/ (0,jsx_runtime.jsxs)("a", {
                                            className: "inline-flex items-center px-4 py-2 border border-transparent shadow-sm text-sm font-medium rounded-md text-white bg-indigo-600 hover:bg-indigo-700 focus:outline-none focus:ring-2 focus:ring-offset-2 focus:ring-indigo-500",
                                            children: [
                                                /*#__PURE__*/ (0,jsx_runtime.jsx)(esm/* MailIcon */.bV6, {
                                                    className: "-ml-1 mr-2 h-5 w-5",
                                                    "aria-hidden": "true"
                                                }),
                                                "Bjud in"
                                            ]
                                        })
                                    })
                                })
                            ]
                        })
                    ]
                })
            })
        ]
    }));
};

;// CONCATENATED MODULE: ./components/ds/02-molecules/admin-match-result-row-item/types.ts

var types_Winner = es6/* union */.G0([
    es6/* literal */.i0('home'),
    es6/* literal */.i0('away'),
    es6/* literal */.i0('draw'),
    es6/* literal */.i0('unknown'), 
]);
var MatchState = es6/* union */.G0([
    es6/* literal */.i0('upcoming'),
    es6/* literal */.i0('played'),
    es6/* literal */.i0('awaiting_play'),
    es6/* literal */.i0('not_confirmed'),
    es6/* literal */.i0('unknown'), 
]);
var NullableString = es6/* union */.G0([
    es6/* string */.Z_,
    es6/* null */.lB
]);
var NullableNumber = es6/* union */.G0([
    es6/* number */.pk,
    es6/* null */.lB
]);
var NullableBoolean = es6/* union */.G0([
    es6/* boolean */.O7,
    es6/* null */.lB
]);
var NullableWinner = es6/* union */.G0([
    types_Winner,
    es6/* null */.lB
]);
var types_MatchTeam = es6/* type */.dt({
    team_name: es6/* string */.Z_,
    player_name: es6/* string */.Z_
});
var AdminMatchResult = es6/* type */.dt({
    match_id: NullableNumber,
    round_name: es6/* string */.Z_,
    round_start: es6/* string */.Z_,
    series_id: es6/* string */.Z_,
    home_teams: es6/* array */.IX(types_MatchTeam),
    away_teams: es6/* array */.IX(types_MatchTeam),
    match_location_name: es6/* string */.Z_,
    match_location_adress: es6/* string */.Z_,
    match_location_zipcode: es6/* string */.Z_,
    match_location_city: es6/* string */.Z_,
    match_location_country: es6/* string */.Z_,
    is_upcoming_match: es6/* boolean */.O7,
    home_total_games: NullableNumber,
    home_set_one_games: NullableNumber,
    home_set_two_games: NullableNumber,
    home_set_three_games: NullableNumber,
    away_total_games: NullableNumber,
    away_set_one_games: NullableNumber,
    away_set_two_games: NullableNumber,
    away_set_three_games: NullableNumber,
    winner: NullableWinner,
    winning_points: NullableNumber,
    loosing_points: NullableNumber,
    tiebreak: NullableBoolean,
    home_tiebreak_points: NullableNumber,
    away_tiebreak_points: NullableNumber,
    match_calculated_state: MatchState,
    match_state: NullableString,
    match_result_state: NullableString
});

;// CONCATENATED MODULE: ./components/ds/02-molecules/admin-match-result-row-item/index.tsx





var AdminMatchResultRowItem = function(param) {
    var match = param.match, handleMatchClick = param.handleMatchClick;
    var winner1st = match.home_set_one_games && match.away_set_one_games && match.home_set_one_games > match.away_set_one_games ? 'home' : match.home_set_one_games && match.away_set_one_games && match.home_set_one_games < match.away_set_one_games ? 'away' : 'undetermined';
    var winner2nd = match.home_set_two_games && match.away_set_two_games && match.home_set_two_games > match.away_set_two_games ? 'home' : match.home_set_two_games && match.away_set_two_games && match.home_set_two_games < match.away_set_two_games ? 'away' : 'undetermined';
    var winner3rd = match.home_set_three_games && match.away_set_three_games && match.home_set_three_games > match.away_set_three_games ? 'home' : match.home_set_three_games && match.away_set_three_games && match.home_set_three_games < match.away_set_three_games ? 'away' : 'undetermined';
    var winnerTiebreak = match.home_tiebreak_points && match.away_tiebreak_points && match.home_tiebreak_points > match.away_tiebreak_points ? 'home' : match.home_tiebreak_points && match.away_tiebreak_points && match.home_tiebreak_points < match.away_tiebreak_points ? 'away' : 'undetermined';
    var dtStart = luxon/* DateTime.fromISO */.ou.fromISO(match.round_start);
    var matchResultBoxClasses = "px-3 py-2 text-center font-mono";
    var statusBadge = function() {
        switch(match.match_state){
            case 'created':
                return(/*#__PURE__*/ (0,jsx_runtime.jsx)("span", {
                    className: "inline-flex items-center px-2 py-0.5 rounded text-xs font-medium bg-purple-100 text-purple-800",
                    children: "Skapad"
                }));
            case 'started':
                return(/*#__PURE__*/ (0,jsx_runtime.jsx)("span", {
                    className: "inline-flex items-center px-2 py-0.5 rounded text-xs font-medium bg-yellow-100 text-yellow-800",
                    children: "Startad"
                }));
            case 'completed':
                return(/*#__PURE__*/ (0,jsx_runtime.jsx)("span", {
                    className: "inline-flex items-center px-2 py-0.5 rounded text-xs font-medium bg-blue-100 text-blue-800",
                    children: "Spelad"
                }));
            case 'confirmed':
                return(/*#__PURE__*/ (0,jsx_runtime.jsx)("span", {
                    className: "inline-flex items-center px-2 py-0.5 rounded text-xs font-medium bg-green-100 text-green-800",
                    children: "Bekr\xe4ftad"
                }));
            case 'deleted':
                return(/*#__PURE__*/ (0,jsx_runtime.jsx)("span", {
                    className: "inline-flex items-center px-2 py-0.5 rounded text-xs font-medium bg-red-100 text-red-800",
                    children: "Borttagen"
                }));
            default:
                return(/*#__PURE__*/ (0,jsx_runtime.jsx)("span", {
                    className: "inline-flex items-center px-2 py-0.5 rounded text-xs font-medium bg-pink-100 text-pink-800",
                    children: "Ov\xe4ntad status"
                }));
        }
    };
    return(/*#__PURE__*/ (0,jsx_runtime.jsx)("li", {
        className: "block",
        onClick: function() {
            if (match && match.match_id) handleMatchClick(match);
        },
        children: /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
            className: "px-4 py-4 flex items-center sm:px-6 font-light",
            children: /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                className: "min-w-0 flex-1 sm:flex sm:items-center sm:justify-between",
                children: [
                    /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                        className: "bg-white pb-5 pt-3 border-b border-gray-200 sm:border-0 sm:px-6",
                        children: [
                            /*#__PURE__*/ (0,jsx_runtime.jsxs)("h3", {
                                className: "text-base leading-6 font-medium text-gray-900",
                                children: [
                                    match.round_name,
                                    " @ ",
                                    match.match_location_name
                                ]
                            }),
                            /*#__PURE__*/ (0,jsx_runtime.jsx)("p", {
                                className: "mt-1 text-sm text-gray-500",
                                children: dtStart.setLocale('sv').toLocaleString(luxon/* DateTime.DATETIME_MED_WITH_WEEKDAY */.ou.DATETIME_MED_WITH_WEEKDAY)
                            }),
                            /*#__PURE__*/ (0,jsx_runtime.jsx)("p", {
                                className: "mt-1 text-sm text-gray-500",
                                children: statusBadge()
                            })
                        ]
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                        children: [
                            /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                                className: "mt-4 py-1 grid grid-cols-8 grid-rows-2 font-light text-xs items-center gap-x-2",
                                children: [
                                    /*#__PURE__*/ (0,jsx_runtime.jsx)("p", {
                                        className: "font-bold row-span-2 col-span-1 px-2 py-2 border border-gray-200 border-solid rounded-md text-center",
                                        children: "L1"
                                    }),
                                    /*#__PURE__*/ (0,jsx_runtime.jsxs)("p", {
                                        className: (0,classnames/* classNames */.A)('py-0 col-span-7'),
                                        children: [
                                            match.home_teams[0].team_name,
                                            " ",
                                            "(",
                                            match.home_teams[0].player_name,
                                            ")"
                                        ]
                                    }),
                                    /*#__PURE__*/ (0,jsx_runtime.jsxs)("p", {
                                        className: (0,classnames/* classNames */.A)('py-0 col-span-7'),
                                        children: [
                                            match.home_teams[1].team_name,
                                            " ",
                                            "(",
                                            match.home_teams[1].player_name,
                                            ")"
                                        ]
                                    })
                                ]
                            }),
                            /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                                className: "py-1 grid grid-cols-8 grid-rows-2 font-light text-xs items-center gap-x-2",
                                children: [
                                    /*#__PURE__*/ (0,jsx_runtime.jsx)("p", {
                                        className: "font-bold row-span-2 col-span-1 px-2 py-2 border border-gray-200 border-solid rounded-md text-center",
                                        children: "L2"
                                    }),
                                    /*#__PURE__*/ (0,jsx_runtime.jsxs)("p", {
                                        className: (0,classnames/* classNames */.A)('py-0 col-span-7'),
                                        children: [
                                            match.away_teams[0].team_name,
                                            " ",
                                            "(",
                                            match.away_teams[0].player_name,
                                            ")"
                                        ]
                                    }),
                                    /*#__PURE__*/ (0,jsx_runtime.jsxs)("p", {
                                        className: (0,classnames/* classNames */.A)('py-0 col-span-7'),
                                        children: [
                                            match.away_teams[1].team_name,
                                            " ",
                                            "(",
                                            match.away_teams[1].player_name,
                                            ")"
                                        ]
                                    })
                                ]
                            })
                        ]
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                        className: (0,classnames/* classNames */.A)(match.tiebreak ? 'grid-cols-7' : 'grid-cols-6', "mt-4 grid grid-rows-3 divide-x-2 divide-y-2 border border-gray-200 border-solid rounded-md font-light text-xs items-center"),
                        children: [
                            /*#__PURE__*/ (0,jsx_runtime.jsx)("p", {}),
                            /*#__PURE__*/ (0,jsx_runtime.jsx)("p", {
                                title: "Set 1",
                                className: (0,classnames/* classNames */.A)('font-bold', matchResultBoxClasses),
                                children: "1"
                            }),
                            /*#__PURE__*/ (0,jsx_runtime.jsx)("p", {
                                title: "Set 2",
                                className: (0,classnames/* classNames */.A)('font-bold', matchResultBoxClasses),
                                children: "2"
                            }),
                            /*#__PURE__*/ (0,jsx_runtime.jsx)("p", {
                                title: "Set 3",
                                className: (0,classnames/* classNames */.A)('font-bold', matchResultBoxClasses),
                                children: "3"
                            }),
                            /*#__PURE__*/ (0,jsx_runtime.jsx)("p", {
                                title: "Totalt antal gem",
                                className: (0,classnames/* classNames */.A)('font-bold', matchResultBoxClasses),
                                children: "T"
                            }),
                            match.tiebreak ? /*#__PURE__*/ (0,jsx_runtime.jsx)("p", {
                                title: "Tiebreak",
                                className: (0,classnames/* classNames */.A)('font-bold', matchResultBoxClasses),
                                children: "TB"
                            }) : null,
                            /*#__PURE__*/ (0,jsx_runtime.jsx)("p", {
                                title: "Po\xe4ng",
                                className: (0,classnames/* classNames */.A)('font-bold', matchResultBoxClasses),
                                children: "P"
                            }),
                            /*#__PURE__*/ (0,jsx_runtime.jsx)("p", {
                                className: (0,classnames/* classNames */.A)('font-bold', matchResultBoxClasses),
                                children: "L1"
                            }),
                            /*#__PURE__*/ (0,jsx_runtime.jsx)("p", {
                                className: (0,classnames/* classNames */.A)(winner1st === 'home' ? 'bg-green-100' : 'bg-red-100', matchResultBoxClasses),
                                children: match.home_set_one_games
                            }),
                            /*#__PURE__*/ (0,jsx_runtime.jsx)("p", {
                                className: (0,classnames/* classNames */.A)(winner2nd === 'home' ? 'bg-green-100' : 'bg-red-100', matchResultBoxClasses),
                                children: match.home_set_two_games
                            }),
                            /*#__PURE__*/ (0,jsx_runtime.jsx)("p", {
                                className: (0,classnames/* classNames */.A)(winner3rd === 'home' ? 'bg-green-100' : 'bg-red-100', matchResultBoxClasses),
                                children: match.home_set_three_games
                            }),
                            /*#__PURE__*/ (0,jsx_runtime.jsx)("p", {
                                className: (0,classnames/* classNames */.A)(match.winner === 'home' ? 'bg-green-100 font-extrabold' : 'bg-red-100', matchResultBoxClasses),
                                children: match.home_total_games
                            }),
                            match.tiebreak ? /*#__PURE__*/ (0,jsx_runtime.jsx)("p", {
                                className: (0,classnames/* classNames */.A)(winnerTiebreak === 'home' ? 'bg-green-100' : 'bg-red-100', matchResultBoxClasses),
                                children: match.home_tiebreak_points
                            }) : null,
                            /*#__PURE__*/ (0,jsx_runtime.jsx)("p", {
                                className: (0,classnames/* classNames */.A)(match.winner === 'home' ? 'bg-green-100 font-extrabold' : 'bg-red-100', matchResultBoxClasses),
                                children: match.winner === 'home' ? match.winning_points : match.loosing_points
                            }),
                            /*#__PURE__*/ (0,jsx_runtime.jsx)("p", {
                                className: (0,classnames/* classNames */.A)('font-bold', matchResultBoxClasses),
                                children: "L2"
                            }),
                            /*#__PURE__*/ (0,jsx_runtime.jsx)("p", {
                                className: (0,classnames/* classNames */.A)(winner1st === 'away' ? 'bg-green-100' : 'bg-red-100', matchResultBoxClasses),
                                children: match.away_set_one_games
                            }),
                            /*#__PURE__*/ (0,jsx_runtime.jsx)("p", {
                                className: (0,classnames/* classNames */.A)(winner2nd === 'away' ? 'bg-green-100' : 'bg-red-100', matchResultBoxClasses),
                                children: match.away_set_two_games
                            }),
                            /*#__PURE__*/ (0,jsx_runtime.jsx)("p", {
                                className: (0,classnames/* classNames */.A)(winner3rd === 'away' ? 'bg-green-100' : 'bg-red-100', matchResultBoxClasses),
                                children: match.away_set_three_games
                            }),
                            /*#__PURE__*/ (0,jsx_runtime.jsx)("p", {
                                className: (0,classnames/* classNames */.A)(match.winner === 'away' ? 'bg-green-100 font-extrabold' : 'bg-red-100', matchResultBoxClasses),
                                children: match.away_total_games
                            }),
                            match.tiebreak ? /*#__PURE__*/ (0,jsx_runtime.jsx)("p", {
                                className: (0,classnames/* classNames */.A)(winnerTiebreak === 'away' ? 'bg-green-100' : 'bg-red-100', matchResultBoxClasses),
                                children: match.away_tiebreak_points
                            }) : null,
                            /*#__PURE__*/ (0,jsx_runtime.jsx)("p", {
                                className: (0,classnames/* classNames */.A)(match.winner === 'away' ? 'bg-green-100 font-extrabold' : 'bg-red-100', matchResultBoxClasses),
                                children: match.winner === 'away' ? match.winning_points : match.loosing_points
                            })
                        ]
                    })
                ]
            })
        })
    }, match.round_name));
};

;// CONCATENATED MODULE: ./components/ds/02-molecules/admin-player-matcher-table-row-item/types.ts


var Partner = es6/* type */.dt({
    name: es6/* string */.Z_,
    id: UUID/* UUID */.h
});
var Breakdown = es6/* type */.dt({
    series_id: UUID/* UUID */.h,
    player_id: UUID/* UUID */.h,
    player_name: es6/* string */.Z_,
    partners: es6/* array */.IX(Partner),
    no_of_partners: es6/* number */.pk
});

;// CONCATENATED MODULE: ./components/ds/02-molecules/admin-player-matcher-table-row-item/index.tsx





var AdminPlayerMatcherTableRowItem = function(param) {
    var row = param.row, rowIdx = param.rowIdx, allRows = param.allRows;
    return(/*#__PURE__*/ (0,jsx_runtime.jsxs)("tr", {
        className: (0,classnames/* classNames */.A)(rowIdx % 2 === 0 ? 'bg-white' : 'bg-gray-50'),
        children: [
            /*#__PURE__*/ (0,jsx_runtime.jsx)("td", {
                className: "px-2 py-1 whitespace-nowrap text-sm text-gray-500",
                children: row.player_name
            }),
            allRows.map(function(innerRow) {
                return(/*#__PURE__*/ (0,jsx_runtime.jsx)(jsx_runtime.Fragment, {
                    children: row.player_id === innerRow.player_id ? /*#__PURE__*/ (0,jsx_runtime.jsx)("td", {
                        className: "px-2 py-1 whitespace-nowrap text-sm text-white bg-gray-900 border border-gray-200",
                        children: /*#__PURE__*/ (0,jsx_runtime.jsx)(outline_esm/* StopIcon */.wNq, {
                            className: "h-5 w-5",
                            "aria-hidden": "true"
                        })
                    }, "".concat(innerRow.player_id, "--inner--column")) : row.partners.map(function(partner) {
                        return partner.id;
                    }).includes(innerRow.player_id) ? /*#__PURE__*/ (0,jsx_runtime.jsx)("td", {
                        className: "px-2 py-1 whitespace-nowrap text-sm text-gray-900 bg-green-500 border border-gray-200",
                        children: /*#__PURE__*/ (0,jsx_runtime.jsx)(outline_esm/* CheckIcon */.nQG, {
                            className: "h-5 w-5",
                            "aria-hidden": "true"
                        })
                    }, "".concat(innerRow.player_id, "--inner--column")) : /*#__PURE__*/ (0,jsx_runtime.jsx)("td", {
                        className: "px-2 py-1 whitespace-nowrap text-sm text-gray-900 bg-gray-50 border border-gray-200"
                    }, "".concat(innerRow.player_id, "--inner--column"))
                }));
            })
        ]
    }, "".concat(row.player_id, "--row")));
};

;// CONCATENATED MODULE: ./components/ds/02-molecules/signup-breadcrumbs.tsx



var SignupBreadcrumbs = function(param) {
    var signup = param.signup, series = param.series, round = param.round;
    return(/*#__PURE__*/ (0,jsx_runtime.jsx)("nav", {
        className: "bg-white border-b border-gray-200 flex",
        "aria-label": "Breadcrumb",
        children: /*#__PURE__*/ (0,jsx_runtime.jsxs)("ol", {
            role: "list",
            className: "max-w-screen-xl w-full mx-auto px-4 flex space-x-4 sm:px-6 lg:px-8",
            children: [
                /*#__PURE__*/ (0,jsx_runtime.jsx)("li", {
                    className: "flex",
                    children: /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                        className: "flex items-center",
                        children: /*#__PURE__*/ (0,jsx_runtime.jsx)(next_link["default"], {
                            href: "/admin/series/".concat(series.id, "/round/").concat(round.round_public_id),
                            children: /*#__PURE__*/ (0,jsx_runtime.jsxs)("a", {
                                className: "text-gray-400 hover:text-gray-500",
                                children: [
                                    /*#__PURE__*/ (0,jsx_runtime.jsx)(esm/* HomeIcon */.tvw, {
                                        className: "flex-shrink-0 h-5 w-5",
                                        "aria-hidden": "true"
                                    }),
                                    /*#__PURE__*/ (0,jsx_runtime.jsx)("span", {
                                        className: "sr-only",
                                        children: "Runda"
                                    })
                                ]
                            })
                        })
                    })
                }),
                /*#__PURE__*/ (0,jsx_runtime.jsx)("li", {
                    className: "flex",
                    children: /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                        className: "flex items-center",
                        children: [
                            /*#__PURE__*/ (0,jsx_runtime.jsx)("svg", {
                                className: "flex-shrink-0 w-6 h-full text-gray-200",
                                viewBox: "0 0 24 44",
                                preserveAspectRatio: "none",
                                fill: "currentColor",
                                xmlns: "http://www.w3.org/2000/svg",
                                "aria-hidden": "true",
                                children: /*#__PURE__*/ (0,jsx_runtime.jsx)("path", {
                                    d: "M.293 0l22 22-22 22h1.414l22-22-22-22H.293z"
                                })
                            }),
                            /*#__PURE__*/ (0,jsx_runtime.jsx)(next_link["default"], {
                                href: "/admin/series/".concat(series.id, "/round/").concat(round.round_public_id, "/signup/").concat(signup.signup_public_id, "/view"),
                                children: /*#__PURE__*/ (0,jsx_runtime.jsxs)("a", {
                                    className: "ml-4 text-sm font-medium text-gray-500 hover:text-gray-700",
                                    "aria-current": true,
                                    children: [
                                        signup.user_name,
                                        " i ",
                                        round.round_name
                                    ]
                                })
                            })
                        ]
                    })
                })
            ]
        })
    }));
};

;// CONCATENATED MODULE: ./components/ds/02-molecules/round-row-item/types.ts


var Round = es6/* type */.dt({
    public_id: UUID/* UUID */.h,
    name: es6/* string */.Z_,
    start: es6/* string */.Z_,
    series_id: es6/* string */.Z_,
    start_week: es6/* number */.pk,
    current_week: es6/* number */.pk,
    is_this_week: es6/* boolean */.O7,
    done: es6/* boolean */.O7,
    upcoming: es6/* boolean */.O7,
    invitations: es6/* number */.pk,
    accepted: es6/* number */.pk,
    declined: es6/* number */.pk,
    pending: es6/* number */.pk,
    confirmed_matches: es6/* number */.pk,
    completed_matches: es6/* number */.pk
});

;// CONCATENATED MODULE: ./components/ds/02-molecules/round-row-item/index.tsx






var RoundRowItem = function(param) {
    var round = param.round, seriesContext = param.seriesContext;
    var dtStart = luxon/* DateTime.fromISO */.ou.fromISO(round.start);
    return(/*#__PURE__*/ (0,jsx_runtime.jsx)("li", {
        className: "block bg-white hover:bg-gray-50",
        children: /*#__PURE__*/ (0,jsx_runtime.jsx)(next_link["default"], {
            href: "/series/".concat(seriesContext.id, "/round/").concat(round.public_id),
            children: /*#__PURE__*/ (0,jsx_runtime.jsx)("a", {
                children: /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                    className: "px-4 py-4 flex items-center sm:px-6 font-light bg-white hover:bg-gray-50",
                    children: /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                        className: "min-w-0 flex-1 sm:flex sm:items-center sm:justify-between",
                        children: [
                            /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                                className: "pb-5 pt-3 border-b border-gray-200 sm:border-0 sm:px-6",
                                children: [
                                    /*#__PURE__*/ (0,jsx_runtime.jsx)("h3", {
                                        className: "text-base leading-6 font-medium text-gray-900",
                                        children: round.name
                                    }),
                                    /*#__PURE__*/ (0,jsx_runtime.jsx)("p", {
                                        className: "mt-1 text-sm text-gray-500",
                                        children: dtStart.setLocale('sv').toLocaleString(luxon/* DateTime.DATETIME_MED_WITH_WEEKDAY */.ou.DATETIME_MED_WITH_WEEKDAY)
                                    })
                                ]
                            }),
                            /*#__PURE__*/ (0,jsx_runtime.jsxs)("span", {
                                className: "inline-flex items-center mt-2 sm:mt-0 px-2.5 py-0.5 rounded-md text-sm font-medium bg-indigo-100 text-indigo-800",
                                children: [
                                    round.confirmed_matches,
                                    " matcher"
                                ]
                            }),
                            /*#__PURE__*/ (0,jsx_runtime.jsxs)("span", {
                                className: "inline-flex items-center mt-2 sm:mt-0 ml-2 sm:ml-0 px-2.5 py-0.5 rounded-md text-sm font-medium bg-blue-100 text-blue-800",
                                children: [
                                    round.accepted,
                                    " spelare"
                                ]
                            }),
                            /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                className: "hidden sm:block",
                                children: /*#__PURE__*/ (0,jsx_runtime.jsx)(esm/* ChevronRightIcon */.XCv, {
                                    className: "h-5 w-5 text-gray-400",
                                    "aria-hidden": "true"
                                })
                            })
                        ]
                    })
                })
            })
        })
    }, round.public_id));
};

;// CONCATENATED MODULE: ./components/ds/02-molecules/round-breadcrumbs.tsx



var RoundBreadcrumbs = function(param) {
    var round = param.round, seriesContext = param.seriesContext;
    return(/*#__PURE__*/ (0,jsx_runtime.jsx)("nav", {
        className: "bg-white border-b border-gray-200 flex",
        "aria-label": "Breadcrumb",
        children: /*#__PURE__*/ (0,jsx_runtime.jsxs)("ol", {
            role: "list",
            className: "max-w-screen-xl w-full mx-auto px-4 flex space-x-4 sm:px-6 lg:px-8",
            children: [
                /*#__PURE__*/ (0,jsx_runtime.jsx)("li", {
                    className: "flex",
                    children: /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                        className: "flex items-center",
                        children: /*#__PURE__*/ (0,jsx_runtime.jsx)(next_link["default"], {
                            href: "/series/".concat(seriesContext.id, "/rounds"),
                            children: /*#__PURE__*/ (0,jsx_runtime.jsxs)("a", {
                                className: "text-gray-400 hover:text-gray-500",
                                children: [
                                    /*#__PURE__*/ (0,jsx_runtime.jsx)(esm/* HomeIcon */.tvw, {
                                        className: "flex-shrink-0 h-5 w-5",
                                        "aria-hidden": "true"
                                    }),
                                    /*#__PURE__*/ (0,jsx_runtime.jsx)("span", {
                                        className: "sr-only",
                                        children: "Omg\xe5ngar"
                                    })
                                ]
                            })
                        })
                    })
                }),
                /*#__PURE__*/ (0,jsx_runtime.jsx)("li", {
                    className: "flex",
                    children: /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                        className: "flex items-center",
                        children: [
                            /*#__PURE__*/ (0,jsx_runtime.jsx)("svg", {
                                className: "flex-shrink-0 w-6 h-full text-gray-200",
                                viewBox: "0 0 24 44",
                                preserveAspectRatio: "none",
                                fill: "currentColor",
                                xmlns: "http://www.w3.org/2000/svg",
                                "aria-hidden": "true",
                                children: /*#__PURE__*/ (0,jsx_runtime.jsx)("path", {
                                    d: "M.293 0l22 22-22 22h1.414l22-22-22-22H.293z"
                                })
                            }),
                            /*#__PURE__*/ (0,jsx_runtime.jsx)(next_link["default"], {
                                href: "/series/".concat(seriesContext.id, "/round/").concat(round.public_id),
                                children: /*#__PURE__*/ (0,jsx_runtime.jsx)("a", {
                                    className: "ml-4 text-sm font-medium text-gray-500 hover:text-gray-700",
                                    "aria-current": true,
                                    children: round.name
                                })
                            })
                        ]
                    })
                })
            ]
        })
    }));
};

;// CONCATENATED MODULE: ./components/ds/02-molecules/ranking-row-item/types.ts

var RankedPlayer = es6/* type */.dt({
    name: es6/* string */.Z_,
    points_standing: es6/* number */.pk,
    plus_minus: es6/* number */.pk,
    no_of_matches: es6/* number */.pk,
    created_at: es6/* string */.Z_,
    seeded: es6/* boolean */.O7,
    guest: es6/* boolean */.O7
});

;// CONCATENATED MODULE: ./components/ds/02-molecules/ranking-row-item/index.tsx




var RankingRowItem = function(param) {
    var player = param.player, listIndex = param.listIndex;
    var dtSignedUpAt = luxon/* DateTime.fromISO */.ou.fromISO(player.created_at);
    return(/*#__PURE__*/ (0,jsx_runtime.jsxs)("tr", {
        className: listIndex % 2 === 0 ? 'bg-white' : 'bg-gray-50',
        children: [
            /*#__PURE__*/ (0,jsx_runtime.jsx)("td", {
                className: "px-6 py-4 whitespace-nowrap text-sm font-medium text-gray-900",
                children: listIndex + 1
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)("td", {
                className: "px-6 py-4 whitespace-nowrap text-sm font-medium text-gray-900",
                children: player.name
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)("td", {
                className: "px-6 py-4 whitespace-nowrap text-sm text-gray-500",
                children: player.points_standing
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)("td", {
                className: "px-6 py-4 whitespace-nowrap text-sm text-gray-500",
                children: player.plus_minus
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)("td", {
                className: "px-6 py-4 whitespace-nowrap text-sm text-gray-500",
                children: player.no_of_matches
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)("td", {
                className: "px-6 py-4 whitespace-nowrap text-sm text-gray-500",
                children: dtSignedUpAt.setLocale('sv').toLocaleString(luxon/* DateTime.DATETIME_MED_WITH_WEEKDAY */.ou.DATETIME_MED_WITH_WEEKDAY)
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)("td", {
                className: "px-6 py-4 whitespace-nowrap text-sm text-gray-500",
                children: /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                    className: "flex items-center h-5",
                    children: /*#__PURE__*/ (0,jsx_runtime.jsx)("input", {
                        id: "seeded",
                        name: "seeded",
                        type: "checkbox",
                        className: "focus:ring-indigo-500 h-4 w-4 text-indigo-600 border-gray-300 rounded",
                        checked: player.seeded,
                        disabled: true
                    })
                })
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)("td", {
                className: "px-6 py-4 whitespace-nowrap text-sm text-gray-500",
                children: /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                    className: "flex items-center h-5",
                    children: /*#__PURE__*/ (0,jsx_runtime.jsx)("input", {
                        id: "guest",
                        name: "guest",
                        type: "checkbox",
                        className: "focus:ring-indigo-500 h-4 w-4 text-indigo-600 border-gray-300 rounded",
                        checked: player.guest,
                        disabled: true
                    })
                })
            })
        ]
    }, player.name));
};

;// CONCATENATED MODULE: ./components/ds/02-molecules/index.ts
















// EXTERNAL MODULE: ./node_modules/@auth0/nextjs-auth0/dist/index.browser.js
var index_browser = __webpack_require__(4713);
// EXTERNAL MODULE: ./node_modules/@headlessui/react/dist/components/popover/popover.esm.js
var popover_esm = __webpack_require__(6835);
// EXTERNAL MODULE: ./node_modules/@headlessui/react/dist/components/transitions/transition.esm.js + 3 modules
var transition_esm = __webpack_require__(9196);
;// CONCATENATED MODULE: ./hooks/useFathomEvents/index.tsx
function useFathomEvents() {
    var trackSignupClickOnHome = function() {
        if ( true && window.fathom) window.fathom.trackGoal('0TFCBK70', 0);
    };
    var trackSignupClickOnHeader = function() {
        if ( true && window.fathom) window.fathom.trackGoal('IBCGINO7', 0);
    };
    var trackSubmitSignupForm = function() {
        if ( true && window.fathom) window.fathom.trackGoal('EIZ8Z1YV', 0);
    };
    return {
        trackSignupClickOnHome: trackSignupClickOnHome,
        trackSignupClickOnHeader: trackSignupClickOnHeader,
        trackSubmitSignupForm: trackSubmitSignupForm
    };
};

;// CONCATENATED MODULE: ./components/ds/03-organisms/header/translations.tsx

var translations_translations = {
    sv: {
        solutionsLabel: 'Serier',
        organizationLabel: 'Organisation',
        organizationHref: '/organization',
        partnersLabel: 'Partners',
        partnersHref: '/partners',
        pricingLabel: 'Pris',
        pricingHref: '/pricing',
        signInCta: {
            text: 'Logga in',
            href: '/api/auth/login',
            type: 'link'
        },
        signOutCta: {
            text: 'Logga ut',
            href: '/api/auth/logout',
            type: 'link'
        },
        signUpCta: {
            text: 'Anm\xe4l dig',
            href: '/signup',
            type: 'link'
        },
        solutions: [
            {
                name: 'Inbox',
                description: 'Get a better understanding of where your traffic is coming from.',
                href: '#',
                icon: outline_esm/* InboxIcon */.xx7
            },
            {
                name: 'Messaging',
                description: 'Speak directly to your customers in a more meaningful way.',
                href: '#',
                icon: outline_esm/* AnnotationIcon */.rDX
            },
            {
                name: 'Live Chat',
                description: "Your customers' data will be safe and secure.",
                href: '#',
                icon: outline_esm/* ChatAlt2Icon */.ItX
            },
            {
                name: 'Knowledge Base',
                description: "Connect with third-party tools that you're already using.",
                href: '#',
                icon: outline_esm/* QuestionMarkCircleIcon */.zqj
            }, 
        ]
    },
    en: {
        solutionsLabel: 'Serier',
        organizationLabel: 'Organisation',
        organizationHref: '/organization',
        partnersLabel: 'Partners',
        partnersHref: '/partners',
        pricingLabel: 'Pris',
        pricingHref: '/pricing',
        signInCta: {
            text: 'Sign in',
            href: '/api/auth/login',
            type: 'link'
        },
        signOutCta: {
            text: 'Sign out',
            href: '/api/auth/logout',
            type: 'link'
        },
        signUpCta: {
            text: 'Sign up',
            href: '/signup',
            type: 'link'
        },
        solutions: [
            {
                name: 'Inbox',
                description: 'Get a better understanding of where your traffic is coming from.',
                href: '#',
                icon: outline_esm/* InboxIcon */.xx7
            },
            {
                name: 'Messaging',
                description: 'Speak directly to your customers in a more meaningful way.',
                href: '#',
                icon: outline_esm/* AnnotationIcon */.rDX
            },
            {
                name: 'Live Chat',
                description: "Your customers' data will be safe and secure.",
                href: '#',
                icon: outline_esm/* ChatAlt2Icon */.ItX
            },
            {
                name: 'Knowledge Base',
                description: "Connect with third-party tools that you're already using.",
                href: '#',
                icon: outline_esm/* QuestionMarkCircleIcon */.zqj
            }, 
        ]
    }
};

// EXTERNAL MODULE: ./node_modules/@headlessui/react/dist/components/switch/switch.esm.js + 1 modules
var switch_esm = __webpack_require__(6354);
// EXTERNAL MODULE: ./hooks/index.ts + 1 modules
var hooks = __webpack_require__(6409);
;// CONCATENATED MODULE: ./components/ds/03-organisms/header/sales-tax-selector.tsx




var SalesTaxSelector = function() {
    var ref = (0,hooks/* useSalesTax */.v)(), type = ref.type, setType = ref.setType;
    return(/*#__PURE__*/ (0,jsx_runtime.jsxs)(switch_esm/* Switch.Group */.r.Group, {
        as: "div",
        className: "flex items-center",
        children: [
            /*#__PURE__*/ (0,jsx_runtime.jsx)(switch_esm/* Switch */.r, {
                checked: type === 'inclusive',
                onChange: function() {
                    return setType(type === 'exclusive' ? 'inclusive' : 'exclusive');
                },
                className: (0,classnames/* classNames */.A)(type === 'inclusive' ? 'bg-indigo-600' : 'bg-gray-200', 'relative inline-flex flex-shrink-0 h-6 w-11 border-2 border-transparent rounded-full cursor-pointer transition-colors ease-in-out duration-200 focus:outline-none focus:ring-2 focus:ring-offset-2 focus:ring-indigo-500'),
                children: /*#__PURE__*/ (0,jsx_runtime.jsx)("span", {
                    "aria-hidden": "true",
                    className: (0,classnames/* classNames */.A)(type === 'inclusive' ? 'translate-x-5' : 'translate-x-0', 'pointer-events-none inline-block h-5 w-5 rounded-full bg-white shadow transform ring-0 transition ease-in-out duration-200')
                })
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsxs)(switch_esm/* Switch.Label */.r.Label, {
                as: "span",
                className: "ml-3",
                children: [
                    /*#__PURE__*/ (0,jsx_runtime.jsx)("span", {
                        className: "text-sm font-medium text-gray-900",
                        children: "Inkl. moms."
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)("span", {
                        className: "ml-2 text-sm text-gray-500",
                        children: "(visa priser)"
                    })
                ]
            })
        ]
    }));
};

;// CONCATENATED MODULE: ./components/ds/03-organisms/header/index.tsx















var solutions = [
    {
        name: 'Plattform',
        description: 'Vi levererar en komplett l\xf6sning s\xe5 att du kan starta en grupp i din stad.',
        linkText: 'Kontakta oss',
        href: 'https://forms.reform.app/gLNw4a/kontaktformular/jo0zn1',
        type: 'external',
        icon: outline_esm/* DesktopComputerIcon */.DAM
    },
    {
        name: 'Turneringar m.m.',
        description: 'I systemet kan du \xe4ven skapa och hantera enskilda turneringar f\xf6r att skapa mer v\xe4rde f\xf6r dina medlemmar.',
        linkText: 'Kontakta oss',
        href: 'https://forms.reform.app/gLNw4a/kontaktformular/jo0zn1',
        type: 'external',
        icon: outline_esm/* PlayIcon */.o1U
    }, 
];
var callsToAction = [
    {
        name: 'Kontakta oss',
        href: 'https://forms.reform.app/gLNw4a/kontaktformular/jo0zn1',
        type: 'external',
        icon: outline_esm/* PhoneIcon */.qWc
    }, 
];
var blogPosts = [
    {
        id: 1,
        name: 'Rapport fr\xe5n andra s\xe4songen',
        href: '/resultat/np-v22',
        preview: 'Under v\xe5ren 2022 genomf\xf6rde vi den andra s\xe4songen. S\xe5h\xe4r gick det.',
        imageUrl: '/assets/martin-hitting-the-ball.jpg'
    },
    {
        id: 2,
        name: 'F\xf6rsta s\xe4songen avklarad',
        href: '/resultat/onp-h21',
        preview: 'Fredag den 17e december genomf\xf6rde vi den f\xf6rsta s\xe4songsavslutningen av \xd6-viks N\xe4tverkspadel.',
        imageUrl: '/assets/fredrik-striking-ball.jpg'
    }, 
];
var Header = function(param1) {
    var series = param1.series;
    var trackSignupClickOnHeader = useFathomEvents().trackSignupClickOnHeader;
    var userData = (0,index_browser/* useUser */.aF)();
    var user = userData.user, error = userData.error, isLoading = userData.isLoading;
    var router = (0,next_router.useRouter)();
    var locale = (0,utils_locale/* makeLocale */.W)(router.locale, router.defaultLocale) || 'sv';
    var translation = translations_translations[locale];
    var sortedSeries = (0,lodash.orderBy)(series, [
        'series_start'
    ], [
        'desc'
    ]);
    return(/*#__PURE__*/ (0,jsx_runtime.jsx)("header", {
        className: "pb-5",
        children: /*#__PURE__*/ (0,jsx_runtime.jsxs)(popover_esm/* Popover */.J, {
            className: "relative bg-white",
            children: [
                /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                    className: "pointer-events-none absolute inset-0 z-30 shadow",
                    "aria-hidden": "true"
                }),
                /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                    className: "relative z-20",
                    children: /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                        className: "mx-auto flex max-w-7xl items-center justify-between px-4 py-5 sm:px-6 sm:py-4 md:justify-start md:space-x-10 lg:px-8",
                        children: [
                            /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                children: /*#__PURE__*/ (0,jsx_runtime.jsx)(next_link["default"], {
                                    href: "/",
                                    children: /*#__PURE__*/ (0,jsx_runtime.jsxs)("a", {
                                        children: [
                                            /*#__PURE__*/ (0,jsx_runtime.jsx)("span", {
                                                className: "sr-only",
                                                children: "N\xe4tverkspadel"
                                            }),
                                            /*#__PURE__*/ (0,jsx_runtime.jsx)("img", {
                                                className: "h-8 w-auto sm:h-12",
                                                src: "/logo/onp-text-logo-800x500.svg",
                                                alt: "N\xe4tverkspadel logo"
                                            })
                                        ]
                                    })
                                })
                            }),
                            /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                className: "-my-2 -mr-2 md:hidden",
                                children: /*#__PURE__*/ (0,jsx_runtime.jsxs)(popover_esm/* Popover.Button */.J.Button, {
                                    className: "inline-flex items-center justify-center rounded-md bg-white p-2 text-gray-400 hover:bg-gray-100 hover:text-gray-500 focus:outline-none focus:ring-2 focus:ring-inset focus:ring-indigo-500",
                                    children: [
                                        /*#__PURE__*/ (0,jsx_runtime.jsx)("span", {
                                            className: "sr-only",
                                            children: "Open menu"
                                        }),
                                        /*#__PURE__*/ (0,jsx_runtime.jsx)(outline_esm/* MenuIcon */.Oqj, {
                                            className: "h-6 w-6",
                                            "aria-hidden": "true"
                                        })
                                    ]
                                })
                            }),
                            /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                                className: "hidden md:flex md:flex-1 md:items-center md:justify-between",
                                children: [
                                    /*#__PURE__*/ (0,jsx_runtime.jsxs)(popover_esm/* Popover.Group */.J.Group, {
                                        as: "nav",
                                        className: "flex space-x-10",
                                        children: [
                                            /*#__PURE__*/ (0,jsx_runtime.jsx)(popover_esm/* Popover */.J, {
                                                children: function(param) {
                                                    var open = param.open;
                                                    /*#__PURE__*/ return (0,jsx_runtime.jsxs)(jsx_runtime.Fragment, {
                                                        children: [
                                                            /*#__PURE__*/ (0,jsx_runtime.jsxs)(popover_esm/* Popover.Button */.J.Button, {
                                                                className: (0,classnames/* classNames */.A)(open ? 'text-gray-900' : 'text-gray-500', 'group inline-flex items-center rounded-md bg-white text-base font-medium hover:text-gray-900 focus:outline-none focus:ring-2 focus:ring-indigo-500 focus:ring-offset-2'),
                                                                children: [
                                                                    /*#__PURE__*/ (0,jsx_runtime.jsx)("span", {
                                                                        children: "Spela padel"
                                                                    }),
                                                                    /*#__PURE__*/ (0,jsx_runtime.jsx)(esm/* ChevronDownIcon */.v4q, {
                                                                        className: (0,classnames/* classNames */.A)(open ? 'text-gray-600' : 'text-gray-400', 'ml-2 h-5 w-5 group-hover:text-gray-500'),
                                                                        "aria-hidden": "true"
                                                                    })
                                                                ]
                                                            }),
                                                            /*#__PURE__*/ (0,jsx_runtime.jsx)(transition_esm/* Transition */.u, {
                                                                as: react.Fragment,
                                                                enter: "transition ease-out duration-200",
                                                                enterFrom: "opacity-0 -translate-y-1",
                                                                enterTo: "opacity-100 translate-y-0",
                                                                leave: "transition ease-in duration-150",
                                                                leaveFrom: "opacity-100 translate-y-0",
                                                                leaveTo: "opacity-0 -translate-y-1",
                                                                children: /*#__PURE__*/ (0,jsx_runtime.jsxs)(popover_esm/* Popover.Panel */.J.Panel, {
                                                                    className: "absolute inset-x-0 top-full z-10 hidden transform shadow-lg md:block",
                                                                    children: [
                                                                        /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                                                                            className: "absolute inset-0 flex",
                                                                            children: [
                                                                                /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                                                                    className: "w-1/2 bg-white"
                                                                                }),
                                                                                /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                                                                    className: "w-1/2 bg-gray-50"
                                                                                })
                                                                            ]
                                                                        }),
                                                                        /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                                                                            className: "relative mx-auto grid max-w-7xl grid-cols-1 lg:grid-cols-2",
                                                                            children: [
                                                                                /*#__PURE__*/ (0,jsx_runtime.jsxs)("nav", {
                                                                                    className: "grid gap-y-10 bg-white px-4 py-8 sm:grid-cols-2 sm:gap-x-8 sm:py-12 sm:px-6 lg:px-8 xl:pr-12",
                                                                                    children: [
                                                                                        /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                                                                                            children: [
                                                                                                /*#__PURE__*/ (0,jsx_runtime.jsx)("h3", {
                                                                                                    className: "text-sm font-medium uppercase tracking-wide text-gray-500",
                                                                                                    children: "Seriespel"
                                                                                                }),
                                                                                                /*#__PURE__*/ (0,jsx_runtime.jsx)("ul", {
                                                                                                    role: "list",
                                                                                                    className: "mt-5 space-y-6",
                                                                                                    children: sortedSeries.filter(function(s) {
                                                                                                        return s.series_type === 'team' || s.series_type === 'single_player';
                                                                                                    }).map(function(s) {
                                                                                                        /*#__PURE__*/ return (0,jsx_runtime.jsx)("li", {
                                                                                                            className: "flow-root",
                                                                                                            children: /*#__PURE__*/ (0,jsx_runtime.jsx)(next_link["default"], {
                                                                                                                href: s.series_type === 'team' ? "/series/".concat(s.series_id, "/team/standings") : s.series_type === 'player' ? "/series/".concat(s.series_id, "/player/standings") : "/series/".concat(s.series_id, "/team/standings"),
                                                                                                                children: /*#__PURE__*/ (0,jsx_runtime.jsxs)("a", {
                                                                                                                    className: "-m-3 flex items-center gap-x-2 rounded-md p-3 text-base font-medium text-gray-900 hover:bg-gray-50",
                                                                                                                    children: [
                                                                                                                        s.series_name,
                                                                                                                        ' ',
                                                                                                                        /*#__PURE__*/ (0,jsx_runtime.jsx)("span", {
                                                                                                                            className: "text-xs font-extralight text-slate-600",
                                                                                                                            children: "(\xd6rnsk\xf6ldsvik)"
                                                                                                                        })
                                                                                                                    ]
                                                                                                                })
                                                                                                            })
                                                                                                        }, s.series_id);
                                                                                                    })
                                                                                                })
                                                                                            ]
                                                                                        }),
                                                                                        /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                                                                                            children: [
                                                                                                /*#__PURE__*/ (0,jsx_runtime.jsx)("h3", {
                                                                                                    className: "text-sm font-medium uppercase tracking-wide text-gray-500",
                                                                                                    children: "Turneringar"
                                                                                                }),
                                                                                                /*#__PURE__*/ (0,jsx_runtime.jsx)("ul", {
                                                                                                    role: "list",
                                                                                                    className: "mt-5 space-y-6",
                                                                                                    children: sortedSeries.filter(function(s) {
                                                                                                        return s.series_type === 'tournament';
                                                                                                    }).map(function(s) {
                                                                                                        /*#__PURE__*/ return (0,jsx_runtime.jsx)("li", {
                                                                                                            className: "flow-root",
                                                                                                            children: /*#__PURE__*/ (0,jsx_runtime.jsx)(next_link["default"], {
                                                                                                                href: "/series/".concat(s.series_id, "/tournament/standings"),
                                                                                                                children: /*#__PURE__*/ (0,jsx_runtime.jsxs)("a", {
                                                                                                                    className: "-m-3 flex items-center gap-x-2 rounded-md p-3 text-base font-medium text-gray-900 hover:bg-gray-50",
                                                                                                                    children: [
                                                                                                                        s.series_name,
                                                                                                                        ' ',
                                                                                                                        /*#__PURE__*/ (0,jsx_runtime.jsx)("span", {
                                                                                                                            className: "text-xs font-extralight text-slate-600",
                                                                                                                            children: "(\xd6rnsk\xf6ldsvik)"
                                                                                                                        })
                                                                                                                    ]
                                                                                                                })
                                                                                                            })
                                                                                                        }, s.series_id);
                                                                                                    })
                                                                                                })
                                                                                            ]
                                                                                        })
                                                                                    ]
                                                                                }),
                                                                                /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                                                                    className: "bg-gray-50 px-4 py-8 sm:py-12 sm:px-6 lg:px-8 xl:pl-12",
                                                                                    children: /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                                                                                        children: [
                                                                                            /*#__PURE__*/ (0,jsx_runtime.jsx)("h3", {
                                                                                                className: "text-sm font-medium uppercase tracking-wide text-gray-500",
                                                                                                children: "Fr\xe5n historiken"
                                                                                            }),
                                                                                            /*#__PURE__*/ (0,jsx_runtime.jsx)("ul", {
                                                                                                role: "list",
                                                                                                className: "mt-6 space-y-6",
                                                                                                children: blogPosts.map(function(post) {
                                                                                                    /*#__PURE__*/ return (0,jsx_runtime.jsx)("li", {
                                                                                                        className: "flow-root",
                                                                                                        children: /*#__PURE__*/ (0,jsx_runtime.jsxs)("a", {
                                                                                                            href: post.href,
                                                                                                            className: "-m-3 flex rounded-lg p-3 hover:bg-gray-100",
                                                                                                            children: [
                                                                                                                /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                                                                                                    className: "hidden flex-shrink-0 sm:block",
                                                                                                                    children: /*#__PURE__*/ (0,jsx_runtime.jsx)("img", {
                                                                                                                        className: "h-20 w-32 rounded-md object-cover",
                                                                                                                        src: post.imageUrl,
                                                                                                                        alt: ""
                                                                                                                    })
                                                                                                                }),
                                                                                                                /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                                                                                                                    className: "w-0 flex-1 sm:ml-8",
                                                                                                                    children: [
                                                                                                                        /*#__PURE__*/ (0,jsx_runtime.jsx)("h4", {
                                                                                                                            className: "truncate text-base font-medium text-gray-900",
                                                                                                                            children: post.name
                                                                                                                        }),
                                                                                                                        /*#__PURE__*/ (0,jsx_runtime.jsx)("p", {
                                                                                                                            className: "mt-1 text-sm text-gray-500",
                                                                                                                            children: post.preview
                                                                                                                        })
                                                                                                                    ]
                                                                                                                })
                                                                                                            ]
                                                                                                        })
                                                                                                    }, post.id);
                                                                                                })
                                                                                            })
                                                                                        ]
                                                                                    })
                                                                                })
                                                                            ]
                                                                        })
                                                                    ]
                                                                })
                                                            })
                                                        ]
                                                    });
                                                }
                                            }),
                                            /*#__PURE__*/ (0,jsx_runtime.jsx)(popover_esm/* Popover */.J, {
                                                children: function(param) {
                                                    var open = param.open;
                                                    /*#__PURE__*/ return (0,jsx_runtime.jsxs)(jsx_runtime.Fragment, {
                                                        children: [
                                                            /*#__PURE__*/ (0,jsx_runtime.jsxs)(popover_esm/* Popover.Button */.J.Button, {
                                                                className: (0,classnames/* classNames */.A)(open ? 'text-gray-900' : 'text-gray-500', 'group inline-flex items-center rounded-md bg-white text-base font-medium hover:text-gray-900 focus:outline-none focus:ring-2 focus:ring-indigo-500 focus:ring-offset-2'),
                                                                children: [
                                                                    /*#__PURE__*/ (0,jsx_runtime.jsx)("span", {
                                                                        children: "Starta"
                                                                    }),
                                                                    /*#__PURE__*/ (0,jsx_runtime.jsx)(esm/* ChevronDownIcon */.v4q, {
                                                                        className: (0,classnames/* classNames */.A)(open ? 'text-gray-600' : 'text-gray-400', 'ml-2 h-5 w-5 group-hover:text-gray-500'),
                                                                        "aria-hidden": "true"
                                                                    })
                                                                ]
                                                            }),
                                                            /*#__PURE__*/ (0,jsx_runtime.jsx)(transition_esm/* Transition */.u, {
                                                                as: react.Fragment,
                                                                enter: "transition ease-out duration-200",
                                                                enterFrom: "opacity-0 -translate-y-1",
                                                                enterTo: "opacity-100 translate-y-0",
                                                                leave: "transition ease-in duration-150",
                                                                leaveFrom: "opacity-100 translate-y-0",
                                                                leaveTo: "opacity-0 -translate-y-1",
                                                                children: /*#__PURE__*/ (0,jsx_runtime.jsxs)(popover_esm/* Popover.Panel */.J.Panel, {
                                                                    className: "absolute inset-x-0 top-full z-10 hidden transform bg-white shadow-lg md:block",
                                                                    children: [
                                                                        /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                                                            className: "mx-auto grid max-w-7xl gap-y-6 px-4 py-6 sm:grid-cols-2 sm:gap-8 sm:px-6 sm:py-8 lg:grid-cols-4 lg:px-8 lg:py-12 xl:py-16",
                                                                            children: solutions.map(function(item) {
                                                                                /*#__PURE__*/ return (0,jsx_runtime.jsx)("a", {
                                                                                    href: item.href,
                                                                                    className: "-m-3 flex flex-col justify-between rounded-lg p-3 hover:bg-gray-50",
                                                                                    target: item.type === 'external' ? '_blank' : '',
                                                                                    rel: "noreferrer",
                                                                                    children: /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                                                                                        className: "flex md:h-full lg:flex-col",
                                                                                        children: [
                                                                                            /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                                                                                className: "flex-shrink-0",
                                                                                                children: /*#__PURE__*/ (0,jsx_runtime.jsx)("span", {
                                                                                                    className: "inline-flex h-10 w-10 items-center justify-center rounded-md bg-indigo-500 text-white sm:h-12 sm:w-12",
                                                                                                    children: /*#__PURE__*/ (0,jsx_runtime.jsx)(item.icon, {
                                                                                                        className: "h-6 w-6",
                                                                                                        "aria-hidden": "true"
                                                                                                    })
                                                                                                })
                                                                                            }),
                                                                                            /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                                                                                                className: "ml-4 md:flex md:flex-1 md:flex-col md:justify-between lg:ml-0 lg:mt-4",
                                                                                                children: [
                                                                                                    /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                                                                                                        children: [
                                                                                                            /*#__PURE__*/ (0,jsx_runtime.jsx)("p", {
                                                                                                                className: "text-base font-medium text-gray-900",
                                                                                                                children: item.name
                                                                                                            }),
                                                                                                            /*#__PURE__*/ (0,jsx_runtime.jsx)("p", {
                                                                                                                className: "mt-1 text-sm text-gray-500",
                                                                                                                children: item.description
                                                                                                            })
                                                                                                        ]
                                                                                                    }),
                                                                                                    /*#__PURE__*/ (0,jsx_runtime.jsxs)("p", {
                                                                                                        className: "mt-2 text-sm font-medium text-indigo-600 lg:mt-4",
                                                                                                        children: [
                                                                                                            item.linkText,
                                                                                                            " ",
                                                                                                            /*#__PURE__*/ (0,jsx_runtime.jsx)("span", {
                                                                                                                "aria-hidden": "true",
                                                                                                                children: "→"
                                                                                                            })
                                                                                                        ]
                                                                                                    })
                                                                                                ]
                                                                                            })
                                                                                        ]
                                                                                    })
                                                                                }, item.name);
                                                                            })
                                                                        }),
                                                                        /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                                                            className: "bg-gray-50",
                                                                            children: /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                                                                className: "mx-auto max-w-7xl space-y-6 px-4 py-5 sm:flex sm:space-y-0 sm:space-x-10 sm:px-6 lg:px-8",
                                                                                children: callsToAction.map(function(item) {
                                                                                    /*#__PURE__*/ return (0,jsx_runtime.jsx)("div", {
                                                                                        className: "flow-root",
                                                                                        children: /*#__PURE__*/ (0,jsx_runtime.jsxs)("a", {
                                                                                            href: item.href,
                                                                                            className: "-m-3 flex items-center rounded-md p-3 text-base font-medium text-gray-900 hover:bg-gray-100",
                                                                                            target: item.type === 'external' ? '_blank' : '',
                                                                                            rel: "noreferrer",
                                                                                            children: [
                                                                                                /*#__PURE__*/ (0,jsx_runtime.jsx)(item.icon, {
                                                                                                    className: "h-6 w-6 flex-shrink-0 text-gray-400",
                                                                                                    "aria-hidden": "true"
                                                                                                }),
                                                                                                /*#__PURE__*/ (0,jsx_runtime.jsx)("span", {
                                                                                                    className: "ml-3",
                                                                                                    children: item.name
                                                                                                })
                                                                                            ]
                                                                                        })
                                                                                    }, item.name);
                                                                                })
                                                                            })
                                                                        })
                                                                    ]
                                                                })
                                                            })
                                                        ]
                                                    });
                                                }
                                            }),
                                            /*#__PURE__*/ (0,jsx_runtime.jsx)("a", {
                                                href: "https://forms.reform.app/gLNw4a/kontaktformular/jo0zn1",
                                                className: "text-base font-medium text-gray-500 hover:text-gray-900",
                                                target: "_blank",
                                                rel: "noreferrer noopener",
                                                children: "Kontakta oss"
                                            })
                                        ]
                                    }),
                                    /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                                        className: "flex items-center gap-x-4 md:ml-12",
                                        children: [
                                            /*#__PURE__*/ (0,jsx_runtime.jsx)(SalesTaxSelector, {}),
                                            !isLoading && !error && !user ? /*#__PURE__*/ (0,jsx_runtime.jsx)(next_link["default"], {
                                                href: translation.signInCta.href,
                                                children: /*#__PURE__*/ (0,jsx_runtime.jsx)("a", {
                                                    className: "text-base font-medium text-gray-500 hover:text-gray-900",
                                                    children: translation.signInCta.text
                                                })
                                            }) : null,
                                            !isLoading && !error && user ? /*#__PURE__*/ (0,jsx_runtime.jsx)(next_link["default"], {
                                                href: translation.signOutCta.href,
                                                children: /*#__PURE__*/ (0,jsx_runtime.jsx)("a", {
                                                    className: "text-base font-medium text-gray-500 hover:text-gray-900",
                                                    children: translation.signOutCta.text
                                                })
                                            }) : null
                                        ]
                                    })
                                ]
                            })
                        ]
                    })
                }),
                /*#__PURE__*/ (0,jsx_runtime.jsx)(transition_esm/* Transition */.u, {
                    as: react.Fragment,
                    enter: "duration-200 ease-out",
                    enterFrom: "opacity-0 scale-95",
                    enterTo: "opacity-100 scale-100",
                    leave: "duration-100 ease-in",
                    leaveFrom: "opacity-100 scale-100",
                    leaveTo: "opacity-0 scale-95",
                    children: /*#__PURE__*/ (0,jsx_runtime.jsx)(popover_esm/* Popover.Panel */.J.Panel, {
                        focus: true,
                        className: "absolute inset-x-0 top-0 z-30 origin-top-right transform p-2 transition md:hidden",
                        children: /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                            className: "divide-y-2 divide-gray-50 rounded-lg bg-white shadow-lg ring-1 ring-black ring-opacity-5",
                            children: [
                                /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                                    className: "px-5 pt-5 pb-6 sm:pb-8",
                                    children: [
                                        /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                                            className: "flex items-center justify-between",
                                            children: [
                                                /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                                    children: /*#__PURE__*/ (0,jsx_runtime.jsx)(next_link["default"], {
                                                        href: "/",
                                                        children: /*#__PURE__*/ (0,jsx_runtime.jsx)("a", {
                                                            children: /*#__PURE__*/ (0,jsx_runtime.jsx)("img", {
                                                                className: "h-8 w-auto",
                                                                src: "/logo/onp-text-logo-800x500.svg",
                                                                alt: "N\xe4tverkspadel logo"
                                                            })
                                                        })
                                                    })
                                                }),
                                                /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                                    className: "-mr-2",
                                                    children: /*#__PURE__*/ (0,jsx_runtime.jsxs)(popover_esm/* Popover.Button */.J.Button, {
                                                        className: "inline-flex items-center justify-center rounded-md bg-white p-2 text-gray-400 hover:bg-gray-100 hover:text-gray-500 focus:outline-none focus:ring-2 focus:ring-inset focus:ring-indigo-500",
                                                        children: [
                                                            /*#__PURE__*/ (0,jsx_runtime.jsx)("span", {
                                                                className: "sr-only",
                                                                children: "Close menu"
                                                            }),
                                                            /*#__PURE__*/ (0,jsx_runtime.jsx)(outline_esm/* XIcon */.b0D, {
                                                                className: "h-6 w-6",
                                                                "aria-hidden": "true"
                                                            })
                                                        ]
                                                    })
                                                })
                                            ]
                                        }),
                                        /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                            className: "mt-6 sm:mt-8",
                                            children: /*#__PURE__*/ (0,jsx_runtime.jsx)("nav", {
                                                children: /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                                    className: "grid gap-7 sm:grid-cols-2 sm:gap-y-8 sm:gap-x-4",
                                                    children: solutions.map(function(item) {
                                                        /*#__PURE__*/ return (0,jsx_runtime.jsxs)("a", {
                                                            href: item.href,
                                                            className: "-m-3 flex items-center rounded-lg p-3 hover:bg-gray-50",
                                                            target: item.type === 'external' ? '_blank' : '',
                                                            rel: "noreferrer",
                                                            children: [
                                                                /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                                                    className: "flex h-10 w-10 flex-shrink-0 items-center justify-center rounded-md bg-indigo-500 text-white sm:h-12 sm:w-12",
                                                                    children: /*#__PURE__*/ (0,jsx_runtime.jsx)(item.icon, {
                                                                        className: "h-6 w-6",
                                                                        "aria-hidden": "true"
                                                                    })
                                                                }),
                                                                /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                                                    className: "ml-4 text-base font-medium text-gray-900",
                                                                    children: item.name
                                                                })
                                                            ]
                                                        }, item.name);
                                                    })
                                                })
                                            })
                                        })
                                    ]
                                }),
                                /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                                    className: "py-6 px-5",
                                    children: [
                                        /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                                            className: "grid grid-cols-2 gap-4",
                                            children: [
                                                sortedSeries.filter(function(s) {
                                                    return s.series_type === 'team' || s.series_type === 'single_player';
                                                }).map(function(s) {
                                                    /*#__PURE__*/ return (0,jsx_runtime.jsx)(next_link["default"], {
                                                        href: s.series_type === 'team' ? "/series/".concat(s.series_id, "/team/standings") : s.series_type === 'player' ? "/series/".concat(s.series_id, "/player/standings") : "/series/".concat(s.series_id, "/team/standings"),
                                                        children: /*#__PURE__*/ (0,jsx_runtime.jsxs)("a", {
                                                            className: "rounded-md text-base font-medium text-gray-900 hover:text-gray-700",
                                                            children: [
                                                                s.series_name,
                                                                ' ',
                                                                /*#__PURE__*/ (0,jsx_runtime.jsx)("span", {
                                                                    className: "text-xs font-extralight text-slate-600",
                                                                    children: "(\xd6rnsk\xf6ldsvik)"
                                                                })
                                                            ]
                                                        })
                                                    }, s.series_id);
                                                }),
                                                sortedSeries.filter(function(s) {
                                                    return s.series_type === 'tournament';
                                                }).map(function(s) {
                                                    /*#__PURE__*/ return (0,jsx_runtime.jsx)(next_link["default"], {
                                                        href: "/series/".concat(s.series_id, "/tournament/standings"),
                                                        children: /*#__PURE__*/ (0,jsx_runtime.jsxs)("a", {
                                                            className: "rounded-md text-base font-medium text-gray-900 hover:text-gray-700",
                                                            children: [
                                                                s.series_name,
                                                                ' ',
                                                                /*#__PURE__*/ (0,jsx_runtime.jsx)("span", {
                                                                    className: "text-xs font-extralight text-slate-600",
                                                                    children: "(\xd6rnsk\xf6ldsvik)"
                                                                })
                                                            ]
                                                        })
                                                    }, s.series_id);
                                                })
                                            ]
                                        }),
                                        /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                            className: "mt-6 grid grid-cols-2 gap-4",
                                            children: /*#__PURE__*/ (0,jsx_runtime.jsx)("a", {
                                                href: "https://forms.reform.app/gLNw4a/kontaktformular/jo0zn1",
                                                className: "rounded-md text-base font-medium text-gray-900 hover:text-gray-700",
                                                target: "_blank",
                                                rel: "noreferrer nooper",
                                                children: "Kontakta oss"
                                            })
                                        }),
                                        /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                                            className: "mt-6",
                                            children: [
                                                !isLoading && !error && !user ? /*#__PURE__*/ (0,jsx_runtime.jsx)(next_link["default"], {
                                                    href: translation.signInCta.href,
                                                    children: /*#__PURE__*/ (0,jsx_runtime.jsx)("a", {
                                                        className: "flex w-full items-center justify-center rounded-md border border-transparent bg-indigo-600 px-4 py-2 text-base font-medium text-white shadow-sm hover:bg-indigo-700",
                                                        children: translation.signInCta.text
                                                    })
                                                }) : null,
                                                !isLoading && !error && user ? /*#__PURE__*/ (0,jsx_runtime.jsx)(next_link["default"], {
                                                    href: translation.signOutCta.href,
                                                    children: /*#__PURE__*/ (0,jsx_runtime.jsx)("a", {
                                                        className: "flex w-full items-center justify-center rounded-md border border-transparent bg-indigo-600 px-4 py-2 text-base font-medium text-white shadow-sm hover:bg-indigo-700",
                                                        children: translation.signOutCta.text
                                                    })
                                                }) : null
                                            ]
                                        })
                                    ]
                                })
                            ]
                        })
                    })
                })
            ]
        })
    }));
};

;// CONCATENATED MODULE: ./components/ds/03-organisms/footer/translations.tsx

function translations_defineProperty(obj, key, value) {
    if (key in obj) {
        Object.defineProperty(obj, key, {
            value: value,
            enumerable: true,
            configurable: true,
            writable: true
        });
    } else {
        obj[key] = value;
    }
    return obj;
}
function translations_objectSpread(target) {
    for(var i = 1; i < arguments.length; i++){
        var source = arguments[i] != null ? arguments[i] : {};
        var ownKeys = Object.keys(source);
        if (typeof Object.getOwnPropertySymbols === "function") {
            ownKeys = ownKeys.concat(Object.getOwnPropertySymbols(source).filter(function(sym) {
                return Object.getOwnPropertyDescriptor(source, sym).enumerable;
            }));
        }
        ownKeys.forEach(function(key) {
            translations_defineProperty(target, key, source[key]);
        });
    }
    return target;
}
var footer_translations_translations = {
    sv: {
        solutionsLabel: 'L\xf6sningar',
        supportLabel: 'Support',
        legalLabel: 'Det finstilta',
        organizationLabel: 'Organisation',
        footerNavigation: {
            solutions: [
                {
                    name: 'Marketing',
                    href: '#'
                },
                {
                    name: 'Analytics',
                    href: '#'
                },
                {
                    name: 'Commerce',
                    href: '#'
                },
                {
                    name: 'Insights',
                    href: '#'
                }, 
            ],
            support: [
                {
                    name: 'Startsida',
                    href: '/'
                },
                {
                    name: 'Kontakta oss',
                    href: '/kontakt',
                    type: 'external'
                }
            ],
            company: [],
            legal: [
                {
                    name: 'Claim',
                    href: '#'
                },
                {
                    name: 'Privacy',
                    href: '#'
                },
                {
                    name: 'Terms',
                    href: '#'
                }, 
            ],
            social: [
                {
                    name: 'Instagram',
                    href: 'https://www.instagram.com/natverkspadel/',
                    icon: function(props) {
                        /*#__PURE__*/ return (0,jsx_runtime.jsx)("svg", translations_objectSpread({
                            fill: "currentColor",
                            viewBox: "0 0 24 24"
                        }, props, {
                            children: /*#__PURE__*/ (0,jsx_runtime.jsx)("path", {
                                fillRule: "evenodd",
                                d: "M12.315 2c2.43 0 2.784.013 3.808.06 1.064.049 1.791.218 2.427.465a4.902 4.902 0 011.772 1.153 4.902 4.902 0 011.153 1.772c.247.636.416 1.363.465 2.427.048 1.067.06 1.407.06 4.123v.08c0 2.643-.012 2.987-.06 4.043-.049 1.064-.218 1.791-.465 2.427a4.902 4.902 0 01-1.153 1.772 4.902 4.902 0 01-1.772 1.153c-.636.247-1.363.416-2.427.465-1.067.048-1.407.06-4.123.06h-.08c-2.643 0-2.987-.012-4.043-.06-1.064-.049-1.791-.218-2.427-.465a4.902 4.902 0 01-1.772-1.153 4.902 4.902 0 01-1.153-1.772c-.247-.636-.416-1.363-.465-2.427-.047-1.024-.06-1.379-.06-3.808v-.63c0-2.43.013-2.784.06-3.808.049-1.064.218-1.791.465-2.427a4.902 4.902 0 011.153-1.772A4.902 4.902 0 015.45 2.525c.636-.247 1.363-.416 2.427-.465C8.901 2.013 9.256 2 11.685 2h.63zm-.081 1.802h-.468c-2.456 0-2.784.011-3.807.058-.975.045-1.504.207-1.857.344-.467.182-.8.398-1.15.748-.35.35-.566.683-.748 1.15-.137.353-.3.882-.344 1.857-.047 1.023-.058 1.351-.058 3.807v.468c0 2.456.011 2.784.058 3.807.045.975.207 1.504.344 1.857.182.466.399.8.748 1.15.35.35.683.566 1.15.748.353.137.882.3 1.857.344 1.054.048 1.37.058 4.041.058h.08c2.597 0 2.917-.01 3.96-.058.976-.045 1.505-.207 1.858-.344.466-.182.8-.398 1.15-.748.35-.35.566-.683.748-1.15.137-.353.3-.882.344-1.857.048-1.055.058-1.37.058-4.041v-.08c0-2.597-.01-2.917-.058-3.96-.045-.976-.207-1.505-.344-1.858a3.097 3.097 0 00-.748-1.15 3.098 3.098 0 00-1.15-.748c-.353-.137-.882-.3-1.857-.344-1.023-.047-1.351-.058-3.807-.058zM12 6.865a5.135 5.135 0 110 10.27 5.135 5.135 0 010-10.27zm0 1.802a3.333 3.333 0 100 6.666 3.333 3.333 0 000-6.666zm5.338-3.205a1.2 1.2 0 110 2.4 1.2 1.2 0 010-2.4z",
                                clipRule: "evenodd"
                            })
                        }));
                    }
                },
                {
                    name: 'LinkedIn',
                    href: 'https://www.linkedin.com/company/natverkspadel',
                    icon: function(props) {
                        /*#__PURE__*/ return (0,jsx_runtime.jsx)("svg", translations_objectSpread({
                            fill: "currentColor",
                            viewBox: "0 0 448 512"
                        }, props, {
                            children: /*#__PURE__*/ (0,jsx_runtime.jsx)("path", {
                                d: "M100.28 448H7.4V148.9h92.88zM53.79 108.1C24.09 108.1 0 83.5 0 53.8a53.79 53.79 0 0 1 107.58 0c0 29.7-24.1 54.3-53.79 54.3zM447.9 448h-92.68V302.4c0-34.7-.7-79.2-48.29-79.2-48.29 0-55.69 37.7-55.69 76.7V448h-92.78V148.9h89.08v40.8h1.3c12.4-23.5 42.69-48.3 87.88-48.3 94 0 111.28 61.9 111.28 142.3V448z"
                            })
                        }));
                    }
                }, 
            ]
        }
    },
    en: {
        solutionsLabel: 'L\xf6sningar',
        supportLabel: 'Support',
        legalLabel: 'Legal',
        organizationLabel: 'Organisation',
        footerNavigation: {
            solutions: [
                {
                    name: 'Marketing',
                    href: '#'
                },
                {
                    name: 'Analytics',
                    href: '#'
                },
                {
                    name: 'Commerce',
                    href: '#'
                },
                {
                    name: 'Insights',
                    href: '#'
                }, 
            ],
            support: [
                {
                    name: 'Home',
                    href: '/'
                },
                {
                    name: 'Contact us',
                    href: '/contact'
                }
            ],
            company: [],
            legal: [
                {
                    name: 'Claim',
                    href: '#'
                },
                {
                    name: 'Privacy',
                    href: '#'
                },
                {
                    name: 'Terms',
                    href: '#'
                }, 
            ],
            social: [
                {
                    name: 'Instagram',
                    href: 'https://www.instagram.com/natverkspadel/',
                    icon: function(props) {
                        /*#__PURE__*/ return (0,jsx_runtime.jsx)("svg", translations_objectSpread({
                            fill: "currentColor",
                            viewBox: "0 0 24 24"
                        }, props, {
                            children: /*#__PURE__*/ (0,jsx_runtime.jsx)("path", {
                                fillRule: "evenodd",
                                d: "M12.315 2c2.43 0 2.784.013 3.808.06 1.064.049 1.791.218 2.427.465a4.902 4.902 0 011.772 1.153 4.902 4.902 0 011.153 1.772c.247.636.416 1.363.465 2.427.048 1.067.06 1.407.06 4.123v.08c0 2.643-.012 2.987-.06 4.043-.049 1.064-.218 1.791-.465 2.427a4.902 4.902 0 01-1.153 1.772 4.902 4.902 0 01-1.772 1.153c-.636.247-1.363.416-2.427.465-1.067.048-1.407.06-4.123.06h-.08c-2.643 0-2.987-.012-4.043-.06-1.064-.049-1.791-.218-2.427-.465a4.902 4.902 0 01-1.772-1.153 4.902 4.902 0 01-1.153-1.772c-.247-.636-.416-1.363-.465-2.427-.047-1.024-.06-1.379-.06-3.808v-.63c0-2.43.013-2.784.06-3.808.049-1.064.218-1.791.465-2.427a4.902 4.902 0 011.153-1.772A4.902 4.902 0 015.45 2.525c.636-.247 1.363-.416 2.427-.465C8.901 2.013 9.256 2 11.685 2h.63zm-.081 1.802h-.468c-2.456 0-2.784.011-3.807.058-.975.045-1.504.207-1.857.344-.467.182-.8.398-1.15.748-.35.35-.566.683-.748 1.15-.137.353-.3.882-.344 1.857-.047 1.023-.058 1.351-.058 3.807v.468c0 2.456.011 2.784.058 3.807.045.975.207 1.504.344 1.857.182.466.399.8.748 1.15.35.35.683.566 1.15.748.353.137.882.3 1.857.344 1.054.048 1.37.058 4.041.058h.08c2.597 0 2.917-.01 3.96-.058.976-.045 1.505-.207 1.858-.344.466-.182.8-.398 1.15-.748.35-.35.566-.683.748-1.15.137-.353.3-.882.344-1.857.048-1.055.058-1.37.058-4.041v-.08c0-2.597-.01-2.917-.058-3.96-.045-.976-.207-1.505-.344-1.858a3.097 3.097 0 00-.748-1.15 3.098 3.098 0 00-1.15-.748c-.353-.137-.882-.3-1.857-.344-1.023-.047-1.351-.058-3.807-.058zM12 6.865a5.135 5.135 0 110 10.27 5.135 5.135 0 010-10.27zm0 1.802a3.333 3.333 0 100 6.666 3.333 3.333 0 000-6.666zm5.338-3.205a1.2 1.2 0 110 2.4 1.2 1.2 0 010-2.4z",
                                clipRule: "evenodd"
                            })
                        }));
                    }
                },
                {
                    name: 'LinkedIn',
                    href: 'https://www.linkedin.com/company/natverkspadel',
                    icon: function(props) {
                        /*#__PURE__*/ return (0,jsx_runtime.jsx)("svg", translations_objectSpread({
                            fill: "currentColor",
                            viewBox: "0 0 448 512"
                        }, props, {
                            children: /*#__PURE__*/ (0,jsx_runtime.jsx)("path", {
                                d: "M100.28 448H7.4V148.9h92.88zM53.79 108.1C24.09 108.1 0 83.5 0 53.8a53.79 53.79 0 0 1 107.58 0c0 29.7-24.1 54.3-53.79 54.3zM447.9 448h-92.68V302.4c0-34.7-.7-79.2-48.29-79.2-48.29 0-55.69 37.7-55.69 76.7V448h-92.78V148.9h89.08v40.8h1.3c12.4-23.5 42.69-48.3 87.88-48.3 94 0 111.28 61.9 111.28 142.3V448z"
                            })
                        }));
                    }
                }, 
            ]
        }
    }
};

;// CONCATENATED MODULE: ./components/ds/03-organisms/footer/index.tsx

/* eslint-disable jsx-a11y/no-redundant-roles */ /* eslint-disable jsx-a11y/anchor-is-valid */ 



var Footer = function() {
    var router = (0,next_router.useRouter)();
    var locale = (0,utils_locale/* makeLocale */.W)(router.locale, router.defaultLocale) || 'sv';
    var translation = footer_translations_translations[locale];
    return(/*#__PURE__*/ (0,jsx_runtime.jsxs)("footer", {
        className: "bg-gray-50",
        "aria-labelledby": "footer-heading",
        children: [
            /*#__PURE__*/ (0,jsx_runtime.jsx)("h2", {
                id: "footer-heading",
                className: "sr-only",
                children: "Footer"
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                className: "max-w-7xl mx-auto pt-16 pb-8 px-4 sm:px-6 lg:pt-24 lg:px-8",
                children: [
                    /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                        className: "xl:grid xl:grid-cols-3 xl:gap-8",
                        children: /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                            className: "grid grid-cols-2 gap-8 xl:col-span-2",
                            children: [
                                /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                    className: "md:grid md:grid-cols-2 md:gap-8",
                                    children: /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                                        className: "mt-12 md:mt-0",
                                        children: [
                                            /*#__PURE__*/ (0,jsx_runtime.jsx)("h3", {
                                                className: "text-sm font-semibold text-gray-400 tracking-wider uppercase",
                                                children: translation.supportLabel
                                            }),
                                            /*#__PURE__*/ (0,jsx_runtime.jsx)("ul", {
                                                role: "list",
                                                className: "mt-4 space-y-4",
                                                children: translation.footerNavigation.support.map(function(item) {
                                                    return !item.type || item.type === 'internal' ? /*#__PURE__*/ (0,jsx_runtime.jsx)("li", {
                                                        children: /*#__PURE__*/ (0,jsx_runtime.jsx)(next_link["default"], {
                                                            href: item.href,
                                                            children: /*#__PURE__*/ (0,jsx_runtime.jsx)("a", {
                                                                className: "text-base text-gray-500 hover:text-gray-900",
                                                                children: item.name
                                                            })
                                                        })
                                                    }, item.name) : item.type === 'external' ? /*#__PURE__*/ (0,jsx_runtime.jsx)("li", {
                                                        children: /*#__PURE__*/ (0,jsx_runtime.jsx)("a", {
                                                            href: item.href,
                                                            target: "_blank",
                                                            className: "text-base text-gray-500 hover:text-gray-900",
                                                            rel: "noreferrer",
                                                            children: item.name
                                                        })
                                                    }, item.name) : null;
                                                })
                                            })
                                        ]
                                    })
                                }),
                                /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                    className: "md:grid md:grid-cols-2 md:gap-8"
                                })
                            ]
                        })
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                        className: "mt-12 border-t border-gray-200 pt-8 md:flex md:items-center md:justify-between lg:mt-16",
                        children: [
                            /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                className: "flex space-x-6 md:order-2",
                                children: translation.footerNavigation.social.map(function(item) {
                                    /*#__PURE__*/ return (0,jsx_runtime.jsx)(next_link["default"], {
                                        href: item.href,
                                        children: /*#__PURE__*/ (0,jsx_runtime.jsxs)("a", {
                                            className: "text-gray-400 hover:text-gray-500",
                                            children: [
                                                /*#__PURE__*/ (0,jsx_runtime.jsx)("span", {
                                                    className: "sr-only",
                                                    children: item.name
                                                }),
                                                /*#__PURE__*/ (0,jsx_runtime.jsx)(item.icon, {
                                                    className: "h-6 w-6",
                                                    "aria-hidden": "true"
                                                })
                                            ]
                                        })
                                    }, item.name);
                                })
                            }),
                            /*#__PURE__*/ (0,jsx_runtime.jsxs)("p", {
                                className: "mt-8 text-base text-gray-400 md:mt-0 md:order-1",
                                children: [
                                    "\xa9 ",
                                    new Date().getFullYear(),
                                    " Impact Quest. All rights reserved."
                                ]
                            })
                        ]
                    })
                ]
            })
        ]
    }));
};

// EXTERNAL MODULE: ./node_modules/@headlessui/react/dist/components/dialog/dialog.esm.js + 5 modules
var dialog_esm = __webpack_require__(5220);
;// CONCATENATED MODULE: ./components/ds/03-organisms/create-team-member-modal/form/types.ts
var types_translations = {
    sv: {
        fields: {
            first_name: {
                label: 'F\xf6rnamn',
                placeholder: 'Skriv spelarens f\xf6rnamn',
                validation: {
                    short: 'F\xf6rnamnet \xe4r f\xf6r kort',
                    long: 'F\xf6rnamnet \xe4r f\xf6r l\xe5ngt',
                    required: 'F\xf6rnamnet saknas'
                }
            },
            last_name: {
                label: 'Efternman',
                placeholder: 'Skriv spelarens efternman',
                validation: {
                    short: 'Efternamnet \xe4r f\xf6r kort',
                    long: 'Efternamnet \xe4r f\xf6r l\xe5ngt',
                    required: 'Efternamnet saknas'
                }
            },
            email_adress: {
                label: 'E-postadress',
                placeholder: 'Skriv spelarens e-postadress',
                validation: {
                    short: 'E-postadressen \xe4r f\xf6r kort',
                    long: 'E-postadressen \xe4r f\xf6r l\xe5ng',
                    format: 'E-postadressen har ogiltigt format',
                    required: 'E-postadressen saknas'
                }
            },
            phone_number: {
                label: 'Telefonnummer',
                placeholder: 'Skriv spelarens telefonummer',
                validation: {
                    short: 'Telefonnumret \xe4r f\xf6r kort',
                    long: 'Telefonnumret \xe4r f\xf6r l\xe5ngt',
                    required: 'Telefonnumret saknas'
                }
            }
        },
        button: {
            text: 'Spara'
        },
        error: {
            headline: 'Det var ett problem med att skapa en ny spelare.'
        },
        success: {
            headline: 'Tack f\xf6r du skapat en spelare. Nu kan du forts\xe4tta med anm\xe4lan.'
        }
    },
    en: {
        fields: {
            first_name: {
                label: 'F\xf6rnamn',
                placeholder: 'Skriv spelarens f\xf6rnamn',
                validation: {
                    short: 'F\xf6rnamnet \xe4r f\xf6r kort',
                    long: 'F\xf6rnamnet \xe4r f\xf6r l\xe5ngt',
                    required: 'F\xf6rnamnet saknas'
                }
            },
            last_name: {
                label: 'Efternman',
                placeholder: 'Skriv spelarens efternman',
                validation: {
                    short: 'Efternamnet \xe4r f\xf6r kort',
                    long: 'Efternamnet \xe4r f\xf6r l\xe5ngt',
                    required: 'Efternamnet saknas'
                }
            },
            email_adress: {
                label: 'E-postadress',
                placeholder: 'Skriv spelarens e-postadress',
                validation: {
                    short: 'E-postadressen \xe4r f\xf6r kort',
                    long: 'E-postadressen \xe4r f\xf6r l\xe5ng',
                    format: 'E-postadressen har ogiltigt format',
                    required: 'E-postadressen saknas'
                }
            },
            phone_number: {
                label: 'Telefonnummer',
                placeholder: 'Skriv spelarens telefonummer',
                validation: {
                    short: 'Telefonnumret \xe4r f\xf6r kort',
                    long: 'Telefonnumret \xe4r f\xf6r l\xe5ngt',
                    required: 'Telefonnumret saknas'
                }
            }
        },
        button: {
            text: 'Spara'
        },
        error: {
            headline: 'Det var ett problem med att skapa en ny spelare.'
        },
        success: {
            headline: 'Tack f\xf6r du skapat en spelare. Nu kan du forts\xe4tta med anm\xe4lan.'
        }
    }
};

;// CONCATENATED MODULE: ./components/ds/03-organisms/create-team-member-modal/form/index.tsx


/* eslint-disable @next/next/no-img-element */ 






function form_asyncGeneratorStep(gen, resolve, reject, _next, _throw, key, arg) {
    try {
        var info = gen[key](arg);
        var value = info.value;
    } catch (error) {
        reject(error);
        return;
    }
    if (info.done) {
        resolve(value);
    } else {
        Promise.resolve(value).then(_next, _throw);
    }
}
function form_asyncToGenerator(fn) {
    return function() {
        var self = this, args = arguments;
        return new Promise(function(resolve, reject) {
            var gen = fn.apply(self, args);
            function _next(value) {
                form_asyncGeneratorStep(gen, resolve, reject, _next, _throw, "next", value);
            }
            function _throw(err) {
                form_asyncGeneratorStep(gen, resolve, reject, _next, _throw, "throw", err);
            }
            _next(undefined);
        });
    };
}
function form_defineProperty(obj, key, value) {
    if (key in obj) {
        Object.defineProperty(obj, key, {
            value: value,
            enumerable: true,
            configurable: true,
            writable: true
        });
    } else {
        obj[key] = value;
    }
    return obj;
}
function form_instanceof(left, right) {
    if (right != null && typeof Symbol !== "undefined" && right[Symbol.hasInstance]) {
        return right[Symbol.hasInstance](left);
    } else {
        return left instanceof right;
    }
}
function form_objectSpread(target) {
    for(var i = 1; i < arguments.length; i++){
        var source = arguments[i] != null ? arguments[i] : {};
        var ownKeys = Object.keys(source);
        if (typeof Object.getOwnPropertySymbols === "function") {
            ownKeys = ownKeys.concat(Object.getOwnPropertySymbols(source).filter(function(sym) {
                return Object.getOwnPropertyDescriptor(source, sym).enumerable;
            }));
        }
        ownKeys.forEach(function(key) {
            form_defineProperty(target, key, source[key]);
        });
    }
    return target;
}
var CreateTeamMemberForm = function(param1) {
    var teamName = param1.teamName, teamId = param1.teamId, setOpen = param1.setOpen;
    var ref = (0,react.useState)(), error = ref[0], setError = ref[1];
    var ref1 = (0,react.useState)(), status = ref1[0], setStatus = ref1[1];
    var router = (0,next_router.useRouter)();
    var locale = (0,utils_locale/* makeLocale */.W)(router.locale, router.defaultLocale) || 'sv';
    var translation = types_translations[locale];
    var reset = function() {
        setError(undefined);
        setStatus('pristine');
    };
    var initialValues = {
        first_name: '',
        last_name: '',
        email_adress: '',
        phone_number: '',
        application_bot_field: ''
    };
    var ValidationSchema = es/* object */.Ry().shape({
        first_name: es/* string */.Z_().min(2, translation.fields.first_name.validation.short).max(40, translation.fields.first_name.validation.long).trim().required(translation.fields.first_name.validation.required),
        last_name: es/* string */.Z_().min(2, translation.fields.last_name.validation.short).max(40, translation.fields.last_name.validation.long).trim().required(translation.fields.last_name.validation.required),
        email_adress: es/* string */.Z_().min(2, translation.fields.email_adress.validation.short).max(40, translation.fields.email_adress.validation.long).email(translation.fields.email_adress.validation.format).trim().lowercase().required(translation.fields.email_adress.validation.required),
        phone_number: es/* string */.Z_().min(5, translation.fields.phone_number.validation.short).max(12, translation.fields.phone_number.validation.long).trim().required(translation.fields.phone_number.validation.required)
    });
    return(/*#__PURE__*/ (0,jsx_runtime.jsxs)(jsx_runtime.Fragment, {
        children: [
            status === 'ok' ? /*#__PURE__*/ (0,jsx_runtime.jsx)(SuccessAlert, {
                translations: {
                    headline: translation.success.headline
                },
                reset: reset
            }) : null,
            status === 'not_ok' && error ? /*#__PURE__*/ (0,jsx_runtime.jsx)(ErrorAlert, {
                translations: {
                    headline: translation.error.headline
                },
                error: error,
                reset: reset
            }) : null,
            /*#__PURE__*/ (0,jsx_runtime.jsx)(formik_esm/* Formik */.J9, {
                initialValues: initialValues,
                validationSchema: ValidationSchema,
                enableReinitialize: true,
                onSubmit: function() {
                    var _ref = form_asyncToGenerator(runtime_default().mark(function _callee(values, actions) {
                        var requestBody, createTeamMemberRes, createTeamMemberResData;
                        return runtime_default().wrap(function _callee$(_ctx) {
                            while(1)switch(_ctx.prev = _ctx.next){
                                case 0:
                                    _ctx.prev = 0;
                                    requestBody = {
                                        first_name: values.first_name,
                                        last_name: values.last_name,
                                        email_adress: values.email_adress,
                                        phone_number: values.phone_number,
                                        application_bot_field: values.application_bot_field,
                                        team_id: teamId,
                                        team_name: teamName
                                    };
                                    _ctx.next = 4;
                                    return fetch('/api/create-team-member', {
                                        method: 'POST',
                                        body: JSON.stringify(requestBody),
                                        headers: {
                                            'Content-Type': 'application/json'
                                        }
                                    });
                                case 4:
                                    createTeamMemberRes = _ctx.sent;
                                    if (!(createTeamMemberRes.status !== 200)) {
                                        _ctx.next = 11;
                                        break;
                                    }
                                    setStatus('not_ok');
                                    setError(new Error('Non 200 response from backend'));
                                    actions.resetForm();
                                    actions.setSubmitting(false);
                                    return _ctx.abrupt("return");
                                case 11:
                                    _ctx.next = 13;
                                    return createTeamMemberRes.json();
                                case 13:
                                    createTeamMemberResData = _ctx.sent;
                                    if (!createTeamMemberResData.success) {
                                        setStatus('not_ok');
                                        setError(new Error(createTeamMemberResData.code));
                                        actions.resetForm();
                                        actions.setSubmitting(false);
                                    } else {
                                        actions.resetForm();
                                        actions.setSubmitting(false);
                                        setOpen(false);
                                        router.replace(router.asPath);
                                    }
                                    _ctx.next = 23;
                                    break;
                                case 17:
                                    _ctx.prev = 17;
                                    _ctx.t0 = _ctx["catch"](0);
                                    setStatus('not_ok');
                                    if (form_instanceof(_ctx.t0, Error)) {
                                        setError(_ctx.t0);
                                    } else {
                                        setError(new Error('Create team member failed due to a unknown error'));
                                    }
                                    actions.resetForm();
                                    actions.setSubmitting(false);
                                case 23:
                                case "end":
                                    return _ctx.stop();
                            }
                        }, _callee, null, [
                            [
                                0,
                                17
                            ]
                        ]);
                    }));
                    return function(values, actions) {
                        return _ref.apply(this, arguments);
                    };
                }(),
                children: function(formikBag) {
                    return(/*#__PURE__*/ (0,jsx_runtime.jsxs)(formik_esm/* Form */.l0, {
                        children: [
                            /*#__PURE__*/ (0,jsx_runtime.jsx)(formik_esm/* Field */.gN, {
                                name: "application_bot_field",
                                children: function(param) {
                                    var field = param.field;
                                    /*#__PURE__*/ return (0,jsx_runtime.jsx)("p", {
                                        className: "hidden",
                                        children: /*#__PURE__*/ (0,jsx_runtime.jsxs)("label", {
                                            htmlFor: "application_bot_field",
                                            children: [
                                                "Don’t fill this out if you're human: ",
                                                /*#__PURE__*/ (0,jsx_runtime.jsx)("input", form_objectSpread({}, field))
                                            ]
                                        })
                                    });
                                }
                            }),
                            /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                className: "px-4 py-5 sm:p-6",
                                children: /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                                    className: "grid grid-cols-6 gap-6",
                                    children: [
                                        /*#__PURE__*/ (0,jsx_runtime.jsx)(formik_esm/* Field */.gN, {
                                            name: "first_name",
                                            children: function(param) {
                                                var field = param.field, meta = param.meta;
                                                /*#__PURE__*/ return (0,jsx_runtime.jsxs)("div", {
                                                    className: "col-span-6 sm:col-span-3",
                                                    children: [
                                                        /*#__PURE__*/ (0,jsx_runtime.jsx)("label", {
                                                            htmlFor: "first_name",
                                                            className: "block text-left text-sm font-medium text-gray-700",
                                                            children: translation.fields.first_name.label
                                                        }),
                                                        /*#__PURE__*/ (0,jsx_runtime.jsx)("input", form_objectSpread({}, field, {
                                                            required: true,
                                                            type: "text",
                                                            placeholder: translation.fields.first_name.placeholder,
                                                            autoComplete: "given-name",
                                                            className: "mt-1 focus:ring-indigo-500 focus:border-indigo-500 block w-full shadow-sm sm:text-sm border-gray-300 rounded-md"
                                                        })),
                                                        meta.touched && meta.error && /*#__PURE__*/ (0,jsx_runtime.jsx)("p", {
                                                            className: "text-red-500 text-xs italic pt-2",
                                                            children: meta.error
                                                        })
                                                    ]
                                                });
                                            }
                                        }),
                                        /*#__PURE__*/ (0,jsx_runtime.jsx)(formik_esm/* Field */.gN, {
                                            name: "last_name",
                                            children: function(param) {
                                                var field = param.field, meta = param.meta;
                                                /*#__PURE__*/ return (0,jsx_runtime.jsxs)("div", {
                                                    className: "col-span-6 sm:col-span-3",
                                                    children: [
                                                        /*#__PURE__*/ (0,jsx_runtime.jsx)("label", {
                                                            htmlFor: "last_name",
                                                            className: "block text-left text-sm font-medium text-gray-700",
                                                            children: translation.fields.last_name.label
                                                        }),
                                                        /*#__PURE__*/ (0,jsx_runtime.jsx)("input", form_objectSpread({}, field, {
                                                            required: true,
                                                            type: "text",
                                                            placeholder: translation.fields.last_name.placeholder,
                                                            autoComplete: "family-name",
                                                            className: "mt-1 focus:ring-indigo-500 focus:border-indigo-500 block w-full shadow-sm sm:text-sm border-gray-300 rounded-md"
                                                        })),
                                                        meta.touched && meta.error && /*#__PURE__*/ (0,jsx_runtime.jsx)("p", {
                                                            className: "text-red-500 text-xs italic pt-2",
                                                            children: meta.error
                                                        })
                                                    ]
                                                });
                                            }
                                        }),
                                        /*#__PURE__*/ (0,jsx_runtime.jsx)(formik_esm/* Field */.gN, {
                                            name: "email_adress",
                                            children: function(param) {
                                                var field = param.field, meta = param.meta;
                                                /*#__PURE__*/ return (0,jsx_runtime.jsxs)("div", {
                                                    className: "col-span-6",
                                                    children: [
                                                        /*#__PURE__*/ (0,jsx_runtime.jsx)("label", {
                                                            htmlFor: "email_adress",
                                                            className: "block text-left text-sm font-medium text-gray-700",
                                                            children: translation.fields.email_adress.label
                                                        }),
                                                        /*#__PURE__*/ (0,jsx_runtime.jsx)("input", form_objectSpread({}, field, {
                                                            required: true,
                                                            type: "email",
                                                            placeholder: translation.fields.email_adress.placeholder,
                                                            autoComplete: "email",
                                                            className: "mt-1 focus:ring-indigo-500 focus:border-indigo-500 block w-full shadow-sm sm:text-sm border-gray-300 rounded-md"
                                                        })),
                                                        meta.touched && meta.error && /*#__PURE__*/ (0,jsx_runtime.jsx)("p", {
                                                            className: "text-red-500 text-xs italic pt-2",
                                                            children: meta.error
                                                        })
                                                    ]
                                                });
                                            }
                                        }),
                                        /*#__PURE__*/ (0,jsx_runtime.jsx)(formik_esm/* Field */.gN, {
                                            name: "phone_number",
                                            children: function(param) {
                                                var field = param.field, meta = param.meta;
                                                /*#__PURE__*/ return (0,jsx_runtime.jsxs)("div", {
                                                    className: "col-span-6",
                                                    children: [
                                                        /*#__PURE__*/ (0,jsx_runtime.jsx)("label", {
                                                            htmlFor: "phone_number",
                                                            className: "block text-left text-sm font-medium text-gray-700",
                                                            children: translation.fields.phone_number.label
                                                        }),
                                                        /*#__PURE__*/ (0,jsx_runtime.jsx)("input", form_objectSpread({}, field, {
                                                            required: true,
                                                            type: "tel",
                                                            placeholder: translation.fields.phone_number.placeholder,
                                                            autoComplete: "tel",
                                                            className: "mt-1 focus:ring-indigo-500 focus:border-indigo-500 block w-full shadow-sm sm:text-sm border-gray-300 rounded-md"
                                                        })),
                                                        meta.touched && meta.error && /*#__PURE__*/ (0,jsx_runtime.jsx)("p", {
                                                            className: "text-red-500 text-xs italic pt-2",
                                                            children: meta.error
                                                        })
                                                    ]
                                                });
                                            }
                                        })
                                    ]
                                })
                            }),
                            /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                                className: "px-4 py-3 text-right sm:px-6",
                                children: [
                                    /*#__PURE__*/ (0,jsx_runtime.jsx)("button", {
                                        onClick: function() {
                                            if (confirm('\xc4r du s\xe4ker p\xe5 att du vill avbryta att skapa en ny medlem i teamet?')) {
                                                formikBag.resetForm();
                                                setOpen(false);
                                            }
                                        },
                                        className: "mr-2 bg-indigo-50 border border-transparent rounded-md shadow-sm py-2 px-4 text-sm font-medium text-indigo-900 hover:bg-indigo-100 focus:outline-none focus:ring-2 focus:ring-offset-2 focus:ring-offset-gray-50 focus:ring-indigo-500",
                                        children: "Avbryt"
                                    }),
                                    /*#__PURE__*/ (0,jsx_runtime.jsx)("button", {
                                        type: "submit",
                                        className: "inline-flex justify-center py-2 px-4 border border-transparent shadow-sm text-sm font-medium rounded-md text-white bg-indigo-600 hover:bg-indigo-700 focus:outline-none focus:ring-2 focus:ring-offset-2 focus:ring-indigo-500",
                                        disabled: formikBag.isSubmitting || !formikBag.isValid,
                                        children: translation.button.text
                                    })
                                ]
                            })
                        ]
                    }));
                }
            })
        ]
    }));
};

;// CONCATENATED MODULE: ./components/ds/03-organisms/create-team-member-modal/index.tsx

/* This example requires Tailwind CSS v2.0+ */ 



var CreateTeamMemberModal = function(param) {
    var open = param.open, setOpen = param.setOpen, teamName = param.teamName, teamId = param.teamId;
    var cancelButtonRef = (0,react.useRef)(null);
    return(/*#__PURE__*/ (0,jsx_runtime.jsx)(transition_esm/* Transition.Root */.u.Root, {
        show: open,
        as: react.Fragment,
        children: /*#__PURE__*/ (0,jsx_runtime.jsx)(dialog_esm/* Dialog */.V, {
            as: "div",
            className: "fixed z-10 inset-0 overflow-y-auto",
            initialFocus: cancelButtonRef,
            onClose: setOpen,
            children: /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                className: "flex items-end justify-center min-h-screen pt-4 px-4 pb-20 text-center sm:block sm:p-0",
                children: [
                    /*#__PURE__*/ (0,jsx_runtime.jsx)(transition_esm/* Transition.Child */.u.Child, {
                        as: react.Fragment,
                        enter: "ease-out duration-300",
                        enterFrom: "opacity-0",
                        enterTo: "opacity-100",
                        leave: "ease-in duration-200",
                        leaveFrom: "opacity-100",
                        leaveTo: "opacity-0",
                        children: /*#__PURE__*/ (0,jsx_runtime.jsx)(dialog_esm/* Dialog.Overlay */.V.Overlay, {
                            className: "fixed inset-0 bg-gray-500 bg-opacity-75 transition-opacity"
                        })
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)("span", {
                        className: "hidden sm:inline-block sm:align-middle sm:h-screen",
                        "aria-hidden": "true",
                        children: "​"
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)(transition_esm/* Transition.Child */.u.Child, {
                        as: react.Fragment,
                        enter: "ease-out duration-300",
                        enterFrom: "opacity-0 translate-y-4 sm:translate-y-0 sm:scale-95",
                        enterTo: "opacity-100 translate-y-0 sm:scale-100",
                        leave: "ease-in duration-200",
                        leaveFrom: "opacity-100 translate-y-0 sm:scale-100",
                        leaveTo: "opacity-0 translate-y-4 sm:translate-y-0 sm:scale-95",
                        children: /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                            className: "inline-block align-bottom bg-white rounded-lg px-4 pt-5 pb-4 text-left overflow-hidden shadow-xl transform transition-all sm:my-8 sm:align-middle sm:max-w-lg sm:w-full sm:p-6",
                            children: /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                                children: [
                                    /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                        className: "mx-auto flex items-center justify-center h-12 w-12 rounded-full bg-green-100",
                                        children: /*#__PURE__*/ (0,jsx_runtime.jsx)(outline_esm/* PlusIcon */.pOD, {
                                            className: "h-6 w-6 text-green-600",
                                            "aria-hidden": "true"
                                        })
                                    }),
                                    /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                                        className: "mt-3 text-center sm:mt-5",
                                        children: [
                                            /*#__PURE__*/ (0,jsx_runtime.jsx)(dialog_esm/* Dialog.Title */.V.Title, {
                                                as: "h3",
                                                className: "text-lg leading-6 font-medium text-gray-900",
                                                children: "L\xe4gg en ny medlem i teamet"
                                            }),
                                            /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                                className: "mt-2",
                                                children: /*#__PURE__*/ (0,jsx_runtime.jsx)(CreateTeamMemberForm, {
                                                    teamName: teamName,
                                                    teamId: teamId,
                                                    open: open,
                                                    setOpen: setOpen
                                                })
                                            })
                                        ]
                                    })
                                ]
                            })
                        })
                    })
                ]
            })
        })
    }));
};

;// CONCATENATED MODULE: ./components/ds/03-organisms/match-result-list/types.ts


var MatchResultRows = es6/* array */.IX(MatchResult);

;// CONCATENATED MODULE: ./components/ds/03-organisms/match-result-list/index.tsx




var MatchResultList = function(param) {
    var matches = param.matches, roundName = param.roundName, seriesContext = param.seriesContext, _compact = param.compact, compact = _compact === void 0 ? false : _compact;
    var upcomingMatches = matches.filter(function(match) {
        return match.is_upcoming_match;
    });
    var completedMatches = matches.filter(function(match) {
        return !match.is_upcoming_match;
    });
    return(/*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
        className: "mt-8 bg-white overflow-hidden",
        children: [
            upcomingMatches && upcomingMatches.length > 0 ? /*#__PURE__*/ (0,jsx_runtime.jsxs)(jsx_runtime.Fragment, {
                children: [
                    !compact ? /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                        className: "pb-5 px-6 border-b border-gray-200",
                        children: /*#__PURE__*/ (0,jsx_runtime.jsxs)("h3", {
                            className: "text-lg leading-6 font-medium text-gray-900",
                            children: [
                                "Kommande matcher",
                                roundName ? " - ".concat(roundName) : null
                            ]
                        })
                    }) : null,
                    /*#__PURE__*/ (0,jsx_runtime.jsx)("ul", {
                        role: "list",
                        className: "divide-y divide-gray-200",
                        children: upcomingMatches.map(function(match) {
                            /*#__PURE__*/ return (0,jsx_runtime.jsx)(MatchResultRowItem, {
                                match: match,
                                seriesContext: seriesContext
                            }, match.match_id);
                        })
                    })
                ]
            }) : null,
            completedMatches && completedMatches.length > 0 ? /*#__PURE__*/ (0,jsx_runtime.jsxs)(jsx_runtime.Fragment, {
                children: [
                    !compact ? /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                        className: "pb-5 px-6 border-b border-gray-200",
                        children: /*#__PURE__*/ (0,jsx_runtime.jsxs)("h3", {
                            className: "text-lg leading-6 font-medium text-gray-900",
                            children: [
                                "Spelade matcher",
                                roundName ? " - ".concat(roundName) : null
                            ]
                        })
                    }) : null,
                    /*#__PURE__*/ (0,jsx_runtime.jsx)("ul", {
                        role: "list",
                        className: "divide-y divide-gray-200",
                        children: completedMatches.map(function(match) {
                            /*#__PURE__*/ return (0,jsx_runtime.jsx)(MatchResultRowItem, {
                                match: match,
                                seriesContext: seriesContext
                            }, match.match_id);
                        })
                    })
                ]
            }) : null
        ]
    }));
};

;// CONCATENATED MODULE: ./components/ds/03-organisms/round-list/types.ts


var RoundRows = es6/* array */.IX(Round);

;// CONCATENATED MODULE: ./components/ds/03-organisms/round-list/index.tsx




var RoundsList = function(param) {
    var rounds = param.rounds, seriesContext = param.seriesContext;
    var upcomingRounds = rounds.filter(function(round) {
        return !round.done;
    });
    var completedRounds = rounds.filter(function(round) {
        return round.done;
    });
    return(/*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
        className: "mt-8 bg-white overflow-hidden",
        children: [
            upcomingRounds && upcomingRounds.length > 0 ? /*#__PURE__*/ (0,jsx_runtime.jsxs)(jsx_runtime.Fragment, {
                children: [
                    /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                        className: "pb-5 px-6 border-b border-gray-200",
                        children: /*#__PURE__*/ (0,jsx_runtime.jsx)("h3", {
                            className: "text-lg leading-6 font-medium text-gray-900",
                            children: "Kommande rundor"
                        })
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)("ul", {
                        role: "list",
                        className: "divide-y divide-gray-200",
                        children: upcomingRounds.map(function(round) {
                            /*#__PURE__*/ return (0,jsx_runtime.jsx)(RoundRowItem, {
                                round: round,
                                seriesContext: seriesContext
                            }, round.public_id);
                        })
                    })
                ]
            }) : null,
            completedRounds && completedRounds.length > 0 ? /*#__PURE__*/ (0,jsx_runtime.jsxs)(jsx_runtime.Fragment, {
                children: [
                    /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                        className: "pb-5 px-6 border-b border-gray-200",
                        children: /*#__PURE__*/ (0,jsx_runtime.jsx)("h3", {
                            className: "text-lg leading-6 font-medium text-gray-900",
                            children: "Spelade rundor"
                        })
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)("ul", {
                        role: "list",
                        className: "divide-y divide-gray-200",
                        children: completedRounds.map(function(round) {
                            /*#__PURE__*/ return (0,jsx_runtime.jsx)(RoundRowItem, {
                                round: round,
                                seriesContext: seriesContext
                            }, round.public_id);
                        })
                    })
                ]
            }) : null
        ]
    }));
};

;// CONCATENATED MODULE: ./components/ds/03-organisms/admin-signup-list/types.ts


var SignupRows = es6/* array */.IX(Signup);

;// CONCATENATED MODULE: ./components/ds/03-organisms/admin-signup-list/index.tsx






function _arrayLikeToArray(arr, len) {
    if (len == null || len > arr.length) len = arr.length;
    for(var i = 0, arr2 = new Array(len); i < len; i++)arr2[i] = arr[i];
    return arr2;
}
function _arrayWithHoles(arr) {
    if (Array.isArray(arr)) return arr;
}
function _iterableToArrayLimit(arr, i) {
    var _i = arr == null ? null : typeof Symbol !== "undefined" && arr[Symbol.iterator] || arr["@@iterator"];
    if (_i == null) return;
    var _arr = [];
    var _n = true;
    var _d = false;
    var _s, _e;
    try {
        for(_i = _i.call(arr); !(_n = (_s = _i.next()).done); _n = true){
            _arr.push(_s.value);
            if (i && _arr.length === i) break;
        }
    } catch (err) {
        _d = true;
        _e = err;
    } finally{
        try {
            if (!_n && _i["return"] != null) _i["return"]();
        } finally{
            if (_d) throw _e;
        }
    }
    return _arr;
}
function _nonIterableRest() {
    throw new TypeError("Invalid attempt to destructure non-iterable instance.\\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method.");
}
function _slicedToArray(arr, i) {
    return _arrayWithHoles(arr) || _iterableToArrayLimit(arr, i) || _unsupportedIterableToArray(arr, i) || _nonIterableRest();
}
function _unsupportedIterableToArray(o, minLen) {
    if (!o) return;
    if (typeof o === "string") return _arrayLikeToArray(o, minLen);
    var n = Object.prototype.toString.call(o).slice(8, -1);
    if (n === "Object" && o.constructor) n = o.constructor.name;
    if (n === "Map" || n === "Set") return Array.from(n);
    if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return _arrayLikeToArray(o, minLen);
}

var SignupsGroup = function(param) {
    var group = param.group, _showDetails = param.showDetails, showDetails = _showDetails === void 0 ? true : _showDetails, series = param.series, round = param.round;
    if (group.length === 0) return null;
    var groupOrdered = (0,lodash.orderBy)(group, [
        'signup_state',
        'signup_created_at'
    ], [
        'asc',
        'asc'
    ]);
    var acceptedCount = (0,lodash.reduce)(groupOrdered, function(sum, row) {
        return row && row.signup_state && row.signup_state === 'accepted' ? sum + 1 : sum;
    }, 0);
    var ref = _slicedToArray((0,lodash.take)(groupOrdered, 1), 1), signup1 = ref[0];
    var roundName = (0,lodash.get)(signup1, 'series_round_name', '');
    var dtStart = luxon/* DateTime.fromISO */.ou.fromISO(signup1.series_round_start);
    var dtEnd = luxon/* DateTime.fromISO */.ou.fromISO(signup1.series_round_end);
    return(/*#__PURE__*/ (0,jsx_runtime.jsxs)(jsx_runtime.Fragment, {
        children: [
            /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                className: "pb-5 border-b border-gray-200 px-4 py-4 sm:px-6 lg:px-8",
                children: /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                    className: "mt-2 max-w-4xl text-sm text-gray-500",
                    children: [
                        showDetails ? /*#__PURE__*/ (0,jsx_runtime.jsxs)(jsx_runtime.Fragment, {
                            children: [
                                /*#__PURE__*/ (0,jsx_runtime.jsxs)("p", {
                                    className: "mt-2 flex items-center text-sm text-gray-500",
                                    children: [
                                        /*#__PURE__*/ (0,jsx_runtime.jsx)(outline_esm/* CalendarIcon */.Que, {
                                            className: "flex-shrink-0 mr-1.5 h-5 w-5 text-green-400",
                                            "aria-hidden": "true"
                                        }),
                                        roundName
                                    ]
                                }),
                                /*#__PURE__*/ (0,jsx_runtime.jsxs)("p", {
                                    className: "mt-2 flex items-center text-sm text-gray-500",
                                    children: [
                                        /*#__PURE__*/ (0,jsx_runtime.jsx)(outline_esm/* ClockIcon */.T39, {
                                            className: "flex-shrink-0 mr-1.5 h-5 w-5 text-green-400",
                                            "aria-hidden": "true"
                                        }),
                                        dtStart.setLocale('sv').toLocaleString(luxon/* DateTime.TIME_24_SIMPLE */.ou.TIME_24_SIMPLE),
                                        " till",
                                        ' ',
                                        dtEnd.setLocale('sv').toLocaleString(luxon/* DateTime.TIME_24_SIMPLE */.ou.TIME_24_SIMPLE)
                                    ]
                                })
                            ]
                        }) : null,
                        /*#__PURE__*/ (0,jsx_runtime.jsxs)("p", {
                            className: "mt-2 flex items-center text-sm text-gray-500",
                            children: [
                                /*#__PURE__*/ (0,jsx_runtime.jsx)(outline_esm/* CalculatorIcon */.Xki, {
                                    className: "flex-shrink-0 mr-1.5 h-5 w-5 text-green-400",
                                    "aria-hidden": "true"
                                }),
                                acceptedCount
                            ]
                        })
                    ]
                })
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)("ul", {
                role: "list",
                className: "divide-y divide-gray-200",
                children: groupOrdered.map(function(signup) {
                    /*#__PURE__*/ return (0,jsx_runtime.jsx)(SignupRowItem, {
                        signup: signup,
                        series: series,
                        round: round
                    }, signup.invitation_public_id);
                })
            })
        ]
    }));
};
var SignupsList = function(param) {
    var signups = param.signups, showDetails = param.showDetails, series = param.series, round = param.round;
    return(/*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
        className: "bg-white shadow overflow-hidden sm:rounded-md",
        children: /*#__PURE__*/ (0,jsx_runtime.jsx)(SignupsGroup, {
            group: signups,
            showDetails: showDetails,
            series: series,
            round: round
        })
    }));
};

;// CONCATENATED MODULE: ./components/ds/03-organisms/admin-round-list/types.ts


var AdminRoundRows = es6/* array */.IX(AdminRound);

;// CONCATENATED MODULE: ./components/ds/03-organisms/admin-round-list/index.tsx






function admin_round_list_arrayLikeToArray(arr, len) {
    if (len == null || len > arr.length) len = arr.length;
    for(var i = 0, arr2 = new Array(len); i < len; i++)arr2[i] = arr[i];
    return arr2;
}
function admin_round_list_arrayWithHoles(arr) {
    if (Array.isArray(arr)) return arr;
}
function admin_round_list_iterableToArrayLimit(arr, i) {
    var _i = arr == null ? null : typeof Symbol !== "undefined" && arr[Symbol.iterator] || arr["@@iterator"];
    if (_i == null) return;
    var _arr = [];
    var _n = true;
    var _d = false;
    var _s, _e;
    try {
        for(_i = _i.call(arr); !(_n = (_s = _i.next()).done); _n = true){
            _arr.push(_s.value);
            if (i && _arr.length === i) break;
        }
    } catch (err) {
        _d = true;
        _e = err;
    } finally{
        try {
            if (!_n && _i["return"] != null) _i["return"]();
        } finally{
            if (_d) throw _e;
        }
    }
    return _arr;
}
function admin_round_list_nonIterableRest() {
    throw new TypeError("Invalid attempt to destructure non-iterable instance.\\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method.");
}
function admin_round_list_slicedToArray(arr, i) {
    return admin_round_list_arrayWithHoles(arr) || admin_round_list_iterableToArrayLimit(arr, i) || admin_round_list_unsupportedIterableToArray(arr, i) || admin_round_list_nonIterableRest();
}
function admin_round_list_unsupportedIterableToArray(o, minLen) {
    if (!o) return;
    if (typeof o === "string") return admin_round_list_arrayLikeToArray(o, minLen);
    var n = Object.prototype.toString.call(o).slice(8, -1);
    if (n === "Object" && o.constructor) n = o.constructor.name;
    if (n === "Map" || n === "Set") return Array.from(n);
    if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return admin_round_list_arrayLikeToArray(o, minLen);
}

var getTimespan = function(showTimespan, rounds) {
    if (!showTimespan) return null;
    var ref = admin_round_list_slicedToArray((0,lodash.take)((0,lodash.filter)(rounds, function(r) {
        return r.group === 'morning';
    }), 1), 1), morning = ref[0];
    var ref1 = admin_round_list_slicedToArray((0,lodash.take)((0,lodash.filter)(rounds, function(r) {
        return r.group === 'lunch';
    }), 1), 1), lunch = ref1[0];
    var dtStart = luxon/* DateTime.fromISO */.ou.fromISO(morning.round_start);
    var dtEnd = lunch ? luxon/* DateTime.fromISO */.ou.fromISO(lunch.round_end) : dtStart.endOf('day');
    return(/*#__PURE__*/ (0,jsx_runtime.jsxs)("p", {
        className: "mt-2 flex items-center text-sm text-gray-500",
        children: [
            /*#__PURE__*/ (0,jsx_runtime.jsx)(outline_esm/* ClockIcon */.T39, {
                className: "flex-shrink-0 mr-1.5 h-5 w-5 text-green-400",
                "aria-hidden": "true"
            }),
            dtStart.setLocale('sv').toLocaleString(luxon/* DateTime.TIME_24_SIMPLE */.ou.TIME_24_SIMPLE),
            " till",
            ' ',
            dtEnd.setLocale('sv').toLocaleString(luxon/* DateTime.TIME_24_SIMPLE */.ou.TIME_24_SIMPLE)
        ]
    }));
};
var getDate = function(showDate, rounds) {
    if (!showDate) return null;
    var ref = admin_round_list_slicedToArray((0,lodash.take)((0,lodash.filter)(rounds, function(r) {
        return r.group === 'morning';
    }), 1), 1), morning = ref[0];
    var dtStart = luxon/* DateTime.fromISO */.ou.fromISO(morning.round_start);
    return(/*#__PURE__*/ (0,jsx_runtime.jsxs)("p", {
        className: "mt-2 flex items-center text-sm text-gray-500",
        children: [
            /*#__PURE__*/ (0,jsx_runtime.jsx)(outline_esm/* CalendarIcon */.Que, {
                className: "flex-shrink-0 mr-1.5 h-5 w-5 text-green-400",
                "aria-hidden": "true"
            }),
            dtStart.setLocale('sv').toLocaleString(luxon/* DateTime.DATE_MED_WITH_WEEKDAY */.ou.DATE_MED_WITH_WEEKDAY)
        ]
    }));
};
var admin_round_list_RoundGroup = function(param) {
    var rounds = param.rounds, title = param.title, _showDate = param.showDate, showDate = _showDate === void 0 ? true : _showDate, _showTimespan = param.showTimespan, showTimespan = _showTimespan === void 0 ? true : _showTimespan;
    return(/*#__PURE__*/ (0,jsx_runtime.jsxs)(jsx_runtime.Fragment, {
        children: [
            /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                className: "pb-5 border-b border-gray-200 px-4 py-4 sm:px-6 lg:px-8",
                children: [
                    /*#__PURE__*/ (0,jsx_runtime.jsx)("h3", {
                        className: "text-lg leading-6 font-medium text-gray-900",
                        children: title
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                        className: "mt-2 max-w-4xl text-sm text-gray-500",
                        children: [
                            getDate(showDate, rounds),
                            getTimespan(showTimespan, rounds)
                        ]
                    })
                ]
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)("ul", {
                role: "list",
                className: "divide-y divide-gray-200",
                children: rounds.map(function(round) {
                    /*#__PURE__*/ return (0,jsx_runtime.jsx)(AdminRoundRowItem, {
                        round: round
                    }, round.round_public_id);
                })
            })
        ]
    }));
};
var AdminRoundsList = function(param) {
    var rounds = param.rounds;
    var ref, ref2, ref3, ref4, ref5, ref6, ref7;
    var pastRounds = (0,lodash.orderBy)((0,lodash.filter)(rounds, function(round) {
        return round.status === 'past';
    }), [
        'round_start'
    ], [
        'asc'
    ]);
    var currentRounds = (0,lodash.orderBy)((0,lodash.filter)(rounds, function(round) {
        return round.status === 'current';
    }), [
        'round_start'
    ], [
        'asc'
    ]);
    var nextWeeksRounds = (0,lodash.orderBy)((0,lodash.filter)(rounds, function(round) {
        return round.status === 'next_week';
    }), [
        'round_start'
    ], [
        'asc'
    ]);
    var upcomingRounds = (0,lodash.orderBy)((0,lodash.filter)(rounds, function(round) {
        return round.status === 'upcoming';
    }), [
        'round_start'
    ], [
        'asc'
    ]);
    var dynamicRounds = (0,lodash.orderBy)((0,lodash.filter)(rounds, function(round) {
        return round.status === 'dynamic';
    }), [
        'round_name'
    ], [
        'asc'
    ]);
    return(/*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
        className: "bg-white shadow overflow-hidden sm:rounded-md",
        children: [
            dynamicRounds && dynamicRounds.length > 0 ? /*#__PURE__*/ (0,jsx_runtime.jsx)(admin_round_list_RoundGroup, {
                rounds: dynamicRounds,
                title: "Nuvarande vecka (".concat((ref = dynamicRounds[0]) === null || ref === void 0 ? void 0 : ref.current_week, ")"),
                showTimespan: false,
                showDate: false
            }) : null,
            currentRounds && currentRounds.length > 0 ? /*#__PURE__*/ (0,jsx_runtime.jsx)(admin_round_list_RoundGroup, {
                rounds: currentRounds,
                title: "Nuvarande vecka (".concat((ref2 = currentRounds[0]) === null || ref2 === void 0 ? void 0 : ref2.current_week, ")")
            }) : null,
            nextWeeksRounds && nextWeeksRounds.length > 0 ? /*#__PURE__*/ (0,jsx_runtime.jsxs)(jsx_runtime.Fragment, {
                children: [
                    /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                        className: "relative py-6",
                        children: [
                            /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                className: "absolute inset-0 flex items-center",
                                "aria-hidden": "true",
                                children: /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                    className: "w-full border-t border-gray-300"
                                })
                            }),
                            /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                className: "relative flex justify-center",
                                children: /*#__PURE__*/ (0,jsx_runtime.jsx)("span", {
                                    className: "px-2 bg-white text-sm text-gray-500",
                                    children: "N\xe4sta vecka"
                                })
                            })
                        ]
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)(admin_round_list_RoundGroup, {
                        rounds: nextWeeksRounds,
                        title: "N\xe4sta vecka (".concat((ref3 = nextWeeksRounds[0]) === null || ref3 === void 0 ? void 0 : ref3.start_week, ")")
                    })
                ]
            }) : null,
            upcomingRounds && upcomingRounds.length > 0 ? /*#__PURE__*/ (0,jsx_runtime.jsxs)(jsx_runtime.Fragment, {
                children: [
                    /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                        className: "relative py-6",
                        children: [
                            /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                className: "absolute inset-0 flex items-center",
                                "aria-hidden": "true",
                                children: /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                    className: "w-full border-t border-gray-300"
                                })
                            }),
                            /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                className: "relative flex justify-center",
                                children: /*#__PURE__*/ (0,jsx_runtime.jsx)("span", {
                                    className: "px-2 bg-white text-sm text-gray-500",
                                    children: "Kommande veckor"
                                })
                            })
                        ]
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)(admin_round_list_RoundGroup, {
                        rounds: upcomingRounds,
                        title: "Kommande veckor (".concat((ref4 = (0,lodash.first)(upcomingRounds)) === null || ref4 === void 0 ? void 0 : ref4.start_week, "-").concat((ref5 = (0,lodash.last)(upcomingRounds)) === null || ref5 === void 0 ? void 0 : ref5.start_week, ")"),
                        showDate: false,
                        showTimespan: false
                    })
                ]
            }) : null,
            pastRounds && pastRounds.length > 0 ? /*#__PURE__*/ (0,jsx_runtime.jsxs)(jsx_runtime.Fragment, {
                children: [
                    /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                        className: "relative py-6",
                        children: [
                            /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                className: "absolute inset-0 flex items-center",
                                "aria-hidden": "true",
                                children: /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                    className: "w-full border-t border-gray-300"
                                })
                            }),
                            /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                className: "relative flex justify-center",
                                children: /*#__PURE__*/ (0,jsx_runtime.jsx)("span", {
                                    className: "px-2 bg-white text-sm text-gray-500",
                                    children: "F\xf6reg\xe5ende veckor"
                                })
                            })
                        ]
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)(admin_round_list_RoundGroup, {
                        rounds: pastRounds,
                        title: "F\xf6reg\xe5ende veckor (".concat((ref6 = (0,lodash.first)(pastRounds)) === null || ref6 === void 0 ? void 0 : ref6.start_week, "-").concat((ref7 = (0,lodash.last)(pastRounds)) === null || ref7 === void 0 ? void 0 : ref7.start_week, ")"),
                        showDate: false,
                        showTimespan: false
                    })
                ]
            }) : null
        ]
    }));
};

;// CONCATENATED MODULE: ./components/ds/03-organisms/admin-round-details/index.tsx


var RoundDetailsPanel = function(param) {
    var round = param.round, series = param.series;
    return(/*#__PURE__*/ (0,jsx_runtime.jsx)(RoundDetailsCard, {
        round: round,
        series: series
    }));
};

;// CONCATENATED MODULE: ./components/ds/03-organisms/admin-match-result-list/types.ts


var AdminMatchResultRows = es6/* array */.IX(AdminMatchResult);

;// CONCATENATED MODULE: ./components/ds/03-organisms/admin-match-result-list/index.tsx




var AdminMatchResultList = function(param) {
    var matches = param.matches, handleMatchClick = param.handleMatchClick;
    return(/*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
        className: "bg-white overflow-hidden",
        children: /*#__PURE__*/ (0,jsx_runtime.jsx)("ul", {
            role: "list",
            className: "divide-y divide-gray-200",
            children: matches.map(function(match) {
                /*#__PURE__*/ return (0,jsx_runtime.jsx)(AdminMatchResultRowItem, {
                    match: match,
                    handleMatchClick: handleMatchClick
                }, match.match_id);
            })
        })
    }));
};

// EXTERNAL MODULE: ./node_modules/swr/dist/index.mjs
var dist = __webpack_require__(8100);
// EXTERNAL MODULE: ./node_modules/@headlessui/react/dist/components/listbox/listbox.esm.js + 1 modules
var listbox_esm = __webpack_require__(124);
;// CONCATENATED MODULE: ./components/ds/03-organisms/admin-create-match-modal/index.tsx










function admin_create_match_modal_asyncGeneratorStep(gen, resolve, reject, _next, _throw, key, arg) {
    try {
        var info = gen[key](arg);
        var value = info.value;
    } catch (error) {
        reject(error);
        return;
    }
    if (info.done) {
        resolve(value);
    } else {
        Promise.resolve(value).then(_next, _throw);
    }
}
function admin_create_match_modal_asyncToGenerator(fn) {
    return function() {
        var self = this, args = arguments;
        return new Promise(function(resolve, reject) {
            var gen = fn.apply(self, args);
            function _next(value) {
                admin_create_match_modal_asyncGeneratorStep(gen, resolve, reject, _next, _throw, "next", value);
            }
            function _throw(err) {
                admin_create_match_modal_asyncGeneratorStep(gen, resolve, reject, _next, _throw, "throw", err);
            }
            _next(undefined);
        });
    };
}
function admin_create_match_modal_instanceof(left, right) {
    if (right != null && typeof Symbol !== "undefined" && right[Symbol.hasInstance]) {
        return right[Symbol.hasInstance](left);
    } else {
        return left instanceof right;
    }
}
var fetcher = function() {
    var _ref = admin_create_match_modal_asyncToGenerator(runtime_default().mark(function _callee(uri) {
        var response;
        return runtime_default().wrap(function _callee$(_ctx) {
            while(1)switch(_ctx.prev = _ctx.next){
                case 0:
                    _ctx.next = 2;
                    return fetch(uri);
                case 2:
                    response = _ctx.sent;
                    return _ctx.abrupt("return", response.json());
                case 4:
                case "end":
                    return _ctx.stop();
            }
        }, _callee);
    }));
    return function fetcher(uri) {
        return _ref.apply(this, arguments);
    };
}();
var PlayerSelector = function(param1) {
    var selected = param1.selected, setSelected = param1.setSelected, label = param1.label, players = param1.players;
    return(/*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
        className: "py-2",
        children: /*#__PURE__*/ (0,jsx_runtime.jsxs)(listbox_esm/* Listbox */.R, {
            value: selected,
            onChange: setSelected,
            children: [
                /*#__PURE__*/ (0,jsx_runtime.jsx)(listbox_esm/* Listbox.Label */.R.Label, {
                    className: "block text-sm font-medium text-gray-700",
                    children: label
                }),
                /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                    className: "relative mt-1",
                    children: [
                        /*#__PURE__*/ (0,jsx_runtime.jsxs)(listbox_esm/* Listbox.Button */.R.Button, {
                            className: "relative w-full cursor-default rounded-md border border-gray-300 bg-white py-2 pl-3 pr-10 text-left shadow-sm focus:border-indigo-500 focus:outline-none focus:ring-1 focus:ring-indigo-500 sm:text-sm",
                            children: [
                                /*#__PURE__*/ (0,jsx_runtime.jsxs)("span", {
                                    className: "block truncate",
                                    children: [
                                        selected === null || selected === void 0 ? void 0 : selected.user_name,
                                        " [",
                                        selected === null || selected === void 0 ? void 0 : selected.team_name,
                                        "]"
                                    ]
                                }),
                                /*#__PURE__*/ (0,jsx_runtime.jsx)("span", {
                                    className: "pointer-events-none absolute inset-y-0 right-0 flex items-center pr-2",
                                    children: /*#__PURE__*/ (0,jsx_runtime.jsx)(outline_esm/* SelectorIcon */.Ta4, {
                                        className: "h-5 w-5 text-gray-400",
                                        "aria-hidden": "true"
                                    })
                                })
                            ]
                        }),
                        /*#__PURE__*/ (0,jsx_runtime.jsx)(transition_esm/* Transition */.u, {
                            as: react.Fragment,
                            leave: "transition ease-in duration-100",
                            leaveFrom: "opacity-100",
                            leaveTo: "opacity-0",
                            children: /*#__PURE__*/ (0,jsx_runtime.jsx)(listbox_esm/* Listbox.Options */.R.Options, {
                                className: "absolute z-10 mt-1 max-h-60 w-full overflow-auto rounded-md bg-white py-1 text-base shadow-lg ring-1 ring-black ring-opacity-5 focus:outline-none sm:text-sm",
                                children: players.map(function(player) {
                                    /*#__PURE__*/ return (0,jsx_runtime.jsx)(listbox_esm/* Listbox.Option */.R.Option, {
                                        className: function(param) {
                                            var active = param.active;
                                            return (0,classnames/* classNames */.A)(active ? 'bg-indigo-600 text-white' : 'text-gray-900', 'relative cursor-default select-none py-2 pl-8 pr-4');
                                        },
                                        value: player,
                                        children: function(param) {
                                            var isSelected = param.selected, isActive = param.active;
                                            return(/*#__PURE__*/ (0,jsx_runtime.jsxs)(jsx_runtime.Fragment, {
                                                children: [
                                                    /*#__PURE__*/ (0,jsx_runtime.jsxs)("span", {
                                                        className: (0,classnames/* classNames */.A)(isSelected ? 'font-semibold' : 'font-normal', 'block truncate'),
                                                        children: [
                                                            player.user_name,
                                                            " [",
                                                            player.team_name,
                                                            "]"
                                                        ]
                                                    }),
                                                    isSelected ? /*#__PURE__*/ (0,jsx_runtime.jsx)("span", {
                                                        className: (0,classnames/* classNames */.A)(isActive ? 'text-white' : 'text-indigo-600', 'absolute inset-y-0 left-0 flex items-center pl-1.5'),
                                                        children: /*#__PURE__*/ (0,jsx_runtime.jsx)(outline_esm/* CheckIcon */.nQG, {
                                                            className: "h-5 w-5",
                                                            "aria-hidden": "true"
                                                        })
                                                    }) : null,
                                                    !player.is_in_series ? /*#__PURE__*/ (0,jsx_runtime.jsx)("span", {
                                                        className: (0,classnames/* classNames */.A)(isActive ? 'text-white' : 'text-indigo-600', 'absolute inset-y-0 left-0 flex items-center pl-1.5'),
                                                        children: /*#__PURE__*/ (0,jsx_runtime.jsx)(outline_esm/* ExclamationCircleIcon */.$Ow, {
                                                            className: "h-5 w-5",
                                                            "aria-hidden": "true"
                                                        })
                                                    }) : null
                                                ]
                                            }));
                                        }
                                    }, player.user_id);
                                })
                            })
                        })
                    ]
                })
            ]
        })
    }));
};
var getAvailablePlayers = function(currentPlayer, currentlySelected, players) {
    if (!currentPlayer) return players;
    return players.filter(function(player) {
        return player.user_id !== currentPlayer.user_id && !(0,lodash.includes)(currentlySelected.map(function(p) {
            return p.user_id;
        }), player.user_id);
    });
};
var CreateMatchModal = function(param) {
    var open = param.open, setOpen = param.setOpen, roundId = param.roundId, seriesId = param.seriesId;
    var router = (0,next_router.useRouter)();
    var ref = (0,react.useState)(false), isSubmitting = ref[0], setIsSubmitting = ref[1];
    var ref1 = (0,react.useState)(), homePlayer1 = ref1[0], setHomePlayer1 = ref1[1];
    var ref2 = (0,react.useState)(), homePlayer2 = ref2[0], setHomePlayer2 = ref2[1];
    var ref3 = (0,react.useState)(), awayPlayer1 = ref3[0], setAwayPlayer1 = ref3[1];
    var ref4 = (0,react.useState)(), awayPlayer2 = ref4[0], setAwayPlayer2 = ref4[1];
    var ref5 = (0,react.useState)(), error = ref5[0], setError = ref5[1];
    var ref6 = (0,react.useState)(), status = ref6[0], setStatus = ref6[1];
    var cancelButtonRef = (0,react.useRef)(null);
    var ref7 = (0,dist/* default */.ZP)("/api/admin/series/".concat(seriesId, "/round/").concat(roundId, "/fetch-players"), fetcher), data = ref7.data, fetchError = ref7.error;
    var selected = [];
    if (homePlayer1) selected.push(homePlayer1);
    if (homePlayer2) selected.push(homePlayer2);
    if (awayPlayer1) selected.push(awayPlayer1);
    if (awayPlayer2) selected.push(awayPlayer2);
    var selectedPlayers = selected.filter(function(player) {
        return player;
    });
    var players = (0,lodash.map)(data === null || data === void 0 ? void 0 : data.players, function(player) {
        return player;
    });
    var resetStateAndClose = function() {
        setHomePlayer1(undefined);
        setHomePlayer2(undefined);
        setAwayPlayer1(undefined);
        setAwayPlayer2(undefined);
        setError(undefined);
        setStatus('pristine');
        setIsSubmitting(false);
        setOpen(false);
    };
    var sendRequest = function() {
        var _ref = admin_create_match_modal_asyncToGenerator(runtime_default().mark(function _callee() {
            var requestBody, createMatchRes, createMatchResData;
            return runtime_default().wrap(function _callee$(_ctx) {
                while(1)switch(_ctx.prev = _ctx.next){
                    case 0:
                        setIsSubmitting(true);
                        _ctx.prev = 1;
                        if (!(!homePlayer1 || !homePlayer2 || !awayPlayer1 || !awayPlayer2)) {
                            _ctx.next = 6;
                            break;
                        }
                        setError(new Error('Non 200 response from backend'));
                        setIsSubmitting(false);
                        return _ctx.abrupt("return");
                    case 6:
                        requestBody = {
                            roundId: roundId,
                            homeTeamMemberIds: [
                                homePlayer1.team_member_id,
                                homePlayer2.team_member_id
                            ],
                            awayTeamMemberIds: [
                                awayPlayer1.team_member_id,
                                awayPlayer2.team_member_id
                            ],
                            court: 'Temp'
                        };
                        _ctx.next = 9;
                        return fetch('/api/admin/match/create', {
                            method: 'POST',
                            body: JSON.stringify(requestBody),
                            headers: {
                                'Content-Type': 'application/json'
                            }
                        });
                    case 9:
                        createMatchRes = _ctx.sent;
                        if (!(createMatchRes.status !== 200)) {
                            _ctx.next = 16;
                            break;
                        }
                        console.error('createMatchRes', createMatchRes);
                        setError(new Error('Non 200 response from backend'));
                        setStatus('not_ok');
                        setIsSubmitting(false);
                        return _ctx.abrupt("return");
                    case 16:
                        _ctx.next = 18;
                        return createMatchRes.json();
                    case 18:
                        createMatchResData = _ctx.sent;
                        console.debug('createMatchResData', createMatchResData);
                        router.replace(router.asPath);
                        resetStateAndClose();
                        _ctx.next = 31;
                        break;
                    case 24:
                        _ctx.prev = 24;
                        _ctx.t0 = _ctx["catch"](1);
                        console.error('Create match error', _ctx.t0);
                        if (admin_create_match_modal_instanceof(_ctx.t0, Error)) {
                            setError(_ctx.t0);
                        } else {
                            setError(new Error('An unknown error was caught'));
                        }
                        setIsSubmitting(false);
                        setStatus('not_ok');
                        return _ctx.abrupt("return");
                    case 31:
                    case "end":
                        return _ctx.stop();
                }
            }, _callee, null, [
                [
                    1,
                    24
                ]
            ]);
        }));
        return function sendRequest() {
            return _ref.apply(this, arguments);
        };
    }();
    return(/*#__PURE__*/ (0,jsx_runtime.jsx)(transition_esm/* Transition.Root */.u.Root, {
        show: open,
        as: react.Fragment,
        children: /*#__PURE__*/ (0,jsx_runtime.jsx)(dialog_esm/* Dialog */.V, {
            as: "div",
            className: "fixed inset-0 z-10 overflow-y-auto",
            initialFocus: cancelButtonRef,
            onClose: setOpen,
            children: /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                className: "flex min-h-screen items-end justify-center px-4 pt-4 pb-20 text-center sm:block sm:p-0",
                children: [
                    /*#__PURE__*/ (0,jsx_runtime.jsx)(transition_esm/* Transition.Child */.u.Child, {
                        as: react.Fragment,
                        enter: "ease-out duration-300",
                        enterFrom: "opacity-0",
                        enterTo: "opacity-100",
                        leave: "ease-in duration-200",
                        leaveFrom: "opacity-100",
                        leaveTo: "opacity-0",
                        children: /*#__PURE__*/ (0,jsx_runtime.jsx)(dialog_esm/* Dialog.Overlay */.V.Overlay, {
                            className: "fixed inset-0 bg-gray-500 bg-opacity-75 transition-opacity"
                        })
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)("span", {
                        className: "hidden sm:inline-block sm:h-screen sm:align-middle",
                        "aria-hidden": "true",
                        children: "​"
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)(transition_esm/* Transition.Child */.u.Child, {
                        as: react.Fragment,
                        enter: "ease-out duration-300",
                        enterFrom: "opacity-0 translate-y-4 sm:translate-y-0 sm:scale-95",
                        enterTo: "opacity-100 translate-y-0 sm:scale-100",
                        leave: "ease-in duration-200",
                        leaveFrom: "opacity-100 translate-y-0 sm:scale-100",
                        leaveTo: "opacity-0 translate-y-4 sm:translate-y-0 sm:scale-95",
                        children: /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                            className: "inline-block h-screen transform overflow-hidden rounded-lg bg-white px-4 pt-5 pb-4 text-left align-bottom shadow-xl transition-all sm:my-8 sm:w-full sm:max-w-lg sm:p-6 sm:align-middle",
                            children: [
                                /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                                    className: "sm:flex sm:items-start",
                                    children: [
                                        /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                            className: "mx-auto flex h-12 w-12 flex-shrink-0 items-center justify-center rounded-full bg-green-100 sm:mx-0 sm:h-10 sm:w-10",
                                            children: /*#__PURE__*/ (0,jsx_runtime.jsx)(outline_esm/* PlusIcon */.pOD, {
                                                className: "h-6 w-6 text-green-600",
                                                "aria-hidden": "true"
                                            })
                                        }),
                                        /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                                            className: "mt-3 text-center sm:mt-0 sm:ml-4 sm:text-left",
                                            children: [
                                                /*#__PURE__*/ (0,jsx_runtime.jsx)(dialog_esm/* Dialog.Title */.V.Title, {
                                                    as: "h3",
                                                    className: "text-lg font-medium leading-6 text-gray-900",
                                                    children: "Skapa ny match"
                                                }),
                                                /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                                    className: "mt-2",
                                                    children: /*#__PURE__*/ (0,jsx_runtime.jsx)("p", {
                                                        className: "text-sm text-gray-500",
                                                        children: "H\xe4r kan du skapa en ny match genom att v\xe4lja fyra stycken spelare."
                                                    })
                                                }),
                                                fetchError ? /*#__PURE__*/ (0,jsx_runtime.jsx)(ErrorAlert, {
                                                    translations: {
                                                        headline: 'Kunde inte h\xe4mta spelare'
                                                    },
                                                    error: fetchError,
                                                    reset: function() {
                                                        return setStatus('pristine');
                                                    }
                                                }) : null,
                                                error ? /*#__PURE__*/ (0,jsx_runtime.jsx)(ErrorAlert, {
                                                    translations: {
                                                        headline: 'Kunde inte skapa match'
                                                    },
                                                    error: error,
                                                    reset: function() {
                                                        return setStatus('pristine');
                                                    }
                                                }) : null,
                                                status === 'ok' ? /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                                    className: "mt-12",
                                                    children: /*#__PURE__*/ (0,jsx_runtime.jsx)(SuccessAlert, {
                                                        translations: {
                                                            headline: 'Match skapad!'
                                                        },
                                                        reset: function() {
                                                            return setStatus('pristine');
                                                        }
                                                    })
                                                }) : null,
                                                data === undefined ? /*#__PURE__*/ (0,jsx_runtime.jsxs)("svg", {
                                                    className: "-mr-1 ml-3 h-5 w-5 animate-spin text-white",
                                                    xmlns: "http://www.w3.org/2000/svg",
                                                    fill: "none",
                                                    viewBox: "0 0 24 24",
                                                    children: [
                                                        /*#__PURE__*/ (0,jsx_runtime.jsx)("circle", {
                                                            className: "opacity-25",
                                                            cx: "12",
                                                            cy: "12",
                                                            r: "10",
                                                            stroke: "currentColor",
                                                            strokeWidth: "4"
                                                        }),
                                                        /*#__PURE__*/ (0,jsx_runtime.jsx)("path", {
                                                            className: "opacity-75",
                                                            fill: "currentColor",
                                                            d: "M4 12a8 8 0 018-8V0C5.373 0 0 5.373 0 12h4zm2 5.291A7.962 7.962 0 014 12H0c0 3.042 1.135 5.824 3 7.938l3-2.647z"
                                                        })
                                                    ]
                                                }) : null,
                                                !fetchError && data ? /*#__PURE__*/ (0,jsx_runtime.jsx)(jsx_runtime.Fragment, {
                                                    children: /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                                                        className: "mt-6 flex items-center justify-between gap-x-4",
                                                        children: [
                                                            /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                                                                className: "grid flex-grow grid-cols-1",
                                                                children: [
                                                                    /*#__PURE__*/ (0,jsx_runtime.jsx)(PlayerSelector, {
                                                                        selected: homePlayer1,
                                                                        setSelected: setHomePlayer1,
                                                                        label: "Hemma - spelare 1",
                                                                        players: getAvailablePlayers(homePlayer2, selectedPlayers, players)
                                                                    }),
                                                                    /*#__PURE__*/ (0,jsx_runtime.jsx)(PlayerSelector, {
                                                                        selected: homePlayer2,
                                                                        setSelected: setHomePlayer2,
                                                                        label: "Hemma - spelare 2",
                                                                        players: getAvailablePlayers(homePlayer1, selectedPlayers, players)
                                                                    })
                                                                ]
                                                            }),
                                                            /*#__PURE__*/ (0,jsx_runtime.jsx)("p", {
                                                                className: "flex-shrink",
                                                                children: "vs."
                                                            }),
                                                            /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                                                                className: "grid flex-grow grid-cols-1",
                                                                children: [
                                                                    /*#__PURE__*/ (0,jsx_runtime.jsx)(PlayerSelector, {
                                                                        selected: awayPlayer1,
                                                                        setSelected: setAwayPlayer1,
                                                                        label: "Borta - spelare 1",
                                                                        players: getAvailablePlayers(awayPlayer2, selectedPlayers, players)
                                                                    }),
                                                                    /*#__PURE__*/ (0,jsx_runtime.jsx)(PlayerSelector, {
                                                                        selected: awayPlayer2,
                                                                        setSelected: setAwayPlayer2,
                                                                        label: "Borta - spelare 2",
                                                                        players: getAvailablePlayers(awayPlayer1, selectedPlayers, players)
                                                                    })
                                                                ]
                                                            })
                                                        ]
                                                    })
                                                }) : null
                                            ]
                                        })
                                    ]
                                }),
                                /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                                    className: "mt-5 sm:mt-4 sm:ml-10 sm:flex sm:pl-4",
                                    children: [
                                        /*#__PURE__*/ (0,jsx_runtime.jsxs)("button", {
                                            type: "button",
                                            className: "inline-flex w-full justify-center rounded-md border border-transparent bg-green-600 px-4 py-2 text-base font-medium text-white shadow-sm hover:bg-green-700 focus:outline-none focus:ring-2 focus:ring-green-500 focus:ring-offset-2 sm:w-auto sm:text-sm",
                                            disabled: fetchError || error || isSubmitting || selectedPlayers.length !== 4,
                                            onClick: function() {
                                                return sendRequest();
                                            },
                                            children: [
                                                "Skapa en match",
                                                isSubmitting ? /*#__PURE__*/ (0,jsx_runtime.jsxs)("svg", {
                                                    className: "-mr-1 ml-3 h-5 w-5 animate-spin text-white",
                                                    xmlns: "http://www.w3.org/2000/svg",
                                                    fill: "none",
                                                    viewBox: "0 0 24 24",
                                                    children: [
                                                        /*#__PURE__*/ (0,jsx_runtime.jsx)("circle", {
                                                            className: "opacity-25",
                                                            cx: "12",
                                                            cy: "12",
                                                            r: "10",
                                                            stroke: "currentColor",
                                                            strokeWidth: "4"
                                                        }),
                                                        /*#__PURE__*/ (0,jsx_runtime.jsx)("path", {
                                                            className: "opacity-75",
                                                            fill: "currentColor",
                                                            d: "M4 12a8 8 0 018-8V0C5.373 0 0 5.373 0 12h4zm2 5.291A7.962 7.962 0 014 12H0c0 3.042 1.135 5.824 3 7.938l3-2.647z"
                                                        })
                                                    ]
                                                }) : null
                                            ]
                                        }),
                                        /*#__PURE__*/ (0,jsx_runtime.jsx)("button", {
                                            type: "button",
                                            className: "mt-3 inline-flex w-full justify-center rounded-md border border-gray-300 bg-white px-4 py-2 text-base font-medium text-gray-700 shadow-sm hover:bg-gray-50 focus:outline-none focus:ring-2 focus:ring-indigo-500 focus:ring-offset-2 sm:mt-0 sm:ml-3 sm:w-auto sm:text-sm",
                                            onClick: function() {
                                                return setOpen(false);
                                            },
                                            ref: cancelButtonRef,
                                            children: "St\xe4ng det h\xe4r f\xf6nstret"
                                        })
                                    ]
                                })
                            ]
                        })
                    })
                ]
            })
        })
    }));
};

;// CONCATENATED MODULE: ./components/ds/03-organisms/admin-manage-match-modal/match-result-form/types.ts
var match_result_form_types_translations = {
    sv: {
        fields: {
            first_name: {
                label: 'F\xf6rnamn',
                placeholder: 'Skriv spelarens f\xf6rnamn',
                validation: {
                    short: 'F\xf6rnamnet \xe4r f\xf6r kort',
                    long: 'F\xf6rnamnet \xe4r f\xf6r l\xe5ngt',
                    required: 'F\xf6rnamnet saknas'
                }
            },
            last_name: {
                label: 'Efternman',
                placeholder: 'Skriv spelarens efternman',
                validation: {
                    short: 'Efternamnet \xe4r f\xf6r kort',
                    long: 'Efternamnet \xe4r f\xf6r l\xe5ngt',
                    required: 'Efternamnet saknas'
                }
            },
            email_adress: {
                label: 'E-postadress',
                placeholder: 'Skriv spelarens e-postadress',
                validation: {
                    short: 'E-postadressen \xe4r f\xf6r kort',
                    long: 'E-postadressen \xe4r f\xf6r l\xe5ng',
                    format: 'E-postadressen har ogiltigt format',
                    required: 'E-postadressen saknas'
                }
            },
            phone_number: {
                label: 'Telefonnummer',
                placeholder: 'Skriv spelarens telefonummer',
                validation: {
                    short: 'Telefonnumret \xe4r f\xf6r kort',
                    long: 'Telefonnumret \xe4r f\xf6r l\xe5ngt',
                    required: 'Telefonnumret saknas'
                }
            }
        },
        button: {
            text: 'Spara'
        },
        error: {
            headline: 'Det var ett problem med att skapa en ny spelare.'
        },
        success: {
            headline: 'Tack f\xf6r du skapat en spelare. Nu kan du forts\xe4tta med anm\xe4lan.'
        }
    },
    en: {
        fields: {
            first_name: {
                label: 'F\xf6rnamn',
                placeholder: 'Skriv spelarens f\xf6rnamn',
                validation: {
                    short: 'F\xf6rnamnet \xe4r f\xf6r kort',
                    long: 'F\xf6rnamnet \xe4r f\xf6r l\xe5ngt',
                    required: 'F\xf6rnamnet saknas'
                }
            },
            last_name: {
                label: 'Efternman',
                placeholder: 'Skriv spelarens efternman',
                validation: {
                    short: 'Efternamnet \xe4r f\xf6r kort',
                    long: 'Efternamnet \xe4r f\xf6r l\xe5ngt',
                    required: 'Efternamnet saknas'
                }
            },
            email_adress: {
                label: 'E-postadress',
                placeholder: 'Skriv spelarens e-postadress',
                validation: {
                    short: 'E-postadressen \xe4r f\xf6r kort',
                    long: 'E-postadressen \xe4r f\xf6r l\xe5ng',
                    format: 'E-postadressen har ogiltigt format',
                    required: 'E-postadressen saknas'
                }
            },
            phone_number: {
                label: 'Telefonnummer',
                placeholder: 'Skriv spelarens telefonummer',
                validation: {
                    short: 'Telefonnumret \xe4r f\xf6r kort',
                    long: 'Telefonnumret \xe4r f\xf6r l\xe5ngt',
                    required: 'Telefonnumret saknas'
                }
            }
        },
        button: {
            text: 'Spara'
        },
        error: {
            headline: 'Det var ett problem med att skapa en ny spelare.'
        },
        success: {
            headline: 'Tack f\xf6r du skapat en spelare. Nu kan du forts\xe4tta med anm\xe4lan.'
        }
    }
};

;// CONCATENATED MODULE: ./components/ds/03-organisms/admin-manage-match-modal/match-result-form/index.tsx









function match_result_form_asyncGeneratorStep(gen, resolve, reject, _next, _throw, key, arg) {
    try {
        var info = gen[key](arg);
        var value = info.value;
    } catch (error) {
        reject(error);
        return;
    }
    if (info.done) {
        resolve(value);
    } else {
        Promise.resolve(value).then(_next, _throw);
    }
}
function match_result_form_asyncToGenerator(fn) {
    return function() {
        var self = this, args = arguments;
        return new Promise(function(resolve, reject) {
            var gen = fn.apply(self, args);
            function _next(value) {
                match_result_form_asyncGeneratorStep(gen, resolve, reject, _next, _throw, "next", value);
            }
            function _throw(err) {
                match_result_form_asyncGeneratorStep(gen, resolve, reject, _next, _throw, "throw", err);
            }
            _next(undefined);
        });
    };
}
function match_result_form_defineProperty(obj, key, value) {
    if (key in obj) {
        Object.defineProperty(obj, key, {
            value: value,
            enumerable: true,
            configurable: true,
            writable: true
        });
    } else {
        obj[key] = value;
    }
    return obj;
}
function match_result_form_instanceof(left, right) {
    if (right != null && typeof Symbol !== "undefined" && right[Symbol.hasInstance]) {
        return right[Symbol.hasInstance](left);
    } else {
        return left instanceof right;
    }
}
function match_result_form_objectSpread(target) {
    for(var i = 1; i < arguments.length; i++){
        var source = arguments[i] != null ? arguments[i] : {};
        var ownKeys = Object.keys(source);
        if (typeof Object.getOwnPropertySymbols === "function") {
            ownKeys = ownKeys.concat(Object.getOwnPropertySymbols(source).filter(function(sym) {
                return Object.getOwnPropertyDescriptor(source, sym).enumerable;
            }));
        }
        ownKeys.forEach(function(key) {
            match_result_form_defineProperty(target, key, source[key]);
        });
    }
    return target;
}
var MatchResultForm = function(param1) {
    var matchId = param1.matchId, _initialValues = param1.initialValues, initialValues = _initialValues === void 0 ? {
        home_set_one: 0,
        home_set_two: 0,
        home_set_three: 0,
        home_tiebreak: 0,
        away_set_one: 0,
        away_set_two: 0,
        away_set_three: 0,
        away_tiebreak: 0
    } : _initialValues, setOpen = param1.setOpen;
    var ref = (0,react.useState)(), error = ref[0], setError = ref[1];
    var ref1 = (0,react.useState)(), status = ref1[0], setStatus = ref1[1];
    var router = (0,next_router.useRouter)();
    var locale = (0,utils_locale/* makeLocale */.W)(router.locale, router.defaultLocale) || 'sv';
    var translation = match_result_form_types_translations[locale];
    var reset = function() {
        setError(undefined);
        setStatus('pristine');
    };
    var ValidationSchema = es/* object */.Ry().shape({
        home_set_one: es/* number */.Rx().min(0, 'M\xe5ste vara minst 0').max(7, 'Du kan bara vinna som mest 7 gem').required('Detta f\xe4lt m\xe5ste ha ett v\xe4rde'),
        home_set_two: es/* number */.Rx().min(0, 'M\xe5ste vara minst 0').max(7, 'Du kan bara vinna som mest 7 gem').required('Detta f\xe4lt m\xe5ste ha ett v\xe4rde'),
        home_set_three: es/* number */.Rx().min(0, 'M\xe5ste vara minst 0').max(7, 'Du kan bara vinna som mest 7 gem').required('Detta f\xe4lt m\xe5ste ha ett v\xe4rde'),
        home_tiebreak: es/* number */.Rx().min(0, 'M\xe5ste vara minst 0').max(7, 'Du kan bara vinna som mest 7 gem'),
        away_set_one: es/* number */.Rx().min(0, 'M\xe5ste vara minst 0').max(7, 'Du kan bara vinna som mest 7 gem').required('Detta f\xe4lt m\xe5ste ha ett v\xe4rde'),
        away_set_two: es/* number */.Rx().min(0, 'M\xe5ste vara minst 0').max(7, 'Du kan bara vinna som mest 7 gem').required('Detta f\xe4lt m\xe5ste ha ett v\xe4rde'),
        away_set_three: es/* number */.Rx().min(0, 'M\xe5ste vara minst 0').max(7, 'Du kan bara vinna som mest 7 gem').required('Detta f\xe4lt m\xe5ste ha ett v\xe4rde'),
        away_tiebreak: es/* number */.Rx().min(0, 'M\xe5ste vara minst 0').max(7, 'Du kan bara vinna som mest 7 gem')
    });
    return(/*#__PURE__*/ (0,jsx_runtime.jsxs)(jsx_runtime.Fragment, {
        children: [
            status === 'ok' ? /*#__PURE__*/ (0,jsx_runtime.jsx)(SuccessAlert, {
                translations: {
                    headline: translation.success.headline
                },
                reset: reset
            }) : null,
            status === 'not_ok' && error ? /*#__PURE__*/ (0,jsx_runtime.jsx)(ErrorAlert, {
                translations: {
                    headline: translation.error.headline
                },
                error: error,
                reset: reset
            }) : null,
            /*#__PURE__*/ (0,jsx_runtime.jsx)(formik_esm/* Formik */.J9, {
                initialValues: initialValues,
                validationSchema: ValidationSchema,
                enableReinitialize: true,
                onSubmit: function() {
                    var _ref = match_result_form_asyncToGenerator(runtime_default().mark(function _callee(values, actions) {
                        var isTiebreak, requestBody, ReportGameResultRes, ReportGameResultResData;
                        return runtime_default().wrap(function _callee$(_ctx) {
                            while(1)switch(_ctx.prev = _ctx.next){
                                case 0:
                                    _ctx.prev = 0;
                                    isTiebreak = values.home_tiebreak > 0 || values.away_tiebreak > 0;
                                    requestBody = {
                                        matchId: matchId,
                                        tiebreak: isTiebreak,
                                        sendNotifications: true,
                                        homeResultSet: {
                                            set_one: values.home_set_one,
                                            set_two: values.home_set_two,
                                            set_three: values.home_set_three,
                                            tiebreak: isTiebreak && values.home_tiebreak ? values.home_tiebreak : 0
                                        },
                                        awayResultSet: {
                                            set_one: values.away_set_one,
                                            set_two: values.away_set_two,
                                            set_three: values.away_set_three,
                                            tiebreak: isTiebreak && values.away_tiebreak ? values.away_tiebreak : 0
                                        }
                                    };
                                    _ctx.next = 5;
                                    return fetch('/api/admin/match/report', {
                                        method: 'POST',
                                        body: JSON.stringify(requestBody),
                                        headers: {
                                            'Content-Type': 'application/json'
                                        }
                                    });
                                case 5:
                                    ReportGameResultRes = _ctx.sent;
                                    if (!(ReportGameResultRes.status !== 200)) {
                                        _ctx.next = 12;
                                        break;
                                    }
                                    setStatus('not_ok');
                                    setError(new Error('Non 200 response from backend'));
                                    actions.resetForm();
                                    actions.setSubmitting(false);
                                    return _ctx.abrupt("return");
                                case 12:
                                    _ctx.next = 14;
                                    return ReportGameResultRes.json();
                                case 14:
                                    ReportGameResultResData = _ctx.sent;
                                    if (!ReportGameResultResData.success) {
                                        setStatus('not_ok');
                                        setError(new Error(ReportGameResultResData.code));
                                        actions.resetForm();
                                        actions.setSubmitting(false);
                                    } else {
                                        actions.resetForm();
                                        actions.setSubmitting(false);
                                        setOpen(false);
                                        router.replace(router.asPath);
                                    }
                                    _ctx.next = 24;
                                    break;
                                case 18:
                                    _ctx.prev = 18;
                                    _ctx.t0 = _ctx["catch"](0);
                                    setStatus('not_ok');
                                    if (match_result_form_instanceof(_ctx.t0, Error)) {
                                        setError(_ctx.t0);
                                    } else {
                                        setError(new Error('Report game result failed due to a unknown error'));
                                    }
                                    actions.resetForm();
                                    actions.setSubmitting(false);
                                case 24:
                                case "end":
                                    return _ctx.stop();
                            }
                        }, _callee, null, [
                            [
                                0,
                                18
                            ]
                        ]);
                    }));
                    return function(values, actions) {
                        return _ref.apply(this, arguments);
                    };
                }(),
                children: function(formikBag) {
                    return(/*#__PURE__*/ (0,jsx_runtime.jsxs)(formik_esm/* Form */.l0, {
                        children: [
                            /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                className: "py-5",
                                children: /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                                    className: "",
                                    children: [
                                        /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                                            className: "flex gap-x-2",
                                            children: [
                                                /*#__PURE__*/ (0,jsx_runtime.jsx)(formik_esm/* Field */.gN, {
                                                    name: "home_set_one",
                                                    children: function(param) {
                                                        var field = param.field, meta = param.meta;
                                                        /*#__PURE__*/ return (0,jsx_runtime.jsxs)("div", {
                                                            className: "col-span-6 sm:col-span-3",
                                                            children: [
                                                                /*#__PURE__*/ (0,jsx_runtime.jsx)("label", {
                                                                    htmlFor: "home_set_one",
                                                                    className: "sr-only",
                                                                    children: "Hemma set 1"
                                                                }),
                                                                /*#__PURE__*/ (0,jsx_runtime.jsx)("input", match_result_form_objectSpread({}, field, {
                                                                    required: true,
                                                                    type: "number",
                                                                    className: "mt-1 focus:ring-indigo-500 focus:border-indigo-500 block w-full shadow-sm sm:text-sm border-gray-300 rounded-md text-center"
                                                                })),
                                                                meta.touched && meta.error && /*#__PURE__*/ (0,jsx_runtime.jsx)("p", {
                                                                    className: "text-red-500 text-xs italic pt-2",
                                                                    children: meta.error
                                                                })
                                                            ]
                                                        });
                                                    }
                                                }),
                                                /*#__PURE__*/ (0,jsx_runtime.jsx)(formik_esm/* Field */.gN, {
                                                    name: "home_set_two",
                                                    children: function(param) {
                                                        var field = param.field, meta = param.meta;
                                                        /*#__PURE__*/ return (0,jsx_runtime.jsxs)("div", {
                                                            className: "col-span-6 sm:col-span-3",
                                                            children: [
                                                                /*#__PURE__*/ (0,jsx_runtime.jsx)("label", {
                                                                    htmlFor: "home_set_two",
                                                                    className: "sr-only",
                                                                    children: "Hemma set 2"
                                                                }),
                                                                /*#__PURE__*/ (0,jsx_runtime.jsx)("input", match_result_form_objectSpread({}, field, {
                                                                    required: true,
                                                                    type: "number",
                                                                    className: "mt-1 focus:ring-indigo-500 focus:border-indigo-500 block w-full shadow-sm sm:text-sm border-gray-300 rounded-md text-center"
                                                                })),
                                                                meta.touched && meta.error && /*#__PURE__*/ (0,jsx_runtime.jsx)("p", {
                                                                    className: "text-red-500 text-xs italic pt-2",
                                                                    children: meta.error
                                                                })
                                                            ]
                                                        });
                                                    }
                                                }),
                                                /*#__PURE__*/ (0,jsx_runtime.jsx)(formik_esm/* Field */.gN, {
                                                    name: "home_set_three",
                                                    children: function(param) {
                                                        var field = param.field, meta = param.meta;
                                                        /*#__PURE__*/ return (0,jsx_runtime.jsxs)("div", {
                                                            className: "col-span-6 sm:col-span-3",
                                                            children: [
                                                                /*#__PURE__*/ (0,jsx_runtime.jsx)("label", {
                                                                    htmlFor: "home_set_three",
                                                                    className: "sr-only",
                                                                    children: "Hemma set 3"
                                                                }),
                                                                /*#__PURE__*/ (0,jsx_runtime.jsx)("input", match_result_form_objectSpread({}, field, {
                                                                    required: true,
                                                                    type: "number",
                                                                    className: "mt-1 focus:ring-indigo-500 focus:border-indigo-500 block w-full shadow-sm sm:text-sm border-gray-300 rounded-md text-center"
                                                                })),
                                                                meta.touched && meta.error && /*#__PURE__*/ (0,jsx_runtime.jsx)("p", {
                                                                    className: "text-red-500 text-xs italic pt-2",
                                                                    children: meta.error
                                                                })
                                                            ]
                                                        });
                                                    }
                                                }),
                                                /*#__PURE__*/ (0,jsx_runtime.jsx)(formik_esm/* Field */.gN, {
                                                    name: "home_tiebreak",
                                                    children: function(param) {
                                                        var field = param.field, meta = param.meta;
                                                        /*#__PURE__*/ return (0,jsx_runtime.jsxs)("div", {
                                                            className: "col-span-6 sm:col-span-3",
                                                            children: [
                                                                /*#__PURE__*/ (0,jsx_runtime.jsx)("label", {
                                                                    htmlFor: "home_tiebreak",
                                                                    className: "sr-only",
                                                                    children: "Hemma tiebreak"
                                                                }),
                                                                /*#__PURE__*/ (0,jsx_runtime.jsx)("input", match_result_form_objectSpread({}, field, {
                                                                    required: true,
                                                                    type: "number",
                                                                    className: "mt-1 focus:ring-indigo-500 focus:border-indigo-500 block w-full shadow-sm sm:text-sm border-gray-300 rounded-md text-center"
                                                                })),
                                                                meta.touched && meta.error && /*#__PURE__*/ (0,jsx_runtime.jsx)("p", {
                                                                    className: "text-red-500 text-xs italic pt-2",
                                                                    children: meta.error
                                                                })
                                                            ]
                                                        });
                                                    }
                                                })
                                            ]
                                        }),
                                        /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                                            className: "flex gap-x-2",
                                            children: [
                                                /*#__PURE__*/ (0,jsx_runtime.jsx)(formik_esm/* Field */.gN, {
                                                    name: "away_set_one",
                                                    children: function(param) {
                                                        var field = param.field, meta = param.meta;
                                                        /*#__PURE__*/ return (0,jsx_runtime.jsxs)("div", {
                                                            className: "col-span-6 sm:col-span-3",
                                                            children: [
                                                                /*#__PURE__*/ (0,jsx_runtime.jsx)("label", {
                                                                    htmlFor: "away_set_one",
                                                                    className: "sr-only",
                                                                    children: "Borta set 1"
                                                                }),
                                                                /*#__PURE__*/ (0,jsx_runtime.jsx)("input", match_result_form_objectSpread({}, field, {
                                                                    required: true,
                                                                    type: "number",
                                                                    className: "mt-1 focus:ring-indigo-500 focus:border-indigo-500 block w-full shadow-sm sm:text-sm border-gray-300 rounded-md text-center"
                                                                })),
                                                                meta.touched && meta.error && /*#__PURE__*/ (0,jsx_runtime.jsx)("p", {
                                                                    className: "text-red-500 text-xs italic pt-2",
                                                                    children: meta.error
                                                                })
                                                            ]
                                                        });
                                                    }
                                                }),
                                                /*#__PURE__*/ (0,jsx_runtime.jsx)(formik_esm/* Field */.gN, {
                                                    name: "away_set_two",
                                                    children: function(param) {
                                                        var field = param.field, meta = param.meta;
                                                        /*#__PURE__*/ return (0,jsx_runtime.jsxs)("div", {
                                                            className: "col-span-6 sm:col-span-3",
                                                            children: [
                                                                /*#__PURE__*/ (0,jsx_runtime.jsx)("label", {
                                                                    htmlFor: "away_set_two",
                                                                    className: "sr-only",
                                                                    children: "Borta set 2"
                                                                }),
                                                                /*#__PURE__*/ (0,jsx_runtime.jsx)("input", match_result_form_objectSpread({}, field, {
                                                                    required: true,
                                                                    type: "number",
                                                                    className: "mt-1 focus:ring-indigo-500 focus:border-indigo-500 block w-full shadow-sm sm:text-sm border-gray-300 rounded-md text-center"
                                                                })),
                                                                meta.touched && meta.error && /*#__PURE__*/ (0,jsx_runtime.jsx)("p", {
                                                                    className: "text-red-500 text-xs italic pt-2",
                                                                    children: meta.error
                                                                })
                                                            ]
                                                        });
                                                    }
                                                }),
                                                /*#__PURE__*/ (0,jsx_runtime.jsx)(formik_esm/* Field */.gN, {
                                                    name: "away_set_three",
                                                    children: function(param) {
                                                        var field = param.field, meta = param.meta;
                                                        /*#__PURE__*/ return (0,jsx_runtime.jsxs)("div", {
                                                            className: "col-span-6 sm:col-span-3",
                                                            children: [
                                                                /*#__PURE__*/ (0,jsx_runtime.jsx)("label", {
                                                                    htmlFor: "away_set_three",
                                                                    className: "sr-only",
                                                                    children: "Borta set 3"
                                                                }),
                                                                /*#__PURE__*/ (0,jsx_runtime.jsx)("input", match_result_form_objectSpread({}, field, {
                                                                    required: true,
                                                                    type: "number",
                                                                    className: "mt-1 focus:ring-indigo-500 focus:border-indigo-500 block w-full shadow-sm sm:text-sm border-gray-300 rounded-md text-center"
                                                                })),
                                                                meta.touched && meta.error && /*#__PURE__*/ (0,jsx_runtime.jsx)("p", {
                                                                    className: "text-red-500 text-xs italic pt-2",
                                                                    children: meta.error
                                                                })
                                                            ]
                                                        });
                                                    }
                                                }),
                                                /*#__PURE__*/ (0,jsx_runtime.jsx)(formik_esm/* Field */.gN, {
                                                    name: "away_tiebreak",
                                                    children: function(param) {
                                                        var field = param.field, meta = param.meta;
                                                        /*#__PURE__*/ return (0,jsx_runtime.jsxs)("div", {
                                                            className: "col-span-6 sm:col-span-3",
                                                            children: [
                                                                /*#__PURE__*/ (0,jsx_runtime.jsx)("label", {
                                                                    htmlFor: "away_tiebreak",
                                                                    className: "sr-only",
                                                                    children: "Borta tiebreak"
                                                                }),
                                                                /*#__PURE__*/ (0,jsx_runtime.jsx)("input", match_result_form_objectSpread({}, field, {
                                                                    required: true,
                                                                    type: "number",
                                                                    className: "mt-1 focus:ring-indigo-500 focus:border-indigo-500 block w-full shadow-sm sm:text-sm border-gray-300 rounded-md text-center"
                                                                })),
                                                                meta.touched && meta.error && /*#__PURE__*/ (0,jsx_runtime.jsx)("p", {
                                                                    className: "text-red-500 text-xs italic pt-2",
                                                                    children: meta.error
                                                                })
                                                            ]
                                                        });
                                                    }
                                                })
                                            ]
                                        })
                                    ]
                                })
                            }),
                            /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                className: "py-3 text-right",
                                children: /*#__PURE__*/ (0,jsx_runtime.jsx)("button", {
                                    type: "submit",
                                    className: "inline-flex justify-center py-2 px-4 border border-transparent shadow-sm text-sm font-medium rounded-md text-white bg-indigo-600 hover:bg-indigo-700 focus:outline-none focus:ring-2 focus:ring-offset-2 focus:ring-indigo-500",
                                    disabled: formikBag.isSubmitting || !formikBag.isValid,
                                    children: translation.button.text
                                })
                            })
                        ]
                    }));
                }
            })
        ]
    }));
};

;// CONCATENATED MODULE: ./components/ds/03-organisms/admin-manage-match-modal/index.tsx








function admin_manage_match_modal_asyncGeneratorStep(gen, resolve, reject, _next, _throw, key, arg) {
    try {
        var info = gen[key](arg);
        var value = info.value;
    } catch (error) {
        reject(error);
        return;
    }
    if (info.done) {
        resolve(value);
    } else {
        Promise.resolve(value).then(_next, _throw);
    }
}
function admin_manage_match_modal_asyncToGenerator(fn) {
    return function() {
        var self = this, args = arguments;
        return new Promise(function(resolve, reject) {
            var gen = fn.apply(self, args);
            function _next(value) {
                admin_manage_match_modal_asyncGeneratorStep(gen, resolve, reject, _next, _throw, "next", value);
            }
            function _throw(err) {
                admin_manage_match_modal_asyncGeneratorStep(gen, resolve, reject, _next, _throw, "throw", err);
            }
            _next(undefined);
        });
    };
}
function admin_manage_match_modal_instanceof(left, right) {
    if (right != null && typeof Symbol !== "undefined" && right[Symbol.hasInstance]) {
        return right[Symbol.hasInstance](left);
    } else {
        return left instanceof right;
    }
}
var ManageMatchModal = function(param) {
    var open = param.open, setOpen = param.setOpen, roundId = param.roundId, seriesId = param.seriesId, matchId = param.matchId, match = param.match;
    var router = (0,next_router.useRouter)();
    var cancelButtonRef = (0,react.useRef)(null);
    var ref = (0,react.useState)(''), courtName = ref[0], setCourtName = ref[1];
    var ref1 = (0,react.useState)(false), isConfirming = ref1[0], setIsConfirming = ref1[1];
    var ref2 = (0,react.useState)(false), isDeleting = ref2[0], setIsDeleting = ref2[1];
    var ref3 = (0,react.useState)(), error = ref3[0], setError = ref3[1];
    var ref4 = (0,react.useState)(), status = ref4[0], setStatus = ref4[1];
    var reset = function() {
        setError(undefined);
        setStatus('pristine');
        setCourtName('');
        setIsConfirming(false);
        setIsDeleting(false);
    };
    var confirmMatch = function() {
        var _ref = admin_manage_match_modal_asyncToGenerator(runtime_default().mark(function _callee() {
            var requestBody, actionRes, responseData;
            return runtime_default().wrap(function _callee$(_ctx) {
                while(1)switch(_ctx.prev = _ctx.next){
                    case 0:
                        setIsConfirming(true);
                        _ctx.prev = 1;
                        if (matchId) {
                            _ctx.next = 8;
                            break;
                        }
                        console.error("Match ID is not set");
                        setError(new Error('Match ID is not set'));
                        setStatus('not_ok');
                        setIsConfirming(false);
                        return _ctx.abrupt("return");
                    case 8:
                        if (!(match && match.match_state !== 'created')) {
                            _ctx.next = 14;
                            break;
                        }
                        console.error("Match in invalid state [".concat(match.match_state, "]"));
                        setError(new Error("Invalid match state [".concat(match.match_state, "]")));
                        setStatus('not_ok');
                        setIsConfirming(false);
                        return _ctx.abrupt("return");
                    case 14:
                        requestBody = {
                            matchId: matchId,
                            sendNotifications: true,
                            courtName: courtName || null
                        };
                        _ctx.next = 17;
                        return fetch('/api/admin/match/confirm', {
                            method: 'POST',
                            body: JSON.stringify(requestBody),
                            headers: {
                                'Content-Type': 'application/json'
                            }
                        });
                    case 17:
                        actionRes = _ctx.sent;
                        if (!(actionRes.status !== 200)) {
                            _ctx.next = 24;
                            break;
                        }
                        console.error('actionRes', actionRes);
                        setError(new Error('Non 200 response from backend'));
                        setStatus('not_ok');
                        setIsConfirming(false);
                        return _ctx.abrupt("return");
                    case 24:
                        _ctx.next = 26;
                        return actionRes.json();
                    case 26:
                        responseData = _ctx.sent;
                        if (responseData.success) {
                            _ctx.next = 33;
                            break;
                        }
                        console.error('responseData', responseData);
                        setError(new Error(responseData.code));
                        setStatus('not_ok');
                        setIsConfirming(false);
                        return _ctx.abrupt("return");
                    case 33:
                        setError(undefined);
                        setStatus('pristine');
                        setIsConfirming(false);
                        router.replace(router.asPath);
                        setOpen(false);
                        _ctx.next = 47;
                        break;
                    case 40:
                        _ctx.prev = 40;
                        _ctx.t0 = _ctx["catch"](1);
                        console.error('Confirm match error', _ctx.t0);
                        if (admin_manage_match_modal_instanceof(_ctx.t0, Error)) {
                            setError(_ctx.t0);
                        } else {
                            setError(new Error('An unknown error was caught'));
                        }
                        setIsConfirming(false);
                        setStatus('not_ok');
                        return _ctx.abrupt("return");
                    case 47:
                    case "end":
                        return _ctx.stop();
                }
            }, _callee, null, [
                [
                    1,
                    40
                ]
            ]);
        }));
        return function confirmMatch() {
            return _ref.apply(this, arguments);
        };
    }();
    var deleteMatch = function() {
        var _ref = admin_manage_match_modal_asyncToGenerator(runtime_default().mark(function _callee() {
            var requestBody, apiRouteUrl, actionRes, responseData;
            return runtime_default().wrap(function _callee$(_ctx) {
                while(1)switch(_ctx.prev = _ctx.next){
                    case 0:
                        setIsDeleting(true);
                        _ctx.prev = 1;
                        if (matchId) {
                            _ctx.next = 8;
                            break;
                        }
                        console.error("Match ID is not set");
                        setError(new Error('Match ID is not set'));
                        setStatus('not_ok');
                        setIsConfirming(false);
                        return _ctx.abrupt("return");
                    case 8:
                        requestBody = {
                            matchId: matchId
                        };
                        apiRouteUrl = '/api/admin/match/delete-soft';
                        _ctx.next = 12;
                        return fetch(apiRouteUrl, {
                            method: 'POST',
                            body: JSON.stringify(requestBody),
                            headers: {
                                'Content-Type': 'application/json'
                            }
                        });
                    case 12:
                        actionRes = _ctx.sent;
                        if (!(actionRes.status !== 200)) {
                            _ctx.next = 19;
                            break;
                        }
                        console.error('actionRes', actionRes);
                        setError(new Error('Non 200 response from backend'));
                        setStatus('not_ok');
                        setIsDeleting(false);
                        return _ctx.abrupt("return");
                    case 19:
                        _ctx.next = 21;
                        return actionRes.json();
                    case 21:
                        responseData = _ctx.sent;
                        setError(undefined);
                        setStatus('ok');
                        setIsDeleting(false);
                        router.replace(router.asPath);
                        _ctx.next = 35;
                        break;
                    case 28:
                        _ctx.prev = 28;
                        _ctx.t0 = _ctx["catch"](1);
                        console.error('Delete match error', _ctx.t0);
                        if (admin_manage_match_modal_instanceof(_ctx.t0, Error)) {
                            setError(_ctx.t0);
                        } else {
                            setError(new Error('An unknown error was caught'));
                        }
                        setIsDeleting(false);
                        setStatus('not_ok');
                        return _ctx.abrupt("return");
                    case 35:
                    case "end":
                        return _ctx.stop();
                }
            }, _callee, null, [
                [
                    1,
                    28
                ]
            ]);
        }));
        return function deleteMatch() {
            return _ref.apply(this, arguments);
        };
    }();
    return(/*#__PURE__*/ (0,jsx_runtime.jsx)(transition_esm/* Transition.Root */.u.Root, {
        show: open,
        as: react.Fragment,
        children: /*#__PURE__*/ (0,jsx_runtime.jsx)(dialog_esm/* Dialog */.V, {
            as: "div",
            className: "fixed inset-0 z-10 overflow-y-auto",
            initialFocus: cancelButtonRef,
            onClose: setOpen,
            children: /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                className: "flex min-h-screen items-end justify-center px-4 pt-4 pb-20 text-center sm:block sm:p-0",
                children: [
                    /*#__PURE__*/ (0,jsx_runtime.jsx)(transition_esm/* Transition.Child */.u.Child, {
                        as: react.Fragment,
                        enter: "ease-out duration-300",
                        enterFrom: "opacity-0",
                        enterTo: "opacity-100",
                        leave: "ease-in duration-200",
                        leaveFrom: "opacity-100",
                        leaveTo: "opacity-0",
                        children: /*#__PURE__*/ (0,jsx_runtime.jsx)(dialog_esm/* Dialog.Overlay */.V.Overlay, {
                            className: "fixed inset-0 bg-gray-500 bg-opacity-75 transition-opacity"
                        })
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)("span", {
                        className: "hidden sm:inline-block sm:h-screen sm:align-middle",
                        "aria-hidden": "true",
                        children: "​"
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)(transition_esm/* Transition.Child */.u.Child, {
                        as: react.Fragment,
                        enter: "ease-out duration-300",
                        enterFrom: "opacity-0 translate-y-4 sm:translate-y-0 sm:scale-95",
                        enterTo: "opacity-100 translate-y-0 sm:scale-100",
                        leave: "ease-in duration-200",
                        leaveFrom: "opacity-100 translate-y-0 sm:scale-100",
                        leaveTo: "opacity-0 translate-y-4 sm:translate-y-0 sm:scale-95",
                        children: /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                            className: "inline-block h-screen transform overflow-hidden rounded-lg bg-white px-4 pt-5 pb-4 text-left align-bottom shadow-xl transition-all sm:my-8 sm:w-full sm:max-w-lg sm:p-6 sm:align-middle",
                            children: /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                                className: "sm:flex sm:items-start",
                                children: [
                                    /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                        className: "mx-auto flex h-12 w-12 flex-shrink-0 items-center justify-center rounded-full bg-green-100 sm:mx-0 sm:h-10 sm:w-10",
                                        children: /*#__PURE__*/ (0,jsx_runtime.jsx)(outline_esm/* PencilIcon */.vdY, {
                                            className: "h-6 w-6 text-green-600",
                                            "aria-hidden": "true"
                                        })
                                    }),
                                    /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                                        className: "mt-3 text-center sm:mt-0 sm:ml-4 sm:text-left",
                                        children: [
                                            /*#__PURE__*/ (0,jsx_runtime.jsx)(dialog_esm/* Dialog.Title */.V.Title, {
                                                as: "h3",
                                                className: "text-lg font-medium leading-6 text-gray-900",
                                                children: "Hantera match"
                                            }),
                                            /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                                className: "mt-2",
                                                children: /*#__PURE__*/ (0,jsx_runtime.jsx)("p", {
                                                    className: "text-sm text-gray-500",
                                                    children: "Rapportera matchresultat m.m."
                                                })
                                            }),
                                            status === 'ok' ? /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                                className: "mt-12",
                                                children: /*#__PURE__*/ (0,jsx_runtime.jsx)(SuccessAlert, {
                                                    translations: {
                                                        headline: 'Den action du tog gick bra!'
                                                    },
                                                    reset: reset
                                                })
                                            }) : null,
                                            status === 'not_ok' && error ? /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                                className: "mt-12",
                                                children: /*#__PURE__*/ (0,jsx_runtime.jsx)(ErrorAlert, {
                                                    translations: {
                                                        headline: 'Typiskt! N\xe5got gick snett.'
                                                    },
                                                    error: error,
                                                    reset: reset
                                                })
                                            }) : null,
                                            matchId ? /*#__PURE__*/ (0,jsx_runtime.jsxs)(jsx_runtime.Fragment, {
                                                children: [
                                                    /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                                        className: "border-b border-gray-200 bg-white py-5",
                                                        children: /*#__PURE__*/ (0,jsx_runtime.jsx)("h3", {
                                                            className: "text-lg font-medium leading-6 text-gray-900",
                                                            children: "Rapportera matchresultat"
                                                        })
                                                    }),
                                                    /*#__PURE__*/ (0,jsx_runtime.jsx)(MatchResultForm, {
                                                        matchId: matchId,
                                                        open: open,
                                                        setOpen: setOpen,
                                                        initialValues: {
                                                            home_set_one: match && match.home_set_one_games || 0,
                                                            home_set_two: match && match.home_set_two_games || 0,
                                                            home_set_three: match && match.home_set_three_games || 0,
                                                            home_tiebreak: match && match.home_tiebreak_points || 0,
                                                            away_set_one: match && match.away_set_one_games || 0,
                                                            away_set_two: match && match.away_set_two_games || 0,
                                                            away_set_three: match && match.away_set_three_games || 0,
                                                            away_tiebreak: match && match.away_tiebreak_points || 0
                                                        }
                                                    })
                                                ]
                                            }) : null,
                                            matchId ? /*#__PURE__*/ (0,jsx_runtime.jsxs)(jsx_runtime.Fragment, {
                                                children: [
                                                    /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                                                        className: "border-b border-gray-200 bg-white py-5",
                                                        children: [
                                                            /*#__PURE__*/ (0,jsx_runtime.jsx)("h3", {
                                                                className: "text-lg font-medium leading-6 text-gray-900",
                                                                children: "Bekr\xe4fta match"
                                                            }),
                                                            /*#__PURE__*/ (0,jsx_runtime.jsx)("p", {
                                                                className: "mt-1 text-sm text-gray-500",
                                                                children: "N\xe4r du bekr\xe4ftar matchen l\xe5ser kommer vi skicka iv\xe4g en notifikation till spelarna s\xe5 de vet n\xe4r, var och med vem de ska spela."
                                                            })
                                                        ]
                                                    }),
                                                    /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                                                        className: "py-5",
                                                        children: [
                                                            /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                                                                children: [
                                                                    /*#__PURE__*/ (0,jsx_runtime.jsx)("label", {
                                                                        htmlFor: "court_name",
                                                                        className: "block text-sm font-medium text-gray-700",
                                                                        children: "Bana"
                                                                    }),
                                                                    /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                                                        className: "mt-1",
                                                                        children: /*#__PURE__*/ (0,jsx_runtime.jsx)("input", {
                                                                            type: "text",
                                                                            name: "court_name",
                                                                            id: "court_name",
                                                                            className: "block w-full rounded-md border-gray-300 shadow-sm focus:border-indigo-500 focus:ring-indigo-500 sm:text-sm",
                                                                            placeholder: "Skriv namnet p\xe5 banan",
                                                                            "aria-describedby": "court_name_description",
                                                                            value: courtName,
                                                                            onChange: function(e) {
                                                                                return setCourtName(e.currentTarget.value);
                                                                            }
                                                                        })
                                                                    }),
                                                                    /*#__PURE__*/ (0,jsx_runtime.jsx)("p", {
                                                                        className: "mt-2 text-sm text-gray-500",
                                                                        id: "court_name_description",
                                                                        children: "Skriv namnet p\xe5 banan som denna match ska spelas p\xe5."
                                                                    })
                                                                ]
                                                            }),
                                                            /*#__PURE__*/ (0,jsx_runtime.jsxs)("button", {
                                                                type: "button",
                                                                className: "inline-flex w-full justify-center rounded-md border border-transparent bg-green-600 px-4 py-2 text-base font-medium text-white shadow-sm hover:bg-green-700 focus:outline-none focus:ring-2 focus:ring-green-500 focus:ring-offset-2 sm:text-sm",
                                                                disabled: isConfirming,
                                                                onClick: function() {
                                                                    if (confirm('\xc4r du s\xe4ker p\xe5 att du vill bekr\xe4fta matchen och skicka notifikationer till spelarna?')) {
                                                                        confirmMatch();
                                                                    }
                                                                },
                                                                children: [
                                                                    "Bekr\xe4fta match",
                                                                    isConfirming ? /*#__PURE__*/ (0,jsx_runtime.jsxs)("svg", {
                                                                        className: "-mr-1 ml-3 h-5 w-5 animate-spin text-white",
                                                                        xmlns: "http://www.w3.org/2000/svg",
                                                                        fill: "none",
                                                                        viewBox: "0 0 24 24",
                                                                        children: [
                                                                            /*#__PURE__*/ (0,jsx_runtime.jsx)("circle", {
                                                                                className: "opacity-25",
                                                                                cx: "12",
                                                                                cy: "12",
                                                                                r: "10",
                                                                                stroke: "currentColor",
                                                                                strokeWidth: "4"
                                                                            }),
                                                                            /*#__PURE__*/ (0,jsx_runtime.jsx)("path", {
                                                                                className: "opacity-75",
                                                                                fill: "currentColor",
                                                                                d: "M4 12a8 8 0 018-8V0C5.373 0 0 5.373 0 12h4zm2 5.291A7.962 7.962 0 014 12H0c0 3.042 1.135 5.824 3 7.938l3-2.647z"
                                                                            })
                                                                        ]
                                                                    }) : null
                                                                ]
                                                            })
                                                        ]
                                                    })
                                                ]
                                            }) : null,
                                            matchId ? /*#__PURE__*/ (0,jsx_runtime.jsxs)(jsx_runtime.Fragment, {
                                                children: [
                                                    /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                                                        className: "border-b border-gray-200 bg-white py-5",
                                                        children: [
                                                            /*#__PURE__*/ (0,jsx_runtime.jsx)("h3", {
                                                                className: "text-lg font-medium leading-6 text-gray-900",
                                                                children: "Ta bort match"
                                                            }),
                                                            /*#__PURE__*/ (0,jsx_runtime.jsx)("p", {
                                                                className: "mt-1 text-sm text-gray-500",
                                                                children: "Lorem ipsum dolor sit amet consectetur adipisicing elit quam corrupti consectetur."
                                                            })
                                                        ]
                                                    }),
                                                    /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                                        className: "py-5",
                                                        children: /*#__PURE__*/ (0,jsx_runtime.jsxs)("button", {
                                                            type: "button",
                                                            className: "inline-flex w-full justify-center rounded-md border border-transparent bg-red-600 px-4 py-2 text-base font-medium text-white shadow-sm hover:bg-red-700 focus:outline-none focus:ring-2 focus:ring-red-500 focus:ring-offset-2 sm:text-sm",
                                                            disabled: isDeleting,
                                                            onClick: function() {
                                                                if (confirm('\xc4r du s\xe4ker p\xe5 att du vill ta bort matchen?')) {
                                                                    deleteMatch();
                                                                }
                                                            },
                                                            children: [
                                                                "Ta bort match",
                                                                isDeleting ? /*#__PURE__*/ (0,jsx_runtime.jsxs)("svg", {
                                                                    className: "-mr-1 ml-3 h-5 w-5 animate-spin text-white",
                                                                    xmlns: "http://www.w3.org/2000/svg",
                                                                    fill: "none",
                                                                    viewBox: "0 0 24 24",
                                                                    children: [
                                                                        /*#__PURE__*/ (0,jsx_runtime.jsx)("circle", {
                                                                            className: "opacity-25",
                                                                            cx: "12",
                                                                            cy: "12",
                                                                            r: "10",
                                                                            stroke: "currentColor",
                                                                            strokeWidth: "4"
                                                                        }),
                                                                        /*#__PURE__*/ (0,jsx_runtime.jsx)("path", {
                                                                            className: "opacity-75",
                                                                            fill: "currentColor",
                                                                            d: "M4 12a8 8 0 018-8V0C5.373 0 0 5.373 0 12h4zm2 5.291A7.962 7.962 0 014 12H0c0 3.042 1.135 5.824 3 7.938l3-2.647z"
                                                                        })
                                                                    ]
                                                                }) : null
                                                            ]
                                                        })
                                                    })
                                                ]
                                            }) : null,
                                            /*#__PURE__*/ (0,jsx_runtime.jsx)("button", {
                                                type: "button",
                                                className: "mt-3 inline-flex w-full justify-center rounded-md border border-gray-300 bg-white px-4 py-2 text-base font-medium text-gray-700 shadow-sm hover:bg-gray-50 focus:outline-none focus:ring-2 focus:ring-indigo-500 focus:ring-offset-2 sm:mt-0 sm:w-auto sm:text-sm",
                                                onClick: function() {
                                                    reset();
                                                    setOpen(false);
                                                },
                                                ref: cancelButtonRef,
                                                children: "St\xe4ng det h\xe4r f\xf6nstret"
                                            })
                                        ]
                                    })
                                ]
                            })
                        })
                    })
                ]
            })
        })
    }));
};

;// CONCATENATED MODULE: ./components/ds/03-organisms/admin-player-matcher-table/types.ts


var AdminPlayerBreakdownRows = es6/* array */.IX(Breakdown);

;// CONCATENATED MODULE: ./components/ds/03-organisms/admin-player-matcher-table/index.tsx




var AdminPlayerMatcherTable = function(param) {
    var allRows = param.allRows;
    return(/*#__PURE__*/ (0,jsx_runtime.jsxs)("table", {
        className: "min-w-full divide-y divide-gray-200",
        children: [
            /*#__PURE__*/ (0,jsx_runtime.jsx)("thead", {
                className: "bg-gray-50",
                children: /*#__PURE__*/ (0,jsx_runtime.jsxs)("tr", {
                    children: [
                        /*#__PURE__*/ (0,jsx_runtime.jsx)("th", {
                            scope: "col",
                            className: "px-2 py-1 text-center text-xs font-medium text-gray-500 uppercase tracking-wider whitespace-nowrap",
                            children: "Spelare"
                        }),
                        allRows.map(function(row) {
                            /*#__PURE__*/ return (0,jsx_runtime.jsx)("th", {
                                scope: "col",
                                className: "px-2 py-1 text-center text-xs font-medium text-gray-500 uppercase tracking-wider whitespace-nowrap",
                                children: row.player_name
                            }, "".concat(row.player_id, "--header-row"));
                        })
                    ]
                })
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)("tbody", {
                children: allRows.map(function(row, rowIdx) {
                    /*#__PURE__*/ return (0,jsx_runtime.jsx)(AdminPlayerMatcherTableRowItem, {
                        row: row,
                        rowIdx: rowIdx,
                        allRows: allRows
                    }, row.player_id);
                })
            })
        ]
    }));
};

;// CONCATENATED MODULE: ./components/ds/03-organisms/ranking-list/types.ts


var RankedPlayers = es6/* array */.IX(RankedPlayer);

;// CONCATENATED MODULE: ./components/ds/03-organisms/ranking-list/index.tsx




var RankingList = function(param) {
    var players = param.players;
    return(/*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
        className: "flex flex-col",
        children: /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
            className: "-my-2 overflow-x-auto sm:-mx-6 lg:-mx-8",
            children: /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                className: "py-2 align-middle inline-block min-w-full sm:px-6 lg:px-8",
                children: /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                    className: "shadow overflow-hidden border-b border-gray-200 sm:rounded-lg",
                    children: /*#__PURE__*/ (0,jsx_runtime.jsxs)("table", {
                        className: "min-w-full divide-y divide-gray-200",
                        children: [
                            /*#__PURE__*/ (0,jsx_runtime.jsx)("thead", {
                                className: "bg-gray-50",
                                children: /*#__PURE__*/ (0,jsx_runtime.jsxs)("tr", {
                                    children: [
                                        /*#__PURE__*/ (0,jsx_runtime.jsx)("th", {
                                            scope: "col",
                                            className: "px-6 py-3 text-left text-xs font-medium text-gray-500 uppercase tracking-wider",
                                            children: "#"
                                        }),
                                        /*#__PURE__*/ (0,jsx_runtime.jsx)("th", {
                                            scope: "col",
                                            className: "px-6 py-3 text-left text-xs font-medium text-gray-500 uppercase tracking-wider",
                                            children: "Namn"
                                        }),
                                        /*#__PURE__*/ (0,jsx_runtime.jsx)("th", {
                                            scope: "col",
                                            className: "px-6 py-3 text-left text-xs font-medium text-gray-500 uppercase tracking-wider",
                                            children: "Po\xe4ng"
                                        }),
                                        /*#__PURE__*/ (0,jsx_runtime.jsx)("th", {
                                            scope: "col",
                                            className: "px-6 py-3 text-left text-xs font-medium text-gray-500 uppercase tracking-wider",
                                            children: "Plus/minus"
                                        }),
                                        /*#__PURE__*/ (0,jsx_runtime.jsx)("th", {
                                            scope: "col",
                                            className: "px-6 py-3 text-left text-xs font-medium text-gray-500 uppercase tracking-wider",
                                            children: "Spelade matcher"
                                        }),
                                        /*#__PURE__*/ (0,jsx_runtime.jsx)("th", {
                                            scope: "col",
                                            className: "px-6 py-3 text-left text-xs font-medium text-gray-500 uppercase tracking-wider",
                                            children: "Anm\xe4lde sig"
                                        }),
                                        /*#__PURE__*/ (0,jsx_runtime.jsx)("th", {
                                            scope: "col",
                                            className: "px-6 py-3 text-left text-xs font-medium text-gray-500 uppercase tracking-wider",
                                            children: "Seedad"
                                        }),
                                        /*#__PURE__*/ (0,jsx_runtime.jsx)("th", {
                                            scope: "col",
                                            className: "px-6 py-3 text-left text-xs font-medium text-gray-500 uppercase tracking-wider",
                                            children: "G\xe4st"
                                        })
                                    ]
                                })
                            }),
                            /*#__PURE__*/ (0,jsx_runtime.jsx)("tbody", {
                                children: players.map(function(player, playerIdx) {
                                    /*#__PURE__*/ return (0,jsx_runtime.jsx)(RankingRowItem, {
                                        player: player,
                                        listIndex: playerIdx
                                    }, player.name);
                                })
                            })
                        ]
                    })
                })
            })
        })
    }));
};

;// CONCATENATED MODULE: ./components/ds/03-organisms/index.ts














// EXTERNAL MODULE: ./components/ds/03-organisms/app-layout/header.tsx
var header = __webpack_require__(6573);
// EXTERNAL MODULE: ./components/ds/03-organisms/app-layout/search-header.tsx + 1 modules
var search_header = __webpack_require__(6235);
;// CONCATENATED MODULE: ./components/ds/04-templates/admin/series-rounds/translations.tsx
var series_rounds_translations_translations = {
    sv: {
        pageTitle: 'Anm\xe4lningar',
        pageDescription: 'H\xe4r kan du se de anm\xe4lningar som hittills gjorts f\xf6r den h\xe4r veckan.'
    },
    en: {
        pageTitle: 'Anm\xe4lningar',
        pageDescription: 'H\xe4r kan du se de anm\xe4lningar som hittills gjorts f\xf6r den h\xe4r veckan.'
    }
};

;// CONCATENATED MODULE: ./components/ds/04-templates/admin/series-rounds/index.tsx










function series_rounds_arrayLikeToArray(arr, len) {
    if (len == null || len > arr.length) len = arr.length;
    for(var i = 0, arr2 = new Array(len); i < len; i++)arr2[i] = arr[i];
    return arr2;
}
function series_rounds_arrayWithHoles(arr) {
    if (Array.isArray(arr)) return arr;
}
function series_rounds_iterableToArrayLimit(arr, i) {
    var _i = arr == null ? null : typeof Symbol !== "undefined" && arr[Symbol.iterator] || arr["@@iterator"];
    if (_i == null) return;
    var _arr = [];
    var _n = true;
    var _d = false;
    var _s, _e;
    try {
        for(_i = _i.call(arr); !(_n = (_s = _i.next()).done); _n = true){
            _arr.push(_s.value);
            if (i && _arr.length === i) break;
        }
    } catch (err) {
        _d = true;
        _e = err;
    } finally{
        try {
            if (!_n && _i["return"] != null) _i["return"]();
        } finally{
            if (_d) throw _e;
        }
    }
    return _arr;
}
function series_rounds_nonIterableRest() {
    throw new TypeError("Invalid attempt to destructure non-iterable instance.\\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method.");
}
function series_rounds_slicedToArray(arr, i) {
    return series_rounds_arrayWithHoles(arr) || series_rounds_iterableToArrayLimit(arr, i) || series_rounds_unsupportedIterableToArray(arr, i) || series_rounds_nonIterableRest();
}
function series_rounds_unsupportedIterableToArray(o, minLen) {
    if (!o) return;
    if (typeof o === "string") return series_rounds_arrayLikeToArray(o, minLen);
    var n = Object.prototype.toString.call(o).slice(8, -1);
    if (n === "Object" && o.constructor) n = o.constructor.name;
    if (n === "Map" || n === "Set") return Array.from(n);
    if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return series_rounds_arrayLikeToArray(o, minLen);
}
var AdminSeriesRoundTemplate = function(param) {
    var rounds = param.rounds, seriesContext = param.seriesContext;
    var router = (0,next_router.useRouter)();
    var locale = (0,utils_locale/* makeLocale */.W)(router.locale, router.defaultLocale) || 'sv';
    var translation = series_rounds_translations_translations[locale];
    var ref = (0,react.useState)(false), sidebarOpen = ref[0], setSidebarOpen = ref[1];
    (0,react.useEffect)(function() {
        if (document) {
            var htmlEl = document.querySelector('html');
            if (htmlEl) {
                htmlEl.classList.add('h-full');
                htmlEl.classList.add('bg-white');
            }
            var bodyEl = document.querySelector('body');
            if (bodyEl) {
                bodyEl.classList.add('h-full');
                bodyEl.classList.add('overflow-hidden');
            }
            var nextWrapperEl = document.querySelector('#__next');
            if (nextWrapperEl) {
                nextWrapperEl.classList.add('h-full');
                nextWrapperEl.classList.add('overflow-hidden');
            }
        }
    });
    var ref1 = series_rounds_slicedToArray((0,lodash.take)(rounds, 1), 1), round = ref1[0];
    return(/*#__PURE__*/ (0,jsx_runtime.jsxs)(jsx_runtime.Fragment, {
        children: [
            /*#__PURE__*/ (0,jsx_runtime.jsx)(Head, {
                title: translation.pageTitle,
                description: translation.pageDescription
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                className: "h-full flex",
                children: [
                    /*#__PURE__*/ (0,jsx_runtime.jsx)(header/* Header */.h, {
                        sidebarOpen: sidebarOpen,
                        setSidebarOpen: setSidebarOpen,
                        incomingSeriesId: seriesContext.id,
                        seriesContext: seriesContext
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                        className: "flex flex-col w-0 flex-1 overflow-hidden",
                        children: [
                            /*#__PURE__*/ (0,jsx_runtime.jsx)(search_header/* SearchHeader */.s, {
                                sidebarOpen: sidebarOpen,
                                setSidebarOpen: setSidebarOpen
                            }),
                            /*#__PURE__*/ (0,jsx_runtime.jsxs)("main", {
                                className: "flex-1 relative z-0 overflow-y-auto focus:outline-none",
                                children: [
                                    /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                        className: "border-b border-gray-200 px-4 py-4 sm:flex sm:items-center sm:justify-between sm:px-6 lg:px-8",
                                        children: /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                            className: "flex-1 min-w-0",
                                            children: /*#__PURE__*/ (0,jsx_runtime.jsxs)("h1", {
                                                className: "text-base font-medium leading-6 text-gray-900 sm:truncate",
                                                children: [
                                                    "Rundor f\xf6r ",
                                                    round && round.series_name ? round.series_name : 'denna serie'
                                                ]
                                            })
                                        })
                                    }),
                                    rounds.length === 0 ? /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                                        className: "mt-12 text-center",
                                        children: [
                                            /*#__PURE__*/ (0,jsx_runtime.jsx)(outline_esm/* StopIcon */.wNq, {
                                                className: "mx-auto h-12 w-12 text-gray-400",
                                                "aria-hidden": "true"
                                            }),
                                            /*#__PURE__*/ (0,jsx_runtime.jsxs)("h3", {
                                                className: "mt-2 text-sm font-medium text-gray-900",
                                                children: [
                                                    "Inga rundor funna f\xf6r",
                                                    ' ',
                                                    round && round.series_name ? round.series_name : 'denna serie'
                                                ]
                                            }),
                                            /*#__PURE__*/ (0,jsx_runtime.jsx)("p", {
                                                className: "mt-1 text-sm text-gray-500",
                                                children: "Kom tillbaka till den h\xe4r sidan vid ett senare tillf\xe4lle."
                                            })
                                        ]
                                    }) : null,
                                    rounds.length > 0 ? /*#__PURE__*/ (0,jsx_runtime.jsx)(AdminRoundsList, {
                                        rounds: rounds
                                    }) : null
                                ]
                            })
                        ]
                    })
                ]
            })
        ]
    }));
};

;// CONCATENATED MODULE: ./components/ds/04-templates/admin/series-round-details/translations.tsx
var series_round_details_translations_translations = {
    sv: {
        pageTitle: 'Anm\xe4lningar',
        pageDescription: 'H\xe4r kan du se de anm\xe4lningar som hittills gjorts f\xf6r den h\xe4r veckan.'
    },
    en: {
        pageTitle: 'Anm\xe4lningar',
        pageDescription: 'H\xe4r kan du se de anm\xe4lningar som hittills gjorts f\xf6r den h\xe4r veckan.'
    }
};

;// CONCATENATED MODULE: ./components/ds/04-templates/admin/series-round-details/index.tsx










var AdminSeriesRoundDetailsTemplate = function(param) {
    var round = param.round, series = param.series, matches = param.matches, signups = param.signups;
    var router = (0,next_router.useRouter)();
    var locale = (0,utils_locale/* makeLocale */.W)(router.locale, router.defaultLocale) || 'sv';
    var translation = series_round_details_translations_translations[locale];
    var ref = (0,react.useState)(false), sidebarOpen = ref[0], setSidebarOpen = ref[1];
    var ref1 = (0,react.useState)(false), addNewMatchModalOpen = ref1[0], setAddNewMatchModalOpen = ref1[1];
    var ref2 = (0,react.useState)(false), manageMatchModalOpen = ref2[0], setManageMatchModalOpen = ref2[1];
    var ref3 = (0,react.useState)(), matchId = ref3[0], setMatchId = ref3[1];
    var ref4 = (0,react.useState)(), match1 = ref4[0], setMatch = ref4[1];
    (0,react.useEffect)(function() {
        if (document) {
            var htmlEl = document.querySelector('html');
            if (htmlEl) {
                htmlEl.classList.add('h-full');
                htmlEl.classList.add('bg-white');
            }
            var bodyEl = document.querySelector('body');
            if (bodyEl) {
                bodyEl.classList.add('h-full');
                bodyEl.classList.add('overflow-hidden');
            }
            var nextWrapperEl = document.querySelector('#__next');
            if (nextWrapperEl) {
                nextWrapperEl.classList.add('h-full');
                nextWrapperEl.classList.add('overflow-hidden');
            }
        }
    });
    var handleMatchClick = function(match) {
        if (match) {
            setMatch(match);
            if (match.match_id) setMatchId(match.match_id);
        }
        setManageMatchModalOpen(true);
    };
    return(/*#__PURE__*/ (0,jsx_runtime.jsxs)(jsx_runtime.Fragment, {
        children: [
            /*#__PURE__*/ (0,jsx_runtime.jsx)(Head, {
                title: translation.pageTitle,
                description: translation.pageDescription
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                className: "h-full flex",
                children: [
                    /*#__PURE__*/ (0,jsx_runtime.jsx)(header/* Header */.h, {
                        sidebarOpen: sidebarOpen,
                        setSidebarOpen: setSidebarOpen,
                        incomingSeriesId: series.id,
                        seriesContext: series
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                        className: "flex flex-col w-0 flex-1 overflow-hidden",
                        children: [
                            /*#__PURE__*/ (0,jsx_runtime.jsx)(search_header/* SearchHeader */.s, {
                                sidebarOpen: sidebarOpen,
                                setSidebarOpen: setSidebarOpen
                            }),
                            /*#__PURE__*/ (0,jsx_runtime.jsxs)("main", {
                                className: "flex-1 relative z-0 overflow-y-auto focus:outline-none pb-12",
                                children: [
                                    /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                        className: "border-b border-gray-200 px-4 py-4 sm:flex sm:items-center sm:justify-between sm:px-6 lg:px-8",
                                        children: /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                            className: "flex-1 min-w-0",
                                            children: /*#__PURE__*/ (0,jsx_runtime.jsxs)("h1", {
                                                className: "text-base font-medium leading-6 text-gray-900 sm:truncate",
                                                children: [
                                                    "Rundor f\xf6r ",
                                                    round && round.series_name ? round.series_name : 'denna serie'
                                                ]
                                            })
                                        })
                                    }),
                                    /*#__PURE__*/ (0,jsx_runtime.jsx)(RoundDetailsPanel, {
                                        round: round,
                                        series: series
                                    }),
                                    /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                        className: "py-5 border-b border-gray-200",
                                        children: /*#__PURE__*/ (0,jsx_runtime.jsxs)("h3", {
                                            className: "px-4 text-lg leading-6 font-bold text-gray-900",
                                            children: [
                                                "Anm\xe4lningar",
                                                ' ',
                                                signups && signups.length > 0 ? "(".concat((0,lodash.reduce)(signups, function(sum, signup) {
                                                    return signup.signup_state === 'accepted' ? sum + 1 : sum;
                                                }, 0), "st bekr\xe4ftade)") : null
                                            ]
                                        })
                                    }),
                                    signups.length === 0 ? /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                                        className: "mt-12 text-center",
                                        children: [
                                            /*#__PURE__*/ (0,jsx_runtime.jsx)(outline_esm/* StopIcon */.wNq, {
                                                className: "mx-auto h-12 w-12 text-gray-400",
                                                "aria-hidden": "true"
                                            }),
                                            /*#__PURE__*/ (0,jsx_runtime.jsx)("h3", {
                                                className: "mt-2 text-sm font-medium text-gray-900",
                                                children: "Inga anm\xe4lningar f\xf6r denna vecka"
                                            }),
                                            /*#__PURE__*/ (0,jsx_runtime.jsx)("p", {
                                                className: "mt-1 text-sm text-gray-500",
                                                children: "Beh\xf6ver det skickas ut en p\xe5minnelse?"
                                            })
                                        ]
                                    }) : null,
                                    signups.length > 0 ? /*#__PURE__*/ (0,jsx_runtime.jsx)(SignupsList, {
                                        signups: signups,
                                        showDetails: false,
                                        series: series,
                                        round: round
                                    }) : null,
                                    /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                                        className: "py-5 border-b border-gray-200 sm:flex sm:items-center sm:justify-between",
                                        children: [
                                            /*#__PURE__*/ (0,jsx_runtime.jsx)("h3", {
                                                className: "px-4 text-lg leading-6 font-bold text-gray-900",
                                                children: "Matcher"
                                            }),
                                            [
                                                'current',
                                                'next_week',
                                                'past'
                                            ].includes(round.status) ? /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                                className: "px-4 mt-3 sm:mt-0",
                                                children: /*#__PURE__*/ (0,jsx_runtime.jsxs)("button", {
                                                    type: "button",
                                                    className: "inline-flex items-center px-4 py-2 border border-transparent rounded-md shadow-sm text-sm font-medium text-white bg-indigo-600 hover:bg-indigo-700 focus:outline-none focus:ring-2 focus:ring-offset-2 focus:ring-indigo-500",
                                                    onClick: function() {
                                                        return setAddNewMatchModalOpen(true);
                                                    },
                                                    children: [
                                                        /*#__PURE__*/ (0,jsx_runtime.jsx)(outline_esm/* PlusIcon */.pOD, {
                                                            className: "-ml-1 mr-2 h-5 w-5",
                                                            "aria-hidden": "true"
                                                        }),
                                                        "Ny match"
                                                    ]
                                                })
                                            }) : null
                                        ]
                                    }),
                                    matches.length === 0 ? /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                                        className: "mt-12 text-center",
                                        children: [
                                            /*#__PURE__*/ (0,jsx_runtime.jsx)(outline_esm/* StopIcon */.wNq, {
                                                className: "mx-auto h-12 w-12 text-gray-400",
                                                "aria-hidden": "true"
                                            }),
                                            /*#__PURE__*/ (0,jsx_runtime.jsx)("h3", {
                                                className: "mt-2 text-sm font-medium text-gray-900",
                                                children: "Inga matcher f\xf6r denna runda"
                                            }),
                                            /*#__PURE__*/ (0,jsx_runtime.jsx)("p", {
                                                className: "mt-1 text-sm text-gray-500",
                                                children: "Klicka p\xe5 knappen nedan f\xf6r att skapa den f\xf6rsta."
                                            }),
                                            /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                                className: "mt-6",
                                                children: /*#__PURE__*/ (0,jsx_runtime.jsxs)("button", {
                                                    type: "button",
                                                    className: "inline-flex items-center px-4 py-2 border border-transparent shadow-sm text-sm font-medium rounded-md text-white bg-indigo-600 hover:bg-indigo-700 focus:outline-none focus:ring-2 focus:ring-offset-2 focus:ring-indigo-500",
                                                    onClick: function() {
                                                        return setAddNewMatchModalOpen(true);
                                                    },
                                                    children: [
                                                        /*#__PURE__*/ (0,jsx_runtime.jsx)(outline_esm/* PlusIcon */.pOD, {
                                                            className: "-ml-1 mr-2 h-5 w-5",
                                                            "aria-hidden": "true"
                                                        }),
                                                        "Ny match"
                                                    ]
                                                })
                                            })
                                        ]
                                    }) : null,
                                    matches.length > 0 ? /*#__PURE__*/ (0,jsx_runtime.jsx)(AdminMatchResultList, {
                                        matches: matches,
                                        handleMatchClick: handleMatchClick
                                    }) : null,
                                    /*#__PURE__*/ (0,jsx_runtime.jsx)(CreateMatchModal, {
                                        open: addNewMatchModalOpen,
                                        setOpen: setAddNewMatchModalOpen,
                                        roundId: round.round_id,
                                        seriesId: round.series_id
                                    }),
                                    /*#__PURE__*/ (0,jsx_runtime.jsx)(ManageMatchModal, {
                                        open: manageMatchModalOpen,
                                        setOpen: function(open) {
                                            setManageMatchModalOpen(open);
                                            if (!open) {
                                                setMatchId(undefined);
                                                setMatch(undefined);
                                            }
                                        },
                                        roundId: round.round_id,
                                        seriesId: round.series_id,
                                        matchId: matchId,
                                        match: match1
                                    })
                                ]
                            })
                        ]
                    })
                ]
            })
        ]
    }));
};

;// CONCATENATED MODULE: ./components/ds/04-templates/admin/manage-series/translations.tsx
var manage_series_translations_translations = {
    sv: {
        pageTitle: 'Anm\xe4lningar',
        pageDescription: 'H\xe4r kan du se de anm\xe4lningar som hittills gjorts f\xf6r den h\xe4r veckan.'
    },
    en: {
        pageTitle: 'Anm\xe4lningar',
        pageDescription: 'H\xe4r kan du se de anm\xe4lningar som hittills gjorts f\xf6r den h\xe4r veckan.'
    }
};

;// CONCATENATED MODULE: ./components/ds/04-templates/admin/manage-series/index.tsx









var AdminManageSeriesTemplate = function(param) {
    var seriesContext = param.seriesContext;
    var router = (0,next_router.useRouter)();
    var locale = (0,utils_locale/* makeLocale */.W)(router.locale, router.defaultLocale) || 'sv';
    var translation = manage_series_translations_translations[locale];
    var ref = (0,react.useState)(false), sidebarOpen = ref[0], setSidebarOpen = ref[1];
    (0,react.useEffect)(function() {
        if (document) {
            var htmlEl = document.querySelector('html');
            if (htmlEl) {
                htmlEl.classList.add('h-full');
                htmlEl.classList.add('bg-white');
            }
            var bodyEl = document.querySelector('body');
            if (bodyEl) {
                bodyEl.classList.add('h-full');
                bodyEl.classList.add('overflow-hidden');
            }
            var nextWrapperEl = document.querySelector('#__next');
            if (nextWrapperEl) {
                nextWrapperEl.classList.add('h-full');
                nextWrapperEl.classList.add('overflow-hidden');
            }
        }
    });
    return(/*#__PURE__*/ (0,jsx_runtime.jsxs)(jsx_runtime.Fragment, {
        children: [
            /*#__PURE__*/ (0,jsx_runtime.jsx)(Head, {
                title: translation.pageTitle,
                description: translation.pageDescription
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                className: "h-full flex",
                children: [
                    /*#__PURE__*/ (0,jsx_runtime.jsx)(header/* Header */.h, {
                        sidebarOpen: sidebarOpen,
                        setSidebarOpen: setSidebarOpen,
                        incomingSeriesId: seriesContext.id,
                        seriesContext: seriesContext
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                        className: "flex flex-col w-0 flex-1 overflow-hidden",
                        children: [
                            /*#__PURE__*/ (0,jsx_runtime.jsx)(search_header/* SearchHeader */.s, {
                                sidebarOpen: sidebarOpen,
                                setSidebarOpen: setSidebarOpen
                            }),
                            /*#__PURE__*/ (0,jsx_runtime.jsxs)("main", {
                                className: "flex-1 relative z-0 overflow-y-auto focus:outline-none",
                                children: [
                                    /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                        className: "border-b border-gray-200 px-4 py-4 sm:flex sm:items-center sm:justify-between sm:px-6 lg:px-8",
                                        children: /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                            className: "flex-1 min-w-0",
                                            children: /*#__PURE__*/ (0,jsx_runtime.jsxs)("h1", {
                                                className: "text-base font-medium leading-6 text-gray-900 sm:truncate",
                                                children: [
                                                    "Hantera ",
                                                    seriesContext && seriesContext.name ? seriesContext.name : 'denna serie'
                                                ]
                                            })
                                        })
                                    }),
                                    /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                        className: "px-4 py-4 sm:flex sm:items-center sm:justify-between sm:px-6 lg:px-8",
                                        children: /*#__PURE__*/ (0,jsx_runtime.jsx)(next_link["default"], {
                                            href: "/admin/series/".concat(seriesContext.id, "/manage/round/create"),
                                            children: /*#__PURE__*/ (0,jsx_runtime.jsx)("a", {
                                                className: "inline-flex items-center px-4 py-2 border border-transparent text-base font-medium rounded-md shadow-sm text-white bg-indigo-600 hover:bg-indigo-700 focus:outline-none focus:ring-2 focus:ring-offset-2 focus:ring-indigo-500",
                                                children: "Skapa en runda i serien"
                                            })
                                        })
                                    }),
                                    /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                        className: "px-4 py-4 sm:flex sm:items-center sm:justify-between sm:px-6 lg:px-8",
                                        children: /*#__PURE__*/ (0,jsx_runtime.jsx)(next_link["default"], {
                                            href: "/admin/series/".concat(seriesContext.id, "/manage/team/create"),
                                            children: /*#__PURE__*/ (0,jsx_runtime.jsx)("a", {
                                                className: "inline-flex items-center px-4 py-2 border border-transparent text-base font-medium rounded-md shadow-sm text-white bg-indigo-600 hover:bg-indigo-700 focus:outline-none focus:ring-2 focus:ring-offset-2 focus:ring-indigo-500",
                                                children: "Skapa lag"
                                            })
                                        })
                                    })
                                ]
                            })
                        ]
                    })
                ]
            })
        ]
    }));
};

;// CONCATENATED MODULE: ./components/ds/04-templates/admin/create-team/form.tsx







function create_team_form_asyncGeneratorStep(gen, resolve, reject, _next, _throw, key, arg) {
    try {
        var info = gen[key](arg);
        var value = info.value;
    } catch (error) {
        reject(error);
        return;
    }
    if (info.done) {
        resolve(value);
    } else {
        Promise.resolve(value).then(_next, _throw);
    }
}
function create_team_form_asyncToGenerator(fn) {
    return function() {
        var self = this, args = arguments;
        return new Promise(function(resolve, reject) {
            var gen = fn.apply(self, args);
            function _next(value) {
                create_team_form_asyncGeneratorStep(gen, resolve, reject, _next, _throw, "next", value);
            }
            function _throw(err) {
                create_team_form_asyncGeneratorStep(gen, resolve, reject, _next, _throw, "throw", err);
            }
            _next(undefined);
        });
    };
}
function create_team_form_defineProperty(obj, key, value) {
    if (key in obj) {
        Object.defineProperty(obj, key, {
            value: value,
            enumerable: true,
            configurable: true,
            writable: true
        });
    } else {
        obj[key] = value;
    }
    return obj;
}
function create_team_form_instanceof(left, right) {
    if (right != null && typeof Symbol !== "undefined" && right[Symbol.hasInstance]) {
        return right[Symbol.hasInstance](left);
    } else {
        return left instanceof right;
    }
}
function create_team_form_objectSpread(target) {
    for(var i = 1; i < arguments.length; i++){
        var source = arguments[i] != null ? arguments[i] : {};
        var ownKeys = Object.keys(source);
        if (typeof Object.getOwnPropertySymbols === "function") {
            ownKeys = ownKeys.concat(Object.getOwnPropertySymbols(source).filter(function(sym) {
                return Object.getOwnPropertyDescriptor(source, sym).enumerable;
            }));
        }
        ownKeys.forEach(function(key) {
            create_team_form_defineProperty(target, key, source[key]);
        });
    }
    return target;
}
var ValidationSchema = es/* object */.Ry().shape({
    team_name: es/* string */.Z_().min(2, 'V\xe4rdet \xe4r f\xf6r kort').max(40, 'V\xe4rdet \xe4r f\xf6r l\xe5ngt').trim().required('Detta f\xe4lt m\xe5ste ha ett v\xe4rde'),
    team_group: es/* string */.Z_().min(0, 'M\xe5ste vara minst 0').max(7, 'Du kan bara vinna som mest 7 gem').lowercase().required('Detta f\xe4lt m\xe5ste ha ett v\xe4rde'),
    player_name: es/* string */.Z_().min(2, 'V\xe4rdet \xe4r f\xf6r kort').max(40, 'V\xe4rdet \xe4r f\xf6r l\xe5ngt').trim().required('Detta f\xe4lt m\xe5ste ha ett v\xe4rde'),
    player_email: es/* string */.Z_().min(2, 'V\xe4rdet \xe4r f\xf6r kort').max(40, 'V\xe4rdet \xe4r f\xf6r l\xe5ngt').email('Fel format p\xe5 e-postadressen').trim().lowercase().required('Detta f\xe4lt m\xe5ste ha ett v\xe4rde'),
    player_phone: es/* string */.Z_().min(2, 'V\xe4rdet \xe4r f\xf6r kort').max(40, 'V\xe4rdet \xe4r f\xf6r l\xe5ngt').trim().required('Detta f\xe4lt m\xe5ste ha ett v\xe4rde')
});
var initialValues = {
    team_name: '',
    team_group: 'morning',
    player_name: '',
    player_email: '',
    player_phone: ''
};
var CreateTeamForm = function(param1) {
    var seriesContext = param1.seriesContext;
    var ref = (0,react.useState)(), error = ref[0], setError = ref[1];
    var ref1 = (0,react.useState)(), status = ref1[0], setStatus = ref1[1];
    var reset = function() {
        setError(undefined);
        setStatus('pristine');
    };
    return(/*#__PURE__*/ (0,jsx_runtime.jsxs)(jsx_runtime.Fragment, {
        children: [
            status === 'ok' ? /*#__PURE__*/ (0,jsx_runtime.jsx)(SuccessAlert, {
                translations: {
                    headline: 'Gick bra!'
                },
                reset: reset
            }) : null,
            status === 'not_ok' && error ? /*#__PURE__*/ (0,jsx_runtime.jsx)(ErrorAlert, {
                translations: {
                    headline: 'Gick inte bra!'
                },
                error: error,
                reset: reset
            }) : null,
            /*#__PURE__*/ (0,jsx_runtime.jsx)(formik_esm/* Formik */.J9, {
                initialValues: initialValues,
                validationSchema: ValidationSchema,
                enableReinitialize: true,
                onSubmit: function() {
                    var _ref = create_team_form_asyncToGenerator(runtime_default().mark(function _callee(values, actions) {
                        var requestBody, CreateTeamRes, CreateTeamResData;
                        return runtime_default().wrap(function _callee$(_ctx) {
                            while(1)switch(_ctx.prev = _ctx.next){
                                case 0:
                                    _ctx.prev = 0;
                                    requestBody = {
                                        teamName: values.team_name,
                                        group: values.team_group,
                                        player: {
                                            name: values.player_name,
                                            email: values.player_email,
                                            phone: values.player_phone
                                        }
                                    };
                                    _ctx.next = 4;
                                    return fetch("/api/admin/series/".concat(seriesContext.id, "/team/create"), {
                                        method: 'POST',
                                        body: JSON.stringify(requestBody),
                                        headers: {
                                            'Content-Type': 'application/json'
                                        }
                                    });
                                case 4:
                                    CreateTeamRes = _ctx.sent;
                                    if (!(CreateTeamRes.status !== 200)) {
                                        _ctx.next = 11;
                                        break;
                                    }
                                    setStatus('not_ok');
                                    setError(new Error('Non 200 response from backend'));
                                    actions.resetForm();
                                    actions.setSubmitting(false);
                                    return _ctx.abrupt("return");
                                case 11:
                                    _ctx.next = 13;
                                    return CreateTeamRes.json();
                                case 13:
                                    CreateTeamResData = _ctx.sent;
                                    if (!CreateTeamResData.success) {
                                        setStatus('not_ok');
                                        setError(new Error(CreateTeamResData.code));
                                        actions.resetForm();
                                        actions.setSubmitting(false);
                                    } else {
                                        actions.resetForm();
                                        actions.setSubmitting(false);
                                        setStatus('pristine');
                                    }
                                    _ctx.next = 23;
                                    break;
                                case 17:
                                    _ctx.prev = 17;
                                    _ctx.t0 = _ctx["catch"](0);
                                    setStatus('not_ok');
                                    if (create_team_form_instanceof(_ctx.t0, Error)) {
                                        setError(_ctx.t0);
                                    } else {
                                        setError(new Error('Report game result failed due to a unknown error'));
                                    }
                                    actions.resetForm();
                                    actions.setSubmitting(false);
                                case 23:
                                case "end":
                                    return _ctx.stop();
                            }
                        }, _callee, null, [
                            [
                                0,
                                17
                            ]
                        ]);
                    }));
                    return function(values, actions) {
                        return _ref.apply(this, arguments);
                    };
                }(),
                children: function(formikBag) {
                    return(/*#__PURE__*/ (0,jsx_runtime.jsxs)(formik_esm/* Form */.l0, {
                        className: "space-y-8 divide-y divide-gray-200",
                        children: [
                            /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                                className: "space-y-8 divide-y divide-gray-200 sm:space-y-5",
                                children: [
                                    /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                                        children: [
                                            /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                                                children: [
                                                    /*#__PURE__*/ (0,jsx_runtime.jsx)("h3", {
                                                        className: "text-lg leading-6 font-medium text-gray-900",
                                                        children: "Laget"
                                                    }),
                                                    /*#__PURE__*/ (0,jsx_runtime.jsx)("p", {
                                                        className: "mt-1 max-w-2xl text-sm text-gray-500",
                                                        children: "This information will be displayed publicly so be careful what you share."
                                                    })
                                                ]
                                            }),
                                            /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                                                className: "mt-6 sm:mt-5 space-y-6 sm:space-y-5",
                                                children: [
                                                    /*#__PURE__*/ (0,jsx_runtime.jsx)(formik_esm/* Field */.gN, {
                                                        name: "team_name",
                                                        children: function(param) {
                                                            var field = param.field, meta = param.meta;
                                                            /*#__PURE__*/ return (0,jsx_runtime.jsxs)("div", {
                                                                className: "sm:grid sm:grid-cols-3 sm:gap-4 sm:items-start sm:border-t sm:border-gray-200 sm:pt-5",
                                                                children: [
                                                                    /*#__PURE__*/ (0,jsx_runtime.jsx)("label", {
                                                                        htmlFor: "team_name",
                                                                        className: "block text-sm font-medium text-gray-700 sm:mt-px sm:pt-2",
                                                                        children: "Lagnamn"
                                                                    }),
                                                                    /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                                                                        className: "mt-1 sm:mt-0 sm:col-span-2",
                                                                        children: [
                                                                            /*#__PURE__*/ (0,jsx_runtime.jsx)("input", create_team_form_objectSpread({}, field, {
                                                                                required: true,
                                                                                type: "text",
                                                                                className: "max-w-lg block w-full shadow-sm focus:ring-indigo-500 focus:border-indigo-500 sm:max-w-xs sm:text-sm border-gray-300 rounded-md"
                                                                            })),
                                                                            meta.touched && meta.error && /*#__PURE__*/ (0,jsx_runtime.jsx)("p", {
                                                                                className: "text-red-500 text-xs italic pt-2",
                                                                                children: meta.error
                                                                            })
                                                                        ]
                                                                    })
                                                                ]
                                                            });
                                                        }
                                                    }),
                                                    /*#__PURE__*/ (0,jsx_runtime.jsx)(formik_esm/* Field */.gN, {
                                                        name: "team_group",
                                                        children: function(param) {
                                                            var field = param.field, meta = param.meta;
                                                            /*#__PURE__*/ return (0,jsx_runtime.jsxs)("div", {
                                                                className: "sm:grid sm:grid-cols-3 sm:gap-4 sm:items-start sm:border-t sm:border-gray-200 sm:pt-5",
                                                                children: [
                                                                    /*#__PURE__*/ (0,jsx_runtime.jsx)("label", {
                                                                        htmlFor: "team_group",
                                                                        className: "block text-sm font-medium text-gray-700 sm:mt-px sm:pt-2",
                                                                        children: "Grupp"
                                                                    }),
                                                                    /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                                                                        className: "mt-1 sm:mt-0 sm:col-span-2",
                                                                        children: [
                                                                            /*#__PURE__*/ (0,jsx_runtime.jsxs)("select", create_team_form_objectSpread({}, field, {
                                                                                required: true,
                                                                                type: "text",
                                                                                className: "max-w-lg block focus:ring-indigo-500 focus:border-indigo-500 w-full shadow-sm sm:max-w-xs sm:text-sm border-gray-300 rounded-md",
                                                                                children: [
                                                                                    /*#__PURE__*/ (0,jsx_runtime.jsx)("option", {
                                                                                        value: "morning",
                                                                                        children: "Morgon"
                                                                                    }),
                                                                                    /*#__PURE__*/ (0,jsx_runtime.jsx)("option", {
                                                                                        value: "lunch",
                                                                                        children: "Lunch"
                                                                                    })
                                                                                ]
                                                                            })),
                                                                            meta.touched && meta.error && /*#__PURE__*/ (0,jsx_runtime.jsx)("p", {
                                                                                className: "text-red-500 text-xs italic pt-2",
                                                                                children: meta.error
                                                                            })
                                                                        ]
                                                                    })
                                                                ]
                                                            });
                                                        }
                                                    })
                                                ]
                                            })
                                        ]
                                    }),
                                    /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                                        className: "pt-8 space-y-6 sm:pt-10 sm:space-y-5",
                                        children: [
                                            /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                                                children: [
                                                    /*#__PURE__*/ (0,jsx_runtime.jsx)("h3", {
                                                        className: "text-lg leading-6 font-medium text-gray-900",
                                                        children: "Spelarinformation"
                                                    }),
                                                    /*#__PURE__*/ (0,jsx_runtime.jsx)("p", {
                                                        className: "mt-1 max-w-2xl text-sm text-gray-500",
                                                        children: "Use a permanent address where you can receive mail."
                                                    })
                                                ]
                                            }),
                                            /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                                                className: "space-y-6 sm:space-y-5",
                                                children: [
                                                    /*#__PURE__*/ (0,jsx_runtime.jsx)(formik_esm/* Field */.gN, {
                                                        name: "player_name",
                                                        children: function(param) {
                                                            var field = param.field, meta = param.meta;
                                                            /*#__PURE__*/ return (0,jsx_runtime.jsxs)("div", {
                                                                className: "sm:grid sm:grid-cols-3 sm:gap-4 sm:items-start sm:border-t sm:border-gray-200 sm:pt-5",
                                                                children: [
                                                                    /*#__PURE__*/ (0,jsx_runtime.jsx)("label", {
                                                                        htmlFor: "player_name",
                                                                        className: "block text-sm font-medium text-gray-700 sm:mt-px sm:pt-2",
                                                                        children: "Namn"
                                                                    }),
                                                                    /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                                                                        className: "mt-1 sm:mt-0 sm:col-span-2",
                                                                        children: [
                                                                            /*#__PURE__*/ (0,jsx_runtime.jsx)("input", create_team_form_objectSpread({}, field, {
                                                                                required: true,
                                                                                type: "text",
                                                                                className: "block max-w-lg w-full shadow-sm focus:ring-indigo-500 focus:border-indigo-500 sm:text-sm border-gray-300 rounded-md"
                                                                            })),
                                                                            meta.touched && meta.error && /*#__PURE__*/ (0,jsx_runtime.jsx)("p", {
                                                                                className: "text-red-500 text-xs italic pt-2",
                                                                                children: meta.error
                                                                            })
                                                                        ]
                                                                    })
                                                                ]
                                                            });
                                                        }
                                                    }),
                                                    /*#__PURE__*/ (0,jsx_runtime.jsx)(formik_esm/* Field */.gN, {
                                                        name: "player_email",
                                                        children: function(param) {
                                                            var field = param.field, meta = param.meta;
                                                            /*#__PURE__*/ return (0,jsx_runtime.jsxs)("div", {
                                                                className: "sm:grid sm:grid-cols-3 sm:gap-4 sm:items-start sm:border-t sm:border-gray-200 sm:pt-5",
                                                                children: [
                                                                    /*#__PURE__*/ (0,jsx_runtime.jsx)("label", {
                                                                        htmlFor: "player_email",
                                                                        className: "block text-sm font-medium text-gray-700 sm:mt-px sm:pt-2",
                                                                        children: "E-post"
                                                                    }),
                                                                    /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                                                                        className: "mt-1 sm:mt-0 sm:col-span-2",
                                                                        children: [
                                                                            /*#__PURE__*/ (0,jsx_runtime.jsx)("input", create_team_form_objectSpread({}, field, {
                                                                                required: true,
                                                                                type: "email",
                                                                                className: "block max-w-lg w-full shadow-sm focus:ring-indigo-500 focus:border-indigo-500 sm:text-sm border-gray-300 rounded-md"
                                                                            })),
                                                                            meta.touched && meta.error && /*#__PURE__*/ (0,jsx_runtime.jsx)("p", {
                                                                                className: "text-red-500 text-xs italic pt-2",
                                                                                children: meta.error
                                                                            })
                                                                        ]
                                                                    })
                                                                ]
                                                            });
                                                        }
                                                    }),
                                                    /*#__PURE__*/ (0,jsx_runtime.jsx)(formik_esm/* Field */.gN, {
                                                        name: "player_phone",
                                                        children: function(param) {
                                                            var field = param.field, meta = param.meta;
                                                            /*#__PURE__*/ return (0,jsx_runtime.jsxs)("div", {
                                                                className: "sm:grid sm:grid-cols-3 sm:gap-4 sm:items-start sm:border-t sm:border-gray-200 sm:pt-5",
                                                                children: [
                                                                    /*#__PURE__*/ (0,jsx_runtime.jsx)("label", {
                                                                        htmlFor: "player_phone",
                                                                        className: "block text-sm font-medium text-gray-700 sm:mt-px sm:pt-2",
                                                                        children: "Telefon"
                                                                    }),
                                                                    /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                                                                        className: "mt-1 sm:mt-0 sm:col-span-2",
                                                                        children: [
                                                                            /*#__PURE__*/ (0,jsx_runtime.jsx)("input", create_team_form_objectSpread({}, field, {
                                                                                required: true,
                                                                                type: "tel",
                                                                                className: "block max-w-lg w-full shadow-sm focus:ring-indigo-500 focus:border-indigo-500 sm:text-sm border-gray-300 rounded-md"
                                                                            })),
                                                                            meta.touched && meta.error && /*#__PURE__*/ (0,jsx_runtime.jsx)("p", {
                                                                                className: "text-red-500 text-xs italic pt-2",
                                                                                children: meta.error
                                                                            })
                                                                        ]
                                                                    })
                                                                ]
                                                            });
                                                        }
                                                    })
                                                ]
                                            })
                                        ]
                                    })
                                ]
                            }),
                            /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                className: "pt-5",
                                children: /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                                    className: "flex justify-end",
                                    children: [
                                        /*#__PURE__*/ (0,jsx_runtime.jsx)(next_link["default"], {
                                            href: "/admin/series/".concat(seriesContext.id, "/manage"),
                                            children: /*#__PURE__*/ (0,jsx_runtime.jsx)("a", {
                                                className: "bg-white py-2 px-4 border border-gray-300 rounded-md shadow-sm text-sm font-medium text-gray-700 hover:bg-gray-50 focus:outline-none focus:ring-2 focus:ring-offset-2 focus:ring-indigo-500",
                                                children: "Avbryt"
                                            })
                                        }),
                                        /*#__PURE__*/ (0,jsx_runtime.jsx)("button", {
                                            type: "submit",
                                            disabled: formikBag.isSubmitting || !formikBag.isValid,
                                            className: "ml-3 inline-flex justify-center py-2 px-4 border border-transparent shadow-sm text-sm font-medium rounded-md text-white bg-indigo-600 hover:bg-indigo-700 focus:outline-none focus:ring-2 focus:ring-offset-2 focus:ring-indigo-500",
                                            children: "Skapa"
                                        })
                                    ]
                                })
                            })
                        ]
                    }));
                }
            })
        ]
    }));
};

;// CONCATENATED MODULE: ./components/ds/04-templates/admin/create-team/translations.tsx
var create_team_translations_translations = {
    sv: {
        pageTitle: 'Skapa ett lag',
        pageDescription: 'Skapa ett lag i en s\xe4song av N\xe4tverkspadel.'
    },
    en: {
        pageTitle: 'Skapa ett lag',
        pageDescription: 'Skapa ett lag i en s\xe4song av N\xe4tverkspadel.'
    }
};

;// CONCATENATED MODULE: ./components/ds/04-templates/admin/create-team/index.tsx









var AdminCreateTeamTemplate = function(param) {
    var seriesContext = param.seriesContext;
    var router = (0,next_router.useRouter)();
    var locale = (0,utils_locale/* makeLocale */.W)(router.locale, router.defaultLocale) || 'sv';
    var translation = create_team_translations_translations[locale];
    var ref = (0,react.useState)(false), sidebarOpen = ref[0], setSidebarOpen = ref[1];
    (0,react.useEffect)(function() {
        if (document) {
            var htmlEl = document.querySelector('html');
            if (htmlEl) {
                htmlEl.classList.add('h-full');
                htmlEl.classList.add('bg-white');
            }
            var bodyEl = document.querySelector('body');
            if (bodyEl) {
                bodyEl.classList.add('h-full');
                bodyEl.classList.add('overflow-hidden');
            }
            var nextWrapperEl = document.querySelector('#__next');
            if (nextWrapperEl) {
                nextWrapperEl.classList.add('h-full');
                nextWrapperEl.classList.add('overflow-hidden');
            }
        }
    });
    return(/*#__PURE__*/ (0,jsx_runtime.jsxs)(jsx_runtime.Fragment, {
        children: [
            /*#__PURE__*/ (0,jsx_runtime.jsx)(Head, {
                title: translation.pageTitle,
                description: translation.pageDescription
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                className: "h-full flex",
                children: [
                    /*#__PURE__*/ (0,jsx_runtime.jsx)(header/* Header */.h, {
                        sidebarOpen: sidebarOpen,
                        setSidebarOpen: setSidebarOpen,
                        incomingSeriesId: seriesContext.id,
                        seriesContext: seriesContext
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                        className: "flex flex-col w-0 flex-1 overflow-hidden",
                        children: [
                            /*#__PURE__*/ (0,jsx_runtime.jsx)(search_header/* SearchHeader */.s, {
                                sidebarOpen: sidebarOpen,
                                setSidebarOpen: setSidebarOpen
                            }),
                            /*#__PURE__*/ (0,jsx_runtime.jsxs)("main", {
                                className: "flex-1 relative z-0 overflow-y-auto focus:outline-none",
                                children: [
                                    /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                        className: "border-b border-gray-200 px-4 py-4 sm:flex sm:items-center sm:justify-between sm:px-6 lg:px-8",
                                        children: /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                            className: "flex-1 min-w-0",
                                            children: /*#__PURE__*/ (0,jsx_runtime.jsxs)("h1", {
                                                className: "text-base font-medium leading-6 text-gray-900 sm:truncate",
                                                children: [
                                                    "Skapa ett lag i",
                                                    ' ',
                                                    seriesContext && seriesContext.name ? seriesContext.name : 'denna serie'
                                                ]
                                            })
                                        })
                                    }),
                                    /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                        className: "px-4 py-4 sm:flex sm:items-center sm:justify-between sm:px-6 lg:px-8",
                                        children: /*#__PURE__*/ (0,jsx_runtime.jsx)(CreateTeamForm, {
                                            seriesContext: seriesContext
                                        })
                                    })
                                ]
                            })
                        ]
                    })
                ]
            })
        ]
    }));
};

;// CONCATENATED MODULE: ./components/ds/04-templates/admin/create-round/form.tsx







function create_round_form_asyncGeneratorStep(gen, resolve, reject, _next, _throw, key, arg) {
    try {
        var info = gen[key](arg);
        var value = info.value;
    } catch (error) {
        reject(error);
        return;
    }
    if (info.done) {
        resolve(value);
    } else {
        Promise.resolve(value).then(_next, _throw);
    }
}
function create_round_form_asyncToGenerator(fn) {
    return function() {
        var self = this, args = arguments;
        return new Promise(function(resolve, reject) {
            var gen = fn.apply(self, args);
            function _next(value) {
                create_round_form_asyncGeneratorStep(gen, resolve, reject, _next, _throw, "next", value);
            }
            function _throw(err) {
                create_round_form_asyncGeneratorStep(gen, resolve, reject, _next, _throw, "throw", err);
            }
            _next(undefined);
        });
    };
}
function create_round_form_defineProperty(obj, key, value) {
    if (key in obj) {
        Object.defineProperty(obj, key, {
            value: value,
            enumerable: true,
            configurable: true,
            writable: true
        });
    } else {
        obj[key] = value;
    }
    return obj;
}
function create_round_form_instanceof(left, right) {
    if (right != null && typeof Symbol !== "undefined" && right[Symbol.hasInstance]) {
        return right[Symbol.hasInstance](left);
    } else {
        return left instanceof right;
    }
}
function create_round_form_objectSpread(target) {
    for(var i = 1; i < arguments.length; i++){
        var source = arguments[i] != null ? arguments[i] : {};
        var ownKeys = Object.keys(source);
        if (typeof Object.getOwnPropertySymbols === "function") {
            ownKeys = ownKeys.concat(Object.getOwnPropertySymbols(source).filter(function(sym) {
                return Object.getOwnPropertyDescriptor(source, sym).enumerable;
            }));
        }
        ownKeys.forEach(function(key) {
            create_round_form_defineProperty(target, key, source[key]);
        });
    }
    return target;
}
var form_ValidationSchema = es/* object */.Ry().shape({
    name: es/* string */.Z_().min(2, 'V\xe4rdet \xe4r f\xf6r kort').max(40, 'V\xe4rdet \xe4r f\xf6r l\xe5ngt').trim().required('Detta f\xe4lt m\xe5ste ha ett v\xe4rde'),
    start_date: es/* string */.Z_().required('Detta f\xe4lt m\xe5ste ha ett v\xe4rde'),
    start_time: es/* string */.Z_().required('Detta f\xe4lt m\xe5ste ha ett v\xe4rde'),
    end_date: es/* string */.Z_().required('Detta f\xe4lt m\xe5ste ha ett v\xe4rde'),
    end_time: es/* string */.Z_().required('Detta f\xe4lt m\xe5ste ha ett v\xe4rde')
});
var form_initialValues = {
    name: '',
    start_date: '',
    start_time: '',
    end_date: '',
    end_time: ''
};
var CreateRoundForm = function(param1) {
    var seriesContext = param1.seriesContext;
    var ref = (0,react.useState)(), error = ref[0], setError = ref[1];
    var ref1 = (0,react.useState)(), status = ref1[0], setStatus = ref1[1];
    var reset = function() {
        setError(undefined);
        setStatus('pristine');
    };
    return(/*#__PURE__*/ (0,jsx_runtime.jsxs)(jsx_runtime.Fragment, {
        children: [
            status === 'ok' ? /*#__PURE__*/ (0,jsx_runtime.jsx)(SuccessAlert, {
                translations: {
                    headline: 'Gick bra!'
                },
                reset: reset
            }) : null,
            status === 'not_ok' && error ? /*#__PURE__*/ (0,jsx_runtime.jsx)(ErrorAlert, {
                translations: {
                    headline: 'Gick inte bra!'
                },
                error: error,
                reset: reset
            }) : null,
            /*#__PURE__*/ (0,jsx_runtime.jsx)(formik_esm/* Formik */.J9, {
                initialValues: form_initialValues,
                validationSchema: form_ValidationSchema,
                enableReinitialize: true,
                onSubmit: function() {
                    var _ref = create_round_form_asyncToGenerator(runtime_default().mark(function _callee(values, actions) {
                        var requestBody, CreateRoundRes, CreateRoundResData;
                        return runtime_default().wrap(function _callee$(_ctx) {
                            while(1)switch(_ctx.prev = _ctx.next){
                                case 0:
                                    _ctx.prev = 0;
                                    requestBody = {
                                        name: values.name,
                                        start: "".concat(values.start_date, " ").concat(values.start_time),
                                        end: "".concat(values.end_date, " ").concat(values.end_time)
                                    };
                                    _ctx.next = 4;
                                    return fetch("/api/admin/series/".concat(seriesContext.id, "/round/create"), {
                                        method: 'POST',
                                        body: JSON.stringify(requestBody),
                                        headers: {
                                            'Content-Type': 'application/json'
                                        }
                                    });
                                case 4:
                                    CreateRoundRes = _ctx.sent;
                                    if (!(CreateRoundRes.status !== 200)) {
                                        _ctx.next = 11;
                                        break;
                                    }
                                    setStatus('not_ok');
                                    setError(new Error('Non 200 response from backend'));
                                    actions.resetForm();
                                    actions.setSubmitting(false);
                                    return _ctx.abrupt("return");
                                case 11:
                                    _ctx.next = 13;
                                    return CreateRoundRes.json();
                                case 13:
                                    CreateRoundResData = _ctx.sent;
                                    if (!CreateRoundResData.success) {
                                        setStatus('not_ok');
                                        setError(new Error(CreateRoundResData.code));
                                        actions.resetForm();
                                        actions.setSubmitting(false);
                                    } else {
                                        actions.resetForm();
                                        actions.setSubmitting(false);
                                        setStatus('pristine');
                                    }
                                    _ctx.next = 23;
                                    break;
                                case 17:
                                    _ctx.prev = 17;
                                    _ctx.t0 = _ctx["catch"](0);
                                    setStatus('not_ok');
                                    if (create_round_form_instanceof(_ctx.t0, Error)) {
                                        setError(_ctx.t0);
                                    } else {
                                        setError(new Error('Report game result failed due to a unknown error'));
                                    }
                                    actions.resetForm();
                                    actions.setSubmitting(false);
                                case 23:
                                case "end":
                                    return _ctx.stop();
                            }
                        }, _callee, null, [
                            [
                                0,
                                17
                            ]
                        ]);
                    }));
                    return function(values, actions) {
                        return _ref.apply(this, arguments);
                    };
                }(),
                children: function(formikBag) {
                    return(/*#__PURE__*/ (0,jsx_runtime.jsxs)(formik_esm/* Form */.l0, {
                        className: "space-y-8 divide-y divide-gray-200",
                        children: [
                            /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                className: "space-y-8 divide-y divide-gray-200 sm:space-y-5",
                                children: /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                                    children: [
                                        /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                                            children: [
                                                /*#__PURE__*/ (0,jsx_runtime.jsx)("h3", {
                                                    className: "text-lg leading-6 font-medium text-gray-900",
                                                    children: "Rundan"
                                                }),
                                                /*#__PURE__*/ (0,jsx_runtime.jsx)("p", {
                                                    className: "mt-1 max-w-2xl text-sm text-gray-500",
                                                    children: "V\xe4lj ett l\xe4sbart namn till rundan och n\xe4r den b\xf6rjar och slutar."
                                                })
                                            ]
                                        }),
                                        /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                                            className: "mt-6 sm:mt-5 space-y-6 sm:space-y-5",
                                            children: [
                                                /*#__PURE__*/ (0,jsx_runtime.jsx)(formik_esm/* Field */.gN, {
                                                    name: "name",
                                                    children: function(param) {
                                                        var field = param.field, meta = param.meta;
                                                        /*#__PURE__*/ return (0,jsx_runtime.jsxs)("div", {
                                                            className: "sm:grid sm:grid-cols-3 sm:gap-4 sm:items-start sm:border-t sm:border-gray-200 sm:pt-5",
                                                            children: [
                                                                /*#__PURE__*/ (0,jsx_runtime.jsx)("label", {
                                                                    htmlFor: "name",
                                                                    className: "block text-sm font-medium text-gray-700 sm:mt-px sm:pt-2",
                                                                    children: "Namn p\xe5 runda"
                                                                }),
                                                                /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                                                                    className: "mt-1 sm:mt-0 sm:col-span-2",
                                                                    children: [
                                                                        /*#__PURE__*/ (0,jsx_runtime.jsx)("input", create_round_form_objectSpread({}, field, {
                                                                            required: true,
                                                                            type: "text",
                                                                            className: "max-w-lg block w-full shadow-sm focus:ring-indigo-500 focus:border-indigo-500 sm:max-w-xs sm:text-sm border-gray-300 rounded-md"
                                                                        })),
                                                                        meta.touched && meta.error && /*#__PURE__*/ (0,jsx_runtime.jsx)("p", {
                                                                            className: "text-red-500 text-xs italic pt-2",
                                                                            children: meta.error
                                                                        })
                                                                    ]
                                                                })
                                                            ]
                                                        });
                                                    }
                                                }),
                                                /*#__PURE__*/ (0,jsx_runtime.jsx)(formik_esm/* Field */.gN, {
                                                    name: "start_date",
                                                    children: function(param) {
                                                        var field = param.field, meta = param.meta;
                                                        /*#__PURE__*/ return (0,jsx_runtime.jsxs)("div", {
                                                            className: "sm:grid sm:grid-cols-3 sm:gap-4 sm:items-start sm:border-t sm:border-gray-200 sm:pt-5",
                                                            children: [
                                                                /*#__PURE__*/ (0,jsx_runtime.jsx)("label", {
                                                                    htmlFor: "start_date",
                                                                    className: "block text-sm font-medium text-gray-700 sm:mt-px sm:pt-2",
                                                                    children: "Start datum"
                                                                }),
                                                                /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                                                                    className: "mt-1 sm:mt-0 sm:col-span-2",
                                                                    children: [
                                                                        /*#__PURE__*/ (0,jsx_runtime.jsx)("input", create_round_form_objectSpread({}, field, {
                                                                            required: true,
                                                                            type: "date",
                                                                            className: "max-w-lg block w-full shadow-sm focus:ring-indigo-500 focus:border-indigo-500 sm:max-w-xs sm:text-sm border-gray-300 rounded-md"
                                                                        })),
                                                                        meta.touched && meta.error && /*#__PURE__*/ (0,jsx_runtime.jsx)("p", {
                                                                            className: "text-red-500 text-xs italic pt-2",
                                                                            children: meta.error
                                                                        })
                                                                    ]
                                                                })
                                                            ]
                                                        });
                                                    }
                                                }),
                                                /*#__PURE__*/ (0,jsx_runtime.jsx)(formik_esm/* Field */.gN, {
                                                    name: "start_time",
                                                    children: function(param) {
                                                        var field = param.field, meta = param.meta;
                                                        /*#__PURE__*/ return (0,jsx_runtime.jsxs)("div", {
                                                            className: "sm:grid sm:grid-cols-3 sm:gap-4 sm:items-start sm:border-t sm:border-gray-200 sm:pt-5",
                                                            children: [
                                                                /*#__PURE__*/ (0,jsx_runtime.jsx)("label", {
                                                                    htmlFor: "start_time",
                                                                    className: "block text-sm font-medium text-gray-700 sm:mt-px sm:pt-2",
                                                                    children: "Start tid"
                                                                }),
                                                                /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                                                                    className: "mt-1 sm:mt-0 sm:col-span-2",
                                                                    children: [
                                                                        /*#__PURE__*/ (0,jsx_runtime.jsx)("input", create_round_form_objectSpread({}, field, {
                                                                            required: true,
                                                                            type: "time",
                                                                            className: "max-w-lg block w-full shadow-sm focus:ring-indigo-500 focus:border-indigo-500 sm:max-w-xs sm:text-sm border-gray-300 rounded-md"
                                                                        })),
                                                                        meta.touched && meta.error && /*#__PURE__*/ (0,jsx_runtime.jsx)("p", {
                                                                            className: "text-red-500 text-xs italic pt-2",
                                                                            children: meta.error
                                                                        })
                                                                    ]
                                                                })
                                                            ]
                                                        });
                                                    }
                                                }),
                                                /*#__PURE__*/ (0,jsx_runtime.jsx)(formik_esm/* Field */.gN, {
                                                    name: "end_date",
                                                    children: function(param) {
                                                        var field = param.field, meta = param.meta;
                                                        /*#__PURE__*/ return (0,jsx_runtime.jsxs)("div", {
                                                            className: "sm:grid sm:grid-cols-3 sm:gap-4 sm:items-start sm:border-t sm:border-gray-200 sm:pt-5",
                                                            children: [
                                                                /*#__PURE__*/ (0,jsx_runtime.jsx)("label", {
                                                                    htmlFor: "end_date",
                                                                    className: "block text-sm font-medium text-gray-700 sm:mt-px sm:pt-2",
                                                                    children: "Slut datum"
                                                                }),
                                                                /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                                                                    className: "mt-1 sm:mt-0 sm:col-span-2",
                                                                    children: [
                                                                        /*#__PURE__*/ (0,jsx_runtime.jsx)("input", create_round_form_objectSpread({}, field, {
                                                                            required: true,
                                                                            type: "date",
                                                                            className: "max-w-lg block w-full shadow-sm focus:ring-indigo-500 focus:border-indigo-500 sm:max-w-xs sm:text-sm border-gray-300 rounded-md"
                                                                        })),
                                                                        meta.touched && meta.error && /*#__PURE__*/ (0,jsx_runtime.jsx)("p", {
                                                                            className: "text-red-500 text-xs italic pt-2",
                                                                            children: meta.error
                                                                        })
                                                                    ]
                                                                })
                                                            ]
                                                        });
                                                    }
                                                }),
                                                /*#__PURE__*/ (0,jsx_runtime.jsx)(formik_esm/* Field */.gN, {
                                                    name: "end_time",
                                                    children: function(param) {
                                                        var field = param.field, meta = param.meta;
                                                        /*#__PURE__*/ return (0,jsx_runtime.jsxs)("div", {
                                                            className: "sm:grid sm:grid-cols-3 sm:gap-4 sm:items-start sm:border-t sm:border-gray-200 sm:pt-5",
                                                            children: [
                                                                /*#__PURE__*/ (0,jsx_runtime.jsx)("label", {
                                                                    htmlFor: "end_time",
                                                                    className: "block text-sm font-medium text-gray-700 sm:mt-px sm:pt-2",
                                                                    children: "Slut tid"
                                                                }),
                                                                /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                                                                    className: "mt-1 sm:mt-0 sm:col-span-2",
                                                                    children: [
                                                                        /*#__PURE__*/ (0,jsx_runtime.jsx)("input", create_round_form_objectSpread({}, field, {
                                                                            required: true,
                                                                            type: "time",
                                                                            className: "max-w-lg block w-full shadow-sm focus:ring-indigo-500 focus:border-indigo-500 sm:max-w-xs sm:text-sm border-gray-300 rounded-md"
                                                                        })),
                                                                        meta.touched && meta.error && /*#__PURE__*/ (0,jsx_runtime.jsx)("p", {
                                                                            className: "text-red-500 text-xs italic pt-2",
                                                                            children: meta.error
                                                                        })
                                                                    ]
                                                                })
                                                            ]
                                                        });
                                                    }
                                                })
                                            ]
                                        })
                                    ]
                                })
                            }),
                            /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                className: "pt-5",
                                children: /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                                    className: "flex justify-end",
                                    children: [
                                        /*#__PURE__*/ (0,jsx_runtime.jsx)(next_link["default"], {
                                            href: "/admin/series/".concat(seriesContext.id, "/manage"),
                                            children: /*#__PURE__*/ (0,jsx_runtime.jsx)("a", {
                                                className: "bg-white py-2 px-4 border border-gray-300 rounded-md shadow-sm text-sm font-medium text-gray-700 hover:bg-gray-50 focus:outline-none focus:ring-2 focus:ring-offset-2 focus:ring-indigo-500",
                                                children: "Avbryt"
                                            })
                                        }),
                                        /*#__PURE__*/ (0,jsx_runtime.jsx)("button", {
                                            type: "submit",
                                            disabled: formikBag.isSubmitting || !formikBag.isValid,
                                            className: "ml-3 inline-flex justify-center py-2 px-4 border border-transparent shadow-sm text-sm font-medium rounded-md text-white bg-indigo-600 hover:bg-indigo-700 focus:outline-none focus:ring-2 focus:ring-offset-2 focus:ring-indigo-500",
                                            children: "Skapa"
                                        })
                                    ]
                                })
                            })
                        ]
                    }));
                }
            })
        ]
    }));
};

;// CONCATENATED MODULE: ./components/ds/04-templates/admin/create-round/translations.tsx
var create_round_translations_translations = {
    sv: {
        pageTitle: 'Skapa en runda',
        pageDescription: 'Skapa en runda i en s\xe4song av N\xe4tverkspadel.'
    },
    en: {
        pageTitle: 'Skapa en runda',
        pageDescription: 'Skapa en runda i en s\xe4song av N\xe4tverkspadel.'
    }
};

;// CONCATENATED MODULE: ./components/ds/04-templates/admin/create-round/index.tsx









var AdminCreateRoundTemplate = function(param) {
    var seriesContext = param.seriesContext;
    var router = (0,next_router.useRouter)();
    var locale = (0,utils_locale/* makeLocale */.W)(router.locale, router.defaultLocale) || 'sv';
    var translation = create_round_translations_translations[locale];
    var ref = (0,react.useState)(false), sidebarOpen = ref[0], setSidebarOpen = ref[1];
    (0,react.useEffect)(function() {
        if (document) {
            var htmlEl = document.querySelector('html');
            if (htmlEl) {
                htmlEl.classList.add('h-full');
                htmlEl.classList.add('bg-white');
            }
            var bodyEl = document.querySelector('body');
            if (bodyEl) {
                bodyEl.classList.add('h-full');
                bodyEl.classList.add('overflow-hidden');
            }
            var nextWrapperEl = document.querySelector('#__next');
            if (nextWrapperEl) {
                nextWrapperEl.classList.add('h-full');
                nextWrapperEl.classList.add('overflow-hidden');
            }
        }
    });
    return(/*#__PURE__*/ (0,jsx_runtime.jsxs)(jsx_runtime.Fragment, {
        children: [
            /*#__PURE__*/ (0,jsx_runtime.jsx)(Head, {
                title: translation.pageTitle,
                description: translation.pageDescription
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                className: "h-full flex",
                children: [
                    /*#__PURE__*/ (0,jsx_runtime.jsx)(header/* Header */.h, {
                        sidebarOpen: sidebarOpen,
                        setSidebarOpen: setSidebarOpen,
                        incomingSeriesId: seriesContext.id,
                        seriesContext: seriesContext
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                        className: "flex flex-col w-0 flex-1 overflow-hidden",
                        children: [
                            /*#__PURE__*/ (0,jsx_runtime.jsx)(search_header/* SearchHeader */.s, {
                                sidebarOpen: sidebarOpen,
                                setSidebarOpen: setSidebarOpen
                            }),
                            /*#__PURE__*/ (0,jsx_runtime.jsxs)("main", {
                                className: "flex-1 relative z-0 overflow-y-auto focus:outline-none",
                                children: [
                                    /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                        className: "border-b border-gray-200 px-4 py-4 sm:flex sm:items-center sm:justify-between sm:px-6 lg:px-8",
                                        children: /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                            className: "flex-1 min-w-0",
                                            children: /*#__PURE__*/ (0,jsx_runtime.jsxs)("h1", {
                                                className: "text-base font-medium leading-6 text-gray-900 sm:truncate",
                                                children: [
                                                    "Skapa en runda i",
                                                    ' ',
                                                    seriesContext && seriesContext.name ? seriesContext.name : 'denna serie'
                                                ]
                                            })
                                        })
                                    }),
                                    /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                        className: "px-4 py-4 sm:flex sm:items-center sm:justify-between sm:px-6 lg:px-8",
                                        children: /*#__PURE__*/ (0,jsx_runtime.jsx)(CreateRoundForm, {
                                            seriesContext: seriesContext
                                        })
                                    })
                                ]
                            })
                        ]
                    })
                ]
            })
        ]
    }));
};

;// CONCATENATED MODULE: ./components/ds/04-templates/admin/invite-team-to-round/form.tsx








function invite_team_to_round_form_asyncGeneratorStep(gen, resolve, reject, _next, _throw, key, arg) {
    try {
        var info = gen[key](arg);
        var value = info.value;
    } catch (error) {
        reject(error);
        return;
    }
    if (info.done) {
        resolve(value);
    } else {
        Promise.resolve(value).then(_next, _throw);
    }
}
function invite_team_to_round_form_asyncToGenerator(fn) {
    return function() {
        var self = this, args = arguments;
        return new Promise(function(resolve, reject) {
            var gen = fn.apply(self, args);
            function _next(value) {
                invite_team_to_round_form_asyncGeneratorStep(gen, resolve, reject, _next, _throw, "next", value);
            }
            function _throw(err) {
                invite_team_to_round_form_asyncGeneratorStep(gen, resolve, reject, _next, _throw, "throw", err);
            }
            _next(undefined);
        });
    };
}
function invite_team_to_round_form_defineProperty(obj, key, value) {
    if (key in obj) {
        Object.defineProperty(obj, key, {
            value: value,
            enumerable: true,
            configurable: true,
            writable: true
        });
    } else {
        obj[key] = value;
    }
    return obj;
}
function invite_team_to_round_form_instanceof(left, right) {
    if (right != null && typeof Symbol !== "undefined" && right[Symbol.hasInstance]) {
        return right[Symbol.hasInstance](left);
    } else {
        return left instanceof right;
    }
}
function invite_team_to_round_form_objectSpread(target) {
    for(var i = 1; i < arguments.length; i++){
        var source = arguments[i] != null ? arguments[i] : {};
        var ownKeys = Object.keys(source);
        if (typeof Object.getOwnPropertySymbols === "function") {
            ownKeys = ownKeys.concat(Object.getOwnPropertySymbols(source).filter(function(sym) {
                return Object.getOwnPropertyDescriptor(source, sym).enumerable;
            }));
        }
        ownKeys.forEach(function(key) {
            invite_team_to_round_form_defineProperty(target, key, source[key]);
        });
    }
    return target;
}
var invite_team_to_round_form_ValidationSchema = es/* object */.Ry().shape({
    team_id: es/* string */.Z_().required('Detta f\xe4lt m\xe5ste ha ett v\xe4rde'),
    send_email: es/* boolean */.O7().required('Detta f\xe4lt m\xe5ste ha ett v\xe4rde')
});
var invite_team_to_round_form_initialValues = {
    team_id: '',
    send_email: false
};
var form_CreateTeamForm = function(param1) {
    var seriesContext = param1.seriesContext, teams = param1.teams, round = param1.round;
    var router = (0,next_router.useRouter)();
    var ref = (0,react.useState)(), error = ref[0], setError = ref[1];
    var ref1 = (0,react.useState)(), status = ref1[0], setStatus = ref1[1];
    var reset = function() {
        setError(undefined);
        setStatus('pristine');
    };
    return(/*#__PURE__*/ (0,jsx_runtime.jsxs)(jsx_runtime.Fragment, {
        children: [
            status === 'ok' ? /*#__PURE__*/ (0,jsx_runtime.jsx)(SuccessAlert, {
                translations: {
                    headline: 'Gick bra!'
                },
                reset: reset
            }) : null,
            status === 'not_ok' && error ? /*#__PURE__*/ (0,jsx_runtime.jsx)(ErrorAlert, {
                translations: {
                    headline: 'Gick inte bra!'
                },
                error: error,
                reset: reset
            }) : null,
            /*#__PURE__*/ (0,jsx_runtime.jsx)(formik_esm/* Formik */.J9, {
                initialValues: invite_team_to_round_form_initialValues,
                validationSchema: invite_team_to_round_form_ValidationSchema,
                enableReinitialize: true,
                onSubmit: function() {
                    var _ref = invite_team_to_round_form_asyncToGenerator(runtime_default().mark(function _callee(values, actions) {
                        var requestBody, InviteTeamToRound, InviteTeamToRoundData;
                        return runtime_default().wrap(function _callee$(_ctx) {
                            while(1)switch(_ctx.prev = _ctx.next){
                                case 0:
                                    _ctx.prev = 0;
                                    requestBody = {
                                        teamId: values.team_id,
                                        sendEmail: values.send_email
                                    };
                                    _ctx.next = 4;
                                    return fetch("/api/admin/series/".concat(seriesContext.id, "/round/").concat(round.round_public_id, "/create-and-send-single-invitation"), {
                                        method: 'POST',
                                        body: JSON.stringify(requestBody),
                                        headers: {
                                            'Content-Type': 'application/json'
                                        }
                                    });
                                case 4:
                                    InviteTeamToRound = _ctx.sent;
                                    if (!(InviteTeamToRound.status !== 200)) {
                                        _ctx.next = 11;
                                        break;
                                    }
                                    setStatus('not_ok');
                                    setError(new Error('Non 200 response from backend'));
                                    actions.resetForm();
                                    actions.setSubmitting(false);
                                    return _ctx.abrupt("return");
                                case 11:
                                    _ctx.next = 13;
                                    return InviteTeamToRound.json();
                                case 13:
                                    InviteTeamToRoundData = _ctx.sent;
                                    if (!InviteTeamToRoundData.success) {
                                        setStatus('not_ok');
                                        setError(new Error(InviteTeamToRoundData.code));
                                        actions.resetForm();
                                        actions.setSubmitting(false);
                                    } else {
                                        actions.resetForm();
                                        actions.setSubmitting(false);
                                        setStatus('pristine');
                                        router.replace("/admin/series/".concat(seriesContext.id, "/round/").concat(round.round_public_id));
                                    }
                                    _ctx.next = 23;
                                    break;
                                case 17:
                                    _ctx.prev = 17;
                                    _ctx.t0 = _ctx["catch"](0);
                                    setStatus('not_ok');
                                    if (invite_team_to_round_form_instanceof(_ctx.t0, Error)) {
                                        setError(_ctx.t0);
                                    } else {
                                        setError(new Error('Inviting team to round failed due to a unknown error'));
                                    }
                                    actions.resetForm();
                                    actions.setSubmitting(false);
                                case 23:
                                case "end":
                                    return _ctx.stop();
                            }
                        }, _callee, null, [
                            [
                                0,
                                17
                            ]
                        ]);
                    }));
                    return function(values, actions) {
                        return _ref.apply(this, arguments);
                    };
                }(),
                children: function(formikBag) {
                    return(/*#__PURE__*/ (0,jsx_runtime.jsxs)(formik_esm/* Form */.l0, {
                        className: "space-y-8 divide-y divide-gray-200",
                        children: [
                            /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                className: "space-y-8 divide-y divide-gray-200 sm:space-y-5",
                                children: /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                                    children: [
                                        /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                                            children: [
                                                /*#__PURE__*/ (0,jsx_runtime.jsx)("h3", {
                                                    className: "text-lg font-medium leading-6 text-gray-900",
                                                    children: "Bjud in ett lag till denna runda"
                                                }),
                                                /*#__PURE__*/ (0,jsx_runtime.jsx)("p", {
                                                    className: "mt-1 max-w-2xl text-sm text-gray-500",
                                                    children: "This information will be displayed publicly so be careful what you share."
                                                })
                                            ]
                                        }),
                                        /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                                            className: "mt-6 space-y-6 sm:mt-5 sm:space-y-5",
                                            children: [
                                                /*#__PURE__*/ (0,jsx_runtime.jsx)(formik_esm/* Field */.gN, {
                                                    name: "team_id",
                                                    children: function(param) {
                                                        var field = param.field, meta = param.meta;
                                                        /*#__PURE__*/ return (0,jsx_runtime.jsxs)("div", {
                                                            className: "sm:grid sm:grid-cols-3 sm:items-start sm:gap-4 sm:border-t sm:border-gray-200 sm:pt-5",
                                                            children: [
                                                                /*#__PURE__*/ (0,jsx_runtime.jsx)("label", {
                                                                    htmlFor: "team_id",
                                                                    className: "block text-sm font-medium text-gray-700 sm:mt-px sm:pt-2",
                                                                    children: "Lag"
                                                                }),
                                                                /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                                                                    className: "mt-1 sm:col-span-2 sm:mt-0",
                                                                    children: [
                                                                        /*#__PURE__*/ (0,jsx_runtime.jsxs)("select", invite_team_to_round_form_objectSpread({}, field, {
                                                                            required: true,
                                                                            type: "text",
                                                                            className: "block w-full max-w-lg rounded-md border-gray-300 shadow-sm focus:border-indigo-500 focus:ring-indigo-500 sm:max-w-xs sm:text-sm",
                                                                            children: [
                                                                                /*#__PURE__*/ (0,jsx_runtime.jsx)("option", {
                                                                                    value: "none",
                                                                                    disabled: true,
                                                                                    children: "V\xe4lj ett lag"
                                                                                }),
                                                                                teams.map(function(team) {
                                                                                    /*#__PURE__*/ return (0,jsx_runtime.jsx)("option", {
                                                                                        value: team.id,
                                                                                        children: team.name
                                                                                    }, team.id);
                                                                                })
                                                                            ]
                                                                        })),
                                                                        meta.touched && meta.error && /*#__PURE__*/ (0,jsx_runtime.jsx)("p", {
                                                                            className: "pt-2 text-xs italic text-red-500",
                                                                            children: meta.error
                                                                        })
                                                                    ]
                                                                })
                                                            ]
                                                        });
                                                    }
                                                }),
                                                /*#__PURE__*/ (0,jsx_runtime.jsx)(formik_esm/* Field */.gN, {
                                                    name: "send_email",
                                                    children: function(param) {
                                                        var field = param.field, meta = param.meta;
                                                        /*#__PURE__*/ return (0,jsx_runtime.jsx)("div", {
                                                            className: "sm:grid sm:grid-cols-3 sm:items-start sm:gap-4 sm:border-t sm:border-gray-200 sm:pt-5",
                                                            children: /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                                                                className: "relative flex items-start",
                                                                children: [
                                                                    /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                                                                        className: "flex h-5 items-center",
                                                                        children: [
                                                                            /*#__PURE__*/ (0,jsx_runtime.jsx)("input", invite_team_to_round_form_objectSpread({}, field, {
                                                                                "aria-describedby": "send_email_description",
                                                                                type: "checkbox",
                                                                                className: "h-4 w-4 rounded border-gray-300 text-indigo-600 focus:ring-indigo-500"
                                                                            })),
                                                                            meta.touched && meta.error && /*#__PURE__*/ (0,jsx_runtime.jsx)("p", {
                                                                                className: "pt-2 text-xs italic text-red-500",
                                                                                children: meta.error
                                                                            })
                                                                        ]
                                                                    }),
                                                                    /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                                                                        className: "ml-3 text-sm",
                                                                        children: [
                                                                            /*#__PURE__*/ (0,jsx_runtime.jsx)("label", {
                                                                                htmlFor: "send_email",
                                                                                className: "font-medium text-gray-700",
                                                                                children: "Skicka mejl"
                                                                            }),
                                                                            /*#__PURE__*/ (0,jsx_runtime.jsx)("p", {
                                                                                id: "send_email_description",
                                                                                className: "text-gray-500",
                                                                                children: "Ska den inbjudne f\xe5 ett mejl n\xe4r inbjudan skapas."
                                                                            })
                                                                        ]
                                                                    })
                                                                ]
                                                            })
                                                        });
                                                    }
                                                })
                                            ]
                                        })
                                    ]
                                })
                            }),
                            /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                className: "pt-5",
                                children: /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                                    className: "flex justify-end",
                                    children: [
                                        /*#__PURE__*/ (0,jsx_runtime.jsx)(next_link["default"], {
                                            href: "/admin/series/".concat(seriesContext.id, "/round/").concat(round.round_public_id),
                                            children: /*#__PURE__*/ (0,jsx_runtime.jsx)("a", {
                                                className: "rounded-md border border-gray-300 bg-white py-2 px-4 text-sm font-medium text-gray-700 shadow-sm hover:bg-gray-50 focus:outline-none focus:ring-2 focus:ring-indigo-500 focus:ring-offset-2",
                                                children: "Avbryt"
                                            })
                                        }),
                                        /*#__PURE__*/ (0,jsx_runtime.jsx)("button", {
                                            type: "submit",
                                            disabled: formikBag.isSubmitting || !formikBag.isValid,
                                            className: "ml-3 inline-flex justify-center rounded-md border border-transparent bg-indigo-600 py-2 px-4 text-sm font-medium text-white shadow-sm hover:bg-indigo-700 focus:outline-none focus:ring-2 focus:ring-indigo-500 focus:ring-offset-2",
                                            children: "Skicka"
                                        })
                                    ]
                                })
                            })
                        ]
                    }));
                }
            })
        ]
    }));
};

;// CONCATENATED MODULE: ./components/ds/04-templates/admin/invite-team-to-round/translations.tsx
var invite_team_to_round_translations_translations = {
    sv: {
        pageTitle: 'Bjud in ett lag till rundan',
        pageDescription: 'Bjud in ett lag till en runda av N\xe4tverkspadel.'
    },
    en: {
        pageTitle: 'Bjud in ett lag till rundan',
        pageDescription: 'Bjud in ett lag till en runda av N\xe4tverkspadel.'
    }
};

;// CONCATENATED MODULE: ./components/ds/04-templates/admin/invite-team-to-round/index.tsx









var AdminInviteTeamToRoundTemplate = function(param) {
    var seriesContext = param.seriesContext, teams = param.teams, round = param.round;
    var router = (0,next_router.useRouter)();
    var locale = (0,utils_locale/* makeLocale */.W)(router.locale, router.defaultLocale) || 'sv';
    var translation = invite_team_to_round_translations_translations[locale];
    var ref = (0,react.useState)(false), sidebarOpen = ref[0], setSidebarOpen = ref[1];
    (0,react.useEffect)(function() {
        if (document) {
            var htmlEl = document.querySelector('html');
            if (htmlEl) {
                htmlEl.classList.add('h-full');
                htmlEl.classList.add('bg-white');
            }
            var bodyEl = document.querySelector('body');
            if (bodyEl) {
                bodyEl.classList.add('h-full');
                bodyEl.classList.add('overflow-hidden');
            }
            var nextWrapperEl = document.querySelector('#__next');
            if (nextWrapperEl) {
                nextWrapperEl.classList.add('h-full');
                nextWrapperEl.classList.add('overflow-hidden');
            }
        }
    });
    return(/*#__PURE__*/ (0,jsx_runtime.jsxs)(jsx_runtime.Fragment, {
        children: [
            /*#__PURE__*/ (0,jsx_runtime.jsx)(Head, {
                title: translation.pageTitle,
                description: translation.pageDescription
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                className: "h-full flex",
                children: [
                    /*#__PURE__*/ (0,jsx_runtime.jsx)(header/* Header */.h, {
                        sidebarOpen: sidebarOpen,
                        setSidebarOpen: setSidebarOpen,
                        incomingSeriesId: seriesContext.id,
                        seriesContext: seriesContext
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                        className: "flex flex-col w-0 flex-1 overflow-hidden",
                        children: [
                            /*#__PURE__*/ (0,jsx_runtime.jsx)(search_header/* SearchHeader */.s, {
                                sidebarOpen: sidebarOpen,
                                setSidebarOpen: setSidebarOpen
                            }),
                            /*#__PURE__*/ (0,jsx_runtime.jsxs)("main", {
                                className: "flex-1 relative z-0 overflow-y-auto focus:outline-none",
                                children: [
                                    /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                        className: "border-b border-gray-200 px-4 py-4 sm:flex sm:items-center sm:justify-between sm:px-6 lg:px-8",
                                        children: /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                            className: "flex-1 min-w-0",
                                            children: /*#__PURE__*/ (0,jsx_runtime.jsxs)("h1", {
                                                className: "text-base font-medium leading-6 text-gray-900 sm:truncate",
                                                children: [
                                                    "Bjud in lag till ",
                                                    round && round.round_name ? round.round_name : 'denna runda'
                                                ]
                                            })
                                        })
                                    }),
                                    /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                        className: "px-4 py-4 sm:flex sm:items-center sm:justify-between sm:px-6 lg:px-8",
                                        children: /*#__PURE__*/ (0,jsx_runtime.jsx)(form_CreateTeamForm, {
                                            seriesContext: seriesContext,
                                            teams: teams,
                                            round: round
                                        })
                                    })
                                ]
                            })
                        ]
                    })
                ]
            })
        ]
    }));
};

;// CONCATENATED MODULE: ./components/ds/04-templates/admin/signup-details/translations.tsx
var signup_details_translations_translations = {
    sv: {
        pageTitle: 'Anm\xe4lningar',
        pageDescription: 'H\xe4r kan du se de anm\xe4lningar som hittills gjorts f\xf6r den h\xe4r veckan.'
    },
    en: {
        pageTitle: 'Anm\xe4lningar',
        pageDescription: 'H\xe4r kan du se de anm\xe4lningar som hittills gjorts f\xf6r den h\xe4r veckan.'
    }
};

;// CONCATENATED MODULE: ./components/ds/04-templates/admin/signup-details/index.tsx








var AdminRoundSignupDetailsTemplate = function(param) {
    var series = param.series, signup = param.signup, round = param.round;
    var router = (0,next_router.useRouter)();
    var locale = (0,utils_locale/* makeLocale */.W)(router.locale, router.defaultLocale) || 'sv';
    var translation = signup_details_translations_translations[locale];
    var ref = (0,react.useState)(false), sidebarOpen = ref[0], setSidebarOpen = ref[1];
    (0,react.useEffect)(function() {
        if (document) {
            var htmlEl = document.querySelector('html');
            if (htmlEl) {
                htmlEl.classList.add('h-full');
                htmlEl.classList.add('bg-white');
            }
            var bodyEl = document.querySelector('body');
            if (bodyEl) {
                bodyEl.classList.add('h-full');
                bodyEl.classList.add('overflow-hidden');
            }
            var nextWrapperEl = document.querySelector('#__next');
            if (nextWrapperEl) {
                nextWrapperEl.classList.add('h-full');
                nextWrapperEl.classList.add('overflow-hidden');
            }
        }
    });
    return(/*#__PURE__*/ (0,jsx_runtime.jsxs)(jsx_runtime.Fragment, {
        children: [
            /*#__PURE__*/ (0,jsx_runtime.jsx)(Head, {
                title: translation.pageTitle,
                description: translation.pageDescription
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                className: "h-full flex",
                children: [
                    /*#__PURE__*/ (0,jsx_runtime.jsx)(header/* Header */.h, {
                        sidebarOpen: sidebarOpen,
                        setSidebarOpen: setSidebarOpen,
                        incomingSeriesId: series.id,
                        seriesContext: series
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                        className: "flex flex-col w-0 flex-1 overflow-hidden",
                        children: [
                            /*#__PURE__*/ (0,jsx_runtime.jsx)(search_header/* SearchHeader */.s, {
                                sidebarOpen: sidebarOpen,
                                setSidebarOpen: setSidebarOpen
                            }),
                            /*#__PURE__*/ (0,jsx_runtime.jsxs)("main", {
                                className: "flex-1 relative z-0 overflow-y-auto focus:outline-none pb-12",
                                children: [
                                    /*#__PURE__*/ (0,jsx_runtime.jsx)(SignupBreadcrumbs, {
                                        signup: signup,
                                        round: round,
                                        series: series
                                    }),
                                    /*#__PURE__*/ (0,jsx_runtime.jsx)(SignupDetails, {
                                        signup: signup,
                                        round: round,
                                        series: series,
                                        expanded: true
                                    })
                                ]
                            })
                        ]
                    })
                ]
            })
        ]
    }));
};

;// CONCATENATED MODULE: ./components/ds/04-templates/index.ts








// EXTERNAL MODULE: ./node_modules/next/image.js
var next_image = __webpack_require__(5675);
;// CONCATENATED MODULE: ./components/ds/05-pages/home/assets/james-clear.jpg
/* harmony default export */ var james_clear = ({"src":"/_next/static/media/james-clear.a2daa37a.jpg","height":1400,"width":1400,"blurDataURL":"data:image/jpeg;base64,/9j/2wBDAAoHBwgHBgoICAgLCgoLDhgQDg0NDh0VFhEYIx8lJCIfIiEmKzcvJik0KSEiMEExNDk7Pj4+JS5ESUM8SDc9Pjv/2wBDAQoLCw4NDhwQEBw7KCIoOzs7Ozs7Ozs7Ozs7Ozs7Ozs7Ozs7Ozs7Ozs7Ozs7Ozs7Ozs7Ozs7Ozs7Ozs7Ozs7Ozv/wAARCAAIAAgDASIAAhEBAxEB/8QAFQABAQAAAAAAAAAAAAAAAAAAAAb/xAAcEAACAgIDAAAAAAAAAAAAAAABAgASAwUEITH/xAAUAQEAAAAAAAAAAAAAAAAAAAAE/8QAFxEAAwEAAAAAAAAAAAAAAAAAAAIDMf/aAAwDAQACEQMRAD8AiDq8yarJbhrcOHGYN3WvkREY8VXAc7s+n//Z"});
;// CONCATENATED MODULE: ./components/ds/05-pages/home/assets/hermes-lots-of-balls-on-court.jpg
/* harmony default export */ var hermes_lots_of_balls_on_court = ({"src":"/_next/static/media/hermes-lots-of-balls-on-court.76bf170d.jpg","height":1939,"width":2830,"blurDataURL":"data:image/jpeg;base64,/9j/2wBDAAoHBwgHBgoICAgLCgoLDhgQDg0NDh0VFhEYIx8lJCIfIiEmKzcvJik0KSEiMEExNDk7Pj4+JS5ESUM8SDc9Pjv/2wBDAQoLCw4NDhwQEBw7KCIoOzs7Ozs7Ozs7Ozs7Ozs7Ozs7Ozs7Ozs7Ozs7Ozs7Ozs7Ozs7Ozs7Ozs7Ozs7Ozs7Ozv/wAARCAAFAAgDASIAAhEBAxEB/8QAFQABAQAAAAAAAAAAAAAAAAAAAAb/xAAZEAADAQEBAAAAAAAAAAAAAAAAAQIRAyH/xAAVAQEBAAAAAAAAAAAAAAAAAAAEBf/EABgRAQEAAwAAAAAAAAAAAAAAAAEAAhJR/9oADAMBAAIRAxEAPwCB68opKXMrF5k4AB2uPKWKF//Z"});
;// CONCATENATED MODULE: ./components/ds/05-pages/home/assets/man-holding-padel-rack-oliver-1.jpg
/* harmony default export */ var man_holding_padel_rack_oliver_1 = ({"src":"/_next/static/media/man-holding-padel-rack-oliver-1.ab1fafd0.jpg","height":1333,"width":2000,"blurDataURL":"data:image/jpeg;base64,/9j/2wBDAAoHBwgHBgoICAgLCgoLDhgQDg0NDh0VFhEYIx8lJCIfIiEmKzcvJik0KSEiMEExNDk7Pj4+JS5ESUM8SDc9Pjv/2wBDAQoLCw4NDhwQEBw7KCIoOzs7Ozs7Ozs7Ozs7Ozs7Ozs7Ozs7Ozs7Ozs7Ozs7Ozs7Ozs7Ozs7Ozs7Ozs7Ozs7Ozv/wAARCAAFAAgDASIAAhEBAxEB/8QAFQABAQAAAAAAAAAAAAAAAAAAAAb/xAAdEAABBAIDAAAAAAAAAAAAAAAAAQIDEQQFITJR/8QAFQEBAQAAAAAAAAAAAAAAAAAAAQT/xAAXEQEBAQEAAAAAAAAAAAAAAAABAAIh/9oADAMBAAIRAxEAPwCdy3ybLVLivkVid7q+PAAJwpHTf//Z"});
;// CONCATENATED MODULE: ./components/ds/05-pages/home/assets/martin-hitting-the-ball.jpg
/* harmony default export */ var martin_hitting_the_ball = ({"src":"/_next/static/media/martin-hitting-the-ball.cdf7b0e9.jpg","height":1333,"width":2000,"blurDataURL":"data:image/jpeg;base64,/9j/2wBDAAoHBwgHBgoICAgLCgoLDhgQDg0NDh0VFhEYIx8lJCIfIiEmKzcvJik0KSEiMEExNDk7Pj4+JS5ESUM8SDc9Pjv/2wBDAQoLCw4NDhwQEBw7KCIoOzs7Ozs7Ozs7Ozs7Ozs7Ozs7Ozs7Ozs7Ozs7Ozs7Ozs7Ozs7Ozs7Ozs7Ozs7Ozs7Ozv/wAARCAAFAAgDASIAAhEBAxEB/8QAFQABAQAAAAAAAAAAAAAAAAAAAAT/xAAeEAAABgIDAAAAAAAAAAAAAAAAAgMEBREBEgYiUf/EABQBAQAAAAAAAAAAAAAAAAAAAAX/xAAYEQACAwAAAAAAAAAAAAAAAAABAwACIf/aAAwDAQACEQMRAD8AhhuJMnUc2eHXX2ygTpZdbq/AAAmtCyNrC2NuDhn/2Q=="});
;// CONCATENATED MODULE: ./components/ds/05-pages/home/assets/fredrik-striking-ball.jpg
/* harmony default export */ var fredrik_striking_ball = ({"src":"/_next/static/media/fredrik-striking-ball.6515bdec.jpg","height":1333,"width":2000,"blurDataURL":"data:image/jpeg;base64,/9j/2wBDAAoHBwgHBgoICAgLCgoLDhgQDg0NDh0VFhEYIx8lJCIfIiEmKzcvJik0KSEiMEExNDk7Pj4+JS5ESUM8SDc9Pjv/2wBDAQoLCw4NDhwQEBw7KCIoOzs7Ozs7Ozs7Ozs7Ozs7Ozs7Ozs7Ozs7Ozs7Ozs7Ozs7Ozs7Ozs7Ozs7Ozs7Ozs7Ozv/wAARCAAFAAgDASIAAhEBAxEB/8QAFQABAQAAAAAAAAAAAAAAAAAAAAX/xAAbEAADAAIDAAAAAAAAAAAAAAAAAQIDBBEWMv/EABUBAQEAAAAAAAAAAAAAAAAAAAED/8QAGBEAAwEBAAAAAAAAAAAAAAAAAAECUQP/2gAMAwEAAhEDEQA/AJvQdV1MTu5ZT4flMAEl0rQcTh//2Q=="});
;// CONCATENATED MODULE: ./components/ds/05-pages/home/translations.tsx

/* eslint-disable @next/next/no-img-element */ 




var home_translations_translations = {
    sv: {
        pageTitle: 'N\xe4tverkspadel',
        pageDescription: 'Vi samlas p\xe5 onsdagar f\xf6r att spela padel och n\xe4tverka. Tv\xe5 flugor i en sm\xe4ll.',
        headlinePlain: 'Spela mer padel',
        headlineMarked: 'och t\xe4vla mot andra f\xf6retag',
        subline: 'N\xe4tverkspadel \xe4r en m\xf6jlighet att varje onsdag spela padel med, och mot, stadens f\xf6retagare, entrepren\xf6rer, och entusiaster. Snacket f\xe5r du st\xe5 f\xf6r sj\xe4lv, resten tar vi hand om.',
        primaryCta: {
            text: 'Anm\xe4l er nu',
            href: '/signup',
            type: 'link'
        },
        secondaryCta: {
            text: 'L\xe4s mer',
            href: '#first-testimonial-block',
            type: 'link'
        },
        logoCloudHeadline: /*#__PURE__*/ (0,jsx_runtime.jsxs)(jsx_runtime.Fragment, {
            children: [
                /*#__PURE__*/ (0,jsx_runtime.jsxs)("span", {
                    className: "hidden md:flex md:items-center",
                    children: [
                        "Presenteras av",
                        ' ',
                        /*#__PURE__*/ (0,jsx_runtime.jsxs)("a", {
                            href: "https://www.ovik.dev/",
                            target: "_blank",
                            rel: "noopener noreferrer",
                            className: "flex items-center pr-1 font-bold",
                            children: [
                                /*#__PURE__*/ (0,jsx_runtime.jsx)("img", {
                                    className: "inline h-4 px-1",
                                    src: "/partners/impact-quest.svg",
                                    alt: "ImpactQuest"
                                }),
                                "Impact Quest"
                            ]
                        }),
                        ' ',
                        "tillsammans med v\xe5ra grymma partners"
                    ]
                }),
                /*#__PURE__*/ (0,jsx_runtime.jsx)("span", {
                    className: "flex items-center md:hidden",
                    children: "Presenteras av Impact Quest tillsammans med v\xe5ra grymma partners"
                })
            ]
        }),
        logoCloud: /*#__PURE__*/ (0,jsx_runtime.jsxs)(jsx_runtime.Fragment, {
            children: [
                /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                    className: "col-span-1 flex justify-center",
                    children: /*#__PURE__*/ (0,jsx_runtime.jsxs)("a", {
                        href: "https://stjarnafyrkant.se/ornskoldsvik/",
                        target: "_blank",
                        rel: "noopener noreferrer",
                        className: "flex flex-col justify-center text-center",
                        children: [
                            /*#__PURE__*/ (0,jsx_runtime.jsx)("img", {
                                className: "h-12",
                                src: "/partners/stjarnafyrkant.svg",
                                alt: "Stj\xe4rnaFyrkant"
                            }),
                            /*#__PURE__*/ (0,jsx_runtime.jsx)("p", {
                                className: "mt-2 text-sm font-semibold text-gray-700",
                                children: "Teknik"
                            })
                        ]
                    })
                }),
                /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                    className: "col-span-1 flex justify-center",
                    children: /*#__PURE__*/ (0,jsx_runtime.jsxs)("a", {
                        href: "https://totalpadelcenter.se/",
                        target: "_blank",
                        rel: "noopener noreferrer",
                        className: "flex flex-col justify-center text-center",
                        children: [
                            /*#__PURE__*/ (0,jsx_runtime.jsx)("img", {
                                className: "h-12",
                                src: "/partners/wap-logo-black-text.svg",
                                alt: "We Are Padel"
                            }),
                            /*#__PURE__*/ (0,jsx_runtime.jsx)("p", {
                                className: "mt-2 text-sm font-semibold text-gray-700",
                                children: "Sport"
                            })
                        ]
                    })
                }),
                /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                    className: "col-span-1 flex justify-center",
                    children: /*#__PURE__*/ (0,jsx_runtime.jsxs)("a", {
                        href: "https://www.halsobarennorrland.se/",
                        target: "_blank",
                        rel: "noopener noreferrer",
                        className: "flex flex-col justify-center text-center",
                        children: [
                            /*#__PURE__*/ (0,jsx_runtime.jsx)("img", {
                                className: "h-12",
                                src: "/partners/halsobaren-logo.svg",
                                alt: "H\xe4lsobaren"
                            }),
                            /*#__PURE__*/ (0,jsx_runtime.jsx)("p", {
                                className: "mt-2 text-sm font-semibold text-gray-700",
                                children: "Mat & dryck"
                            })
                        ]
                    })
                }),
                /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                    className: "col-span-1 flex justify-center",
                    children: /*#__PURE__*/ (0,jsx_runtime.jsxs)("a", {
                        href: "https://varlion.com/en/",
                        target: "_blank",
                        rel: "noopener noreferrer",
                        className: "flex flex-col justify-center text-center",
                        children: [
                            /*#__PURE__*/ (0,jsx_runtime.jsx)("img", {
                                className: "h-12",
                                src: "/partners/varlion.svg",
                                alt: "Varlion"
                            }),
                            /*#__PURE__*/ (0,jsx_runtime.jsx)("p", {
                                className: "mt-2 text-sm font-semibold text-gray-700",
                                children: "Bollar"
                            })
                        ]
                    })
                })
            ]
        }),
        firstFeature: {
            headline: 'Tr\xe4ffa nya m\xe4nniskor',
            description: 'Vi tror starkt p\xe5 att om det \xe4r i kalendern blir det av. I det h\xe4r fallet \xe4r det tv\xe5 flugor i en sm\xe4ll. F\xf6r det f\xf6rsta f\xe5r du tr\xe4ningen gjord samt att du p\xe5 samma g\xe5ng har ut\xf6kat och f\xf6rst\xe4rkt ditt lokala n\xe4tverk. Bra va?',
            cta: {
                text: 'Anm\xe4l er nu',
                href: '/signup',
                type: 'link'
            }
        },
        jamesClearNote: 'James Clear, F\xf6rfattare av Atomic Habits',
        secondFeature: {
            headline: 'H\xe4lsan f\xe5r en boost',
            description: 'Med N\xe4tverkspadeln kan du r\xe4kna med tr\xe4ning, t\xe4vling, och nyttigt k\xe4k under 10 veckor. Vi samarbetar med H\xe4lsobaren f\xf6r att erbjuda en bra och n\xe4ringsrik mat som tar dig genom hela dagen.',
            cta: {
                text: 'Anm\xe4l er nu',
                href: '/signup',
                type: 'link'
            }
        },
        featuresHeadline: 'Vad du f\xe5r med p\xe5 k\xf6pet',
        featuresDescription: 'Vi designar en smidig och effektiv upplevelse f\xf6r alla deltagare. H\xe4r nedan ser du ett smakprov av vad du kan f\xf6rv\xe4nta dig.',
        metricsHeadline: 'Hur man vinner s\xe4songen',
        metricsSubline: 'Speldynamik',
        metricsDescription: /*#__PURE__*/ (0,jsx_runtime.jsxs)(jsx_runtime.Fragment, {
            children: [
                /*#__PURE__*/ (0,jsx_runtime.jsx)("p", {
                    children: "Varje omg\xe5ng spelar vi en mexicanoturnering d\xe4r hela s\xe4songens ranking tas i beaktning f\xf6r att skapa en ranking av deltagarna. I varje match spelas 7 gem och det kan bli 7-0, 3-4, 5-2 etc. Varje gem r\xe4knas sedan in den individuella spelarens s\xe4song."
                }),
                /*#__PURE__*/ (0,jsx_runtime.jsx)("p", {
                    children: "Varje match tar ungef\xe4r 15-20 minuter och frukostgruppen hinner 4 matcher varje omg\xe5ng och lunchgruppen 3 matcher."
                }),
                /*#__PURE__*/ (0,jsx_runtime.jsxs)("p", {
                    children: [
                        "Tabellen sorteras sedan p\xe5 ett \"",
                        /*#__PURE__*/ (0,jsx_runtime.jsx)("em", {
                            children: "Po\xe4ng per match snitt"
                        }),
                        "\" (PPM) vilket \xe4r",
                        ' ',
                        /*#__PURE__*/ (0,jsx_runtime.jsx)("em", {
                            children: "totalt antal vunna gem / antal matcher"
                        }),
                        "."
                    ]
                }),
                /*#__PURE__*/ (0,jsx_runtime.jsx)("p", {
                    children: "I \xd6NP \xe4r “deltagare” den organisation eller f\xf6retag som anm\xe4lt sig. F\xf6retaget/organisationen kan representeras av en eller flera personer, men endast 1 spelare vid varje enskilt speltillf\xe4lle."
                })
            ]
        }),
        bottomCta: {
            prompt: 'Redo att komma ig\xe5ng?',
            headline: 'L\xe4s p\xe5 eller s\xe5 anm\xe4ler du dig bara.',
            primaryButton: {
                text: 'L\xe4s mer',
                href: '#first-testimonial-block',
                type: 'link'
            },
            secondaryButton: {
                text: 'Anm\xe4l er nu',
                href: '/signup',
                type: 'link'
            }
        },
        metricsLabel: 'Metrics',
        features: [
            {
                name: 'Gott om speltid',
                description: 'Du kan r\xe4kna med att konsekvent f\xe5 tr\xe4na p\xe5 din padel. M\xe4ngden \xe4r beroende p\xe5 vilken grupp du deltar i.',
                icon: outline_esm/* ClockIcon */.T39
            },
            {
                name: 'En boost p\xe5 morgonen',
                description: 'Om du spelar i morgongruppen kommer det finnas kaffe redo n\xe4r du kommer, f\xf6r den v\xe4lbeh\xf6vliga koffein-kicken.',
                icon: outline_esm/* ChevronDoubleUpIcon */.eWv
            },
            {
                name: '\xc5terh\xe4mtning',
                description: 'Efter spel ing\xe5r en frukost eller lunch (beroende p\xe5 vilken grupp du spelar i) uppe p\xe5 hyllan s\xe5 du kan g\xf6ra dig redo vad som h\xe4nder h\xe4rn\xe4st.',
                icon: outline_esm/* LightningBoltIcon */.YGl
            },
            {
                name: 'Beh\xf6ver du ett nytt racket?',
                description: 'Kanske du vill levla upp, eller beh\xf6ver det bytas ut efter n\xe5gra d\xe5liga tillslag? Oavsett f\xe5r du 20% p\xe5 racket hos WAP \xd6rnsk\xf6ldsvik under hela s\xe4songen.',
                icon: outline_esm/* CreditCardIcon */.ciH
            },
            {
                name: 'Har sk\xe4rmen g\xe5tt s\xf6nder?',
                description: 'Som deltagare f\xe5r du 15% p\xe5 service & reparation och 10% p\xe5 tillbeh\xf6r hos Stj\xe4rnaFyrkant \xd6rnsk\xf6ldsvik. Varf\xf6r inte f\xe5 det billigare om du kan?',
                icon: outline_esm/* HashtagIcon */.jdL
            },
            {
                name: 'Sugen p\xe5 en sjyst lunch?',
                description: 'Som deltagare f\xe5r du gratis dryck n\xe4r du k\xf6per lunch hos v\xe5r partner H\xe4lsobaren. Visa upp ditt \xd6NP medlemskort s\xe5 hj\xe4lper dom dig.',
                icon: outline_esm/* SparklesIcon */.T$Z
            },
            {
                name: 'S\xe4songsavslutning',
                description: 'Efter s\xe4songen har vi en gemensam avslutning med Mexicano-turnering samt AW och annat skoj. B\xf6r inte missas.',
                icon: outline_esm/* MusicNoteIcon */.GGj
            },
            {
                name: 'Nya kunder eller partners',
                description: 'Kanske s\xe4ger sig sj\xe4lv men det \xe4r sannerligen en "feature" av detta. Finns alla m\xf6jligheter att g\xf6ra aff\xe4rer. Upp till dig.',
                icon: outline_esm/* HeartIcon */.h_8
            }, 
        ],
        metrics: [
            {
                id: 1,
                stat: '7-12+',
                emphasis: 'Timmar',
                rest: 'och gott om tid att ta steg i ditt spel.'
            },
            {
                id: 2,
                stat: '20',
                emphasis: 'Deltagare',
                rest: 'som g\xf6r upp om att vinna titeln vid s\xe4songens slut.'
            }, 
        ],
        images: {
            balls: {
                source: hermes_lots_of_balls_on_court,
                alt: 'M\xe5nga bollar ligger p\xe5 banan',
                attribution: /*#__PURE__*/ (0,jsx_runtime.jsxs)(jsx_runtime.Fragment, {
                    children: [
                        "Foto av",
                        ' ',
                        /*#__PURE__*/ (0,jsx_runtime.jsx)("a", {
                            href: "https://unsplash.com/@hermez777?utm_source=unsplash&utm_medium=referral&utm_content=creditCopyText",
                            children: "Hermes Rivera"
                        }),
                        ' ',
                        "p\xe5",
                        ' ',
                        /*#__PURE__*/ (0,jsx_runtime.jsx)("a", {
                            href: "https://unsplash.com/s/photos/padel?utm_source=unsplash&utm_medium=referral&utm_content=creditCopyText",
                            children: "Unsplash"
                        })
                    ]
                })
            },
            blueAndOrange: {
                source: martin_hitting_the_ball,
                alt: 'Ett bl\xe5tt och orange padel rack',
                attribution: /*#__PURE__*/ (0,jsx_runtime.jsxs)(jsx_runtime.Fragment, {
                    children: [
                        "Foto av",
                        ' ',
                        /*#__PURE__*/ (0,jsx_runtime.jsx)("a", {
                            href: "https://unsplash.com/@manupappa?utm_source=unsplash&utm_medium=referral&utm_content=creditCopyText",
                            children: "Manuel Pappacena"
                        }),
                        ' ',
                        "p\xe5",
                        ' ',
                        /*#__PURE__*/ (0,jsx_runtime.jsx)("a", {
                            href: "https://unsplash.com/s/photos/padel?utm_source=unsplash&utm_medium=referral&utm_content=creditCopyText",
                            children: "Unsplash"
                        })
                    ]
                })
            },
            holdingRack: {
                source: man_holding_padel_rack_oliver_1,
                alt: 'Spelare h\xe5ller ett rack',
                attribution: /*#__PURE__*/ (0,jsx_runtime.jsxs)(jsx_runtime.Fragment, {
                    children: [
                        "Foto av",
                        ' ',
                        /*#__PURE__*/ (0,jsx_runtime.jsx)("a", {
                            href: "https://unsplash.com/@ollivves?utm_source=unsplash&utm_medium=referral&utm_content=creditCopyText",
                            children: "Oliver Sj\xf6str\xf6m"
                        }),
                        ' ',
                        "p\xe5",
                        ' ',
                        /*#__PURE__*/ (0,jsx_runtime.jsx)("a", {
                            href: "https://unsplash.com/s/photos/padel?utm_source=unsplash&utm_medium=referral&utm_content=creditCopyText",
                            children: "Unsplash"
                        })
                    ]
                })
            },
            lyingDown: {
                source: fredrik_striking_ball,
                alt: 'Spelare ligger p\xe5 banan',
                attribution: /*#__PURE__*/ (0,jsx_runtime.jsxs)(jsx_runtime.Fragment, {
                    children: [
                        "Foto av",
                        ' ',
                        /*#__PURE__*/ (0,jsx_runtime.jsx)("a", {
                            href: "https://unsplash.com/@ollivves?utm_source=unsplash&utm_medium=referral&utm_content=creditCopyText",
                            children: "Oliver Sj\xf6str\xf6m"
                        }),
                        ' ',
                        "p\xe5",
                        ' ',
                        /*#__PURE__*/ (0,jsx_runtime.jsx)("a", {
                            href: "https://unsplash.com/s/photos/padel?utm_source=unsplash&utm_medium=referral&utm_content=creditCopyText",
                            children: "Unsplash"
                        })
                    ]
                })
            }
        },
        companySignupCta: {
            headlinePartOne: 'L\xe5ter det mycket med varje vecka?',
            headlinePartTwo: 'Spela som ett lag ist\xe4llet.',
            description: 'Om {{packageLength}} g\xe5nger k\xe4nns som ett stort \xe5tagande kan ni p\xe5 f\xf6retaget dela p\xe5 passen och spela som ett lag. Best\xe4m vecka till vecka vem som ska spela och samla po\xe4ng f\xf6r att t\xe4vla mot andra f\xf6retag.',
            button: {
                text: 'Anm\xe4l er nu',
                href: '/signup',
                type: 'link'
            }
        }
    },
    en: {
        pageTitle: 'N\xe4tverkspadel',
        pageDescription: 'Vi samlas p\xe5 onsdagar f\xf6r att spela padel och n\xe4tverka. Tv\xe5 flugor i en sm\xe4ll.',
        headlinePlain: 'Spela mer padel',
        headlineMarked: 'och t\xe4vla mot andra f\xf6retag',
        subline: 'N\xe4tverkspadel \xe4r en m\xf6jlighet att varje onsdag spela padel med, och mot, stadens f\xf6retagare, entrepren\xf6rer, och entusiaster. Snacket f\xe5r du st\xe5 f\xf6r sj\xe4lv, resten tar vi hand om.',
        primaryCta: {
            text: 'Anm\xe4l er nu',
            href: '/signup',
            type: 'link'
        },
        secondaryCta: {
            text: 'L\xe4s mer',
            href: '#first-testimonial-block',
            type: 'link'
        },
        logoCloudHeadline: 'Presenteras av Impact Quest tillsammans med v\xe5ra grymma partners',
        logoCloud: /*#__PURE__*/ (0,jsx_runtime.jsxs)(jsx_runtime.Fragment, {
            children: [
                /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                    className: "col-span-1 flex justify-center",
                    children: /*#__PURE__*/ (0,jsx_runtime.jsx)("a", {
                        href: "https://www.impactquest.se",
                        target: "_blank",
                        rel: "noopener noreferrer",
                        children: /*#__PURE__*/ (0,jsx_runtime.jsx)("img", {
                            className: "h-12",
                            src: "/partners/impact-quest.svg",
                            alt: "ImpactQuest"
                        })
                    })
                }),
                /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                    className: "col-span-1 flex justify-center",
                    children: /*#__PURE__*/ (0,jsx_runtime.jsx)("a", {
                        href: "https://stjarnafyrkant.se/ornskoldsvik/",
                        target: "_blank",
                        rel: "noopener noreferrer",
                        children: /*#__PURE__*/ (0,jsx_runtime.jsx)("img", {
                            className: "h-12",
                            src: "/partners/stjarnafyrkant.svg",
                            alt: "Stj\xe4rnaFyrkant"
                        })
                    })
                }),
                /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                    className: "col-span-1 flex justify-center",
                    children: /*#__PURE__*/ (0,jsx_runtime.jsx)("a", {
                        href: "https://totalpadelcenter.se/",
                        target: "_blank",
                        rel: "noopener noreferrer",
                        children: /*#__PURE__*/ (0,jsx_runtime.jsx)("img", {
                            className: "h-12",
                            src: "/partners/wap-logo-black-text.svg",
                            alt: "Total Padelcenter"
                        })
                    })
                }),
                /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                    className: "col-span-1 flex justify-center",
                    children: /*#__PURE__*/ (0,jsx_runtime.jsx)("a", {
                        href: "https://www.halsobarennorrland.se/",
                        target: "_blank",
                        rel: "noopener noreferrer",
                        children: /*#__PURE__*/ (0,jsx_runtime.jsx)("img", {
                            className: "h-12",
                            src: "/partners/halsobaren-logo.svg",
                            alt: "H\xe4lsobaren"
                        })
                    })
                })
            ]
        }),
        firstFeature: {
            headline: 'Tr\xe4ffa nya m\xe4nniskor',
            description: 'Vi tror starkt p\xe5 att om det \xe4r i kalendern blir det av. I det h\xe4r fallet \xe4r det tv\xe5 flugor i en sm\xe4ll. F\xf6r det f\xf6rsta f\xe5r du tr\xe4ningen gjord samt att du p\xe5 samma g\xe5ng har ut\xf6kat och f\xf6rst\xe4rkt ditt lokala n\xe4tverk. Bra va?',
            cta: {
                text: 'Anm\xe4l er nu',
                href: '/signup',
                type: 'link'
            }
        },
        jamesClearNote: 'James Clear, F\xf6rfattare av Atomic Habits',
        secondFeature: {
            headline: 'H\xe4lsan f\xe5r en boost',
            description: 'Med N\xe4tverkspadeln kan du r\xe4kna med tr\xe4ning, t\xe4vling, och nyttigt k\xe4k under 10 veckor. Vi samarbetar med H\xe4lsobaren f\xf6r att erbjuda en bra och n\xe4ringsrik mat som tar dig genom hela dagen.',
            cta: {
                text: 'Anm\xe4l er nu',
                href: '/signup',
                type: 'link'
            }
        },
        featuresHeadline: 'Vad du f\xe5r med p\xe5 k\xf6pet',
        featuresDescription: 'Vi designar en smidig och effektiv upplevelse f\xf6r alla deltagare. H\xe4r nedan ser du ett smakprov av vad du kan f\xf6rv\xe4nta dig.',
        metricsHeadline: 'Hur man vinner s\xe4songen',
        metricsSubline: 'Speldynamik',
        metricsDescription: /*#__PURE__*/ (0,jsx_runtime.jsxs)(jsx_runtime.Fragment, {
            children: [
                /*#__PURE__*/ (0,jsx_runtime.jsx)("p", {
                    children: "Varje omg\xe5ng spelar vi en mexicanoturnering d\xe4r hela s\xe4songens ranking tas i beaktning f\xf6r att skapa en ranking av deltagarna. I varje match spelas 7 gem och det kan bli 7-0, 3-4, 5-2 etc. Varje gem r\xe4knas sedan in den individuella spelarens s\xe4song."
                }),
                /*#__PURE__*/ (0,jsx_runtime.jsx)("p", {
                    children: "Varje match tar ungef\xe4r 15-20 minuter och frukostgruppen hinner 4 matcher varje omg\xe5ng och lunchgruppen 3 matcher."
                }),
                /*#__PURE__*/ (0,jsx_runtime.jsxs)("p", {
                    children: [
                        "Tabellen sorteras sedan p\xe5 ett \"",
                        /*#__PURE__*/ (0,jsx_runtime.jsx)("em", {
                            children: "Po\xe4ng per match snitt"
                        }),
                        "\" (PPM) vilket \xe4r",
                        ' ',
                        /*#__PURE__*/ (0,jsx_runtime.jsx)("em", {
                            children: "totalt antal vunna gem / antal matcher"
                        }),
                        "."
                    ]
                }),
                /*#__PURE__*/ (0,jsx_runtime.jsx)("p", {
                    children: "I \xd6NP \xe4r “deltagare” den organisation eller f\xf6retag som anm\xe4lt sig. F\xf6retaget/organisationen kan representeras av en eller flera personer, men endast 1 spelare vid varje enskilt speltillf\xe4lle."
                })
            ]
        }),
        bottomCta: {
            prompt: 'Redo att komma ig\xe5ng?',
            headline: 'L\xe4s p\xe5 eller s\xe5 anm\xe4ler du dig bara.',
            primaryButton: {
                text: 'L\xe4s mer',
                href: '#first-testimonial-block',
                type: 'link'
            },
            secondaryButton: {
                text: 'Anm\xe4l er nu',
                href: '/signup',
                type: 'link'
            }
        },
        metricsLabel: 'Metrics',
        features: [
            {
                name: 'Gott om speltid',
                description: 'Du kan r\xe4kna med att konsekvent f\xe5 tr\xe4na p\xe5 din padel. M\xe4ngden \xe4r beroende p\xe5 vilken grupp du deltar i.',
                icon: outline_esm/* ClockIcon */.T39
            },
            {
                name: 'En boost p\xe5 morgonen',
                description: 'Om du spelar i morgongruppen kommer det finnas kaffe redo n\xe4r du kommer, f\xf6r den v\xe4lbeh\xf6vliga koffein-kicken.',
                icon: outline_esm/* ChevronDoubleUpIcon */.eWv
            },
            {
                name: '\xc5terh\xe4mtning',
                description: 'Efter spel ing\xe5r en frukost eller lunch (beroende p\xe5 vilken grupp du spelar i) uppe p\xe5 hyllan s\xe5 du kan g\xf6ra dig redo vad som h\xe4nder h\xe4rn\xe4st.',
                icon: outline_esm/* LightningBoltIcon */.YGl
            },
            {
                name: 'Beh\xf6ver du ett nytt racket?',
                description: 'Kanske du vill levla upp, eller beh\xf6ver det bytas ut efter n\xe5gra d\xe5liga tillslag? Oavsett f\xe5r du 20% p\xe5 racket hos WAP \xd6rnsk\xf6ldsvik under hela s\xe4songen.',
                icon: outline_esm/* CreditCardIcon */.ciH
            },
            {
                name: 'Har sk\xe4rmen g\xe5tt s\xf6nder?',
                description: 'Som deltagare f\xe5r du 15% p\xe5 service & reparation och 10% p\xe5 tillbeh\xf6r hos Stj\xe4rnaFyrkant \xd6rnsk\xf6ldsvik. Varf\xf6r inte f\xe5 det billigare om du kan?',
                icon: outline_esm/* HashtagIcon */.jdL
            },
            {
                name: 'Sugen p\xe5 en sjyst lunch?',
                description: 'Som deltagare f\xe5r du gratis dryck n\xe4r du k\xf6per lunch hos v\xe5r partner H\xe4lsobaren. Visa upp ditt \xd6NP medlemskort s\xe5 hj\xe4lper dom dig.',
                icon: outline_esm/* SparklesIcon */.T$Z
            },
            {
                name: 'S\xe4songsavslutning',
                description: 'Efter s\xe4songen har vi en gemensam avslutning med Mexicano-turnering samt AW och annat skoj. B\xf6r inte missas.',
                icon: outline_esm/* MusicNoteIcon */.GGj
            },
            {
                name: 'Nya kunder eller partners',
                description: 'Kanske s\xe4ger sig sj\xe4lv men det \xe4r sannerligen en "feature" av detta. Finns alla m\xf6jligheter att g\xf6ra aff\xe4rer. Upp till dig.',
                icon: outline_esm/* HeartIcon */.h_8
            }, 
        ],
        metrics: [
            {
                id: 1,
                stat: '7-12+',
                emphasis: 'Timmar',
                rest: 'och gott om tid att ta steg i ditt spel.'
            },
            {
                id: 2,
                stat: '20',
                emphasis: 'Deltagare',
                rest: 'som g\xf6r upp om att vinna titeln vid s\xe4songens slut.'
            }, 
        ],
        images: {
            balls: {
                source: hermes_lots_of_balls_on_court,
                alt: 'M\xe5nga bollar ligger p\xe5 banan',
                attribution: /*#__PURE__*/ (0,jsx_runtime.jsxs)(jsx_runtime.Fragment, {
                    children: [
                        "Foto av",
                        ' ',
                        /*#__PURE__*/ (0,jsx_runtime.jsx)("a", {
                            href: "https://unsplash.com/@hermez777?utm_source=unsplash&utm_medium=referral&utm_content=creditCopyText",
                            children: "Hermes Rivera"
                        }),
                        ' ',
                        "p\xe5",
                        ' ',
                        /*#__PURE__*/ (0,jsx_runtime.jsx)("a", {
                            href: "https://unsplash.com/s/photos/padel?utm_source=unsplash&utm_medium=referral&utm_content=creditCopyText",
                            children: "Unsplash"
                        })
                    ]
                })
            },
            blueAndOrange: {
                source: martin_hitting_the_ball,
                alt: 'Ett bl\xe5tt och orange padel rack',
                attribution: /*#__PURE__*/ (0,jsx_runtime.jsxs)(jsx_runtime.Fragment, {
                    children: [
                        "Foto av",
                        ' ',
                        /*#__PURE__*/ (0,jsx_runtime.jsx)("a", {
                            href: "https://unsplash.com/@manupappa?utm_source=unsplash&utm_medium=referral&utm_content=creditCopyText",
                            children: "Manuel Pappacena"
                        }),
                        ' ',
                        "p\xe5",
                        ' ',
                        /*#__PURE__*/ (0,jsx_runtime.jsx)("a", {
                            href: "https://unsplash.com/s/photos/padel?utm_source=unsplash&utm_medium=referral&utm_content=creditCopyText",
                            children: "Unsplash"
                        })
                    ]
                })
            },
            holdingRack: {
                source: man_holding_padel_rack_oliver_1,
                alt: 'Spelare h\xe5ller ett rack',
                attribution: /*#__PURE__*/ (0,jsx_runtime.jsxs)(jsx_runtime.Fragment, {
                    children: [
                        "Foto av",
                        ' ',
                        /*#__PURE__*/ (0,jsx_runtime.jsx)("a", {
                            href: "https://unsplash.com/@ollivves?utm_source=unsplash&utm_medium=referral&utm_content=creditCopyText",
                            children: "Oliver Sj\xf6str\xf6m"
                        }),
                        ' ',
                        "p\xe5",
                        ' ',
                        /*#__PURE__*/ (0,jsx_runtime.jsx)("a", {
                            href: "https://unsplash.com/s/photos/padel?utm_source=unsplash&utm_medium=referral&utm_content=creditCopyText",
                            children: "Unsplash"
                        })
                    ]
                })
            },
            lyingDown: {
                source: fredrik_striking_ball,
                alt: 'Spelare ligger p\xe5 banan',
                attribution: /*#__PURE__*/ (0,jsx_runtime.jsxs)(jsx_runtime.Fragment, {
                    children: [
                        "Foto av",
                        ' ',
                        /*#__PURE__*/ (0,jsx_runtime.jsx)("a", {
                            href: "https://unsplash.com/@ollivves?utm_source=unsplash&utm_medium=referral&utm_content=creditCopyText",
                            children: "Oliver Sj\xf6str\xf6m"
                        }),
                        ' ',
                        "p\xe5",
                        ' ',
                        /*#__PURE__*/ (0,jsx_runtime.jsx)("a", {
                            href: "https://unsplash.com/s/photos/padel?utm_source=unsplash&utm_medium=referral&utm_content=creditCopyText",
                            children: "Unsplash"
                        })
                    ]
                })
            }
        },
        companySignupCta: {
            headlinePartOne: 'L\xe5ter det mycket med varje vecka?',
            headlinePartTwo: 'Spela som ett lag ist\xe4llet.',
            description: 'Om {{packageLength}} g\xe5nger k\xe4nns som ett stort \xe5tagande kan ni p\xe5 f\xf6retaget dela p\xe5 passen och spela som ett lag. Best\xe4m vecka till vecka vem som ska spela och samla po\xe4ng f\xf6r att t\xe4vla mot andra f\xf6retag.',
            button: {
                text: 'Anm\xe4l er nu',
                href: '/signup',
                type: 'link'
            }
        }
    }
};

;// CONCATENATED MODULE: ./components/ds/05-pages/home/alternatives/translations.tsx
var alternatives_translations_translations = {
    sv: {
        headline: 'Vad \xe4r r\xe4tt f\xf6r er?',
        description: 'Vi erbjuder olika varianter f\xf6r att kunna fungera f\xf6r fler deltagare. Kolla in dem nedan.',
        callToActionButtons: {
            prefix: 'Boka'
        },
        price: {
            suffix: 'kr',
            type: 'omg\xe5ng'
        },
        lengthSelectors: {
            fiveWeeks: {
                label: '5 veckor'
            },
            tenWeeks: {
                label: '10 veckor'
            }
        },
        tiers: [
            {
                name: 'Morgon',
                href: '/signup?alternative=morning',
                priceTenWeeks: 2999,
                priceFiveWeeks: 1499,
                description: '{{packageLength}} tillf\xe4llen med 90 minuter padel och frukost fr\xe5n H\xe4lsobaren.',
                includedFeatures: [
                    '07:00-08:30 spel.',
                    '08:30-09:00 frukost.',
                    'Frukost fr\xe5n H\xe4lsobaren.',
                    'Slutspel och s\xe4songsavslutning med Mexicano-turnering.',
                    'Kan delas p\xe5 mellan kollegor', 
                ],
                featuresTenWeek: [
                    'Upp till 17 timmar padel.'
                ],
                featuresFiveWeek: [
                    'Upp till 9,5 timmar padel.'
                ],
                full: false
            },
            {
                name: 'Lunch',
                href: '/signup?alternative=lunch',
                priceTenWeeks: 2999,
                priceFiveWeeks: 1499,
                description: '{{packageLength}} tillf\xe4llen med 60 minuter padel och lunch fr\xe5n H\xe4lsobaren.',
                includedFeatures: [
                    '11:30-12:30 spel.',
                    '12:30-13:00 lunch.',
                    'Lunch fr\xe5n H\xe4lsobaren',
                    'Slutspel och s\xe4songsavslutning med Mexicano-turnering.',
                    'Kan delas p\xe5 mellan kollegor', 
                ],
                featuresTenWeek: [
                    'Upp till 12 timmar padel.'
                ],
                featuresFiveWeek: [
                    'Upp till 7 timmar padel.'
                ],
                full: false
            }, 
        ]
    },
    en: {
        headline: 'Vad \xe4r r\xe4tt f\xf6r er?',
        description: 'Vi erbjuder lite olika varianter f\xf6r att kunna fungera f\xf6r fler deltagare. Kolla in dem nedan.',
        callToActionButtons: {
            prefix: 'Boka'
        },
        price: {
            suffix: 'kr',
            type: 'omg\xe5ng'
        },
        lengthSelectors: {
            fiveWeeks: {
                label: '5 veckor'
            },
            tenWeeks: {
                label: '10 veckor'
            }
        },
        tiers: [
            {
                name: 'Morgon',
                href: '/signup?alternative=morning',
                priceTenWeeks: 2999,
                priceFiveWeeks: 1499,
                description: '{{packageLength}} tillf\xe4llen med 90 minuter padel och frukost.',
                includedFeatures: [
                    '07:00-08:30 spel.',
                    '08:30-09:00 frukost.',
                    'Kaffe p\xe5 plats innan match.',
                    'Slutspel och s\xe4songsavslutning med Mexicano-turnering.', 
                ],
                featuresTenWeek: [
                    'Upp till 17 timmar padel.'
                ],
                featuresFiveWeek: [
                    'Upp till 9,5 timmar padel.'
                ],
                full: false
            },
            {
                name: 'Lunch',
                href: '/signup?alternative=lunch',
                priceTenWeeks: 2999,
                priceFiveWeeks: 1499,
                description: '{{packageLength}} tillf\xe4llen med 60 minuter padel och lunch fr\xe5n H\xe4lsobaren.',
                includedFeatures: [
                    '11:30-12:30 spel.',
                    '12:30-13:00 lunch.',
                    'Lunch fr\xe5n H\xe4lsobaren',
                    'Slutspel och s\xe4songsavslutning med Mexicano-turnering.', 
                ],
                featuresTenWeek: [
                    'Upp till 12 timmar padel.'
                ],
                featuresFiveWeek: [
                    'Upp till 7 timmar padel.'
                ],
                full: false
            }, 
        ]
    }
};

;// CONCATENATED MODULE: ./components/ds/05-pages/home/alternatives/index.tsx









function alternatives_arrayLikeToArray(arr, len) {
    if (len == null || len > arr.length) len = arr.length;
    for(var i = 0, arr2 = new Array(len); i < len; i++)arr2[i] = arr[i];
    return arr2;
}
function _arrayWithoutHoles(arr) {
    if (Array.isArray(arr)) return alternatives_arrayLikeToArray(arr);
}
function _iterableToArray(iter) {
    if (typeof Symbol !== "undefined" && iter[Symbol.iterator] != null || iter["@@iterator"] != null) return Array.from(iter);
}
function _nonIterableSpread() {
    throw new TypeError("Invalid attempt to spread non-iterable instance.\\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method.");
}
function _toConsumableArray(arr) {
    return _arrayWithoutHoles(arr) || _iterableToArray(arr) || alternatives_unsupportedIterableToArray(arr) || _nonIterableSpread();
}
function alternatives_unsupportedIterableToArray(o, minLen) {
    if (!o) return;
    if (typeof o === "string") return alternatives_arrayLikeToArray(o, minLen);
    var n = Object.prototype.toString.call(o).slice(8, -1);
    if (n === "Object" && o.constructor) n = o.constructor.name;
    if (n === "Map" || n === "Set") return Array.from(n);
    if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return alternatives_arrayLikeToArray(o, minLen);
}
var Alternatives = function(param) {
    var packageLength = param.packageLength, setPackageLength = param.setPackageLength;
    var trackSignupClickOnHome = useFathomEvents().trackSignupClickOnHome;
    var type = (0,hooks/* useSalesTax */.v)().type;
    var router = (0,next_router.useRouter)();
    var locale = (0,utils_locale/* makeLocale */.W)(router.locale, router.defaultLocale) || 'sv';
    var translation = alternatives_translations_translations[locale];
    var getPrice = function(price) {
        return type === 'exclusive' ? price : (0,lodash.round)(price * 1.06, 0);
    };
    return(/*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
        className: "bg-gray-100",
        children: /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
            className: "max-w-7xl mx-auto py-24 px-4 sm:px-6 lg:px-8",
            children: [
                /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                    className: "sm:flex sm:flex-col sm:align-center",
                    children: [
                        /*#__PURE__*/ (0,jsx_runtime.jsx)("h1", {
                            className: "text-5xl font-extrabold text-gray-900 sm:text-center",
                            children: translation.headline
                        }),
                        /*#__PURE__*/ (0,jsx_runtime.jsx)("p", {
                            className: "mt-5 text-xl text-gray-500 sm:text-center",
                            children: translation.description
                        })
                    ]
                }),
                /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                    className: "mt-12 space-y-4 sm:mt-16 sm:space-y-0 sm:grid sm:grid-cols-2 sm:gap-6 lg:max-w-4xl lg:mx-auto xl:max-w-none xl:mx-0",
                    children: translation.tiers.map(function(tier) {
                        /*#__PURE__*/ return (0,jsx_runtime.jsxs)("div", {
                            className: "bg-white border border-gray-200 rounded-lg shadow-sm divide-y divide-gray-200",
                            children: [
                                /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                                    className: "p-6",
                                    children: [
                                        /*#__PURE__*/ (0,jsx_runtime.jsx)("h2", {
                                            className: "text-lg leading-6 font-medium text-gray-900",
                                            children: tier.name
                                        }),
                                        /*#__PURE__*/ (0,jsx_runtime.jsx)("p", {
                                            className: "mt-4 text-sm text-gray-500",
                                            children: (0,lodash.replace)(tier.description, '{{packageLength}}', "".concat(packageLength))
                                        }),
                                        /*#__PURE__*/ (0,jsx_runtime.jsxs)("p", {
                                            className: "mt-8",
                                            children: [
                                                /*#__PURE__*/ (0,jsx_runtime.jsxs)("span", {
                                                    className: "text-4xl font-extrabold text-gray-900",
                                                    children: [
                                                        packageLength === 10 ? getPrice(tier.priceTenWeeks) : getPrice(tier.priceFiveWeeks),
                                                        translation.price.suffix
                                                    ]
                                                }),
                                                ' ',
                                                /*#__PURE__*/ (0,jsx_runtime.jsxs)("span", {
                                                    className: "text-base font-medium text-gray-500",
                                                    children: [
                                                        "/",
                                                        translation.price.type
                                                    ]
                                                })
                                            ]
                                        }),
                                        !tier.full ? /*#__PURE__*/ (0,jsx_runtime.jsx)(next_link["default"], {
                                            href: "".concat(tier.href, "&length=").concat(packageLength, "weeks"),
                                            children: /*#__PURE__*/ (0,jsx_runtime.jsxs)("a", {
                                                onClick: trackSignupClickOnHome,
                                                className: "mt-8 block w-full rounded-md py-2 text-center text-base font-medium text-white bg-gradient-to-r from-purple-600 to-blue-600 bg-origin-border border border-transparent hover:from-purple-700 hover:to-blue-700",
                                                children: [
                                                    translation.callToActionButtons.prefix,
                                                    " ",
                                                    tier.name
                                                ]
                                            })
                                        }) : null,
                                        tier.full ? /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                                            className: "mt-8 w-full rounded-md py-2 text-center text-base font-medium text-white bg-gradient-to-r from-teal-600 to-green-600 bg-origin-border border border-transparent inline-flex gap-x-2 justify-center items-center",
                                            children: [
                                                /*#__PURE__*/ (0,jsx_runtime.jsx)("svg", {
                                                    xmlns: "http://www.w3.org/2000/svg",
                                                    className: "h-6 w-6",
                                                    fill: "none",
                                                    viewBox: "0 0 24 24",
                                                    stroke: "currentColor",
                                                    children: /*#__PURE__*/ (0,jsx_runtime.jsx)("path", {
                                                        strokeLinecap: "round",
                                                        strokeLinejoin: "round",
                                                        strokeWidth: 2,
                                                        d: "M9 12l2 2 4-4m6 2a9 9 0 11-18 0 9 9 0 0118 0z"
                                                    })
                                                }),
                                                /*#__PURE__*/ (0,jsx_runtime.jsx)("span", {
                                                    children: "Fullbokat"
                                                })
                                            ]
                                        }) : null
                                    ]
                                }),
                                /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                                    className: "pt-6 pb-8 px-6",
                                    children: [
                                        /*#__PURE__*/ (0,jsx_runtime.jsx)("h3", {
                                            className: "text-xs font-medium text-gray-900 tracking-wide uppercase",
                                            children: "Vad ing\xe5r"
                                        }),
                                        /*#__PURE__*/ (0,jsx_runtime.jsx)("ul", {
                                            role: "list",
                                            className: "mt-6 space-y-4",
                                            children: _toConsumableArray(tier.includedFeatures).concat(_toConsumableArray(packageLength === 10 ? tier.featuresTenWeek : tier.featuresFiveWeek)).map(function(feature) {
                                                /*#__PURE__*/ return (0,jsx_runtime.jsxs)("li", {
                                                    className: "flex space-x-3",
                                                    children: [
                                                        /*#__PURE__*/ (0,jsx_runtime.jsx)(esm/* CheckIcon */.nQG, {
                                                            className: "flex-shrink-0 h-5 w-5 text-green-500",
                                                            "aria-hidden": "true"
                                                        }),
                                                        /*#__PURE__*/ (0,jsx_runtime.jsx)("span", {
                                                            className: "text-sm text-gray-500",
                                                            children: feature
                                                        })
                                                    ]
                                                }, feature);
                                            })
                                        })
                                    ]
                                })
                            ]
                        }, tier.name);
                    })
                })
            ]
        })
    }));
};

;// CONCATENATED MODULE: ./components/ds/05-pages/home/testimonials/single-testimonial/index.tsx

var Testimonial = function(param) {
    var id = param.id, firstTestimonial = param.firstTestimonial, secondTestimonial = param.secondTestimonial;
    return(/*#__PURE__*/ (0,jsx_runtime.jsx)("section", {
        id: id,
        className: "bg-gradient-to-r from-purple-800 to-blue-700",
        children: /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
            className: "max-w-7xl mx-auto md:grid md:grid-cols-2 md:px-6 lg:px-8",
            children: [
                /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                    className: "py-12 px-4 sm:px-6 md:flex md:flex-col md:py-16 md:pl-0 md:pr-10 lg:pr-16",
                    children: [
                        /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                            className: "md:flex-shrink-0 bg-white rounded-md flex justify-center items-center py-4",
                            children: /*#__PURE__*/ (0,jsx_runtime.jsx)("img", {
                                className: "h-12",
                                src: firstTestimonial.logoUrl,
                                alt: firstTestimonial.companyName
                            })
                        }),
                        /*#__PURE__*/ (0,jsx_runtime.jsx)("blockquote", {
                            className: "mt-6 md:flex-grow md:flex md:flex-col",
                            children: /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                className: "video-responsive",
                                children: /*#__PURE__*/ (0,jsx_runtime.jsx)("iframe", {
                                    title: "N\xe4tverkspadel testimonial",
                                    width: "560",
                                    height: "315",
                                    src: firstTestimonial.embedUrl,
                                    loading: "lazy",
                                    frameBorder: "0",
                                    allow: "accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture",
                                    className: "rounded-md",
                                    allowFullScreen: true
                                })
                            })
                        })
                    ]
                }),
                /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                    className: "py-12 px-4 sm:px-6 md:flex md:flex-col md:py-16 md:pl-0 md:pr-10 lg:pr-16",
                    children: [
                        /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                            className: "md:flex-shrink-0 bg-white rounded-md flex justify-center items-center py-4",
                            children: /*#__PURE__*/ (0,jsx_runtime.jsx)("img", {
                                className: "h-12",
                                src: secondTestimonial.logoUrl,
                                alt: secondTestimonial.companyName
                            })
                        }),
                        /*#__PURE__*/ (0,jsx_runtime.jsx)("blockquote", {
                            className: "mt-6 md:flex-grow md:flex md:flex-col",
                            children: /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                className: "video-responsive",
                                children: /*#__PURE__*/ (0,jsx_runtime.jsx)("iframe", {
                                    title: "N\xe4tverkspadel testimonial",
                                    width: "560",
                                    height: "315",
                                    src: secondTestimonial.embedUrl,
                                    loading: "lazy",
                                    frameBorder: "0",
                                    allow: "accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture",
                                    className: "rounded-md",
                                    allowFullScreen: true
                                })
                            })
                        })
                    ]
                })
            ]
        })
    }));
};

;// CONCATENATED MODULE: ./components/ds/05-pages/home/bottom-banner/index.tsx




var SeasonEndResultBanner = function() {
    var ref = (0,react.useState)(true), show = ref[0], setShow = ref[1];
    if (!show) return null;
    return(/*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
        className: "fixed inset-x-0 bottom-0 pb-2 sm:pb-5",
        children: /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
            className: "mx-auto max-w-7xl px-2 sm:px-6 lg:px-8",
            children: /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                className: "rounded-lg bg-blue-600 p-2 shadow-lg sm:p-3",
                children: /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                    className: "flex flex-wrap items-center justify-between",
                    children: [
                        /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                            className: "flex w-0 flex-1 items-center",
                            children: [
                                /*#__PURE__*/ (0,jsx_runtime.jsx)("span", {
                                    className: "flex rounded-lg bg-blue-800 p-2",
                                    children: /*#__PURE__*/ (0,jsx_runtime.jsx)(outline_esm/* SpeakerphoneIcon */.rIV, {
                                        className: "h-6 w-6 text-white",
                                        "aria-hidden": "true"
                                    })
                                }),
                                /*#__PURE__*/ (0,jsx_runtime.jsxs)("p", {
                                    className: "ml-3 truncate font-medium text-white",
                                    children: [
                                        /*#__PURE__*/ (0,jsx_runtime.jsx)("span", {
                                            className: "md:hidden",
                                            children: "Andra s\xe4songen \xe4r avklarad!"
                                        }),
                                        /*#__PURE__*/ (0,jsx_runtime.jsx)("span", {
                                            className: "hidden md:inline",
                                            children: "Sverige vi har ett resultat! Andra s\xe4songen av N\xe4tverkspadeln \xe4r avklarad."
                                        })
                                    ]
                                })
                            ]
                        }),
                        /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                            className: "order-3 mt-2 w-full flex-shrink-0 sm:order-2 sm:mt-0 sm:w-auto",
                            children: /*#__PURE__*/ (0,jsx_runtime.jsx)(next_link["default"], {
                                href: "/resultat/np-v22",
                                children: /*#__PURE__*/ (0,jsx_runtime.jsx)("a", {
                                    className: "flex items-center justify-center rounded-md border border-transparent bg-white px-4 py-2 text-sm font-medium text-blue-600 shadow-sm hover:bg-blue-50",
                                    children: "L\xe4s mer"
                                })
                            })
                        }),
                        /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                            className: "order-2 flex-shrink-0 sm:order-3 sm:ml-2",
                            children: /*#__PURE__*/ (0,jsx_runtime.jsxs)("button", {
                                type: "button",
                                className: "-mr-1 flex rounded-md p-2 hover:bg-blue-500 focus:outline-none focus:ring-2 focus:ring-white",
                                onClick: function() {
                                    return setShow(false);
                                },
                                children: [
                                    /*#__PURE__*/ (0,jsx_runtime.jsx)("span", {
                                        className: "sr-only",
                                        children: "Dismiss"
                                    }),
                                    /*#__PURE__*/ (0,jsx_runtime.jsx)(outline_esm/* XIcon */.b0D, {
                                        className: "h-6 w-6 text-white",
                                        "aria-hidden": "true"
                                    })
                                ]
                            })
                        })
                    ]
                })
            })
        })
    }));
};

;// CONCATENATED MODULE: ./components/ds/05-pages/home/index.tsx

/* eslint-disable @next/next/no-img-element */ /* eslint-disable jsx-a11y/no-redundant-roles */ /* eslint-disable jsx-a11y/anchor-is-valid */ 













var testimonials = [
    {
        embedUrl: 'https://www.youtube-nocookie.com/embed/1d4G2_fzaY0',
        logoUrl: 'https://res.cloudinary.com/db7wmjwhe/image/upload/v1639676714/logo_color_white_fvqbfm_hngh0a.svg',
        personName: 'Johan Lindgren',
        companyName: 'XLENT'
    },
    {
        embedUrl: 'https://www.youtube-nocookie.com/embed/eZPvqaSwLLU',
        logoUrl: 'https://res.cloudinary.com/db7wmjwhe/image/upload/v1639676619/bonnier_qpxyty.svg',
        personName: 'Mikael Nordstrand',
        companyName: 'Bonnier News Local'
    },
    {
        embedUrl: 'https://www.youtube-nocookie.com/embed/lQuH5zfznC8',
        logoUrl: 'https://res.cloudinary.com/db7wmjwhe/image/upload/v1636013468/carstedts_a1hgoa.png',
        personName: 'Martin Carstedt',
        companyName: 'Carstedts Bil'
    },
    {
        embedUrl: 'https://www.youtube-nocookie.com/embed/zmORqW8yaZU',
        logoUrl: 'https://res.cloudinary.com/db7wmjwhe/image/upload/v1636013351/placerum_logotyp_RGB_vyrt3e.svg',
        personName: 'Victor Hansson',
        companyName: 'Placerum'
    }, 
];
var HomePage = function(param) {
    var series = param.series;
    var trackSignupClickOnHome = useFathomEvents().trackSignupClickOnHome;
    var router = (0,next_router.useRouter)();
    var locale = (0,utils_locale/* makeLocale */.W)(router.locale, router.defaultLocale) || 'sv';
    var translation = home_translations_translations[locale];
    var ref = (0,react.useState)(10), packageLength = ref[0], setPackageLength = ref[1];
    return(/*#__PURE__*/ (0,jsx_runtime.jsxs)(jsx_runtime.Fragment, {
        children: [
            /*#__PURE__*/ (0,jsx_runtime.jsx)(Head, {
                title: translation.pageTitle,
                description: translation.pageDescription
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                className: "bg-white",
                children: [
                    /*#__PURE__*/ (0,jsx_runtime.jsx)(Header, {
                        series: series
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsxs)("main", {
                        children: [
                            /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                                className: "relative",
                                children: [
                                    /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                        className: "absolute inset-x-0 bottom-0 h-1/2 bg-gray-100"
                                    }),
                                    /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                        className: "mx-auto max-w-7xl sm:px-6 lg:px-8",
                                        children: /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                                            className: "relative shadow-xl sm:overflow-hidden sm:rounded-2xl",
                                            children: [
                                                /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                                                    className: "absolute inset-0",
                                                    children: [
                                                        /*#__PURE__*/ (0,jsx_runtime.jsx)("img", {
                                                            className: "h-full w-full object-cover",
                                                            src: "/assets/man-holding-padel-rack-oliver-1.jpg",
                                                            alt: "Player holding rack"
                                                        }),
                                                        /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                                            className: "absolute inset-0 bg-gradient-to-r from-purple-500 to-blue-400 mix-blend-multiply"
                                                        })
                                                    ]
                                                }),
                                                /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                                                    className: "relative px-4 py-16 sm:px-6 sm:py-24 lg:py-32 lg:px-8",
                                                    children: [
                                                        /*#__PURE__*/ (0,jsx_runtime.jsxs)("h1", {
                                                            className: "text-center text-4xl font-extrabold tracking-tight sm:text-5xl lg:text-6xl",
                                                            children: [
                                                                /*#__PURE__*/ (0,jsx_runtime.jsx)("span", {
                                                                    className: "block text-white",
                                                                    children: translation.headlinePlain
                                                                }),
                                                                /*#__PURE__*/ (0,jsx_runtime.jsx)("span", {
                                                                    className: "block text-blue-200",
                                                                    children: translation.headlineMarked
                                                                })
                                                            ]
                                                        }),
                                                        /*#__PURE__*/ (0,jsx_runtime.jsx)("p", {
                                                            className: "mx-auto mt-6 max-w-lg text-center text-xl text-blue-200 sm:max-w-3xl",
                                                            children: translation.subline
                                                        }),
                                                        /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                                            className: "mx-auto mt-10 max-w-sm sm:flex sm:max-w-none sm:justify-center",
                                                            children: /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                                                                className: "space-y-4 sm:mx-auto sm:inline-grid sm:grid-cols-2 sm:gap-5 sm:space-y-0",
                                                                children: [
                                                                    translation.primaryCta.type === 'anchor' ? /*#__PURE__*/ (0,jsx_runtime.jsx)("a", {
                                                                        href: translation.primaryCta.href,
                                                                        className: "flex items-center justify-center rounded-md border border-transparent bg-white px-4 py-3 text-base font-medium text-blue-700 shadow-sm hover:bg-blue-50 sm:px-8",
                                                                        children: translation.primaryCta.text
                                                                    }) : null,
                                                                    translation.primaryCta.type === 'external' ? /*#__PURE__*/ (0,jsx_runtime.jsx)("a", {
                                                                        href: translation.primaryCta.href,
                                                                        className: "flex items-center justify-center rounded-md border border-transparent bg-white px-4 py-3 text-base font-medium text-blue-700 shadow-sm hover:bg-blue-50 sm:px-8",
                                                                        rel: "noopener noreferrer",
                                                                        target: "_blank",
                                                                        children: translation.primaryCta.text
                                                                    }) : null,
                                                                    translation.primaryCta.type === 'link' ? /*#__PURE__*/ (0,jsx_runtime.jsx)(next_link["default"], {
                                                                        href: translation.primaryCta.href,
                                                                        children: /*#__PURE__*/ (0,jsx_runtime.jsx)("a", {
                                                                            onClick: trackSignupClickOnHome,
                                                                            className: "flex items-center justify-center rounded-md border border-transparent bg-white px-4 py-3 text-base font-medium text-blue-700 shadow-sm hover:bg-blue-50 sm:px-8",
                                                                            children: translation.primaryCta.text
                                                                        })
                                                                    }) : null,
                                                                    translation.secondaryCta.type === 'anchor' ? /*#__PURE__*/ (0,jsx_runtime.jsx)("a", {
                                                                        href: translation.secondaryCta.href,
                                                                        className: "flex items-center justify-center rounded-md border border-transparent bg-blue-500 bg-opacity-60 px-4 py-3 text-base font-medium text-white shadow-sm hover:bg-opacity-70 sm:px-8",
                                                                        children: translation.secondaryCta.text
                                                                    }) : null,
                                                                    translation.secondaryCta.type === 'external' ? /*#__PURE__*/ (0,jsx_runtime.jsx)("a", {
                                                                        href: translation.secondaryCta.href,
                                                                        className: "flex items-center justify-center rounded-md border border-transparent bg-blue-500 bg-opacity-60 px-4 py-3 text-base font-medium text-white shadow-sm hover:bg-opacity-70 sm:px-8",
                                                                        rel: "noopener noreferrer",
                                                                        target: "_blank",
                                                                        children: translation.secondaryCta.text
                                                                    }) : null,
                                                                    translation.secondaryCta.type === 'link' ? /*#__PURE__*/ (0,jsx_runtime.jsx)(next_link["default"], {
                                                                        href: translation.secondaryCta.href,
                                                                        children: /*#__PURE__*/ (0,jsx_runtime.jsx)("a", {
                                                                            className: "flex items-center justify-center rounded-md border border-transparent bg-blue-500 bg-opacity-60 px-4 py-3 text-base font-medium text-white shadow-sm hover:bg-opacity-70 sm:px-8",
                                                                            children: translation.secondaryCta.text
                                                                        })
                                                                    }) : null
                                                                ]
                                                            })
                                                        })
                                                    ]
                                                })
                                            ]
                                        })
                                    })
                                ]
                            }),
                            /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                className: "bg-gray-100",
                                children: /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                                    className: "mx-auto max-w-7xl py-16 px-4 sm:px-6 lg:px-8",
                                    children: [
                                        /*#__PURE__*/ (0,jsx_runtime.jsx)("p", {
                                            className: "flex justify-center text-center text-sm font-semibold uppercase tracking-wide text-gray-500",
                                            children: translation.logoCloudHeadline
                                        }),
                                        /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                            className: "mt-6 grid grid-cols-4 gap-8",
                                            children: translation.logoCloud
                                        })
                                    ]
                                })
                            }),
                            /*#__PURE__*/ (0,jsx_runtime.jsx)(Testimonial, {
                                id: "first-testimonial-block",
                                firstTestimonial: testimonials[0],
                                secondTestimonial: testimonials[1]
                            }),
                            /*#__PURE__*/ (0,jsx_runtime.jsx)(Alternatives, {
                                packageLength: packageLength,
                                setPackageLength: setPackageLength
                            }),
                            /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                                className: "relative overflow-hidden pt-16 pb-32",
                                id: "features",
                                children: [
                                    /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                        "aria-hidden": "true",
                                        className: "absolute inset-x-0 top-0 h-48 bg-gradient-to-b from-gray-100"
                                    }),
                                    /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                        className: "relative",
                                        children: /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                                            className: "lg:mx-auto lg:grid lg:max-w-7xl lg:grid-flow-col-dense lg:grid-cols-2 lg:gap-24 lg:px-8",
                                            children: [
                                                /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                                                    className: "mx-auto max-w-xl px-4 sm:px-6 lg:mx-0 lg:max-w-none lg:py-16 lg:px-0",
                                                    children: [
                                                        /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                                                            children: [
                                                                /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                                                    children: /*#__PURE__*/ (0,jsx_runtime.jsx)("span", {
                                                                        className: "flex h-12 w-12 items-center justify-center rounded-md bg-gradient-to-r from-purple-600 to-blue-600",
                                                                        children: /*#__PURE__*/ (0,jsx_runtime.jsx)(outline_esm/* TrendingUpIcon */.Zab, {
                                                                            className: "h-6 w-6 text-white",
                                                                            "aria-hidden": "true"
                                                                        })
                                                                    })
                                                                }),
                                                                /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                                                                    className: "mt-6",
                                                                    children: [
                                                                        /*#__PURE__*/ (0,jsx_runtime.jsx)("h2", {
                                                                            className: "text-3xl font-extrabold tracking-tight text-gray-900",
                                                                            children: translation.firstFeature.headline
                                                                        }),
                                                                        /*#__PURE__*/ (0,jsx_runtime.jsx)("p", {
                                                                            className: "mt-4 text-lg text-gray-500",
                                                                            children: translation.firstFeature.description
                                                                        }),
                                                                        /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                                                                            className: "mt-6",
                                                                            children: [
                                                                                translation.firstFeature.cta.type === 'anchor' ? /*#__PURE__*/ (0,jsx_runtime.jsx)("a", {
                                                                                    href: translation.firstFeature.cta.href,
                                                                                    className: "inline-flex rounded-md border border-transparent bg-gradient-to-r from-purple-600 to-blue-600 bg-origin-border px-4 py-2 text-base font-medium text-white shadow-sm hover:from-purple-700 hover:to-blue-700",
                                                                                    children: translation.firstFeature.cta.text
                                                                                }) : null,
                                                                                translation.firstFeature.cta.type === 'external' ? /*#__PURE__*/ (0,jsx_runtime.jsx)("a", {
                                                                                    href: translation.firstFeature.cta.href,
                                                                                    className: "inline-flex rounded-md border border-transparent bg-gradient-to-r from-purple-600 to-blue-600 bg-origin-border px-4 py-2 text-base font-medium text-white shadow-sm hover:from-purple-700 hover:to-blue-700",
                                                                                    rel: "noopener noreferrer",
                                                                                    target: "_blank",
                                                                                    children: translation.firstFeature.cta.text
                                                                                }) : null,
                                                                                translation.firstFeature.cta.type === 'link' ? /*#__PURE__*/ (0,jsx_runtime.jsx)(next_link["default"], {
                                                                                    href: translation.firstFeature.cta.href,
                                                                                    children: /*#__PURE__*/ (0,jsx_runtime.jsx)("a", {
                                                                                        onClick: trackSignupClickOnHome,
                                                                                        className: "inline-flex rounded-md border border-transparent bg-gradient-to-r from-purple-600 to-blue-600 bg-origin-border px-4 py-2 text-base font-medium text-white shadow-sm hover:from-purple-700 hover:to-blue-700",
                                                                                        children: translation.firstFeature.cta.text
                                                                                    })
                                                                                }) : null
                                                                            ]
                                                                        })
                                                                    ]
                                                                })
                                                            ]
                                                        }),
                                                        /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                                            className: "mt-8 border-t border-gray-200 pt-6",
                                                            children: /*#__PURE__*/ (0,jsx_runtime.jsxs)("blockquote", {
                                                                children: [
                                                                    /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                                                        children: /*#__PURE__*/ (0,jsx_runtime.jsx)("p", {
                                                                            className: "text-base text-gray-500",
                                                                            children: "“You do not rise to the level of your goals. You fall to the level of your systems.”"
                                                                        })
                                                                    }),
                                                                    /*#__PURE__*/ (0,jsx_runtime.jsx)("footer", {
                                                                        className: "mt-3",
                                                                        children: /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                                                                            className: "flex items-center space-x-3",
                                                                            children: [
                                                                                /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                                                                    className: "flex-shrink-0",
                                                                                    children: /*#__PURE__*/ (0,jsx_runtime.jsx)(next_image["default"], {
                                                                                        className: "h-6 w-6 rounded-full",
                                                                                        src: james_clear,
                                                                                        alt: "James Clear",
                                                                                        layout: "fixed",
                                                                                        width: 50,
                                                                                        height: 50
                                                                                    })
                                                                                }),
                                                                                /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                                                                    className: "text-base font-medium text-gray-700",
                                                                                    children: translation.jamesClearNote
                                                                                })
                                                                            ]
                                                                        })
                                                                    })
                                                                ]
                                                            })
                                                        })
                                                    ]
                                                }),
                                                /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                                    className: "mt-12 sm:mt-16 lg:mt-0",
                                                    children: /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                                        className: "-mr-48 pl-4 sm:pl-6 md:-mr-16 lg:relative lg:m-0 lg:h-full lg:px-0",
                                                        children: /*#__PURE__*/ (0,jsx_runtime.jsx)("img", {
                                                            className: "w-full rounded-xl shadow-xl ring-1 ring-black ring-opacity-5 lg:absolute lg:left-0 lg:h-full lg:w-auto lg:max-w-none",
                                                            src: "/assets/fredrik-striking-ball.jpg",
                                                            alt: "Player just before hitting the ball"
                                                        })
                                                    })
                                                })
                                            ]
                                        })
                                    }),
                                    /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                        className: "mt-24",
                                        children: /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                                            className: "lg:mx-auto lg:grid lg:max-w-7xl lg:grid-flow-col-dense lg:grid-cols-2 lg:gap-24 lg:px-8",
                                            children: [
                                                /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                                    className: "mx-auto max-w-xl px-4 sm:px-6 lg:col-start-2 lg:mx-0 lg:max-w-none lg:py-32 lg:px-0",
                                                    children: /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                                                        children: [
                                                            /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                                                children: /*#__PURE__*/ (0,jsx_runtime.jsx)("span", {
                                                                    className: "flex h-12 w-12 items-center justify-center rounded-md bg-gradient-to-r from-purple-600 to-blue-600",
                                                                    children: /*#__PURE__*/ (0,jsx_runtime.jsx)(outline_esm/* ChatIcon */.kBi, {
                                                                        className: "h-6 w-6 text-white",
                                                                        "aria-hidden": "true"
                                                                    })
                                                                })
                                                            }),
                                                            /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                                                                className: "mt-6",
                                                                children: [
                                                                    /*#__PURE__*/ (0,jsx_runtime.jsx)("h2", {
                                                                        className: "text-3xl font-extrabold tracking-tight text-gray-900",
                                                                        children: translation.secondFeature.headline
                                                                    }),
                                                                    /*#__PURE__*/ (0,jsx_runtime.jsx)("p", {
                                                                        className: "mt-4 text-lg text-gray-500",
                                                                        children: translation.secondFeature.description
                                                                    }),
                                                                    /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                                                                        className: "mt-6",
                                                                        children: [
                                                                            translation.secondFeature.cta.type === 'anchor' ? /*#__PURE__*/ (0,jsx_runtime.jsx)("a", {
                                                                                href: translation.secondFeature.cta.href,
                                                                                className: "inline-flex rounded-md border border-transparent bg-gradient-to-r from-purple-600 to-blue-600 bg-origin-border px-4 py-2 text-base font-medium text-white shadow-sm hover:from-purple-700 hover:to-blue-700",
                                                                                children: translation.secondFeature.cta.text
                                                                            }) : null,
                                                                            translation.secondFeature.cta.type === 'external' ? /*#__PURE__*/ (0,jsx_runtime.jsx)("a", {
                                                                                href: translation.secondFeature.cta.href,
                                                                                className: "inline-flex rounded-md border border-transparent bg-gradient-to-r from-purple-600 to-blue-600 bg-origin-border px-4 py-2 text-base font-medium text-white shadow-sm hover:from-purple-700 hover:to-blue-700",
                                                                                rel: "noopener noreferrer",
                                                                                target: "_blank",
                                                                                children: translation.secondFeature.cta.text
                                                                            }) : null,
                                                                            translation.secondFeature.cta.type === 'link' ? /*#__PURE__*/ (0,jsx_runtime.jsx)(next_link["default"], {
                                                                                href: translation.secondFeature.cta.href,
                                                                                children: /*#__PURE__*/ (0,jsx_runtime.jsx)("a", {
                                                                                    onClick: trackSignupClickOnHome,
                                                                                    className: "inline-flex rounded-md border border-transparent bg-gradient-to-r from-purple-600 to-blue-600 bg-origin-border px-4 py-2 text-base font-medium text-white shadow-sm hover:from-purple-700 hover:to-blue-700",
                                                                                    children: translation.secondFeature.cta.text
                                                                                })
                                                                            }) : null
                                                                        ]
                                                                    })
                                                                ]
                                                            })
                                                        ]
                                                    })
                                                }),
                                                /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                                    className: "mt-12 sm:mt-16 lg:col-start-1 lg:mt-0",
                                                    children: /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                                        className: "-ml-48 pr-4 sm:pr-6 md:-ml-16 lg:relative lg:m-0 lg:h-full lg:px-0",
                                                        children: /*#__PURE__*/ (0,jsx_runtime.jsx)("img", {
                                                            className: "w-full rounded-xl shadow-xl ring-1 ring-black ring-opacity-5 lg:absolute lg:right-0 lg:h-full lg:w-auto lg:max-w-none",
                                                            src: "/assets/martin-hitting-the-ball.jpg",
                                                            alt: "Player hitting the ball"
                                                        })
                                                    })
                                                })
                                            ]
                                        })
                                    })
                                ]
                            }),
                            /*#__PURE__*/ (0,jsx_runtime.jsx)(Testimonial, {
                                id: "second-testimonial-block",
                                firstTestimonial: testimonials[2],
                                secondTestimonial: testimonials[3]
                            }),
                            /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                className: "bg-gradient-to-r from-purple-800 to-blue-700",
                                children: /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                                    className: "mx-auto max-w-4xl px-4 py-16 sm:px-6 sm:pt-20 sm:pb-24 lg:max-w-7xl lg:px-8 lg:pt-24",
                                    children: [
                                        /*#__PURE__*/ (0,jsx_runtime.jsx)("h2", {
                                            className: "text-3xl font-extrabold tracking-tight text-white",
                                            children: translation.featuresHeadline
                                        }),
                                        /*#__PURE__*/ (0,jsx_runtime.jsx)("p", {
                                            className: "mt-4 max-w-3xl text-lg text-purple-200",
                                            children: translation.featuresDescription
                                        }),
                                        /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                            className: "mt-12 grid grid-cols-1 gap-x-6 gap-y-12 sm:grid-cols-2 lg:mt-16 lg:grid-cols-4 lg:gap-x-8 lg:gap-y-16",
                                            children: translation.features.map(function(feature) {
                                                /*#__PURE__*/ return (0,jsx_runtime.jsxs)("div", {
                                                    children: [
                                                        /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                                            children: /*#__PURE__*/ (0,jsx_runtime.jsx)("span", {
                                                                className: "flex h-12 w-12 items-center justify-center rounded-md bg-white bg-opacity-10",
                                                                children: /*#__PURE__*/ (0,jsx_runtime.jsx)(feature.icon, {
                                                                    className: "h-6 w-6 text-white",
                                                                    "aria-hidden": "true"
                                                                })
                                                            })
                                                        }),
                                                        /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                                                            className: "mt-6",
                                                            children: [
                                                                /*#__PURE__*/ (0,jsx_runtime.jsx)("h3", {
                                                                    className: "text-lg font-medium text-white",
                                                                    children: feature.name
                                                                }),
                                                                /*#__PURE__*/ (0,jsx_runtime.jsx)("p", {
                                                                    className: "mt-2 text-base text-purple-200",
                                                                    children: feature.description
                                                                })
                                                            ]
                                                        })
                                                    ]
                                                }, feature.name);
                                            })
                                        })
                                    ]
                                })
                            }),
                            /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                                className: "relative bg-gray-900",
                                children: [
                                    /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                        className: "absolute inset-x-0 bottom-0 h-80 xl:top-0 xl:h-full",
                                        children: /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                            className: "h-full w-full xl:grid xl:grid-cols-2",
                                            children: /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                                                className: "h-full xl:relative xl:col-start-2",
                                                children: [
                                                    /*#__PURE__*/ (0,jsx_runtime.jsx)("img", {
                                                        className: "h-full w-full object-cover opacity-25 xl:absolute xl:inset-0",
                                                        src: "/assets/hermes-lots-of-balls-on-court.jpg",
                                                        alt: "Lots of balls on the court"
                                                    }),
                                                    /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                                        "aria-hidden": "true",
                                                        className: "absolute inset-x-0 top-0 h-32 bg-gradient-to-b from-gray-900 xl:inset-y-0 xl:left-0 xl:h-full xl:w-32 xl:bg-gradient-to-r"
                                                    })
                                                ]
                                            })
                                        })
                                    }),
                                    /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                        className: "mx-auto max-w-4xl px-4 sm:px-6 lg:max-w-7xl lg:px-8 xl:grid xl:grid-flow-col-dense xl:grid-cols-2 xl:gap-x-8",
                                        children: /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                                            className: "relative pt-12 pb-64 sm:pt-24 sm:pb-64 xl:col-start-1 xl:pb-24",
                                            children: [
                                                /*#__PURE__*/ (0,jsx_runtime.jsx)("h2", {
                                                    className: "text-sm font-semibold uppercase tracking-wide",
                                                    children: /*#__PURE__*/ (0,jsx_runtime.jsx)("span", {
                                                        className: "bg-gradient-to-r from-purple-300 to-blue-300 bg-clip-text text-transparent",
                                                        children: translation.metricsSubline
                                                    })
                                                }),
                                                /*#__PURE__*/ (0,jsx_runtime.jsx)("p", {
                                                    className: "mt-3 text-3xl font-extrabold text-white",
                                                    children: translation.metricsHeadline
                                                }),
                                                /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                                    className: "text-md prose mt-5 text-gray-300",
                                                    children: translation.metricsDescription
                                                }),
                                                /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                                    className: "mt-12 grid grid-cols-1 gap-y-12 gap-x-6 sm:grid-cols-2",
                                                    children: translation.metrics.map(function(item) {
                                                        /*#__PURE__*/ return (0,jsx_runtime.jsxs)("p", {
                                                            children: [
                                                                /*#__PURE__*/ (0,jsx_runtime.jsx)("span", {
                                                                    className: "block text-2xl font-bold text-white",
                                                                    children: item.stat
                                                                }),
                                                                /*#__PURE__*/ (0,jsx_runtime.jsxs)("span", {
                                                                    className: "mt-1 block text-base text-gray-300",
                                                                    children: [
                                                                        /*#__PURE__*/ (0,jsx_runtime.jsx)("span", {
                                                                            className: "font-medium text-white",
                                                                            children: item.emphasis
                                                                        }),
                                                                        " ",
                                                                        item.rest
                                                                    ]
                                                                })
                                                            ]
                                                        }, item.id);
                                                    })
                                                })
                                            ]
                                        })
                                    })
                                ]
                            }),
                            /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                className: "bg-indigo-700",
                                children: /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                                    className: "mx-auto max-w-3xl py-16 px-4 text-center sm:py-20 sm:px-6 lg:px-8",
                                    children: [
                                        /*#__PURE__*/ (0,jsx_runtime.jsxs)("h2", {
                                            className: "text-3xl font-extrabold text-white sm:text-4xl",
                                            children: [
                                                /*#__PURE__*/ (0,jsx_runtime.jsx)("span", {
                                                    className: "block",
                                                    children: translation.companySignupCta.headlinePartOne
                                                }),
                                                /*#__PURE__*/ (0,jsx_runtime.jsx)("span", {
                                                    className: "block",
                                                    children: translation.companySignupCta.headlinePartTwo
                                                })
                                            ]
                                        }),
                                        /*#__PURE__*/ (0,jsx_runtime.jsx)("p", {
                                            className: "mt-4 text-lg leading-6 text-indigo-200",
                                            children: (0,lodash.replace)(translation.companySignupCta.description, '{{packageLength}}', "".concat(packageLength))
                                        }),
                                        translation.companySignupCta.button.type === 'anchor' ? /*#__PURE__*/ (0,jsx_runtime.jsx)("a", {
                                            href: translation.companySignupCta.button.href,
                                            onClick: trackSignupClickOnHome,
                                            className: "mt-8 inline-flex w-full items-center justify-center rounded-md border border-transparent bg-white px-5 py-3 text-base font-medium text-indigo-600 hover:bg-indigo-50 sm:w-auto",
                                            children: translation.companySignupCta.button.text
                                        }) : null,
                                        translation.companySignupCta.button.type === 'external' ? /*#__PURE__*/ (0,jsx_runtime.jsx)("a", {
                                            href: translation.companySignupCta.button.href,
                                            onClick: trackSignupClickOnHome,
                                            className: "mt-8 inline-flex w-full items-center justify-center rounded-md border border-transparent bg-white px-5 py-3 text-base font-medium text-indigo-600 hover:bg-indigo-50 sm:w-auto",
                                            rel: "noopener noreferrer",
                                            target: "_blank",
                                            children: translation.companySignupCta.button.text
                                        }) : null,
                                        translation.companySignupCta.button.type === 'link' ? /*#__PURE__*/ (0,jsx_runtime.jsx)("a", {
                                            href: translation.companySignupCta.button.href,
                                            onClick: trackSignupClickOnHome,
                                            className: "mt-8 inline-flex w-full items-center justify-center rounded-md border border-transparent bg-white px-5 py-3 text-base font-medium text-indigo-600 hover:bg-indigo-50 sm:w-auto",
                                            children: translation.companySignupCta.button.text
                                        }) : null
                                    ]
                                })
                            }),
                            /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                className: "bg-white",
                                children: /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                                    className: "mx-auto max-w-4xl py-16 px-4 sm:px-6 sm:py-24 lg:flex lg:max-w-7xl lg:items-center lg:justify-between lg:px-8",
                                    children: [
                                        /*#__PURE__*/ (0,jsx_runtime.jsxs)("h2", {
                                            className: "text-4xl font-extrabold tracking-tight text-gray-900 sm:text-4xl",
                                            children: [
                                                /*#__PURE__*/ (0,jsx_runtime.jsx)("span", {
                                                    className: "block",
                                                    children: translation.bottomCta.prompt
                                                }),
                                                /*#__PURE__*/ (0,jsx_runtime.jsx)("span", {
                                                    className: "block bg-gradient-to-r from-purple-600 to-blue-600 bg-clip-text text-transparent",
                                                    children: translation.bottomCta.headline
                                                })
                                            ]
                                        }),
                                        /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                                            className: "mt-6 space-y-4 sm:flex sm:space-y-0 sm:space-x-5",
                                            children: [
                                                translation.bottomCta.primaryButton.type === 'anchor' ? /*#__PURE__*/ (0,jsx_runtime.jsx)("a", {
                                                    href: translation.bottomCta.primaryButton.href,
                                                    className: "flex items-center justify-center rounded-md border border-transparent bg-gradient-to-r from-purple-600 to-blue-600 bg-origin-border px-4 py-3 text-base font-medium text-white shadow-sm hover:from-purple-700 hover:to-blue-700",
                                                    children: translation.bottomCta.primaryButton.text
                                                }) : null,
                                                translation.bottomCta.primaryButton.type === 'link' ? /*#__PURE__*/ (0,jsx_runtime.jsx)(next_link["default"], {
                                                    href: translation.bottomCta.primaryButton.href,
                                                    children: /*#__PURE__*/ (0,jsx_runtime.jsx)("a", {
                                                        className: "flex items-center justify-center rounded-md border border-transparent bg-gradient-to-r from-purple-600 to-blue-600 bg-origin-border px-4 py-3 text-base font-medium text-white shadow-sm hover:from-purple-700 hover:to-blue-700",
                                                        children: translation.bottomCta.primaryButton.text
                                                    })
                                                }) : null,
                                                translation.bottomCta.secondaryButton.type === 'anchor' ? /*#__PURE__*/ (0,jsx_runtime.jsx)("a", {
                                                    onClick: trackSignupClickOnHome,
                                                    href: translation.bottomCta.secondaryButton.href,
                                                    className: "flex items-center justify-center rounded-md border border-transparent bg-blue-50 px-4 py-3 text-base font-medium text-blue-800 shadow-sm hover:bg-blue-100",
                                                    children: translation.bottomCta.secondaryButton.text
                                                }) : null,
                                                translation.bottomCta.secondaryButton.type === 'link' ? /*#__PURE__*/ (0,jsx_runtime.jsx)(next_link["default"], {
                                                    href: translation.bottomCta.secondaryButton.href,
                                                    children: /*#__PURE__*/ (0,jsx_runtime.jsx)("a", {
                                                        onClick: trackSignupClickOnHome,
                                                        className: "flex items-center justify-center rounded-md border border-transparent bg-blue-50 px-4 py-3 text-base font-medium text-blue-800 shadow-sm hover:bg-blue-100",
                                                        children: translation.bottomCta.secondaryButton.text
                                                    })
                                                }) : null
                                            ]
                                        })
                                    ]
                                })
                            })
                        ]
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)(Footer, {})
                ]
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)(SeasonEndResultBanner, {})
        ]
    }));
};

;// CONCATENATED MODULE: ./components/ds/05-pages/signup/translations.tsx

var signup_translations_translations = {
    sv: {
        pageTitle: 'Anm\xe4lan |\xa0\xd6-viks N\xe4tverkspadel',
        pageDescription: 'V\xe4lkommen med din anm\xe4lan. Vi f\xf6rv\xe4ntar oss att intresset kommer vara stort s\xe5 boka din plats idag.',
        headline: 'Boka din plats nu.',
        subline: 'Anm\xe4lan',
        description: 'Vi f\xf6rv\xe4ntar oss att intresset kommer vara stort s\xe5 boka din plats idag.',
        secondSubline: 'Allt du beh\xf6ver',
        secondHeadline: 'Du beh\xf6ver bara dyka upp',
        priceHeadline: 'Pris',
        priceTenWeeks: 2999,
        priceFiveWeeks: 1499,
        currencySuffix: 'kr',
        priceInclusive: 'inkl. 6% moms.',
        priceExclusive: 'exkl. moms.',
        partnersHeadline: 'I samarbete mellan dessa partners',
        faqHeadline: 'Vanliga fr\xe5gor',
        faqs: [
            {
                id: 1,
                question: 'Men jag \xe4r inte s\xe5 bra, kan jag \xe4nd\xe5 vara med?',
                answer: 'Sj\xe4lvklart. H\xe4ng med och l\xe4r dig p\xe5 v\xe4gen, se till att vara \xf6ppen f\xf6r tips och tr\xe4na p\xe5.'
            },
            {
                id: 2,
                question: 'N\xe4tverka? Jag tror inte jag beh\xf6ver det f\xf6r mitt jobb.',
                answer: 'Att knyta kontakter \xe4r aldrig fel. Du vet inte vad som h\xe4nder i framtiden.'
            },
            {
                id: 3,
                question: '06:30, varf\xf6r s\xe5 tidigt?',
                answer: 'Vi vet att alla har mycket att g\xf6ra och vi \xe4r \xf6vertygade att om man f\xe5r in det i kalendern blir det f\xf6ruts\xe4gbart. \xc4ven om man, som vi, har familjepussel att styra upp.'
            },
            {
                id: 4,
                question: 'M\xe5ste jag vara med alla g\xe5nger?',
                answer: 'Nej det beh\xf6ver du inte. Du \xe4r garanterad att f\xe5 spela 12 timmar, dvs 8 av 10 g\xe5nger. Men om du endast har tid med 6 \xe4r det helt OK. '
            },
            {
                id: 5,
                question: 'Finns det n\xe5got alternativ om jag vill spela men inte kan alla g\xe5nger?',
                answer: 'Ja! Anm\xe4l ditt f\xf6retag och sedan kan ni dela upp passen mellan er. Varje match samlar ni ihop po\xe4ng och t\xe4vlar mot andra f\xf6retag.'
            }, 
        ],
        features: [
            {
                name: 'B\xf6rja med anm\xe4lan',
                description: 'F\xf6rsta steget \xe4r att genomf\xf6ra din anm\xe4lan. F\xf6rst till kvarn g\xe4ller. Vi har 24 platser.',
                icon: outline_esm/* ArrowCircleDownIcon */.shm
            },
            {
                name: 'Hantera betalning',
                description: 'Vi kommer h\xf6ra av oss till dig p\xe5 mejl f\xf6r att hantera betalning. Din anm\xe4lan \xe4r inte bekr\xe4ftad f\xf6rr\xe4n betalning \xe4r klar.',
                icon: outline_esm/* ArrowCircleDownIcon */.shm
            },
            {
                name: 'Boka in i kalendern',
                description: 'Nu \xe4r du anm\xe4ld och du kan b\xf6rja stretcha och f\xf6rbereda dig f\xf6r den f\xf6rsta matchen.',
                icon: outline_esm/* ArrowCircleDownIcon */.shm
            },
            {
                name: 'Ta vara p\xe5 chansen',
                description: 'Ha kul, ta det inte p\xe5 f\xf6r stort allvar, skapa m\xe5nga nya kontakter.',
                icon: outline_esm/* CheckCircleIcon */.rE2
            }, 
        ]
    },
    en: {
        pageTitle: 'Anm\xe4lan |\xa0\xd6-viks N\xe4tverkspadel',
        pageDescription: 'V\xe4lkommen med din anm\xe4lan. Vi f\xf6rv\xe4ntar oss att intresset kommer vara stort s\xe5 boka din plats idag.',
        headline: 'Boka din plats nu.',
        subline: 'Anm\xe4lan',
        description: 'Vi f\xf6rv\xe4ntar oss att intresset kommer vara stort s\xe5 boka din plats idag.',
        secondSubline: 'Allt du beh\xf6ver',
        secondHeadline: 'Du beh\xf6ver bara dyka upp',
        priceHeadline: 'Pris',
        priceTenWeeks: 2999,
        priceFiveWeeks: 1499,
        currencySuffix: 'kr',
        priceInclusive: 'inkl. 6% moms.',
        priceExclusive: 'exkl. moms.',
        partnersHeadline: 'I samarbete mellan dessa partners',
        faqHeadline: 'Vanliga fr\xe5gor',
        faqs: [
            {
                id: 1,
                question: 'Men jag \xe4r inte s\xe5 bra, kan jag \xe4nd\xe5 vara med?',
                answer: 'Sj\xe4lvklart. H\xe4ng med och l\xe4r dig p\xe5 v\xe4gen, se till att vara \xf6ppen f\xf6r tips och tr\xe4na p\xe5.'
            },
            {
                id: 2,
                question: 'N\xe4tverka? Jag tror inte jag beh\xf6ver det f\xf6r mitt jobb.',
                answer: 'Att knyta kontakter \xe4r aldrig fel. Du vet inte vad som h\xe4nder i framtiden.'
            },
            {
                id: 3,
                question: '06:30, varf\xf6r s\xe5 tidigt?',
                answer: 'Vi vet att alla har mycket att g\xf6ra och vi \xe4r \xf6vertygade att om man f\xe5r in det i kalendern blir det f\xf6ruts\xe4gbart. \xc4ven om man, som vi, har familjepussel att styra upp.'
            },
            {
                id: 4,
                question: 'M\xe5ste jag vara med alla g\xe5nger?',
                answer: 'Nej det beh\xf6ver du inte. Du \xe4r garanterad att f\xe5 spela 12 timmar, dvs 8 av 10 g\xe5nger. Men om du endast har tid med 6 \xe4r det helt OK. '
            },
            {
                id: 5,
                question: 'Finns det n\xe5got alternativ om jag vill spela men inte kan alla g\xe5nger?',
                answer: 'Ja! Anm\xe4l ditt f\xf6retag och sedan kan ni dela upp passen mellan er. Varje match samlar ni ihop po\xe4ng och t\xe4vlar mot andra f\xf6retag.'
            }, 
        ],
        features: [
            {
                name: 'B\xf6rja med anm\xe4lan',
                description: 'F\xf6rsta steget \xe4r att genomf\xf6ra din anm\xe4lan. F\xf6rst till kvarn g\xe4ller. Vi har 24 platser.',
                icon: outline_esm/* ArrowCircleDownIcon */.shm
            },
            {
                name: 'Hantera betalning',
                description: 'Vi kommer h\xf6ra av oss till dig p\xe5 mejl f\xf6r att hantera betalning. Din anm\xe4lan \xe4r inte bekr\xe4ftad f\xf6rr\xe4n betalning \xe4r klar.',
                icon: outline_esm/* ArrowCircleDownIcon */.shm
            },
            {
                name: 'Boka in i kalendern',
                description: 'Nu \xe4r du anm\xe4ld och du kan b\xf6rja stretcha och f\xf6rbereda dig f\xf6r den f\xf6rsta matchen.',
                icon: outline_esm/* ArrowCircleDownIcon */.shm
            },
            {
                name: 'Ta vara p\xe5 chansen',
                description: 'Ha kul, ta det inte p\xe5 f\xf6r stort allvar, skapa m\xe5nga nya kontakter.',
                icon: outline_esm/* CheckCircleIcon */.rE2
            }, 
        ]
    }
};

;// CONCATENATED MODULE: ./components/ds/05-pages/signup/signup-form/form/types.ts
var form_types_translations = {
    sv: {
        fields: {
            company: {
                label: 'Vilket f\xf6retag representerar du?',
                placeholder: 'Skriv f\xf6retagsnamn eller organisationsnummer',
                validation: {
                    short: 'F\xf6retaget \xe4r f\xf6r kort',
                    long: 'F\xf6retaget \xe4r f\xf6r l\xe5ngt',
                    required: 'F\xf6retaget saknas'
                }
            },
            name: {
                label: 'Vad \xe4r ditt namn?',
                placeholder: 'Ted Lasso',
                validation: {
                    short: 'Namnet \xe4r f\xf6r kort',
                    long: 'Namnet \xe4r f\xf6r l\xe5ngt',
                    required: 'Namnet saknas'
                }
            },
            email: {
                label: 'Vad \xe4r din mejladress?',
                placeholder: 'ted@example.se',
                validation: {
                    short: 'E-postadressen \xe4r f\xf6r kort',
                    long: 'E-postadressen \xe4r f\xf6r l\xe5ng',
                    format: 'E-postadressen har ogiltigt format',
                    required: 'E-postadressen saknas'
                }
            },
            phone: {
                label: 'Vad \xe4r ditt telefonnummer?',
                placeholder: 'Skriv ditt telefonummer',
                validation: {
                    short: 'Telefonnumret \xe4r f\xf6r kort',
                    long: 'Telefonnumret \xe4r f\xf6r l\xe5ngt',
                    required: 'Telefonnumret saknas'
                }
            },
            group: {
                label: 'Vilken grupp \xe4r du intressad av?',
                placeholder: '',
                validation: {
                    short: 'Grupp \xe4r f\xf6r kort',
                    long: 'Grupp \xe4r f\xf6r l\xe5ngt',
                    required: 'Grupp saknas'
                }
            },
            series_length: {
                label: 'N\xe4r vill du starta?',
                placeholder: '',
                validation: {
                    short: 'L\xe4ngd \xe4r f\xf6r kort',
                    long: 'L\xe4ngd \xe4r f\xf6r l\xe5ngt',
                    required: 'L\xe4ngd saknas'
                }
            },
            quantity: {
                label: 'Hur m\xe5nga platser vill du boka?',
                placeholder: '',
                validation: {
                    short: 'Antalet \xe4r f\xf6r f\xe5',
                    long: 'Antalet \xe4r f\xf6r m\xe5nga',
                    required: 'Antal saknas'
                }
            }
        },
        button: {
            text: 'Skicka'
        },
        error: {
            headline: 'Det var ett problem med din anm\xe4lan'
        },
        success: {
            headline: 'Tack f\xf6r din anm\xe4lan. Vi h\xf6r av oss.'
        }
    },
    en: {
        fields: {
            company: {
                label: 'Vilket f\xf6retag representerar du?',
                placeholder: 'Skriv f\xf6retagsnamn eller organisationsnummer',
                validation: {
                    short: 'F\xf6retaget \xe4r f\xf6r kort',
                    long: 'F\xf6retaget \xe4r f\xf6r l\xe5ngt',
                    required: 'F\xf6retaget saknas'
                }
            },
            name: {
                label: 'Vad \xe4r ditt namn?',
                placeholder: 'Ted Lasso',
                validation: {
                    short: 'Namnet \xe4r f\xf6r kort',
                    long: 'Namnet \xe4r f\xf6r l\xe5ngt',
                    required: 'Namnet saknas'
                }
            },
            email: {
                label: 'Vad \xe4r din mejladress?',
                placeholder: 'ted@example.se',
                validation: {
                    short: 'E-postadressen \xe4r f\xf6r kort',
                    long: 'E-postadressen \xe4r f\xf6r l\xe5ng',
                    format: 'E-postadressen har ogiltigt format',
                    required: 'E-postadressen saknas'
                }
            },
            phone: {
                label: 'Vad \xe4r ditt telefonnummer?',
                placeholder: 'Skriv ditt telefonummer',
                validation: {
                    short: 'Telefonnumret \xe4r f\xf6r kort',
                    long: 'Telefonnumret \xe4r f\xf6r l\xe5ngt',
                    required: 'Telefonnumret saknas'
                }
            },
            group: {
                label: 'Vilken grupp \xe4r du intressad av?',
                placeholder: '',
                validation: {
                    short: 'Grupp \xe4r f\xf6r kort',
                    long: 'Grupp \xe4r f\xf6r l\xe5ngt',
                    required: 'Grupp saknas'
                }
            },
            series_length: {
                label: 'N\xe4r vill du starta?',
                placeholder: '',
                validation: {
                    short: 'L\xe4ngd \xe4r f\xf6r kort',
                    long: 'L\xe4ngd \xe4r f\xf6r l\xe5ngt',
                    required: 'L\xe4ngd saknas'
                }
            },
            quantity: {
                label: 'Hur m\xe5nga platser vill du boka?',
                placeholder: '',
                validation: {
                    short: 'Antalet \xe4r f\xf6r f\xe5',
                    long: 'Antalet \xe4r f\xf6r m\xe5nga',
                    required: 'Antal saknas'
                }
            }
        },
        button: {
            text: 'Send'
        },
        error: {
            headline: 'There was an error with your submission.'
        },
        success: {
            headline: "Thank you for your submission. We'll be in touch"
        }
    }
};

;// CONCATENATED MODULE: ./components/ds/05-pages/signup/signup-form/form/index.tsx


/* eslint-disable @next/next/no-img-element */ 









function signup_form_form_asyncGeneratorStep(gen, resolve, reject, _next, _throw, key, arg) {
    try {
        var info = gen[key](arg);
        var value = info.value;
    } catch (error) {
        reject(error);
        return;
    }
    if (info.done) {
        resolve(value);
    } else {
        Promise.resolve(value).then(_next, _throw);
    }
}
function signup_form_form_asyncToGenerator(fn) {
    return function() {
        var self = this, args = arguments;
        return new Promise(function(resolve, reject) {
            var gen = fn.apply(self, args);
            function _next(value) {
                signup_form_form_asyncGeneratorStep(gen, resolve, reject, _next, _throw, "next", value);
            }
            function _throw(err) {
                signup_form_form_asyncGeneratorStep(gen, resolve, reject, _next, _throw, "throw", err);
            }
            _next(undefined);
        });
    };
}
function signup_form_form_defineProperty(obj, key, value) {
    if (key in obj) {
        Object.defineProperty(obj, key, {
            value: value,
            enumerable: true,
            configurable: true,
            writable: true
        });
    } else {
        obj[key] = value;
    }
    return obj;
}
function signup_form_form_instanceof(left, right) {
    if (right != null && typeof Symbol !== "undefined" && right[Symbol.hasInstance]) {
        return right[Symbol.hasInstance](left);
    } else {
        return left instanceof right;
    }
}
function signup_form_form_objectSpread(target) {
    for(var i = 1; i < arguments.length; i++){
        var source = arguments[i] != null ? arguments[i] : {};
        var ownKeys = Object.keys(source);
        if (typeof Object.getOwnPropertySymbols === "function") {
            ownKeys = ownKeys.concat(Object.getOwnPropertySymbols(source).filter(function(sym) {
                return Object.getOwnPropertyDescriptor(source, sym).enumerable;
            }));
        }
        ownKeys.forEach(function(key) {
            signup_form_form_defineProperty(target, key, source[key]);
        });
    }
    return target;
}
var SignupForm = function(param1) {
    var seriesGroup = param1.seriesGroup, seriesLength = param1.seriesLength, user = param1.user;
    var trackSubmitSignupForm = useFathomEvents().trackSubmitSignupForm;
    var ref = (0,react.useState)(), error = ref[0], setError = ref[1];
    var ref1 = (0,react.useState)(), status = ref1[0], setStatus = ref1[1];
    var router = (0,next_router.useRouter)();
    var locale = (0,utils_locale/* makeLocale */.W)(router.locale, router.defaultLocale) || 'sv';
    var translation = form_types_translations[locale];
    var reset = function() {
        setError(undefined);
        setStatus('pristine');
    };
    var initialValues = {
        company: '',
        name: user && user.name ? user.name : '',
        email: user && user.email ? user.email : '',
        phone: '',
        group: seriesGroup ? seriesGroup : 'morning',
        series_length: seriesLength ? seriesLength : '10weeks',
        quantity: 1,
        application_bot_field: ''
    };
    var ValidationSchema = es/* object */.Ry().shape({
        company: es/* string */.Z_().min(2, translation.fields.company.validation.short).max(40, translation.fields.company.validation.long).trim().required(translation.fields.company.validation.required),
        name: es/* string */.Z_().min(2, translation.fields.name.validation.short).max(40, translation.fields.name.validation.long).trim().required(translation.fields.name.validation.required),
        email: es/* string */.Z_().min(2, translation.fields.email.validation.short).max(40, translation.fields.email.validation.long).email(translation.fields.email.validation.format).trim().lowercase().required(translation.fields.email.validation.required),
        phone: es/* string */.Z_().min(5, translation.fields.phone.validation.short).max(12, translation.fields.phone.validation.long).trim().required(translation.fields.phone.validation.required),
        group: es/* string */.Z_().min(2, translation.fields.group.validation.short).max(20, translation.fields.group.validation.long).trim().lowercase().required(translation.fields.group.validation.required),
        series_length: es/* string */.Z_().min(2, translation.fields.series_length.validation.short).max(10, translation.fields.series_length.validation.long).trim().lowercase().required(translation.fields.series_length.validation.required),
        quantity: es/* number */.Rx().min(1, translation.fields.quantity.validation.short).max(10, translation.fields.quantity.validation.long)
    });
    return(/*#__PURE__*/ (0,jsx_runtime.jsxs)(jsx_runtime.Fragment, {
        children: [
            status === 'ok' ? /*#__PURE__*/ (0,jsx_runtime.jsx)(SuccessAlert, {
                translations: {
                    headline: translation.success.headline
                },
                reset: reset
            }) : null,
            status === 'not_ok' && error ? /*#__PURE__*/ (0,jsx_runtime.jsx)(ErrorAlert, {
                translations: {
                    headline: translation.error.headline
                },
                error: error,
                reset: reset
            }) : null,
            /*#__PURE__*/ (0,jsx_runtime.jsx)(formik_esm/* Formik */.J9, {
                initialValues: initialValues,
                validationSchema: ValidationSchema,
                enableReinitialize: true,
                onSubmit: function() {
                    var _ref = signup_form_form_asyncToGenerator(runtime_default().mark(function _callee(values, actions) {
                        var signupRes, signupResData;
                        return runtime_default().wrap(function _callee$(_ctx) {
                            while(1)switch(_ctx.prev = _ctx.next){
                                case 0:
                                    _ctx.prev = 0;
                                    trackSubmitSignupForm();
                                    _ctx.next = 4;
                                    return fetch('/api/signup', {
                                        method: 'POST',
                                        body: JSON.stringify({
                                            company: values.company,
                                            name: values.name,
                                            email: values.email,
                                            phone: values.phone,
                                            group: values.group,
                                            series_length: values.series_length,
                                            quantity: values.quantity,
                                            application_bot_field: values.application_bot_field
                                        }),
                                        headers: {
                                            'Content-Type': 'application/json'
                                        }
                                    });
                                case 4:
                                    signupRes = _ctx.sent;
                                    if (!(signupRes.status !== 200)) {
                                        _ctx.next = 11;
                                        break;
                                    }
                                    setStatus('not_ok');
                                    setError(new Error('Non 200 response from backend'));
                                    actions.resetForm();
                                    actions.setSubmitting(false);
                                    return _ctx.abrupt("return");
                                case 11:
                                    if (!(signupRes.status === 200 && signupRes.redirected)) {
                                        _ctx.next = 17;
                                        break;
                                    }
                                    actions.resetForm();
                                    actions.setSubmitting(false);
                                    return _ctx.abrupt("return", router.push(signupRes.url));
                                case 17:
                                    _ctx.next = 19;
                                    return signupRes.json();
                                case 19:
                                    signupResData = _ctx.sent;
                                    if (!signupResData.success) {
                                        setStatus('not_ok');
                                        setError(new Error(signupResData.code));
                                        actions.resetForm();
                                        actions.setSubmitting(false);
                                    } else {
                                        setStatus('ok');
                                        actions.resetForm();
                                        actions.setSubmitting(false);
                                        if (signupResData.redirect_to_survey) {
                                            location.href = "https://forms.reform.app/gLNw4a/post-signup-survey/7waj93?4f0ae710-16a4-4f25-8437-c2b710573148=".concat(encodeURIComponent(values.company));
                                        } else {
                                            router.push('/signup/success');
                                        }
                                    }
                                case 21:
                                    _ctx.next = 29;
                                    break;
                                case 23:
                                    _ctx.prev = 23;
                                    _ctx.t0 = _ctx["catch"](0);
                                    setStatus('not_ok');
                                    if (signup_form_form_instanceof(_ctx.t0, Error)) {
                                        setError(_ctx.t0);
                                    } else {
                                        setError(new Error('Signup failed due to a unknown error'));
                                    }
                                    actions.resetForm();
                                    actions.setSubmitting(false);
                                case 29:
                                case "end":
                                    return _ctx.stop();
                            }
                        }, _callee, null, [
                            [
                                0,
                                23
                            ]
                        ]);
                    }));
                    return function(values, actions) {
                        return _ref.apply(this, arguments);
                    };
                }(),
                children: function(formikBag) {
                    var products = [
                        {
                            id: 1,
                            name: 'T\xe4vlingsanm\xe4lan \xd6-viks N\xe4tverkspadel',
                            price: formikBag.values.series_length === '10weeks' ? 299900 : formikBag.values.series_length === '5weeks' ? 149900 : 299900,
                            descriptionLine1: formikBag.values.series_length === '10weeks' ? '10 veckor med start 21 september' : formikBag.values.series_length === '5weeks' ? '5 veckor med start 21 september' : '10 veckor med start 21 september',
                            descriptionLine2: formikBag.values.group === 'morning' ? 'Morgon - 07:00' : formikBag.values.group === 'lunch' ? 'Lunch - 11:30' : 'Morgon - 07:00',
                            imageSrc: '/logo/np-logo.svg',
                            imageAlt: 'N\xe4tverkspadel logo'
                        }, 
                    ];
                    var totalPrice = (0,lodash.reduce)(products, function(sum, product) {
                        return sum + product.price;
                    }, 0) * formikBag.values.quantity;
                    var totalWithSalesTax = (0,lodash.round)(totalPrice * 1.06 / 100, 0);
                    var justSalesTax = (0,lodash.round)((totalPrice * 1.06 - totalPrice) / 100, 2);
                    var roundedTotalPrice = (0,lodash.round)(totalPrice / 100, 0);
                    return(/*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                        className: "bg-white",
                        children: [
                            /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                className: "fixed top-0 left-0 hidden h-full w-1/2 bg-white lg:block",
                                "aria-hidden": "true"
                            }),
                            /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                className: "fixed top-0 right-0 hidden h-full w-1/2 bg-indigo-900 lg:block",
                                "aria-hidden": "true"
                            }),
                            /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                                className: "relative mx-auto grid max-w-7xl grid-cols-1 gap-x-16 lg:grid-cols-2 lg:px-8 lg:pt-16",
                                children: [
                                    /*#__PURE__*/ (0,jsx_runtime.jsx)("h1", {
                                        className: "sr-only",
                                        children: "Checkout"
                                    }),
                                    /*#__PURE__*/ (0,jsx_runtime.jsx)("section", {
                                        "aria-labelledby": "summary-heading",
                                        className: "bg-indigo-900 py-12 text-indigo-300 md:px-10 lg:col-start-2 lg:row-start-1 lg:mx-auto lg:w-full lg:max-w-lg lg:bg-transparent lg:px-0 lg:pt-0 lg:pb-24",
                                        children: /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                                            className: "mx-auto max-w-2xl px-4 lg:max-w-none lg:px-0",
                                            children: [
                                                /*#__PURE__*/ (0,jsx_runtime.jsx)("h2", {
                                                    id: "summary-heading",
                                                    className: "sr-only",
                                                    children: "Order summary"
                                                }),
                                                /*#__PURE__*/ (0,jsx_runtime.jsxs)("dl", {
                                                    children: [
                                                        /*#__PURE__*/ (0,jsx_runtime.jsx)("dt", {
                                                            className: "text-sm font-medium",
                                                            children: "Pris"
                                                        }),
                                                        /*#__PURE__*/ (0,jsx_runtime.jsxs)("dd", {
                                                            className: "mt-1 text-3xl font-extrabold text-white",
                                                            children: [
                                                                roundedTotalPrice,
                                                                "kr"
                                                            ]
                                                        })
                                                    ]
                                                }),
                                                /*#__PURE__*/ (0,jsx_runtime.jsx)("ul", {
                                                    role: "list",
                                                    className: "divide-y divide-white divide-opacity-10 text-sm font-medium",
                                                    children: products.map(function(product) {
                                                        /*#__PURE__*/ return (0,jsx_runtime.jsxs)("li", {
                                                            className: "flex items-start space-x-4 py-6",
                                                            children: [
                                                                /*#__PURE__*/ (0,jsx_runtime.jsx)("img", {
                                                                    src: product.imageSrc,
                                                                    alt: product.imageAlt,
                                                                    className: "w-30 h-20 flex-none rounded-md bg-transparent object-cover object-center"
                                                                }),
                                                                /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                                                                    className: "flex-auto space-y-1",
                                                                    children: [
                                                                        /*#__PURE__*/ (0,jsx_runtime.jsxs)("h3", {
                                                                            className: "text-white",
                                                                            children: [
                                                                                formikBag.values.quantity,
                                                                                "x ",
                                                                                product.name
                                                                            ]
                                                                        }),
                                                                        /*#__PURE__*/ (0,jsx_runtime.jsx)("p", {
                                                                            children: product.descriptionLine1
                                                                        }),
                                                                        /*#__PURE__*/ (0,jsx_runtime.jsx)("p", {
                                                                            children: product.descriptionLine2
                                                                        })
                                                                    ]
                                                                }),
                                                                /*#__PURE__*/ (0,jsx_runtime.jsxs)("p", {
                                                                    className: "flex-none text-base font-medium text-white",
                                                                    children: [
                                                                        product.price / 100,
                                                                        "kr"
                                                                    ]
                                                                })
                                                            ]
                                                        }, product.id);
                                                    })
                                                }),
                                                /*#__PURE__*/ (0,jsx_runtime.jsxs)("dl", {
                                                    className: "space-y-6 border-t border-white border-opacity-10 pt-6 text-sm font-medium",
                                                    children: [
                                                        /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                                                            className: "flex items-center justify-between",
                                                            children: [
                                                                /*#__PURE__*/ (0,jsx_runtime.jsx)("dt", {
                                                                    children: "Subtotal"
                                                                }),
                                                                /*#__PURE__*/ (0,jsx_runtime.jsxs)("dd", {
                                                                    children: [
                                                                        roundedTotalPrice,
                                                                        "kr"
                                                                    ]
                                                                })
                                                            ]
                                                        }),
                                                        /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                                                            className: "flex items-center justify-between",
                                                            children: [
                                                                /*#__PURE__*/ (0,jsx_runtime.jsx)("dt", {
                                                                    children: "Moms 6%"
                                                                }),
                                                                /*#__PURE__*/ (0,jsx_runtime.jsxs)("dd", {
                                                                    children: [
                                                                        justSalesTax,
                                                                        "kr"
                                                                    ]
                                                                })
                                                            ]
                                                        }),
                                                        /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                                                            className: "flex items-center justify-between border-t border-white border-opacity-10 pt-6 text-white",
                                                            children: [
                                                                /*#__PURE__*/ (0,jsx_runtime.jsx)("dt", {
                                                                    className: "text-base",
                                                                    children: "Total"
                                                                }),
                                                                /*#__PURE__*/ (0,jsx_runtime.jsxs)("dd", {
                                                                    className: "text-base",
                                                                    children: [
                                                                        totalWithSalesTax,
                                                                        "kr"
                                                                    ]
                                                                })
                                                            ]
                                                        })
                                                    ]
                                                })
                                            ]
                                        })
                                    }),
                                    /*#__PURE__*/ (0,jsx_runtime.jsxs)("section", {
                                        "aria-labelledby": "payment-and-shipping-heading",
                                        className: "py-16 lg:col-start-1 lg:row-start-1 lg:mx-auto lg:w-full lg:max-w-lg lg:pt-0 lg:pb-24",
                                        children: [
                                            /*#__PURE__*/ (0,jsx_runtime.jsx)("h2", {
                                                id: "payment-and-shipping-heading",
                                                className: "sr-only",
                                                children: "Payment and shipping details"
                                            }),
                                            /*#__PURE__*/ (0,jsx_runtime.jsxs)(formik_esm/* Form */.l0, {
                                                children: [
                                                    /*#__PURE__*/ (0,jsx_runtime.jsx)(formik_esm/* Field */.gN, {
                                                        name: "application_bot_field",
                                                        children: function(param) {
                                                            var field = param.field;
                                                            /*#__PURE__*/ return (0,jsx_runtime.jsx)("p", {
                                                                className: "hidden",
                                                                children: /*#__PURE__*/ (0,jsx_runtime.jsxs)("label", {
                                                                    htmlFor: "application_bot_field",
                                                                    children: [
                                                                        "Don’t fill this out if you're human: ",
                                                                        /*#__PURE__*/ (0,jsx_runtime.jsx)("input", signup_form_form_objectSpread({}, field))
                                                                    ]
                                                                })
                                                            });
                                                        }
                                                    }),
                                                    /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                                                        className: "mx-auto max-w-2xl px-4 lg:max-w-none lg:px-0",
                                                        children: [
                                                            /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                                                                children: [
                                                                    /*#__PURE__*/ (0,jsx_runtime.jsx)("h3", {
                                                                        id: "contact-info-heading",
                                                                        className: "text-lg font-medium text-gray-900",
                                                                        children: "F\xf6retagsinformation"
                                                                    }),
                                                                    /*#__PURE__*/ (0,jsx_runtime.jsx)(formik_esm/* Field */.gN, {
                                                                        name: "company",
                                                                        children: function(param) {
                                                                            var field = param.field, meta = param.meta;
                                                                            /*#__PURE__*/ return (0,jsx_runtime.jsxs)("div", {
                                                                                className: "mt-6",
                                                                                children: [
                                                                                    /*#__PURE__*/ (0,jsx_runtime.jsx)("label", {
                                                                                        htmlFor: "company",
                                                                                        className: "block text-sm font-medium text-gray-700",
                                                                                        children: translation.fields.company.label
                                                                                    }),
                                                                                    /*#__PURE__*/ (0,jsx_runtime.jsx)("input", signup_form_form_objectSpread({}, field, {
                                                                                        required: true,
                                                                                        type: "text",
                                                                                        autoComplete: "name",
                                                                                        placeholder: translation.fields.company.placeholder,
                                                                                        className: "block w-full rounded-md border-gray-300 shadow-sm focus:border-indigo-500 focus:ring-indigo-500 sm:text-sm"
                                                                                    })),
                                                                                    meta.touched && meta.error && /*#__PURE__*/ (0,jsx_runtime.jsx)("p", {
                                                                                        className: "pt-2 text-xs italic text-red-500",
                                                                                        children: meta.error
                                                                                    })
                                                                                ]
                                                                            });
                                                                        }
                                                                    })
                                                                ]
                                                            }),
                                                            /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                                                                className: "mt-10",
                                                                children: [
                                                                    /*#__PURE__*/ (0,jsx_runtime.jsx)("h3", {
                                                                        id: "contact-info-heading",
                                                                        className: "text-lg font-medium text-gray-900",
                                                                        children: "Kontaktinformation"
                                                                    }),
                                                                    /*#__PURE__*/ (0,jsx_runtime.jsx)(formik_esm/* Field */.gN, {
                                                                        name: "email",
                                                                        children: function(param) {
                                                                            var field = param.field, meta = param.meta;
                                                                            /*#__PURE__*/ return (0,jsx_runtime.jsxs)("div", {
                                                                                className: "mt-6",
                                                                                children: [
                                                                                    /*#__PURE__*/ (0,jsx_runtime.jsx)("label", {
                                                                                        htmlFor: "email",
                                                                                        className: "block text-sm font-medium text-gray-700",
                                                                                        children: translation.fields.email.label
                                                                                    }),
                                                                                    /*#__PURE__*/ (0,jsx_runtime.jsx)("input", signup_form_form_objectSpread({}, field, {
                                                                                        required: true,
                                                                                        type: "email",
                                                                                        autoComplete: "email",
                                                                                        placeholder: translation.fields.email.placeholder,
                                                                                        className: "block w-full rounded-md border-gray-300 shadow-sm focus:border-indigo-500 focus:ring-indigo-500 sm:text-sm"
                                                                                    })),
                                                                                    meta.touched && meta.error && /*#__PURE__*/ (0,jsx_runtime.jsx)("p", {
                                                                                        className: "pt-2 text-xs italic text-red-500",
                                                                                        children: meta.error
                                                                                    })
                                                                                ]
                                                                            });
                                                                        }
                                                                    }),
                                                                    /*#__PURE__*/ (0,jsx_runtime.jsx)(formik_esm/* Field */.gN, {
                                                                        name: "name",
                                                                        children: function(param) {
                                                                            var field = param.field, meta = param.meta;
                                                                            /*#__PURE__*/ return (0,jsx_runtime.jsxs)("div", {
                                                                                className: "mt-6",
                                                                                children: [
                                                                                    /*#__PURE__*/ (0,jsx_runtime.jsx)("label", {
                                                                                        htmlFor: "name",
                                                                                        className: "block text-sm font-medium text-gray-700",
                                                                                        children: translation.fields.name.label
                                                                                    }),
                                                                                    /*#__PURE__*/ (0,jsx_runtime.jsx)("input", signup_form_form_objectSpread({}, field, {
                                                                                        required: true,
                                                                                        type: "text",
                                                                                        autoComplete: "name",
                                                                                        placeholder: translation.fields.name.placeholder,
                                                                                        className: "block w-full rounded-md border-gray-300 shadow-sm focus:border-indigo-500 focus:ring-indigo-500 sm:text-sm"
                                                                                    })),
                                                                                    meta.touched && meta.error && /*#__PURE__*/ (0,jsx_runtime.jsx)("p", {
                                                                                        className: "pt-2 text-xs italic text-red-500",
                                                                                        children: meta.error
                                                                                    })
                                                                                ]
                                                                            });
                                                                        }
                                                                    }),
                                                                    /*#__PURE__*/ (0,jsx_runtime.jsx)(formik_esm/* Field */.gN, {
                                                                        name: "phone",
                                                                        children: function(param) {
                                                                            var field = param.field, meta = param.meta;
                                                                            /*#__PURE__*/ return (0,jsx_runtime.jsxs)("div", {
                                                                                className: "mt-6",
                                                                                children: [
                                                                                    /*#__PURE__*/ (0,jsx_runtime.jsx)("label", {
                                                                                        htmlFor: "phone",
                                                                                        className: "block text-sm font-medium text-gray-700",
                                                                                        children: translation.fields.phone.label
                                                                                    }),
                                                                                    /*#__PURE__*/ (0,jsx_runtime.jsx)("input", signup_form_form_objectSpread({}, field, {
                                                                                        required: true,
                                                                                        type: "tel",
                                                                                        autoComplete: "tel",
                                                                                        placeholder: translation.fields.phone.placeholder,
                                                                                        className: "block w-full rounded-md border-gray-300 shadow-sm focus:border-indigo-500 focus:ring-indigo-500 sm:text-sm"
                                                                                    })),
                                                                                    meta.touched && meta.error && /*#__PURE__*/ (0,jsx_runtime.jsx)("p", {
                                                                                        className: "pt-2 text-xs italic text-red-500",
                                                                                        children: meta.error
                                                                                    })
                                                                                ]
                                                                            });
                                                                        }
                                                                    })
                                                                ]
                                                            }),
                                                            /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                                                                className: "mt-10",
                                                                children: [
                                                                    /*#__PURE__*/ (0,jsx_runtime.jsx)("h3", {
                                                                        className: "text-lg font-medium text-gray-900",
                                                                        children: "N\xe4r & Hur"
                                                                    }),
                                                                    /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                                                                        className: "mt-6 grid grid-cols-1 gap-y-6 gap-x-4",
                                                                        children: [
                                                                            /*#__PURE__*/ (0,jsx_runtime.jsx)(formik_esm/* Field */.gN, {
                                                                                name: "group",
                                                                                children: function(param) {
                                                                                    var field = param.field, meta = param.meta;
                                                                                    /*#__PURE__*/ return (0,jsx_runtime.jsxs)("div", {
                                                                                        children: [
                                                                                            /*#__PURE__*/ (0,jsx_runtime.jsx)("label", {
                                                                                                htmlFor: "group",
                                                                                                className: "block text-sm font-medium text-gray-700",
                                                                                                children: translation.fields.group.label
                                                                                            }),
                                                                                            /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                                                                                                className: "mt-1",
                                                                                                children: [
                                                                                                    /*#__PURE__*/ (0,jsx_runtime.jsxs)("select", signup_form_form_objectSpread({}, field, {
                                                                                                        className: "block w-full rounded-md border-gray-300 shadow-sm focus:border-indigo-500 focus:ring-indigo-500 sm:text-sm",
                                                                                                        children: [
                                                                                                            /*#__PURE__*/ (0,jsx_runtime.jsx)("option", {
                                                                                                                value: "morning",
                                                                                                                children: "Morgon 90min (07:00)"
                                                                                                            }),
                                                                                                            /*#__PURE__*/ (0,jsx_runtime.jsx)("option", {
                                                                                                                value: "lunch",
                                                                                                                children: "Lunch 60min (11:30)"
                                                                                                            })
                                                                                                        ]
                                                                                                    })),
                                                                                                    meta.touched && meta.error && /*#__PURE__*/ (0,jsx_runtime.jsx)("p", {
                                                                                                        className: "pt-2 text-xs italic text-red-500",
                                                                                                        children: meta.error
                                                                                                    })
                                                                                                ]
                                                                                            })
                                                                                        ]
                                                                                    });
                                                                                }
                                                                            }),
                                                                            /*#__PURE__*/ (0,jsx_runtime.jsx)(formik_esm/* Field */.gN, {
                                                                                name: "quantity",
                                                                                children: function(param) {
                                                                                    var field = param.field, meta = param.meta;
                                                                                    /*#__PURE__*/ return (0,jsx_runtime.jsxs)("div", {
                                                                                        children: [
                                                                                            /*#__PURE__*/ (0,jsx_runtime.jsx)("label", {
                                                                                                htmlFor: "quantity",
                                                                                                className: "block text-sm font-medium text-gray-700",
                                                                                                children: translation.fields.quantity.label
                                                                                            }),
                                                                                            /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                                                                                                className: "mt-1",
                                                                                                children: [
                                                                                                    /*#__PURE__*/ (0,jsx_runtime.jsx)("input", signup_form_form_objectSpread({}, field, {
                                                                                                        type: "number",
                                                                                                        min: 1,
                                                                                                        max: 10,
                                                                                                        className: "block w-full rounded-md border-gray-300 shadow-sm focus:border-indigo-500 focus:ring-indigo-500 sm:text-sm"
                                                                                                    })),
                                                                                                    meta.touched && meta.error && /*#__PURE__*/ (0,jsx_runtime.jsx)("p", {
                                                                                                        className: "pt-2 text-xs italic text-red-500",
                                                                                                        children: meta.error
                                                                                                    })
                                                                                                ]
                                                                                            })
                                                                                        ]
                                                                                    });
                                                                                }
                                                                            })
                                                                        ]
                                                                    })
                                                                ]
                                                            }),
                                                            /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                                                                className: "mt-10 flex justify-end border-t border-gray-200 pt-6",
                                                                children: [
                                                                    /*#__PURE__*/ (0,jsx_runtime.jsx)(next_link["default"], {
                                                                        href: "/",
                                                                        children: /*#__PURE__*/ (0,jsx_runtime.jsx)("a", {
                                                                            className: "mr-2 rounded-md border border-transparent bg-indigo-50 py-2 px-4 text-sm font-medium text-indigo-900 shadow-sm hover:bg-indigo-100 focus:outline-none focus:ring-2 focus:ring-indigo-500 focus:ring-offset-2 focus:ring-offset-gray-50",
                                                                            children: "Avbryt"
                                                                        })
                                                                    }),
                                                                    /*#__PURE__*/ (0,jsx_runtime.jsx)("button", {
                                                                        type: "submit",
                                                                        className: "rounded-md border border-transparent bg-indigo-600 py-2 px-4 text-sm font-medium text-white shadow-sm hover:bg-indigo-700 focus:outline-none focus:ring-2 focus:ring-indigo-500 focus:ring-offset-2 focus:ring-offset-gray-50",
                                                                        disabled: formikBag.isSubmitting || !formikBag.isValid,
                                                                        children: translation.button.text
                                                                    })
                                                                ]
                                                            })
                                                        ]
                                                    })
                                                ]
                                            })
                                        ]
                                    })
                                ]
                            })
                        ]
                    }));
                }
            })
        ]
    }));
};

;// CONCATENATED MODULE: ./components/ds/05-pages/signup/signup-form/index.tsx


;// CONCATENATED MODULE: ./components/ds/05-pages/signup/index.tsx

/* eslint-disable @next/next/no-img-element */ /* eslint-disable jsx-a11y/anchor-is-valid */ /* eslint-disable jsx-a11y/no-redundant-roles */ 








var SignupPage = function() {
    var ref = (0,react.useState)('10weeks'), seriesLength = ref[0], setSeriesLength = ref[1];
    var ref1 = (0,react.useState)('morning'), seriesGroup = ref1[0], setSeriesGroup = ref1[1];
    var type = (0,hooks/* useSalesTax */.v)().type;
    var userData = (0,index_browser/* useUser */.aF)();
    var router = (0,next_router.useRouter)();
    var locale = (0,utils_locale/* makeLocale */.W)(router.locale, router.defaultLocale) || 'sv';
    var translation = signup_translations_translations[locale];
    var user = userData.user, error = userData.error, isLoading = userData.isLoading;
    var query = router.query;
    var length = (0,lodash.get)(query, 'length', '10weeks');
    (0,react.useEffect)(function() {
        if (length) {
            setSeriesLength(length === '10weeks' ? '10weeks' : length === '5weeks' ? '5weeks' : '10weeks');
        }
    }, [
        length
    ]);
    var alternative = (0,lodash.get)(query, 'alternative', 'morning');
    (0,react.useEffect)(function() {
        if (alternative) {
            setSeriesGroup(alternative === 'morning' ? 'morning' : alternative === 'lunch' ? 'lunch' : 'morning');
        }
    }, [
        alternative
    ]);
    return(/*#__PURE__*/ (0,jsx_runtime.jsxs)(jsx_runtime.Fragment, {
        children: [
            /*#__PURE__*/ (0,jsx_runtime.jsx)(Head, {
                title: translation.pageTitle,
                description: translation.pageDescription
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                className: "bg-white",
                children: /*#__PURE__*/ (0,jsx_runtime.jsx)(SignupForm, {
                    seriesLength: seriesLength,
                    seriesGroup: seriesGroup,
                    user: user
                })
            })
        ]
    }));
};

;// CONCATENATED MODULE: ./components/ds/05-pages/series/standings/team/translations.tsx
var team_translations_translations = {
    sv: {
        pageTitle: '\xd6-viks N\xe4tverkspadel',
        pageDescription: 'Vi samlas p\xe5 onsdagar f\xf6r att spela padel och n\xe4tverka. Tv\xe5 flugor i en sm\xe4ll.'
    },
    en: {
        pageTitle: "\xd6-vik's Network Padel ",
        pageDescription: 'We gather on Wednesdays to play padel and network. Two birds with one stone.'
    }
};

// EXTERNAL MODULE: ./node_modules/@headlessui/react/dist/components/menu/menu.esm.js + 1 modules
var menu_esm = __webpack_require__(9706);
;// CONCATENATED MODULE: ./components/ds/05-pages/series/standings/team/layout/index.tsx

/* eslint-disable @next/next/no-img-element */ 








var StandingsLayout = function(param1) {
    var standings = param1.standings, seriesContext = param1.seriesContext;
    var ref = (0,react.useState)(false), sidebarOpen = ref[0], setSidebarOpen = ref[1];
    (0,react.useEffect)(function() {
        if (document) {
            var htmlEl = document.querySelector('html');
            if (htmlEl) {
                htmlEl.classList.add('h-full');
                htmlEl.classList.add('bg-white');
            }
            var bodyEl = document.querySelector('body');
            if (bodyEl) {
                bodyEl.classList.add('h-full');
                bodyEl.classList.add('overflow-hidden');
            }
            var nextWrapperEl = document.querySelector('#__next');
            if (nextWrapperEl) {
                nextWrapperEl.classList.add('h-full');
                nextWrapperEl.classList.add('overflow-hidden');
            }
        }
    });
    var orderedStandings = (0,lodash.orderBy)(standings, [
        'points_standing',
        'plus_minus',
        'no_of_matches'
    ], [
        'desc',
        'desc',
        'desc'
    ]);
    var filteredStandings = orderedStandings.filter(function(row) {
        return row.no_of_matches > 0;
    });
    var top3 = (0,lodash.take)(filteredStandings, 3);
    return(/*#__PURE__*/ (0,jsx_runtime.jsx)(jsx_runtime.Fragment, {
        children: /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
            className: "flex h-full",
            children: [
                /*#__PURE__*/ (0,jsx_runtime.jsx)(header/* Header */.h, {
                    sidebarOpen: sidebarOpen,
                    setSidebarOpen: setSidebarOpen,
                    seriesContext: seriesContext
                }),
                /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                    className: "flex w-0 flex-1 flex-col overflow-hidden",
                    children: [
                        /*#__PURE__*/ (0,jsx_runtime.jsx)(search_header/* SearchHeader */.s, {
                            sidebarOpen: sidebarOpen,
                            setSidebarOpen: setSidebarOpen
                        }),
                        /*#__PURE__*/ (0,jsx_runtime.jsxs)("main", {
                            className: "relative z-0 flex-1 overflow-y-auto focus:outline-none",
                            children: [
                                /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                    className: "border-b border-gray-200 px-4 py-4 sm:flex sm:items-center sm:justify-between sm:px-6 lg:px-8",
                                    children: /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                        className: "min-w-0 flex-1",
                                        children: /*#__PURE__*/ (0,jsx_runtime.jsx)("h1", {
                                            className: "text-lg font-medium leading-6 text-gray-900 sm:truncate",
                                            children: "Tabell"
                                        })
                                    })
                                }),
                                top3.length > 0 ? /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                                    className: "mt-6 px-4 sm:px-6 lg:px-8",
                                    children: [
                                        /*#__PURE__*/ (0,jsx_runtime.jsx)("h2", {
                                            className: "text-xs font-medium uppercase tracking-wide text-gray-500",
                                            children: "Top 3"
                                        }),
                                        /*#__PURE__*/ (0,jsx_runtime.jsx)("ul", {
                                            role: "list",
                                            className: "mt-3 grid grid-cols-1 gap-4 sm:grid-cols-2 sm:gap-6 xl:grid-cols-4",
                                            children: top3.map(function(team, i) {
                                                /*#__PURE__*/ return (0,jsx_runtime.jsxs)("li", {
                                                    className: "relative col-span-1 flex rounded-md shadow-sm",
                                                    children: [
                                                        /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                                                            className: (0,classnames/* classNames */.A)('flex w-16 flex-shrink-0 items-center justify-center rounded-l-md border-t border-l border-b border-gray-200 bg-white pl-1 text-sm font-medium text-white'),
                                                            children: [
                                                                team.image_url_logo ? /*#__PURE__*/ (0,jsx_runtime.jsx)("img", {
                                                                    src: team.image_url_logo
                                                                }) : null,
                                                                !team.image_url_logo ? i + 1 : null
                                                            ]
                                                        }),
                                                        /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                                                            className: "flex flex-1 items-center justify-between truncate rounded-r-md border-t border-r border-b border-gray-200 bg-white",
                                                            children: [
                                                                /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                                                                    className: "flex-1 truncate px-4 py-2 text-sm",
                                                                    children: [
                                                                        /*#__PURE__*/ (0,jsx_runtime.jsx)(next_link["default"], {
                                                                            href: "/series/".concat(seriesContext.id, "/team/").concat(team.team_id),
                                                                            children: /*#__PURE__*/ (0,jsx_runtime.jsx)("a", {
                                                                                className: "font-medium text-gray-900 hover:text-gray-600",
                                                                                children: team.name
                                                                            })
                                                                        }),
                                                                        /*#__PURE__*/ (0,jsx_runtime.jsxs)("p", {
                                                                            className: "text-gray-500",
                                                                            children: [
                                                                                team.points_standing,
                                                                                " Po\xe4ng"
                                                                            ]
                                                                        })
                                                                    ]
                                                                }),
                                                                /*#__PURE__*/ (0,jsx_runtime.jsxs)(menu_esm/* Menu */.v, {
                                                                    as: "div",
                                                                    className: "flex-shrink-0 pr-2",
                                                                    children: [
                                                                        /*#__PURE__*/ (0,jsx_runtime.jsxs)(menu_esm/* Menu.Button */.v.Button, {
                                                                            className: "inline-flex h-8 w-8 items-center justify-center rounded-full bg-white text-gray-400 hover:text-gray-500 focus:outline-none focus:ring-2 focus:ring-purple-500 focus:ring-offset-2",
                                                                            children: [
                                                                                /*#__PURE__*/ (0,jsx_runtime.jsx)("span", {
                                                                                    className: "sr-only",
                                                                                    children: "Open options"
                                                                                }),
                                                                                /*#__PURE__*/ (0,jsx_runtime.jsx)(outline_esm/* DotsVerticalIcon */.AjK, {
                                                                                    className: "h-5 w-5",
                                                                                    "aria-hidden": "true"
                                                                                })
                                                                            ]
                                                                        }),
                                                                        /*#__PURE__*/ (0,jsx_runtime.jsx)(transition_esm/* Transition */.u, {
                                                                            as: react.Fragment,
                                                                            enter: "transition ease-out duration-100",
                                                                            enterFrom: "transform opacity-0 scale-95",
                                                                            enterTo: "transform opacity-100 scale-100",
                                                                            leave: "transition ease-in duration-75",
                                                                            leaveFrom: "transform opacity-100 scale-100",
                                                                            leaveTo: "transform opacity-0 scale-95",
                                                                            children: /*#__PURE__*/ (0,jsx_runtime.jsxs)(menu_esm/* Menu.Items */.v.Items, {
                                                                                className: "absolute right-10 top-3 z-10 mx-3 mt-1 w-48 origin-top-right divide-y divide-gray-200 rounded-md bg-white shadow-lg ring-1 ring-black ring-opacity-5 focus:outline-none",
                                                                                children: [
                                                                                    /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                                                                        className: "py-1",
                                                                                        children: /*#__PURE__*/ (0,jsx_runtime.jsx)(menu_esm/* Menu.Item */.v.Item, {
                                                                                            children: function(param) {
                                                                                                var active = param.active;
                                                                                                /*#__PURE__*/ return (0,jsx_runtime.jsx)(next_link["default"], {
                                                                                                    href: "/series/".concat(seriesContext.id, "/team/").concat(team.team_id),
                                                                                                    children: /*#__PURE__*/ (0,jsx_runtime.jsx)("a", {
                                                                                                        className: (0,classnames/* classNames */.A)(active ? 'bg-gray-100 text-gray-900' : 'text-gray-700', 'block px-4 py-2 text-sm'),
                                                                                                        children: "Se mer information"
                                                                                                    })
                                                                                                });
                                                                                            }
                                                                                        })
                                                                                    }),
                                                                                    team.website ? /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                                                                        className: "py-1",
                                                                                        children: /*#__PURE__*/ (0,jsx_runtime.jsx)(menu_esm/* Menu.Item */.v.Item, {
                                                                                            children: function(param) {
                                                                                                var active = param.active;
                                                                                                /*#__PURE__*/ return (0,jsx_runtime.jsxs)("a", {
                                                                                                    href: "".concat(team.website),
                                                                                                    target: "_blank",
                                                                                                    rel: "noopener noreferrer",
                                                                                                    className: (0,classnames/* classNames */.A)(active ? 'bg-gray-100 text-gray-900' : 'text-gray-700', 'block flex justify-between gap-x-1 px-4 py-2 text-sm'),
                                                                                                    children: [
                                                                                                        "Se hemsida",
                                                                                                        /*#__PURE__*/ (0,jsx_runtime.jsx)(outline_esm/* ExternalLinkIcon */.h0n, {
                                                                                                            className: "h-5 w-5",
                                                                                                            "aria-hidden": "true"
                                                                                                        })
                                                                                                    ]
                                                                                                });
                                                                                            }
                                                                                        })
                                                                                    }) : null
                                                                                ]
                                                                            })
                                                                        })
                                                                    ]
                                                                })
                                                            ]
                                                        })
                                                    ]
                                                }, team.name);
                                            })
                                        })
                                    ]
                                }) : null,
                                /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                                    className: "mt-10 sm:hidden",
                                    children: [
                                        /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                            className: "px-4 sm:px-6",
                                            children: /*#__PURE__*/ (0,jsx_runtime.jsx)("h2", {
                                                className: "text-xs font-medium uppercase tracking-wide text-gray-500",
                                                children: "Tabell"
                                            })
                                        }),
                                        /*#__PURE__*/ (0,jsx_runtime.jsx)("ul", {
                                            role: "list",
                                            className: "mt-3 divide-y divide-gray-100 border-t border-gray-200",
                                            children: orderedStandings.map(function(team, i) {
                                                /*#__PURE__*/ return (0,jsx_runtime.jsx)("li", {
                                                    children: /*#__PURE__*/ (0,jsx_runtime.jsx)(next_link["default"], {
                                                        href: "/series/".concat(seriesContext.id, "/team/").concat(team.team_id),
                                                        children: /*#__PURE__*/ (0,jsx_runtime.jsxs)("a", {
                                                            className: "group flex items-center justify-between px-4 py-4 hover:bg-gray-50 sm:px-6",
                                                            children: [
                                                                /*#__PURE__*/ (0,jsx_runtime.jsxs)("span", {
                                                                    className: "flex items-center space-x-3 truncate",
                                                                    children: [
                                                                        /*#__PURE__*/ (0,jsx_runtime.jsx)("span", {
                                                                            className: 'flex flex-shrink-0 items-center justify-center font-mono',
                                                                            "aria-hidden": "true",
                                                                            children: i + 1
                                                                        }),
                                                                        /*#__PURE__*/ (0,jsx_runtime.jsxs)("span", {
                                                                            className: "truncate text-sm font-medium leading-6",
                                                                            children: [
                                                                                team.name,
                                                                                ' ',
                                                                                /*#__PURE__*/ (0,jsx_runtime.jsxs)("span", {
                                                                                    className: "truncate font-normal text-gray-500",
                                                                                    children: [
                                                                                        "med ",
                                                                                        team.points_standing,
                                                                                        " po\xe4ng"
                                                                                    ]
                                                                                })
                                                                            ]
                                                                        })
                                                                    ]
                                                                }),
                                                                /*#__PURE__*/ (0,jsx_runtime.jsx)(esm/* ChevronRightIcon */.XCv, {
                                                                    className: "ml-4 h-5 w-5 text-gray-400 group-hover:text-gray-500",
                                                                    "aria-hidden": "true"
                                                                })
                                                            ]
                                                        })
                                                    })
                                                }, team.name);
                                            })
                                        })
                                    ]
                                }),
                                /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                    className: "mt-8 hidden sm:block",
                                    children: /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                                        className: "inline-block min-w-full border-b border-gray-200 align-middle",
                                        children: [
                                            /*#__PURE__*/ (0,jsx_runtime.jsxs)("table", {
                                                className: "min-w-full table-auto",
                                                children: [
                                                    /*#__PURE__*/ (0,jsx_runtime.jsx)("thead", {
                                                        children: /*#__PURE__*/ (0,jsx_runtime.jsxs)("tr", {
                                                            className: "border-t border-gray-200",
                                                            children: [
                                                                /*#__PURE__*/ (0,jsx_runtime.jsx)("th", {
                                                                    className: "border-b border-gray-200 bg-gray-50 px-6 py-3 text-center text-xs font-bold uppercase tracking-wider text-gray-500",
                                                                    children: "Rank"
                                                                }),
                                                                /*#__PURE__*/ (0,jsx_runtime.jsx)("th", {
                                                                    className: "border-b border-gray-200 bg-gray-50 px-6 py-3 text-left text-xs font-bold uppercase tracking-wider text-gray-500",
                                                                    children: "Lag"
                                                                }),
                                                                /*#__PURE__*/ (0,jsx_runtime.jsx)("th", {
                                                                    className: "hidden border-b border-gray-200 bg-gray-50 px-6 py-3 text-center text-xs font-bold uppercase tracking-wider text-gray-500 md:table-cell",
                                                                    children: "GP"
                                                                }),
                                                                /*#__PURE__*/ (0,jsx_runtime.jsx)("th", {
                                                                    className: "hidden border-b border-gray-200 bg-gray-50 px-6 py-3 text-center text-xs font-bold uppercase tracking-wider text-gray-500 md:table-cell",
                                                                    children: "5P"
                                                                }),
                                                                /*#__PURE__*/ (0,jsx_runtime.jsx)("th", {
                                                                    className: "hidden border-b border-gray-200 bg-gray-50 px-6 py-3 text-center text-xs font-bold uppercase tracking-wider text-gray-500 md:table-cell",
                                                                    children: "4P"
                                                                }),
                                                                /*#__PURE__*/ (0,jsx_runtime.jsx)("th", {
                                                                    className: "hidden border-b border-gray-200 bg-gray-50 px-6 py-3 text-center text-xs font-bold uppercase tracking-wider text-gray-500 md:table-cell",
                                                                    children: "3P"
                                                                }),
                                                                /*#__PURE__*/ (0,jsx_runtime.jsx)("th", {
                                                                    className: "hidden border-b border-gray-200 bg-gray-50 px-6 py-3 text-center text-xs font-bold uppercase tracking-wider text-gray-500 md:table-cell",
                                                                    children: "2P"
                                                                }),
                                                                /*#__PURE__*/ (0,jsx_runtime.jsx)("th", {
                                                                    className: "hidden border-b border-gray-200 bg-gray-50 px-6 py-3 text-center text-xs font-bold uppercase tracking-wider text-gray-500 md:table-cell",
                                                                    children: "-2P"
                                                                }),
                                                                /*#__PURE__*/ (0,jsx_runtime.jsx)("th", {
                                                                    className: "hidden border-b border-gray-200 bg-gray-50 px-6 py-3 text-center text-xs font-bold uppercase tracking-wider text-gray-500 md:table-cell",
                                                                    children: "-3P"
                                                                }),
                                                                /*#__PURE__*/ (0,jsx_runtime.jsx)("th", {
                                                                    className: "hidden border-b border-gray-200 bg-gray-50 px-6 py-3 text-center text-xs font-bold uppercase tracking-wider text-gray-500 md:table-cell",
                                                                    children: "G"
                                                                }),
                                                                /*#__PURE__*/ (0,jsx_runtime.jsx)("th", {
                                                                    className: "hidden border-b border-gray-200 bg-gray-50 px-6 py-3 text-center text-xs font-bold uppercase tracking-wider text-gray-500 md:table-cell",
                                                                    children: "GA"
                                                                }),
                                                                /*#__PURE__*/ (0,jsx_runtime.jsx)("th", {
                                                                    className: "hidden border-b border-gray-200 bg-gray-50 px-6 py-3 text-center text-xs font-bold uppercase tracking-wider text-gray-500 md:table-cell",
                                                                    children: "+/-"
                                                                }),
                                                                /*#__PURE__*/ (0,jsx_runtime.jsx)("th", {
                                                                    className: "hidden border-b border-gray-200 bg-gray-100 px-6 py-3 text-center text-xs font-bold uppercase tracking-wider text-gray-500 md:table-cell",
                                                                    children: "Po\xe4ng"
                                                                })
                                                            ]
                                                        })
                                                    }),
                                                    /*#__PURE__*/ (0,jsx_runtime.jsx)("tbody", {
                                                        className: "divide-y divide-gray-100 bg-white",
                                                        children: orderedStandings.map(function(standingsRow, i) {
                                                            return(/*#__PURE__*/ (0,jsx_runtime.jsxs)("tr", {
                                                                className: i % 2 ? 'bg-gray-50' : '',
                                                                children: [
                                                                    /*#__PURE__*/ (0,jsx_runtime.jsx)("td", {
                                                                        className: "whitespace-nowrap px-6 py-3 text-center text-sm font-light lining-nums text-gray-500",
                                                                        children: i + 1
                                                                    }),
                                                                    /*#__PURE__*/ (0,jsx_runtime.jsx)("td", {
                                                                        className: "whitespace-nowrap px-6 py-3 text-sm font-medium text-gray-900",
                                                                        children: /*#__PURE__*/ (0,jsx_runtime.jsx)(next_link["default"], {
                                                                            href: "/series/".concat(seriesContext.id, "/team/").concat(standingsRow.team_id),
                                                                            children: /*#__PURE__*/ (0,jsx_runtime.jsxs)("a", {
                                                                                className: "truncate hover:text-gray-600",
                                                                                children: [
                                                                                    standingsRow.name,
                                                                                    ' ',
                                                                                    standingsRow.no_of_spots > 1 ? /*#__PURE__*/ (0,jsx_runtime.jsxs)("span", {
                                                                                        className: "inline-flex items-center rounded-full bg-indigo-100 px-2.5 py-0.5 text-xs font-medium text-indigo-800",
                                                                                        children: [
                                                                                            /*#__PURE__*/ (0,jsx_runtime.jsx)("svg", {
                                                                                                className: "-ml-0.5 mr-1.5 h-2 w-2 text-indigo-400",
                                                                                                fill: "currentColor",
                                                                                                viewBox: "0 0 8 8",
                                                                                                children: /*#__PURE__*/ (0,jsx_runtime.jsx)("circle", {
                                                                                                    cx: 4,
                                                                                                    cy: 4,
                                                                                                    r: 3
                                                                                                })
                                                                                            }),
                                                                                            standingsRow.no_of_spots
                                                                                        ]
                                                                                    }) : null
                                                                                ]
                                                                            })
                                                                        })
                                                                    }),
                                                                    /*#__PURE__*/ (0,jsx_runtime.jsx)("td", {
                                                                        className: "hidden whitespace-nowrap px-6 py-3 text-center text-sm font-light lining-nums text-gray-500 md:table-cell",
                                                                        children: standingsRow.no_of_matches
                                                                    }),
                                                                    /*#__PURE__*/ (0,jsx_runtime.jsx)("td", {
                                                                        className: "hidden whitespace-nowrap px-6 py-3 text-center text-sm font-light lining-nums text-gray-500 md:table-cell",
                                                                        children: standingsRow.five_points
                                                                    }),
                                                                    /*#__PURE__*/ (0,jsx_runtime.jsx)("td", {
                                                                        className: "hidden whitespace-nowrap px-6 py-3 text-center text-sm font-light lining-nums text-gray-500 md:table-cell",
                                                                        children: standingsRow.four_points
                                                                    }),
                                                                    /*#__PURE__*/ (0,jsx_runtime.jsx)("td", {
                                                                        className: "hidden whitespace-nowrap px-6 py-3 text-center text-sm font-light lining-nums text-gray-500 md:table-cell",
                                                                        children: standingsRow.three_points
                                                                    }),
                                                                    /*#__PURE__*/ (0,jsx_runtime.jsx)("td", {
                                                                        className: "hidden whitespace-nowrap px-6 py-3 text-center text-sm font-light lining-nums text-gray-500 md:table-cell",
                                                                        children: standingsRow.two_points
                                                                    }),
                                                                    /*#__PURE__*/ (0,jsx_runtime.jsx)("td", {
                                                                        className: "hidden whitespace-nowrap px-6 py-3 text-center text-sm font-light lining-nums text-gray-500 md:table-cell",
                                                                        children: standingsRow.minus_two_points
                                                                    }),
                                                                    /*#__PURE__*/ (0,jsx_runtime.jsx)("td", {
                                                                        className: "hidden whitespace-nowrap px-6 py-3 text-center text-sm font-light lining-nums text-gray-500 md:table-cell",
                                                                        children: standingsRow.minus_three_points
                                                                    }),
                                                                    /*#__PURE__*/ (0,jsx_runtime.jsx)("td", {
                                                                        className: "hidden whitespace-nowrap px-6 py-3 text-center text-sm font-light lining-nums text-gray-500 md:table-cell",
                                                                        children: standingsRow.total_games_won
                                                                    }),
                                                                    /*#__PURE__*/ (0,jsx_runtime.jsx)("td", {
                                                                        className: "hidden whitespace-nowrap px-6 py-3 text-center text-sm font-light lining-nums text-gray-500 md:table-cell",
                                                                        children: standingsRow.total_games_lost
                                                                    }),
                                                                    /*#__PURE__*/ (0,jsx_runtime.jsx)("td", {
                                                                        className: "hidden whitespace-nowrap px-6 py-3 text-center text-sm font-light lining-nums text-gray-500 md:table-cell",
                                                                        children: standingsRow.plus_minus
                                                                    }),
                                                                    /*#__PURE__*/ (0,jsx_runtime.jsx)("td", {
                                                                        className: "hidden whitespace-nowrap bg-gray-100 px-6 py-3 text-center text-sm font-light lining-nums text-gray-500 md:table-cell",
                                                                        children: standingsRow.points_standing
                                                                    })
                                                                ]
                                                            }, standingsRow.name));
                                                        })
                                                    })
                                                ]
                                            }),
                                            /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                                children: /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                                                    className: "px-4 py-5 sm:p-6",
                                                    children: [
                                                        /*#__PURE__*/ (0,jsx_runtime.jsx)("h3", {
                                                            className: "text-lg font-medium leading-6 text-gray-900",
                                                            children: "F\xf6rkortningar"
                                                        }),
                                                        /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                                            className: "mt-5",
                                                            children: /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                                                className: "rounded-md bg-gray-50 px-6 py-5 sm:flex sm:items-start sm:justify-between",
                                                                children: /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                                                    className: "grid grid-cols-12",
                                                                    children: [
                                                                        {
                                                                            text: 'Rank',
                                                                            description: 'Ranking'
                                                                        },
                                                                        {
                                                                            text: 'Lag',
                                                                            description: 'Lag f\xf6r vald s\xe4song'
                                                                        },
                                                                        {
                                                                            text: 'GP',
                                                                            description: 'Spelade matcher'
                                                                        },
                                                                        {
                                                                            text: '5P',
                                                                            description: '5 po\xe4ng (stor vinst)'
                                                                        },
                                                                        {
                                                                            text: '4P',
                                                                            description: '4 po\xe4ng (medelstor vinst)'
                                                                        },
                                                                        {
                                                                            text: '3P',
                                                                            description: '3 po\xe4ng (liten vinst)'
                                                                        },
                                                                        {
                                                                            text: '2P',
                                                                            description: '2 po\xe4ng (vinst i tiebreak)'
                                                                        },
                                                                        {
                                                                            text: '-2P',
                                                                            description: '-2 po\xe4ng (f\xf6rlust i tiebreak)'
                                                                        },
                                                                        {
                                                                            text: '-3P',
                                                                            description: '-3 po\xe4ng (f\xf6rlust)'
                                                                        },
                                                                        {
                                                                            text: 'G',
                                                                            description: 'Vunna gem'
                                                                        },
                                                                        {
                                                                            text: 'GA',
                                                                            description: 'F\xf6rlorade gem'
                                                                        },
                                                                        {
                                                                            text: '+/-',
                                                                            description: 'Plus/minus f\xf6r gem'
                                                                        },
                                                                        {
                                                                            text: 'Po\xe4ng',
                                                                            description: 'Nuvarande po\xe4ng med start p\xe5 100 po\xe4ng'
                                                                        }, 
                                                                    ].map(function(abbr) {
                                                                        /*#__PURE__*/ return (0,jsx_runtime.jsxs)(react.Fragment, {
                                                                            children: [
                                                                                /*#__PURE__*/ (0,jsx_runtime.jsx)("p", {
                                                                                    className: "col-span-2 col-start-1 font-bold",
                                                                                    children: abbr.text
                                                                                }),
                                                                                /*#__PURE__*/ (0,jsx_runtime.jsx)("p", {
                                                                                    className: "col-span-10 col-start-3",
                                                                                    children: abbr.description
                                                                                })
                                                                            ]
                                                                        }, abbr.text);
                                                                    })
                                                                })
                                                            })
                                                        })
                                                    ]
                                                })
                                            })
                                        ]
                                    })
                                })
                            ]
                        })
                    ]
                })
            ]
        })
    }));
};

;// CONCATENATED MODULE: ./components/ds/05-pages/series/standings/team/types.ts

var TeamStandingRow = es6/* type */.dt({
    team_id: es6/* string */.Z_,
    name: es6/* string */.Z_,
    image_url_logo: es6/* union */.G0([
        es6/* string */.Z_,
        es6/* null */.lB
    ]),
    website: es6/* union */.G0([
        es6/* string */.Z_,
        es6/* null */.lB
    ]),
    points_standing: es6/* number */.pk,
    average_match_point: es6/* number */.pk,
    no_of_matches: es6/* number */.pk,
    positive: es6/* number */.pk,
    negative: es6/* number */.pk,
    total_games_won: es6/* number */.pk,
    total_games_lost: es6/* number */.pk,
    plus_minus: es6/* number */.pk,
    five_points: es6/* number */.pk,
    four_points: es6/* number */.pk,
    three_points: es6/* number */.pk,
    two_points: es6/* number */.pk,
    minus_two_points: es6/* number */.pk,
    minus_three_points: es6/* number */.pk,
    no_of_spots: es6/* number */.pk
});
var TeamStandingRows = es6/* array */.IX(TeamStandingRow);

;// CONCATENATED MODULE: ./components/ds/05-pages/series/standings/team/index.tsx







var TeamStandingsPage = function(param) {
    var standings = param.standings, seriesContext = param.seriesContext;
    var router = (0,next_router.useRouter)();
    var locale = (0,utils_locale/* makeLocale */.W)(router.locale, router.defaultLocale) || 'sv';
    var translation = team_translations_translations[locale];
    return(/*#__PURE__*/ (0,jsx_runtime.jsxs)(jsx_runtime.Fragment, {
        children: [
            /*#__PURE__*/ (0,jsx_runtime.jsx)(Head, {
                title: translation.pageTitle,
                description: translation.pageDescription
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)(StandingsLayout, {
                standings: standings,
                seriesContext: seriesContext
            })
        ]
    }));
};

;// CONCATENATED MODULE: ./components/ds/05-pages/series/standings/player/translations.tsx
var player_translations_translations = {
    sv: {
        pageTitle: '\xd6-viks N\xe4tverkspadel',
        pageDescription: 'Vi samlas p\xe5 onsdagar f\xf6r att spela padel och n\xe4tverka. Tv\xe5 flugor i en sm\xe4ll.'
    },
    en: {
        pageTitle: "\xd6-vik's Network Padel ",
        pageDescription: 'We gather on Wednesdays to play padel and network. Two birds with one stone.'
    }
};

;// CONCATENATED MODULE: ./components/ds/05-pages/series/standings/player/layout/index.tsx

/* eslint-disable @next/next/no-img-element */ 








var layout_StandingsLayout = function(param1) {
    var standings = param1.standings, seriesContext = param1.seriesContext;
    var ref = (0,react.useState)(false), sidebarOpen = ref[0], setSidebarOpen = ref[1];
    (0,react.useEffect)(function() {
        if (document) {
            var htmlEl = document.querySelector('html');
            if (htmlEl) {
                htmlEl.classList.add('h-full');
                htmlEl.classList.add('bg-white');
            }
            var bodyEl = document.querySelector('body');
            if (bodyEl) {
                bodyEl.classList.add('h-full');
                bodyEl.classList.add('overflow-hidden');
            }
            var nextWrapperEl = document.querySelector('#__next');
            if (nextWrapperEl) {
                nextWrapperEl.classList.add('h-full');
                nextWrapperEl.classList.add('overflow-hidden');
            }
        }
    });
    var orderedStandings = (0,lodash.orderBy)(standings, [
        'points_standing',
        'plus_minus',
        'no_of_matches'
    ], [
        'desc',
        'desc',
        'desc'
    ]);
    var filteredStandings = orderedStandings.filter(function(row) {
        return row.no_of_matches > 0;
    });
    var top3 = (0,lodash.take)(filteredStandings, 3);
    return(/*#__PURE__*/ (0,jsx_runtime.jsx)(jsx_runtime.Fragment, {
        children: /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
            className: "flex h-full",
            children: [
                /*#__PURE__*/ (0,jsx_runtime.jsx)(header/* Header */.h, {
                    sidebarOpen: sidebarOpen,
                    setSidebarOpen: setSidebarOpen,
                    seriesContext: seriesContext
                }),
                /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                    className: "flex w-0 flex-1 flex-col overflow-hidden",
                    children: [
                        /*#__PURE__*/ (0,jsx_runtime.jsx)(search_header/* SearchHeader */.s, {
                            sidebarOpen: sidebarOpen,
                            setSidebarOpen: setSidebarOpen
                        }),
                        /*#__PURE__*/ (0,jsx_runtime.jsxs)("main", {
                            className: "relative z-0 flex-1 overflow-y-auto focus:outline-none",
                            children: [
                                /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                    className: "border-b border-gray-200 px-4 py-4 sm:flex sm:items-center sm:justify-between sm:px-6 lg:px-8",
                                    children: /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                        className: "min-w-0 flex-1",
                                        children: /*#__PURE__*/ (0,jsx_runtime.jsx)("h1", {
                                            className: "text-lg font-medium leading-6 text-gray-900 sm:truncate",
                                            children: "Spelare"
                                        })
                                    })
                                }),
                                top3.length > 0 ? /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                                    className: "mt-6 px-4 sm:px-6 lg:px-8",
                                    children: [
                                        /*#__PURE__*/ (0,jsx_runtime.jsx)("h2", {
                                            className: "text-xs font-medium uppercase tracking-wide text-gray-500",
                                            children: "Top 3"
                                        }),
                                        /*#__PURE__*/ (0,jsx_runtime.jsx)("ul", {
                                            role: "list",
                                            className: "mt-3 grid grid-cols-1 gap-4 sm:grid-cols-2 sm:gap-6 xl:grid-cols-4",
                                            children: top3.map(function(player, i) {
                                                /*#__PURE__*/ return (0,jsx_runtime.jsxs)("li", {
                                                    className: "relative col-span-1 flex rounded-md shadow-sm",
                                                    children: [
                                                        /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                                                            className: (0,classnames/* classNames */.A)('flex w-16 flex-shrink-0 items-center justify-center rounded-l-md border-t border-l border-b border-gray-200 bg-white pl-1 text-sm font-medium text-white'),
                                                            children: [
                                                                player.image_url_logo ? /*#__PURE__*/ (0,jsx_runtime.jsx)("img", {
                                                                    src: player.image_url_logo
                                                                }) : null,
                                                                !player.image_url_logo ? i + 1 : null
                                                            ]
                                                        }),
                                                        /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                                                            className: "flex flex-1 items-center justify-between truncate rounded-r-md border-t border-r border-b border-gray-200 bg-white",
                                                            children: [
                                                                /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                                                                    className: "flex-1 truncate px-4 py-2 text-sm",
                                                                    children: [
                                                                        /*#__PURE__*/ (0,jsx_runtime.jsx)(next_link["default"], {
                                                                            href: "/series/".concat(seriesContext.id, "/player/").concat(player.user_id),
                                                                            children: /*#__PURE__*/ (0,jsx_runtime.jsx)("a", {
                                                                                className: "font-medium text-gray-900 hover:text-gray-600",
                                                                                children: player.name
                                                                            })
                                                                        }),
                                                                        /*#__PURE__*/ (0,jsx_runtime.jsxs)("p", {
                                                                            className: "text-gray-500",
                                                                            children: [
                                                                                player.points_standing,
                                                                                " Po\xe4ng"
                                                                            ]
                                                                        })
                                                                    ]
                                                                }),
                                                                /*#__PURE__*/ (0,jsx_runtime.jsxs)(menu_esm/* Menu */.v, {
                                                                    as: "div",
                                                                    className: "flex-shrink-0 pr-2",
                                                                    children: [
                                                                        /*#__PURE__*/ (0,jsx_runtime.jsxs)(menu_esm/* Menu.Button */.v.Button, {
                                                                            className: "inline-flex h-8 w-8 items-center justify-center rounded-full bg-white text-gray-400 hover:text-gray-500 focus:outline-none focus:ring-2 focus:ring-purple-500 focus:ring-offset-2",
                                                                            children: [
                                                                                /*#__PURE__*/ (0,jsx_runtime.jsx)("span", {
                                                                                    className: "sr-only",
                                                                                    children: "Open options"
                                                                                }),
                                                                                /*#__PURE__*/ (0,jsx_runtime.jsx)(outline_esm/* DotsVerticalIcon */.AjK, {
                                                                                    className: "h-5 w-5",
                                                                                    "aria-hidden": "true"
                                                                                })
                                                                            ]
                                                                        }),
                                                                        /*#__PURE__*/ (0,jsx_runtime.jsx)(transition_esm/* Transition */.u, {
                                                                            as: react.Fragment,
                                                                            enter: "transition ease-out duration-100",
                                                                            enterFrom: "transform opacity-0 scale-95",
                                                                            enterTo: "transform opacity-100 scale-100",
                                                                            leave: "transition ease-in duration-75",
                                                                            leaveFrom: "transform opacity-100 scale-100",
                                                                            leaveTo: "transform opacity-0 scale-95",
                                                                            children: /*#__PURE__*/ (0,jsx_runtime.jsx)(menu_esm/* Menu.Items */.v.Items, {
                                                                                className: "absolute right-10 top-3 z-10 mx-3 mt-1 w-48 origin-top-right divide-y divide-gray-200 rounded-md bg-white shadow-lg ring-1 ring-black ring-opacity-5 focus:outline-none",
                                                                                children: /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                                                                    className: "py-1",
                                                                                    children: /*#__PURE__*/ (0,jsx_runtime.jsx)(menu_esm/* Menu.Item */.v.Item, {
                                                                                        children: function(param) {
                                                                                            var active = param.active;
                                                                                            /*#__PURE__*/ return (0,jsx_runtime.jsx)(next_link["default"], {
                                                                                                href: "/series/".concat(seriesContext.id, "/player/").concat(player.user_id),
                                                                                                children: /*#__PURE__*/ (0,jsx_runtime.jsx)("a", {
                                                                                                    className: (0,classnames/* classNames */.A)(active ? 'bg-gray-100 text-gray-900' : 'text-gray-700', 'block px-4 py-2 text-sm'),
                                                                                                    children: "Se mer"
                                                                                                })
                                                                                            });
                                                                                        }
                                                                                    })
                                                                                })
                                                                            })
                                                                        })
                                                                    ]
                                                                })
                                                            ]
                                                        })
                                                    ]
                                                }, player.name);
                                            })
                                        })
                                    ]
                                }) : null,
                                /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                                    className: "mt-10 sm:hidden",
                                    children: [
                                        /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                            className: "px-4 sm:px-6",
                                            children: /*#__PURE__*/ (0,jsx_runtime.jsx)("h2", {
                                                className: "text-xs font-medium uppercase tracking-wide text-gray-500",
                                                children: "Tabell"
                                            })
                                        }),
                                        /*#__PURE__*/ (0,jsx_runtime.jsx)("ul", {
                                            role: "list",
                                            className: "mt-3 divide-y divide-gray-100 border-t border-gray-200",
                                            children: orderedStandings.map(function(player, i) {
                                                /*#__PURE__*/ return (0,jsx_runtime.jsx)("li", {
                                                    children: /*#__PURE__*/ (0,jsx_runtime.jsx)(next_link["default"], {
                                                        href: "/series/".concat(seriesContext.id, "/player/").concat(player.user_id),
                                                        children: /*#__PURE__*/ (0,jsx_runtime.jsxs)("a", {
                                                            className: "group flex items-center justify-between px-4 py-4 hover:bg-gray-50 sm:px-6",
                                                            children: [
                                                                /*#__PURE__*/ (0,jsx_runtime.jsxs)("span", {
                                                                    className: "flex items-center space-x-3 truncate",
                                                                    children: [
                                                                        /*#__PURE__*/ (0,jsx_runtime.jsx)("span", {
                                                                            className: 'flex flex-shrink-0 items-center justify-center font-mono',
                                                                            "aria-hidden": "true",
                                                                            children: i + 1
                                                                        }),
                                                                        /*#__PURE__*/ (0,jsx_runtime.jsxs)("span", {
                                                                            className: "truncate text-sm font-medium leading-6",
                                                                            children: [
                                                                                player.name,
                                                                                ' ',
                                                                                /*#__PURE__*/ (0,jsx_runtime.jsxs)("span", {
                                                                                    className: "truncate font-normal text-gray-500",
                                                                                    children: [
                                                                                        "med ",
                                                                                        player.points_standing,
                                                                                        " po\xe4ng"
                                                                                    ]
                                                                                })
                                                                            ]
                                                                        })
                                                                    ]
                                                                }),
                                                                /*#__PURE__*/ (0,jsx_runtime.jsx)(esm/* ChevronRightIcon */.XCv, {
                                                                    className: "ml-4 h-5 w-5 text-gray-400 group-hover:text-gray-500",
                                                                    "aria-hidden": "true"
                                                                })
                                                            ]
                                                        })
                                                    })
                                                }, player.user_id);
                                            })
                                        })
                                    ]
                                }),
                                /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                    className: "mt-8 hidden sm:block",
                                    children: /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                                        className: "inline-block min-w-full border-b border-gray-200 align-middle",
                                        children: [
                                            /*#__PURE__*/ (0,jsx_runtime.jsxs)("table", {
                                                className: "min-w-full table-auto",
                                                children: [
                                                    /*#__PURE__*/ (0,jsx_runtime.jsx)("thead", {
                                                        children: /*#__PURE__*/ (0,jsx_runtime.jsxs)("tr", {
                                                            className: "border-t border-gray-200",
                                                            children: [
                                                                /*#__PURE__*/ (0,jsx_runtime.jsx)("th", {
                                                                    className: "border-b border-gray-200 bg-gray-50 px-6 py-3 text-center text-xs font-bold uppercase tracking-wider text-gray-500",
                                                                    children: "Rank"
                                                                }),
                                                                /*#__PURE__*/ (0,jsx_runtime.jsx)("th", {
                                                                    className: "border-b border-gray-200 bg-gray-50 px-6 py-3 text-left text-xs font-bold uppercase tracking-wider text-gray-500",
                                                                    children: "Lag"
                                                                }),
                                                                /*#__PURE__*/ (0,jsx_runtime.jsx)("th", {
                                                                    className: "hidden border-b border-gray-200 bg-gray-50 px-6 py-3 text-center text-xs font-bold uppercase tracking-wider text-gray-500 sm:table-cell",
                                                                    children: "GP"
                                                                }),
                                                                /*#__PURE__*/ (0,jsx_runtime.jsx)("th", {
                                                                    className: "hidden border-b border-gray-200 bg-gray-50 px-6 py-3 text-center text-xs font-bold uppercase tracking-wider text-gray-500 sm:table-cell",
                                                                    children: "5P"
                                                                }),
                                                                /*#__PURE__*/ (0,jsx_runtime.jsx)("th", {
                                                                    className: "hidden border-b border-gray-200 bg-gray-50 px-6 py-3 text-center text-xs font-bold uppercase tracking-wider text-gray-500 sm:table-cell",
                                                                    children: "4P"
                                                                }),
                                                                /*#__PURE__*/ (0,jsx_runtime.jsx)("th", {
                                                                    className: "hidden border-b border-gray-200 bg-gray-50 px-6 py-3 text-center text-xs font-bold uppercase tracking-wider text-gray-500 sm:table-cell",
                                                                    children: "3P"
                                                                }),
                                                                /*#__PURE__*/ (0,jsx_runtime.jsx)("th", {
                                                                    className: "hidden border-b border-gray-200 bg-gray-50 px-6 py-3 text-center text-xs font-bold uppercase tracking-wider text-gray-500 sm:table-cell",
                                                                    children: "2P"
                                                                }),
                                                                /*#__PURE__*/ (0,jsx_runtime.jsx)("th", {
                                                                    className: "hidden border-b border-gray-200 bg-gray-50 px-6 py-3 text-center text-xs font-bold uppercase tracking-wider text-gray-500 sm:table-cell",
                                                                    children: "-2P"
                                                                }),
                                                                /*#__PURE__*/ (0,jsx_runtime.jsx)("th", {
                                                                    className: "hidden border-b border-gray-200 bg-gray-50 px-6 py-3 text-center text-xs font-bold uppercase tracking-wider text-gray-500 sm:table-cell",
                                                                    children: "-3P"
                                                                }),
                                                                /*#__PURE__*/ (0,jsx_runtime.jsx)("th", {
                                                                    className: "hidden border-b border-gray-200 bg-gray-50 px-6 py-3 text-center text-xs font-bold uppercase tracking-wider text-gray-500 sm:table-cell",
                                                                    children: "G"
                                                                }),
                                                                /*#__PURE__*/ (0,jsx_runtime.jsx)("th", {
                                                                    className: "hidden border-b border-gray-200 bg-gray-50 px-6 py-3 text-center text-xs font-bold uppercase tracking-wider text-gray-500 sm:table-cell",
                                                                    children: "GA"
                                                                }),
                                                                /*#__PURE__*/ (0,jsx_runtime.jsx)("th", {
                                                                    className: "hidden border-b border-gray-200 bg-gray-50 px-6 py-3 text-center text-xs font-bold uppercase tracking-wider text-gray-500 sm:table-cell",
                                                                    children: "+/-"
                                                                }),
                                                                /*#__PURE__*/ (0,jsx_runtime.jsx)("th", {
                                                                    className: "hidden border-b border-gray-200 bg-gray-100 px-6 py-3 text-center text-xs font-bold uppercase tracking-wider text-gray-500 sm:table-cell",
                                                                    children: "Po\xe4ng"
                                                                })
                                                            ]
                                                        })
                                                    }),
                                                    /*#__PURE__*/ (0,jsx_runtime.jsx)("tbody", {
                                                        className: "divide-y divide-gray-100 bg-white",
                                                        children: orderedStandings.map(function(standingsRow, i) {
                                                            return(/*#__PURE__*/ (0,jsx_runtime.jsxs)("tr", {
                                                                className: i % 2 ? 'bg-gray-50' : '',
                                                                children: [
                                                                    /*#__PURE__*/ (0,jsx_runtime.jsx)("td", {
                                                                        className: "whitespace-nowrap px-6 py-3 text-center text-sm font-light lining-nums text-gray-500",
                                                                        children: i + 1
                                                                    }),
                                                                    /*#__PURE__*/ (0,jsx_runtime.jsx)("td", {
                                                                        className: "whitespace-nowrap px-6 py-3 text-sm font-medium text-gray-900",
                                                                        children: /*#__PURE__*/ (0,jsx_runtime.jsx)(next_link["default"], {
                                                                            href: "/series/".concat(seriesContext.id, "/player/").concat(standingsRow.user_id),
                                                                            children: /*#__PURE__*/ (0,jsx_runtime.jsx)("a", {
                                                                                className: "truncate hover:text-gray-600",
                                                                                children: standingsRow.name
                                                                            })
                                                                        })
                                                                    }),
                                                                    /*#__PURE__*/ (0,jsx_runtime.jsx)("td", {
                                                                        className: "hidden whitespace-nowrap px-6 py-3 text-center text-sm font-light lining-nums text-gray-500 sm:table-cell",
                                                                        children: standingsRow.no_of_matches
                                                                    }),
                                                                    /*#__PURE__*/ (0,jsx_runtime.jsx)("td", {
                                                                        className: "hidden whitespace-nowrap px-6 py-3 text-center text-sm font-light lining-nums text-gray-500 sm:table-cell",
                                                                        children: standingsRow.five_points
                                                                    }),
                                                                    /*#__PURE__*/ (0,jsx_runtime.jsx)("td", {
                                                                        className: "hidden whitespace-nowrap px-6 py-3 text-center text-sm font-light lining-nums text-gray-500 sm:table-cell",
                                                                        children: standingsRow.four_points
                                                                    }),
                                                                    /*#__PURE__*/ (0,jsx_runtime.jsx)("td", {
                                                                        className: "hidden whitespace-nowrap px-6 py-3 text-center text-sm font-light lining-nums text-gray-500 sm:table-cell",
                                                                        children: standingsRow.three_points
                                                                    }),
                                                                    /*#__PURE__*/ (0,jsx_runtime.jsx)("td", {
                                                                        className: "hidden whitespace-nowrap px-6 py-3 text-center text-sm font-light lining-nums text-gray-500 sm:table-cell",
                                                                        children: standingsRow.two_points
                                                                    }),
                                                                    /*#__PURE__*/ (0,jsx_runtime.jsx)("td", {
                                                                        className: "hidden whitespace-nowrap px-6 py-3 text-center text-sm font-light lining-nums text-gray-500 sm:table-cell",
                                                                        children: standingsRow.minus_two_points
                                                                    }),
                                                                    /*#__PURE__*/ (0,jsx_runtime.jsx)("td", {
                                                                        className: "hidden whitespace-nowrap px-6 py-3 text-center text-sm font-light lining-nums text-gray-500 sm:table-cell",
                                                                        children: standingsRow.minus_three_points
                                                                    }),
                                                                    /*#__PURE__*/ (0,jsx_runtime.jsx)("td", {
                                                                        className: "hidden whitespace-nowrap px-6 py-3 text-center text-sm font-light lining-nums text-gray-500 sm:table-cell",
                                                                        children: standingsRow.total_games_won
                                                                    }),
                                                                    /*#__PURE__*/ (0,jsx_runtime.jsx)("td", {
                                                                        className: "hidden whitespace-nowrap px-6 py-3 text-center text-sm font-light lining-nums text-gray-500 sm:table-cell",
                                                                        children: standingsRow.total_games_lost
                                                                    }),
                                                                    /*#__PURE__*/ (0,jsx_runtime.jsx)("td", {
                                                                        className: "hidden whitespace-nowrap px-6 py-3 text-center text-sm font-light lining-nums text-gray-500 sm:table-cell",
                                                                        children: standingsRow.plus_minus
                                                                    }),
                                                                    /*#__PURE__*/ (0,jsx_runtime.jsx)("td", {
                                                                        className: "hidden whitespace-nowrap bg-gray-100 px-6 py-3 text-center text-sm font-light lining-nums text-gray-500 sm:table-cell",
                                                                        children: standingsRow.points_standing
                                                                    })
                                                                ]
                                                            }, standingsRow.name));
                                                        })
                                                    })
                                                ]
                                            }),
                                            /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                                className: "bg-white shadow sm:rounded-lg",
                                                children: /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                                                    className: "px-4 py-5 sm:p-6",
                                                    children: [
                                                        /*#__PURE__*/ (0,jsx_runtime.jsx)("h3", {
                                                            className: "text-lg font-medium leading-6 text-gray-900",
                                                            children: "F\xf6rkortningar"
                                                        }),
                                                        /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                                            className: "mt-5",
                                                            children: /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                                                className: "rounded-md bg-gray-50 px-6 py-5 sm:flex sm:items-start sm:justify-between",
                                                                children: /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                                                    className: "grid grid-cols-12",
                                                                    children: [
                                                                        {
                                                                            text: 'Rank',
                                                                            description: 'Ranking'
                                                                        },
                                                                        {
                                                                            text: 'Lag',
                                                                            description: 'Lag f\xf6r vald s\xe4song'
                                                                        },
                                                                        {
                                                                            text: 'GP',
                                                                            description: 'Spelade matcher'
                                                                        },
                                                                        {
                                                                            text: '5P',
                                                                            description: '5 po\xe4ng (stor vinst)'
                                                                        },
                                                                        {
                                                                            text: '4P',
                                                                            description: '4 po\xe4ng (medelstor vinst)'
                                                                        },
                                                                        {
                                                                            text: '3P',
                                                                            description: '3 po\xe4ng (liten vinst)'
                                                                        },
                                                                        {
                                                                            text: '2P',
                                                                            description: '2 po\xe4ng (vinst efter tiebreak)'
                                                                        },
                                                                        {
                                                                            text: '-2P',
                                                                            description: '-2 po\xe4ng (f\xf6rlust i tiebreak)'
                                                                        },
                                                                        {
                                                                            text: '-3P',
                                                                            description: '-3 po\xe4ng (f\xf6rlust)'
                                                                        },
                                                                        {
                                                                            text: 'G',
                                                                            description: 'Vunna gem'
                                                                        },
                                                                        {
                                                                            text: 'GA',
                                                                            description: 'F\xf6rlorade gem'
                                                                        },
                                                                        {
                                                                            text: '+/-',
                                                                            description: 'Plus/minus f\xf6r gem'
                                                                        },
                                                                        {
                                                                            text: 'Po\xe4ng',
                                                                            description: 'Nuvarande po\xe4ng med start p\xe5 100 po\xe4ng'
                                                                        }, 
                                                                    ].map(function(abbr) {
                                                                        /*#__PURE__*/ return (0,jsx_runtime.jsxs)(react.Fragment, {
                                                                            children: [
                                                                                /*#__PURE__*/ (0,jsx_runtime.jsx)("p", {
                                                                                    className: "col-span-2 col-start-1 font-bold",
                                                                                    children: abbr.text
                                                                                }),
                                                                                /*#__PURE__*/ (0,jsx_runtime.jsx)("p", {
                                                                                    className: "col-span-10 col-start-3",
                                                                                    children: abbr.description
                                                                                })
                                                                            ]
                                                                        }, abbr.text);
                                                                    })
                                                                })
                                                            })
                                                        })
                                                    ]
                                                })
                                            })
                                        ]
                                    })
                                })
                            ]
                        })
                    ]
                })
            ]
        })
    }));
};

;// CONCATENATED MODULE: ./components/ds/05-pages/series/standings/player/types.ts

var PlayerStandingRow = es6/* type */.dt({
    user_id: es6/* string */.Z_,
    name: es6/* string */.Z_,
    points_standing: es6/* number */.pk,
    average_match_point: es6/* number */.pk,
    no_of_matches: es6/* number */.pk,
    positive: es6/* number */.pk,
    negative: es6/* number */.pk,
    total_games_won: es6/* number */.pk,
    total_games_lost: es6/* number */.pk,
    plus_minus: es6/* number */.pk,
    five_points: es6/* number */.pk,
    four_points: es6/* number */.pk,
    three_points: es6/* number */.pk,
    two_points: es6/* number */.pk,
    minus_two_points: es6/* number */.pk,
    minus_three_points: es6/* number */.pk,
    image_url_logo: es6/* union */.G0([
        es6/* string */.Z_,
        es6/* null */.lB
    ])
});
var PlayerStandingRows = es6/* array */.IX(PlayerStandingRow);

;// CONCATENATED MODULE: ./components/ds/05-pages/series/standings/player/index.tsx







var PlayerStandingsPage = function(param) {
    var standings = param.standings, seriesContext = param.seriesContext;
    var router = (0,next_router.useRouter)();
    var locale = (0,utils_locale/* makeLocale */.W)(router.locale, router.defaultLocale) || 'sv';
    var translation = player_translations_translations[locale];
    return(/*#__PURE__*/ (0,jsx_runtime.jsxs)(jsx_runtime.Fragment, {
        children: [
            /*#__PURE__*/ (0,jsx_runtime.jsx)(Head, {
                title: translation.pageTitle,
                description: translation.pageDescription
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)(layout_StandingsLayout, {
                standings: standings,
                seriesContext: seriesContext
            })
        ]
    }));
};

;// CONCATENATED MODULE: ./components/ds/05-pages/series/standings/index.ts



// EXTERNAL MODULE: ./components/index.ts
var components = __webpack_require__(339);
;// CONCATENATED MODULE: ./components/ds/05-pages/series/matches/translations.tsx
var matches_translations_translations = {
    sv: {
        pageTitle: 'Matcher',
        pageDescription: 'H\xe4r kan du se de matcher som hittills har spelats i \xd6NP.'
    },
    en: {
        pageTitle: 'Matcher',
        pageDescription: 'H\xe4r kan du se de matcher som hittills har spelats i \xd6NP.'
    }
};

;// CONCATENATED MODULE: ./components/ds/05-pages/series/matches/layout/index.tsx

/* eslint-disable @next/next/no-img-element */ 




var MatchResultsPageLayout = function(param) {
    var matchResults = param.matchResults, seriesContext = param.seriesContext;
    var ref = (0,react.useState)(false), sidebarOpen = ref[0], setSidebarOpen = ref[1];
    (0,react.useEffect)(function() {
        if (document) {
            var htmlEl = document.querySelector('html');
            if (htmlEl) {
                htmlEl.classList.add('h-full');
                htmlEl.classList.add('bg-white');
            }
            var bodyEl = document.querySelector('body');
            if (bodyEl) {
                bodyEl.classList.add('h-full');
                bodyEl.classList.add('overflow-hidden');
            }
            var nextWrapperEl = document.querySelector('#__next');
            if (nextWrapperEl) {
                nextWrapperEl.classList.add('h-full');
                nextWrapperEl.classList.add('overflow-hidden');
            }
        }
    });
    return(/*#__PURE__*/ (0,jsx_runtime.jsx)(jsx_runtime.Fragment, {
        children: /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
            className: "h-full flex",
            children: [
                /*#__PURE__*/ (0,jsx_runtime.jsx)(header/* Header */.h, {
                    sidebarOpen: sidebarOpen,
                    setSidebarOpen: setSidebarOpen,
                    incomingSeriesId: seriesContext.id,
                    seriesContext: seriesContext
                }),
                /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                    className: "flex flex-col w-0 flex-1 overflow-hidden",
                    children: [
                        /*#__PURE__*/ (0,jsx_runtime.jsx)(search_header/* SearchHeader */.s, {
                            sidebarOpen: sidebarOpen,
                            setSidebarOpen: setSidebarOpen
                        }),
                        /*#__PURE__*/ (0,jsx_runtime.jsxs)("main", {
                            className: "flex-1 relative z-0 overflow-y-auto focus:outline-none",
                            children: [
                                matchResults.length === 0 ? /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                                    className: "mt-12 text-center",
                                    children: [
                                        /*#__PURE__*/ (0,jsx_runtime.jsx)(esm/* StopIcon */.wNq, {
                                            className: "mx-auto h-12 w-12 text-gray-400",
                                            "aria-hidden": "true"
                                        }),
                                        /*#__PURE__*/ (0,jsx_runtime.jsx)("h3", {
                                            className: "mt-2 text-sm font-medium text-gray-900",
                                            children: "Inga matcher"
                                        }),
                                        /*#__PURE__*/ (0,jsx_runtime.jsx)("p", {
                                            className: "mt-1 text-sm text-gray-500",
                                            children: "Kom tillbaka till den h\xe4r sidan vid ett senare tillf\xe4lle."
                                        })
                                    ]
                                }) : null,
                                matchResults.length > 0 ? /*#__PURE__*/ (0,jsx_runtime.jsx)(MatchResultList, {
                                    matches: matchResults,
                                    seriesContext: seriesContext
                                }) : null
                            ]
                        })
                    ]
                })
            ]
        })
    }));
};

;// CONCATENATED MODULE: ./components/ds/05-pages/series/matches/index.tsx







var MatchResultsPage = function(param) {
    var matchResults = param.matchResults, type = param.type, seriesContext = param.seriesContext;
    var router = (0,next_router.useRouter)();
    var locale = (0,utils_locale/* makeLocale */.W)(router.locale, router.defaultLocale) || 'sv';
    var translation = matches_translations_translations[locale];
    return(/*#__PURE__*/ (0,jsx_runtime.jsxs)(jsx_runtime.Fragment, {
        children: [
            /*#__PURE__*/ (0,jsx_runtime.jsx)(components/* Head */.Fb, {
                title: translation.pageTitle,
                description: translation.pageDescription
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)(MatchResultsPageLayout, {
                matchResults: matchResults,
                type: type,
                seriesContext: seriesContext
            })
        ]
    }));
};

;// CONCATENATED MODULE: ./components/ds/05-pages/series/match/translations.tsx
var match_translations_translations = {
    sv: {
        pageTitle: 'Match',
        pageDescription: 'Detaljer om en match i N\xe4tverkspadeln'
    },
    en: {
        pageTitle: 'Match',
        pageDescription: 'Detaljer om en match i N\xe4tverkspadeln'
    }
};

;// CONCATENATED MODULE: ./components/ds/05-pages/series/match/layout/index.tsx





var MatchPageLayout = function(param) {
    var match = param.match, seriesContext = param.seriesContext;
    var ref = (0,react.useState)(false), sidebarOpen = ref[0], setSidebarOpen = ref[1];
    (0,react.useEffect)(function() {
        if (document) {
            var htmlEl = document.querySelector('html');
            if (htmlEl) {
                htmlEl.classList.add('h-full');
                htmlEl.classList.add('bg-white');
            }
            var bodyEl = document.querySelector('body');
            if (bodyEl) {
                bodyEl.classList.add('h-full');
                bodyEl.classList.add('overflow-hidden');
            }
            var nextWrapperEl = document.querySelector('#__next');
            if (nextWrapperEl) {
                nextWrapperEl.classList.add('h-full');
                nextWrapperEl.classList.add('overflow-hidden');
            }
        }
    });
    return(/*#__PURE__*/ (0,jsx_runtime.jsx)(jsx_runtime.Fragment, {
        children: /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
            className: "h-full flex",
            children: [
                /*#__PURE__*/ (0,jsx_runtime.jsx)(header/* Header */.h, {
                    sidebarOpen: sidebarOpen,
                    setSidebarOpen: setSidebarOpen,
                    incomingSeriesId: seriesContext.id,
                    seriesContext: seriesContext
                }),
                /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                    className: "flex flex-col w-0 flex-1 overflow-hidden",
                    children: [
                        /*#__PURE__*/ (0,jsx_runtime.jsx)(search_header/* SearchHeader */.s, {
                            sidebarOpen: sidebarOpen,
                            setSidebarOpen: setSidebarOpen
                        }),
                        /*#__PURE__*/ (0,jsx_runtime.jsx)("main", {
                            className: "flex-1 relative z-0 overflow-y-auto focus:outline-none",
                            children: /*#__PURE__*/ (0,jsx_runtime.jsx)(MatchResultSummary, {
                                match: match,
                                seriesContext: seriesContext
                            }, match.match_id)
                        })
                    ]
                })
            ]
        })
    }));
};

;// CONCATENATED MODULE: ./components/ds/05-pages/series/match/index.tsx







var MatchPage = function(param) {
    var match = param.match, seriesContext = param.seriesContext;
    var router = (0,next_router.useRouter)();
    var locale = (0,utils_locale/* makeLocale */.W)(router.locale, router.defaultLocale) || 'sv';
    var translation = match_translations_translations[locale];
    return(/*#__PURE__*/ (0,jsx_runtime.jsxs)(jsx_runtime.Fragment, {
        children: [
            /*#__PURE__*/ (0,jsx_runtime.jsx)(components/* Head */.Fb, {
                title: translation.pageTitle,
                description: translation.pageDescription
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)(MatchPageLayout, {
                match: match,
                seriesContext: seriesContext
            })
        ]
    }));
};

;// CONCATENATED MODULE: ./components/ds/05-pages/series/match-result-form/translations.tsx
var match_result_form_translations_translations = {
    sv: {
        pageTitle: 'Redigera matchresultat',
        pageDescription: 'Redigera matchresultat i N\xe4tverkspadeln'
    },
    en: {
        pageTitle: 'Redigera matchresultat',
        pageDescription: 'Redigera matchresultat i N\xe4tverkspadeln'
    }
};

;// CONCATENATED MODULE: ./components/ds/05-pages/series/match-result-form/layout/index.tsx





var MatchResultFormLayout = function(param) {
    var match = param.match, seriesContext = param.seriesContext;
    var ref = (0,react.useState)(false), sidebarOpen = ref[0], setSidebarOpen = ref[1];
    (0,react.useEffect)(function() {
        if (document) {
            var htmlEl = document.querySelector('html');
            if (htmlEl) {
                htmlEl.classList.add('h-full');
                htmlEl.classList.add('bg-white');
            }
            var bodyEl = document.querySelector('body');
            if (bodyEl) {
                bodyEl.classList.add('h-full');
                bodyEl.classList.add('overflow-hidden');
            }
            var nextWrapperEl = document.querySelector('#__next');
            if (nextWrapperEl) {
                nextWrapperEl.classList.add('h-full');
                nextWrapperEl.classList.add('overflow-hidden');
            }
        }
    });
    return(/*#__PURE__*/ (0,jsx_runtime.jsx)(jsx_runtime.Fragment, {
        children: /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
            className: "h-full flex",
            children: [
                /*#__PURE__*/ (0,jsx_runtime.jsx)(header/* Header */.h, {
                    sidebarOpen: sidebarOpen,
                    setSidebarOpen: setSidebarOpen,
                    incomingSeriesId: seriesContext.id,
                    seriesContext: seriesContext
                }),
                /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                    className: "flex flex-col w-0 flex-1 overflow-hidden",
                    children: [
                        /*#__PURE__*/ (0,jsx_runtime.jsx)(search_header/* SearchHeader */.s, {
                            sidebarOpen: sidebarOpen,
                            setSidebarOpen: setSidebarOpen
                        }),
                        /*#__PURE__*/ (0,jsx_runtime.jsx)("main", {
                            className: "flex-1 relative z-0 overflow-y-auto focus:outline-none",
                            children: /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                className: "px-4 py-5 sm:px-6",
                                children: /*#__PURE__*/ (0,jsx_runtime.jsx)(MatchEditResultForm, {
                                    match: match,
                                    seriesContext: seriesContext
                                })
                            })
                        })
                    ]
                })
            ]
        })
    }));
};

;// CONCATENATED MODULE: ./components/ds/05-pages/series/match-result-form/index.tsx







var MatchResultFormPage = function(param) {
    var match = param.match, seriesContext = param.seriesContext;
    var router = (0,next_router.useRouter)();
    var locale = (0,utils_locale/* makeLocale */.W)(router.locale, router.defaultLocale) || 'sv';
    var translation = match_result_form_translations_translations[locale];
    return(/*#__PURE__*/ (0,jsx_runtime.jsxs)(jsx_runtime.Fragment, {
        children: [
            /*#__PURE__*/ (0,jsx_runtime.jsx)(components/* Head */.Fb, {
                title: translation.pageTitle,
                description: translation.pageDescription
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)(MatchResultFormLayout, {
                match: match,
                seriesContext: seriesContext
            })
        ]
    }));
};

;// CONCATENATED MODULE: ./components/ds/05-pages/series/match-result-report/translations.tsx
var match_result_report_translations_translations = {
    sv: {
        pageTitle: 'Rapportera matchresultat',
        pageDescription: 'Rapportera matchresultat i N\xe4tverkspadeln'
    },
    en: {
        pageTitle: 'Rapportera matchresultat',
        pageDescription: 'Rapportera matchresultat i N\xe4tverkspadeln'
    }
};

;// CONCATENATED MODULE: ./components/ds/05-pages/series/match-result-report/layout/index.tsx




var MatchResultReportLayout = function(param) {
    var match = param.match, seriesContext = param.seriesContext;
    var ref = (0,react.useState)(false), sidebarOpen = ref[0], setSidebarOpen = ref[1];
    (0,react.useEffect)(function() {
        if (document) {
            var htmlEl = document.querySelector('html');
            if (htmlEl) {
                htmlEl.classList.add('h-full');
                htmlEl.classList.add('bg-white');
            }
            var bodyEl = document.querySelector('body');
            if (bodyEl) {
                bodyEl.classList.add('h-full');
                bodyEl.classList.add('overflow-hidden');
            }
            var nextWrapperEl = document.querySelector('#__next');
            if (nextWrapperEl) {
                nextWrapperEl.classList.add('h-full');
                nextWrapperEl.classList.add('overflow-hidden');
            }
        }
    });
    return(/*#__PURE__*/ (0,jsx_runtime.jsx)(jsx_runtime.Fragment, {
        children: /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
            className: "h-full flex",
            children: [
                /*#__PURE__*/ (0,jsx_runtime.jsx)(header/* Header */.h, {
                    sidebarOpen: sidebarOpen,
                    setSidebarOpen: setSidebarOpen,
                    incomingSeriesId: seriesContext.id,
                    seriesContext: seriesContext
                }),
                /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                    className: "flex flex-col w-0 flex-1 overflow-hidden",
                    children: [
                        /*#__PURE__*/ (0,jsx_runtime.jsx)(search_header/* SearchHeader */.s, {
                            sidebarOpen: sidebarOpen,
                            setSidebarOpen: setSidebarOpen
                        }),
                        /*#__PURE__*/ (0,jsx_runtime.jsx)("main", {
                            className: "flex-1 relative z-0 overflow-y-auto focus:outline-none",
                            children: /*#__PURE__*/ (0,jsx_runtime.jsx)("p", {
                                children: "L\xe4gg till flagga/rapportera form h\xe4r"
                            })
                        })
                    ]
                })
            ]
        })
    }));
};

;// CONCATENATED MODULE: ./components/ds/05-pages/series/match-result-report/index.tsx







var MatchResultReportPage = function(param) {
    var match = param.match, seriesContext = param.seriesContext;
    var router = (0,next_router.useRouter)();
    var locale = (0,utils_locale/* makeLocale */.W)(router.locale, router.defaultLocale) || 'sv';
    var translation = match_result_report_translations_translations[locale];
    return(/*#__PURE__*/ (0,jsx_runtime.jsxs)(jsx_runtime.Fragment, {
        children: [
            /*#__PURE__*/ (0,jsx_runtime.jsx)(components/* Head */.Fb, {
                title: translation.pageTitle,
                description: translation.pageDescription
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)(MatchResultReportLayout, {
                match: match,
                seriesContext: seriesContext
            })
        ]
    }));
};

;// CONCATENATED MODULE: ./components/ds/05-pages/series/team/translations.tsx
var series_team_translations_translations = {
    sv: {
        pageTitle: '\xd6-viks N\xe4tverkspadel',
        pageDescription: 'Vi samlas p\xe5 onsdagar f\xf6r att spela padel och n\xe4tverka. Tv\xe5 flugor i en sm\xe4ll.'
    },
    en: {
        pageTitle: "\xd6-vik's Network Padel ",
        pageDescription: 'We gather on Wednesdays to play padel and network. Two birds with one stone.'
    }
};

;// CONCATENATED MODULE: ./components/ds/05-pages/series/team/layout/index.tsx

/* eslint-disable @next/next/no-img-element */ 



var TeamPageLayout = function(param) {
    var matchResults = param.matchResults, teamInformation = param.teamInformation, seriesContext = param.seriesContext;
    var ref = (0,react.useState)(false), sidebarOpen = ref[0], setSidebarOpen = ref[1];
    (0,react.useEffect)(function() {
        if (document) {
            var htmlEl = document.querySelector("html");
            if (htmlEl) {
                htmlEl.classList.add("h-full");
                htmlEl.classList.add("bg-white");
            }
            var bodyEl = document.querySelector("body");
            if (bodyEl) {
                bodyEl.classList.add("h-full");
                bodyEl.classList.add("overflow-hidden");
            }
            var nextWrapperEl = document.querySelector("#__next");
            if (nextWrapperEl) {
                nextWrapperEl.classList.add("h-full");
                nextWrapperEl.classList.add("overflow-hidden");
            }
        }
    });
    return(/*#__PURE__*/ (0,jsx_runtime.jsx)(jsx_runtime.Fragment, {
        children: /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
            className: "h-full flex",
            children: [
                /*#__PURE__*/ (0,jsx_runtime.jsx)(header/* Header */.h, {
                    sidebarOpen: sidebarOpen,
                    setSidebarOpen: setSidebarOpen,
                    incomingSeriesId: seriesContext.id,
                    seriesContext: seriesContext
                }),
                /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                    className: "flex flex-col w-0 flex-1 overflow-hidden",
                    children: [
                        /*#__PURE__*/ (0,jsx_runtime.jsx)(search_header/* SearchHeader */.s, {
                            sidebarOpen: sidebarOpen,
                            setSidebarOpen: setSidebarOpen
                        }),
                        /*#__PURE__*/ (0,jsx_runtime.jsxs)("main", {
                            className: "flex-1 relative z-0 overflow-y-auto focus:outline-none",
                            children: [
                                /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                    className: "border-b border-gray-200 px-4 py-4 sm:flex sm:items-center sm:justify-between sm:px-6 lg:px-8",
                                    children: /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                        className: "flex-1 min-w-0",
                                        children: /*#__PURE__*/ (0,jsx_runtime.jsx)("h1", {
                                            className: "text-lg font-medium leading-6 text-gray-900 sm:truncate",
                                            children: teamInformation.name
                                        })
                                    })
                                }),
                                /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                    className: "mt-8 px-6 pb-5 border-b border-gray-200",
                                    children: /*#__PURE__*/ (0,jsx_runtime.jsx)("h3", {
                                        className: "text-lg leading-6 font-medium text-gray-900",
                                        children: "Statistik"
                                    })
                                }),
                                /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                    className: "mt-8 block overflow-y-scroll",
                                    children: /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                        className: "align-middle inline-block min-w-full border-b border-gray-200",
                                        children: /*#__PURE__*/ (0,jsx_runtime.jsxs)("table", {
                                            className: "min-w-full table-auto",
                                            children: [
                                                /*#__PURE__*/ (0,jsx_runtime.jsx)("thead", {
                                                    children: /*#__PURE__*/ (0,jsx_runtime.jsxs)("tr", {
                                                        className: "border-t border-gray-200",
                                                        children: [
                                                            /*#__PURE__*/ (0,jsx_runtime.jsx)("th", {
                                                                className: "table-cell px-6 py-3 border-b border-gray-200 bg-gray-100 text-center text-xs font-bold text-gray-500 uppercase tracking-wider",
                                                                children: "Po\xe4ng"
                                                            }),
                                                            /*#__PURE__*/ (0,jsx_runtime.jsx)("th", {
                                                                className: "table-cell px-6 py-3 border-b border-gray-200 bg-gray-50 text-center text-xs font-bold text-gray-500 uppercase tracking-wider",
                                                                children: "GP"
                                                            }),
                                                            /*#__PURE__*/ (0,jsx_runtime.jsx)("th", {
                                                                className: "table-cell px-6 py-3 border-b border-gray-200 bg-gray-50 text-center text-xs font-bold text-gray-500 uppercase tracking-wider",
                                                                children: "5P"
                                                            }),
                                                            /*#__PURE__*/ (0,jsx_runtime.jsx)("th", {
                                                                className: "table-cell px-6 py-3 border-b border-gray-200 bg-gray-50 text-center text-xs font-bold text-gray-500 uppercase tracking-wider",
                                                                children: "4P"
                                                            }),
                                                            /*#__PURE__*/ (0,jsx_runtime.jsx)("th", {
                                                                className: "table-cell px-6 py-3 border-b border-gray-200 bg-gray-50 text-center text-xs font-bold text-gray-500 uppercase tracking-wider",
                                                                children: "3P"
                                                            }),
                                                            /*#__PURE__*/ (0,jsx_runtime.jsx)("th", {
                                                                className: "table-cell px-6 py-3 border-b border-gray-200 bg-gray-50 text-center text-xs font-bold text-gray-500 uppercase tracking-wider",
                                                                children: "2P"
                                                            }),
                                                            /*#__PURE__*/ (0,jsx_runtime.jsx)("th", {
                                                                className: "table-cell px-6 py-3 border-b border-gray-200 bg-gray-50 text-center text-xs font-bold text-gray-500 uppercase tracking-wider",
                                                                children: "-2P"
                                                            }),
                                                            /*#__PURE__*/ (0,jsx_runtime.jsx)("th", {
                                                                className: "table-cell px-6 py-3 border-b border-gray-200 bg-gray-50 text-center text-xs font-bold text-gray-500 uppercase tracking-wider",
                                                                children: "-3P"
                                                            }),
                                                            /*#__PURE__*/ (0,jsx_runtime.jsx)("th", {
                                                                className: "table-cell px-6 py-3 border-b border-gray-200 bg-gray-50 text-center text-xs font-bold text-gray-500 uppercase tracking-wider",
                                                                children: "G"
                                                            }),
                                                            /*#__PURE__*/ (0,jsx_runtime.jsx)("th", {
                                                                className: "table-cell px-6 py-3 border-b border-gray-200 bg-gray-50 text-center text-xs font-bold text-gray-500 uppercase tracking-wider",
                                                                children: "GA"
                                                            }),
                                                            /*#__PURE__*/ (0,jsx_runtime.jsx)("th", {
                                                                className: "table-cell px-6 py-3 border-b border-gray-200 bg-gray-50 text-center text-xs font-bold text-gray-500 uppercase tracking-wider",
                                                                children: "+/-"
                                                            })
                                                        ]
                                                    })
                                                }),
                                                /*#__PURE__*/ (0,jsx_runtime.jsx)("tbody", {
                                                    className: "bg-white divide-y divide-gray-100",
                                                    children: /*#__PURE__*/ (0,jsx_runtime.jsxs)("tr", {
                                                        children: [
                                                            /*#__PURE__*/ (0,jsx_runtime.jsx)("td", {
                                                                className: "table-cell px-6 py-3 whitespace-nowrap text-sm text-gray-500 bg-gray-100 text-center lining-nums font-light",
                                                                children: teamInformation.points_standing
                                                            }),
                                                            /*#__PURE__*/ (0,jsx_runtime.jsx)("td", {
                                                                className: "table-cell px-6 py-3 whitespace-nowrap text-sm text-gray-500 text-center lining-nums font-light",
                                                                children: teamInformation.no_of_matches
                                                            }),
                                                            /*#__PURE__*/ (0,jsx_runtime.jsx)("td", {
                                                                className: "table-cell px-6 py-3 whitespace-nowrap text-sm text-gray-500 text-center lining-nums font-light",
                                                                children: teamInformation.five_points
                                                            }),
                                                            /*#__PURE__*/ (0,jsx_runtime.jsx)("td", {
                                                                className: "table-cell px-6 py-3 whitespace-nowrap text-sm text-gray-500 text-center lining-nums font-light",
                                                                children: teamInformation.four_points
                                                            }),
                                                            /*#__PURE__*/ (0,jsx_runtime.jsx)("td", {
                                                                className: "table-cell px-6 py-3 whitespace-nowrap text-sm text-gray-500 text-center lining-nums font-light",
                                                                children: teamInformation.three_points
                                                            }),
                                                            /*#__PURE__*/ (0,jsx_runtime.jsx)("td", {
                                                                className: "table-cell px-6 py-3 whitespace-nowrap text-sm text-gray-500 text-center lining-nums font-light",
                                                                children: teamInformation.two_points
                                                            }),
                                                            /*#__PURE__*/ (0,jsx_runtime.jsx)("td", {
                                                                className: "table-cell px-6 py-3 whitespace-nowrap text-sm text-gray-500 text-center lining-nums font-light",
                                                                children: teamInformation.minus_two_points
                                                            }),
                                                            /*#__PURE__*/ (0,jsx_runtime.jsx)("td", {
                                                                className: "table-cell px-6 py-3 whitespace-nowrap text-sm text-gray-500 text-center lining-nums font-light",
                                                                children: teamInformation.minus_three_points
                                                            }),
                                                            /*#__PURE__*/ (0,jsx_runtime.jsx)("td", {
                                                                className: "table-cell px-6 py-3 whitespace-nowrap text-sm text-gray-500 text-center lining-nums font-light",
                                                                children: teamInformation.total_games_won
                                                            }),
                                                            /*#__PURE__*/ (0,jsx_runtime.jsx)("td", {
                                                                className: "table-cell px-6 py-3 whitespace-nowrap text-sm text-gray-500 text-center lining-nums font-light",
                                                                children: teamInformation.total_games_lost
                                                            }),
                                                            /*#__PURE__*/ (0,jsx_runtime.jsx)("td", {
                                                                className: "table-cell px-6 py-3 whitespace-nowrap text-sm text-gray-500 text-center lining-nums font-light",
                                                                children: teamInformation.plus_minus
                                                            })
                                                        ]
                                                    })
                                                })
                                            ]
                                        })
                                    })
                                }),
                                /*#__PURE__*/ (0,jsx_runtime.jsx)(MatchResultList, {
                                    matches: matchResults,
                                    seriesContext: seriesContext
                                }),
                                /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                    className: "mt-8 px-6 pb-5 border-b border-gray-200",
                                    children: /*#__PURE__*/ (0,jsx_runtime.jsx)("h3", {
                                        className: "text-lg leading-6 font-medium text-gray-900",
                                        children: "F\xf6rkortningar"
                                    })
                                }),
                                /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                    className: "bg-gray-50 px-6 py-5 sm:flex sm:items-start sm:justify-between",
                                    children: /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                        className: "grid grid-cols-12",
                                        children: [
                                            {
                                                text: 'Rank',
                                                description: 'Ranking'
                                            },
                                            {
                                                text: 'Lag',
                                                description: 'Lag f\xf6r vald s\xe4song'
                                            },
                                            {
                                                text: 'GP',
                                                description: 'Spelade matcher'
                                            },
                                            {
                                                text: '5P',
                                                description: '5 po\xe4ng (stor vinst)'
                                            },
                                            {
                                                text: '4P',
                                                description: '4 po\xe4ng (medelstor vinst)'
                                            },
                                            {
                                                text: '3P',
                                                description: '3 po\xe4ng (liten vinst)'
                                            },
                                            {
                                                text: '2P',
                                                description: '2 po\xe4ng (vinst i tiebreak)'
                                            },
                                            {
                                                text: '-2P',
                                                description: '-2 po\xe4ng (f\xf6rlust i tiebreak)'
                                            },
                                            {
                                                text: '-3P',
                                                description: '-3 po\xe4ng (f\xf6rlust)'
                                            },
                                            {
                                                text: 'G',
                                                description: 'Vunna gem'
                                            },
                                            {
                                                text: 'GA',
                                                description: 'F\xf6rlorade gem'
                                            },
                                            {
                                                text: '+/-',
                                                description: 'Plus/minus f\xf6r gem'
                                            },
                                            {
                                                text: 'Po\xe4ng',
                                                description: 'Nuvarande po\xe4ng med start p\xe5 100 po\xe4ng'
                                            }, 
                                        ].map(function(abbr) {
                                            /*#__PURE__*/ return (0,jsx_runtime.jsxs)(react.Fragment, {
                                                children: [
                                                    /*#__PURE__*/ (0,jsx_runtime.jsx)("p", {
                                                        className: "font-bold col-start-1 col-span-2",
                                                        children: abbr.text
                                                    }),
                                                    /*#__PURE__*/ (0,jsx_runtime.jsx)("p", {
                                                        className: "col-start-3 col-span-10",
                                                        children: abbr.description
                                                    })
                                                ]
                                            }, abbr.text);
                                        })
                                    })
                                })
                            ]
                        })
                    ]
                })
            ]
        })
    }));
};

;// CONCATENATED MODULE: ./components/ds/05-pages/series/team/types.ts

var TeamInformation = es6/* type */.dt({
    team_id: es6/* string */.Z_,
    name: es6/* string */.Z_,
    points_standing: es6/* number */.pk,
    average_match_point: es6/* number */.pk,
    no_of_matches: es6/* number */.pk,
    positive: es6/* number */.pk,
    negative: es6/* number */.pk,
    total_games_won: es6/* number */.pk,
    total_games_lost: es6/* number */.pk,
    plus_minus: es6/* number */.pk,
    five_points: es6/* number */.pk,
    four_points: es6/* number */.pk,
    three_points: es6/* number */.pk,
    two_points: es6/* number */.pk,
    minus_two_points: es6/* number */.pk,
    minus_three_points: es6/* number */.pk
});

;// CONCATENATED MODULE: ./components/ds/05-pages/series/team/index.tsx







var TeamDetailsPage = function(param) {
    var matchResults = param.matchResults, teamInformation = param.teamInformation, seriesContext = param.seriesContext;
    var router = (0,next_router.useRouter)();
    var locale = (0,utils_locale/* makeLocale */.W)(router.locale, router.defaultLocale) || 'sv';
    var translation = series_team_translations_translations[locale];
    return(/*#__PURE__*/ (0,jsx_runtime.jsxs)(jsx_runtime.Fragment, {
        children: [
            /*#__PURE__*/ (0,jsx_runtime.jsx)(components/* Head */.Fb, {
                title: translation.pageTitle,
                description: translation.pageDescription
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)(TeamPageLayout, {
                matchResults: matchResults,
                teamInformation: teamInformation,
                seriesContext: seriesContext
            })
        ]
    }));
};

;// CONCATENATED MODULE: ./components/ds/05-pages/series/player/translations.tsx
var series_player_translations_translations = {
    sv: {
        pageTitle: '\xd6-viks N\xe4tverkspadel',
        pageDescription: 'Vi samlas p\xe5 onsdagar f\xf6r att spela padel och n\xe4tverka. Tv\xe5 flugor i en sm\xe4ll.'
    },
    en: {
        pageTitle: "\xd6-vik's Network Padel ",
        pageDescription: 'We gather on Wednesdays to play padel and network. Two birds with one stone.'
    }
};

;// CONCATENATED MODULE: ./components/ds/05-pages/series/player/layout/index.tsx

/* eslint-disable @next/next/no-img-element */ 




function layout_arrayLikeToArray(arr, len) {
    if (len == null || len > arr.length) len = arr.length;
    for(var i = 0, arr2 = new Array(len); i < len; i++)arr2[i] = arr[i];
    return arr2;
}
function layout_arrayWithHoles(arr) {
    if (Array.isArray(arr)) return arr;
}
function layout_iterableToArrayLimit(arr, i) {
    var _i = arr == null ? null : typeof Symbol !== "undefined" && arr[Symbol.iterator] || arr["@@iterator"];
    if (_i == null) return;
    var _arr = [];
    var _n = true;
    var _d = false;
    var _s, _e;
    try {
        for(_i = _i.call(arr); !(_n = (_s = _i.next()).done); _n = true){
            _arr.push(_s.value);
            if (i && _arr.length === i) break;
        }
    } catch (err) {
        _d = true;
        _e = err;
    } finally{
        try {
            if (!_n && _i["return"] != null) _i["return"]();
        } finally{
            if (_d) throw _e;
        }
    }
    return _arr;
}
function layout_nonIterableRest() {
    throw new TypeError("Invalid attempt to destructure non-iterable instance.\\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method.");
}
function layout_slicedToArray(arr, i) {
    return layout_arrayWithHoles(arr) || layout_iterableToArrayLimit(arr, i) || layout_unsupportedIterableToArray(arr, i) || layout_nonIterableRest();
}
function layout_unsupportedIterableToArray(o, minLen) {
    if (!o) return;
    if (typeof o === "string") return layout_arrayLikeToArray(o, minLen);
    var n = Object.prototype.toString.call(o).slice(8, -1);
    if (n === "Object" && o.constructor) n = o.constructor.name;
    if (n === "Map" || n === "Set") return Array.from(n);
    if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return layout_arrayLikeToArray(o, minLen);
}
var UserPageLayout = function(param) {
    var matchResults = param.matchResults, userInformation = param.userInformation, seriesContext = param.seriesContext;
    var ref = (0,react.useState)(false), sidebarOpen = ref[0], setSidebarOpen = ref[1];
    (0,react.useEffect)(function() {
        if (document) {
            var htmlEl = document.querySelector("html");
            if (htmlEl) {
                htmlEl.classList.add("h-full");
                htmlEl.classList.add("bg-white");
            }
            var bodyEl = document.querySelector("body");
            if (bodyEl) {
                bodyEl.classList.add("h-full");
                bodyEl.classList.add("overflow-hidden");
            }
            var nextWrapperEl = document.querySelector("#__next");
            if (nextWrapperEl) {
                nextWrapperEl.classList.add("h-full");
                nextWrapperEl.classList.add("overflow-hidden");
            }
        }
    });
    var ref1 = layout_slicedToArray((0,lodash.take)(matchResults, 1), 1), result = ref1[0];
    return(/*#__PURE__*/ (0,jsx_runtime.jsx)(jsx_runtime.Fragment, {
        children: /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
            className: "h-full flex",
            children: [
                /*#__PURE__*/ (0,jsx_runtime.jsx)(header/* Header */.h, {
                    sidebarOpen: sidebarOpen,
                    setSidebarOpen: setSidebarOpen,
                    incomingSeriesId: result === null || result === void 0 ? void 0 : result.series_id,
                    seriesContext: seriesContext
                }),
                /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                    className: "flex flex-col w-0 flex-1 overflow-hidden",
                    children: [
                        /*#__PURE__*/ (0,jsx_runtime.jsx)(search_header/* SearchHeader */.s, {
                            sidebarOpen: sidebarOpen,
                            setSidebarOpen: setSidebarOpen
                        }),
                        /*#__PURE__*/ (0,jsx_runtime.jsxs)("main", {
                            className: "flex-1 relative z-0 overflow-y-auto focus:outline-none",
                            children: [
                                /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                    className: "border-b border-gray-200 px-4 py-4 sm:flex sm:items-center sm:justify-between sm:px-6 lg:px-8",
                                    children: /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                        className: "flex-1 min-w-0",
                                        children: /*#__PURE__*/ (0,jsx_runtime.jsx)("h1", {
                                            className: "text-lg font-medium leading-6 text-gray-900 sm:truncate",
                                            children: userInformation.name
                                        })
                                    })
                                }),
                                /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                    className: "mt-8 px-6 pb-5 border-b border-gray-200",
                                    children: /*#__PURE__*/ (0,jsx_runtime.jsx)("h3", {
                                        className: "text-lg leading-6 font-medium text-gray-900",
                                        children: "Statistik"
                                    })
                                }),
                                /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                    className: "mt-8 block overflow-y-scroll",
                                    children: /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                        className: "align-middle inline-block min-w-full border-b border-gray-200",
                                        children: /*#__PURE__*/ (0,jsx_runtime.jsxs)("table", {
                                            className: "min-w-full table-auto",
                                            children: [
                                                /*#__PURE__*/ (0,jsx_runtime.jsx)("thead", {
                                                    children: /*#__PURE__*/ (0,jsx_runtime.jsxs)("tr", {
                                                        className: "border-t border-gray-200",
                                                        children: [
                                                            /*#__PURE__*/ (0,jsx_runtime.jsx)("th", {
                                                                className: "table-cell px-6 py-3 border-b border-gray-200 bg-gray-100 text-center text-xs font-bold text-gray-500 uppercase tracking-wider",
                                                                children: "Po\xe4ng"
                                                            }),
                                                            /*#__PURE__*/ (0,jsx_runtime.jsx)("th", {
                                                                className: "table-cell px-6 py-3 border-b border-gray-200 bg-gray-50 text-center text-xs font-bold text-gray-500 uppercase tracking-wider",
                                                                children: "GP"
                                                            }),
                                                            /*#__PURE__*/ (0,jsx_runtime.jsx)("th", {
                                                                className: "table-cell px-6 py-3 border-b border-gray-200 bg-gray-50 text-center text-xs font-bold text-gray-500 uppercase tracking-wider",
                                                                children: "5P"
                                                            }),
                                                            /*#__PURE__*/ (0,jsx_runtime.jsx)("th", {
                                                                className: "table-cell px-6 py-3 border-b border-gray-200 bg-gray-50 text-center text-xs font-bold text-gray-500 uppercase tracking-wider",
                                                                children: "4P"
                                                            }),
                                                            /*#__PURE__*/ (0,jsx_runtime.jsx)("th", {
                                                                className: "table-cell px-6 py-3 border-b border-gray-200 bg-gray-50 text-center text-xs font-bold text-gray-500 uppercase tracking-wider",
                                                                children: "3P"
                                                            }),
                                                            /*#__PURE__*/ (0,jsx_runtime.jsx)("th", {
                                                                className: "table-cell px-6 py-3 border-b border-gray-200 bg-gray-50 text-center text-xs font-bold text-gray-500 uppercase tracking-wider",
                                                                children: "2P"
                                                            }),
                                                            /*#__PURE__*/ (0,jsx_runtime.jsx)("th", {
                                                                className: "table-cell px-6 py-3 border-b border-gray-200 bg-gray-50 text-center text-xs font-bold text-gray-500 uppercase tracking-wider",
                                                                children: "-2P"
                                                            }),
                                                            /*#__PURE__*/ (0,jsx_runtime.jsx)("th", {
                                                                className: "table-cell px-6 py-3 border-b border-gray-200 bg-gray-50 text-center text-xs font-bold text-gray-500 uppercase tracking-wider",
                                                                children: "-3P"
                                                            }),
                                                            /*#__PURE__*/ (0,jsx_runtime.jsx)("th", {
                                                                className: "table-cell px-6 py-3 border-b border-gray-200 bg-gray-50 text-center text-xs font-bold text-gray-500 uppercase tracking-wider",
                                                                children: "G"
                                                            }),
                                                            /*#__PURE__*/ (0,jsx_runtime.jsx)("th", {
                                                                className: "table-cell px-6 py-3 border-b border-gray-200 bg-gray-50 text-center text-xs font-bold text-gray-500 uppercase tracking-wider",
                                                                children: "GA"
                                                            }),
                                                            /*#__PURE__*/ (0,jsx_runtime.jsx)("th", {
                                                                className: "table-cell px-6 py-3 border-b border-gray-200 bg-gray-50 text-center text-xs font-bold text-gray-500 uppercase tracking-wider",
                                                                children: "+/-"
                                                            })
                                                        ]
                                                    })
                                                }),
                                                /*#__PURE__*/ (0,jsx_runtime.jsx)("tbody", {
                                                    className: "bg-white divide-y divide-gray-100",
                                                    children: /*#__PURE__*/ (0,jsx_runtime.jsxs)("tr", {
                                                        children: [
                                                            /*#__PURE__*/ (0,jsx_runtime.jsx)("td", {
                                                                className: "table-cell px-6 py-3 whitespace-nowrap text-sm text-gray-500 bg-gray-100 text-center lining-nums font-light",
                                                                children: userInformation.points_standing
                                                            }),
                                                            /*#__PURE__*/ (0,jsx_runtime.jsx)("td", {
                                                                className: "table-cell px-6 py-3 whitespace-nowrap text-sm text-gray-500 text-center lining-nums font-light",
                                                                children: userInformation.no_of_matches
                                                            }),
                                                            /*#__PURE__*/ (0,jsx_runtime.jsx)("td", {
                                                                className: "table-cell px-6 py-3 whitespace-nowrap text-sm text-gray-500 text-center lining-nums font-light",
                                                                children: userInformation.five_points
                                                            }),
                                                            /*#__PURE__*/ (0,jsx_runtime.jsx)("td", {
                                                                className: "table-cell px-6 py-3 whitespace-nowrap text-sm text-gray-500 text-center lining-nums font-light",
                                                                children: userInformation.four_points
                                                            }),
                                                            /*#__PURE__*/ (0,jsx_runtime.jsx)("td", {
                                                                className: "table-cell px-6 py-3 whitespace-nowrap text-sm text-gray-500 text-center lining-nums font-light",
                                                                children: userInformation.three_points
                                                            }),
                                                            /*#__PURE__*/ (0,jsx_runtime.jsx)("td", {
                                                                className: "table-cell px-6 py-3 whitespace-nowrap text-sm text-gray-500 text-center lining-nums font-light",
                                                                children: userInformation.two_points
                                                            }),
                                                            /*#__PURE__*/ (0,jsx_runtime.jsx)("td", {
                                                                className: "table-cell px-6 py-3 whitespace-nowrap text-sm text-gray-500 text-center lining-nums font-light",
                                                                children: userInformation.minus_two_points
                                                            }),
                                                            /*#__PURE__*/ (0,jsx_runtime.jsx)("td", {
                                                                className: "table-cell px-6 py-3 whitespace-nowrap text-sm text-gray-500 text-center lining-nums font-light",
                                                                children: userInformation.minus_three_points
                                                            }),
                                                            /*#__PURE__*/ (0,jsx_runtime.jsx)("td", {
                                                                className: "table-cell px-6 py-3 whitespace-nowrap text-sm text-gray-500 text-center lining-nums font-light",
                                                                children: userInformation.total_games_won
                                                            }),
                                                            /*#__PURE__*/ (0,jsx_runtime.jsx)("td", {
                                                                className: "table-cell px-6 py-3 whitespace-nowrap text-sm text-gray-500 text-center lining-nums font-light",
                                                                children: userInformation.total_games_lost
                                                            }),
                                                            /*#__PURE__*/ (0,jsx_runtime.jsx)("td", {
                                                                className: "table-cell px-6 py-3 whitespace-nowrap text-sm text-gray-500 text-center lining-nums font-light",
                                                                children: userInformation.plus_minus
                                                            })
                                                        ]
                                                    })
                                                })
                                            ]
                                        })
                                    })
                                }),
                                /*#__PURE__*/ (0,jsx_runtime.jsx)(MatchResultList, {
                                    matches: matchResults,
                                    seriesContext: seriesContext
                                }),
                                /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                    className: "mt-8 px-6 pb-5 border-b border-gray-200",
                                    children: /*#__PURE__*/ (0,jsx_runtime.jsx)("h3", {
                                        className: "text-lg leading-6 font-medium text-gray-900",
                                        children: "F\xf6rkortningar"
                                    })
                                }),
                                /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                    className: "bg-gray-50 px-6 py-5 sm:flex sm:items-start sm:justify-between",
                                    children: /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                        className: "grid grid-cols-12",
                                        children: [
                                            {
                                                text: 'Rank',
                                                description: 'Ranking'
                                            },
                                            {
                                                text: 'Lag',
                                                description: 'Lag f\xf6r vald s\xe4song'
                                            },
                                            {
                                                text: 'GP',
                                                description: 'Spelade matcher'
                                            },
                                            {
                                                text: '5P',
                                                description: '5 po\xe4ng (stor vinst)'
                                            },
                                            {
                                                text: '4P',
                                                description: '4 po\xe4ng (medelstor vinst)'
                                            },
                                            {
                                                text: '3P',
                                                description: '3 po\xe4ng (liten vinst)'
                                            },
                                            {
                                                text: '2P',
                                                description: '2 po\xe4ng (vinst i tiebreak)'
                                            },
                                            {
                                                text: '-2P',
                                                description: '-2 po\xe4ng (f\xf6rlust i tiebreak)'
                                            },
                                            {
                                                text: '-3P',
                                                description: '-3 po\xe4ng (f\xf6rlust)'
                                            },
                                            {
                                                text: 'G',
                                                description: 'Vunna gem'
                                            },
                                            {
                                                text: 'GA',
                                                description: 'F\xf6rlorade gem'
                                            },
                                            {
                                                text: '+/-',
                                                description: 'Plus/minus f\xf6r gem'
                                            },
                                            {
                                                text: 'Po\xe4ng',
                                                description: 'Nuvarande po\xe4ng med start p\xe5 100 po\xe4ng'
                                            }, 
                                        ].map(function(abbr) {
                                            /*#__PURE__*/ return (0,jsx_runtime.jsxs)(react.Fragment, {
                                                children: [
                                                    /*#__PURE__*/ (0,jsx_runtime.jsx)("p", {
                                                        className: "font-bold col-start-1 col-span-2",
                                                        children: abbr.text
                                                    }),
                                                    /*#__PURE__*/ (0,jsx_runtime.jsx)("p", {
                                                        className: "col-start-3 col-span-10",
                                                        children: abbr.description
                                                    })
                                                ]
                                            }, abbr.text);
                                        })
                                    })
                                })
                            ]
                        })
                    ]
                })
            ]
        })
    }));
};

;// CONCATENATED MODULE: ./components/ds/05-pages/series/player/types.ts

var UserInformation = es6/* type */.dt({
    user_id: es6/* string */.Z_,
    name: es6/* string */.Z_,
    points_standing: es6/* number */.pk,
    average_match_point: es6/* number */.pk,
    no_of_matches: es6/* number */.pk,
    positive: es6/* number */.pk,
    negative: es6/* number */.pk,
    total_games_won: es6/* number */.pk,
    total_games_lost: es6/* number */.pk,
    plus_minus: es6/* number */.pk,
    five_points: es6/* number */.pk,
    four_points: es6/* number */.pk,
    three_points: es6/* number */.pk,
    two_points: es6/* number */.pk,
    minus_two_points: es6/* number */.pk,
    minus_three_points: es6/* number */.pk
});

;// CONCATENATED MODULE: ./components/ds/05-pages/series/player/index.tsx







var UserDetailsPage = function(param) {
    var matchResults = param.matchResults, userInformation = param.userInformation, seriesContext = param.seriesContext;
    var router = (0,next_router.useRouter)();
    var locale = (0,utils_locale/* makeLocale */.W)(router.locale, router.defaultLocale) || 'sv';
    var translation = series_player_translations_translations[locale];
    return(/*#__PURE__*/ (0,jsx_runtime.jsxs)(jsx_runtime.Fragment, {
        children: [
            /*#__PURE__*/ (0,jsx_runtime.jsx)(components/* Head */.Fb, {
                title: translation.pageTitle,
                description: translation.pageDescription
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)(UserPageLayout, {
                matchResults: matchResults,
                userInformation: userInformation,
                seriesContext: seriesContext
            })
        ]
    }));
};

;// CONCATENATED MODULE: ./components/ds/05-pages/series/rounds/translations.tsx
var rounds_translations_translations = {
    sv: {
        pageTitle: 'Omg\xe5ngar',
        pageDescription: 'H\xe4r kan du se s\xe4songens omg\xe5ngar i \xd6NP.'
    },
    en: {
        pageTitle: 'Omg\xe5ngar',
        pageDescription: 'H\xe4r kan du se s\xe4songens omg\xe5ngar i \xd6NP.'
    }
};

;// CONCATENATED MODULE: ./components/ds/05-pages/series/rounds/layout/index.tsx






var RoundsPageLayout = function(param) {
    var rounds = param.rounds, seriesContext = param.seriesContext;
    var ref = (0,react.useState)(false), sidebarOpen = ref[0], setSidebarOpen = ref[1];
    (0,react.useEffect)(function() {
        if (document) {
            var htmlEl = document.querySelector('html');
            if (htmlEl) {
                htmlEl.classList.add('h-full');
                htmlEl.classList.add('bg-white');
            }
            var bodyEl = document.querySelector('body');
            if (bodyEl) {
                bodyEl.classList.add('h-full');
                bodyEl.classList.add('overflow-hidden');
            }
            var nextWrapperEl = document.querySelector('#__next');
            if (nextWrapperEl) {
                nextWrapperEl.classList.add('h-full');
                nextWrapperEl.classList.add('overflow-hidden');
            }
        }
    });
    return(/*#__PURE__*/ (0,jsx_runtime.jsx)(jsx_runtime.Fragment, {
        children: /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
            className: "h-full flex",
            children: [
                /*#__PURE__*/ (0,jsx_runtime.jsx)(header/* Header */.h, {
                    sidebarOpen: sidebarOpen,
                    setSidebarOpen: setSidebarOpen,
                    incomingSeriesId: seriesContext.id,
                    seriesContext: seriesContext
                }),
                /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                    className: "flex flex-col w-0 flex-1 overflow-hidden",
                    children: [
                        /*#__PURE__*/ (0,jsx_runtime.jsx)(search_header/* SearchHeader */.s, {
                            sidebarOpen: sidebarOpen,
                            setSidebarOpen: setSidebarOpen
                        }),
                        /*#__PURE__*/ (0,jsx_runtime.jsxs)("main", {
                            className: "flex-1 relative z-0 overflow-y-auto focus:outline-none",
                            children: [
                                rounds.length === 0 ? /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                                    className: "mt-12 text-center",
                                    children: [
                                        /*#__PURE__*/ (0,jsx_runtime.jsx)(esm/* StopIcon */.wNq, {
                                            className: "mx-auto h-12 w-12 text-gray-400",
                                            "aria-hidden": "true"
                                        }),
                                        /*#__PURE__*/ (0,jsx_runtime.jsx)("h3", {
                                            className: "mt-2 text-sm font-medium text-gray-900",
                                            children: "Inga rundor"
                                        }),
                                        /*#__PURE__*/ (0,jsx_runtime.jsx)("p", {
                                            className: "mt-1 text-sm text-gray-500",
                                            children: "Kom tillbaka till den h\xe4r sidan vid ett senare tillf\xe4lle."
                                        })
                                    ]
                                }) : null,
                                rounds.length > 0 ? /*#__PURE__*/ (0,jsx_runtime.jsx)(RoundsList, {
                                    rounds: rounds,
                                    seriesContext: seriesContext
                                }) : null
                            ]
                        })
                    ]
                })
            ]
        })
    }));
};

;// CONCATENATED MODULE: ./components/ds/05-pages/series/rounds/index.tsx







var RoundsPage = function(param) {
    var rounds = param.rounds, seriesContext = param.seriesContext;
    var router = (0,next_router.useRouter)();
    var locale = (0,utils_locale/* makeLocale */.W)(router.locale, router.defaultLocale) || 'sv';
    var translation = rounds_translations_translations[locale];
    return(/*#__PURE__*/ (0,jsx_runtime.jsxs)(jsx_runtime.Fragment, {
        children: [
            /*#__PURE__*/ (0,jsx_runtime.jsx)(components/* Head */.Fb, {
                title: translation.pageTitle,
                description: translation.pageDescription
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)(RoundsPageLayout, {
                rounds: rounds,
                seriesContext: seriesContext
            })
        ]
    }));
};

;// CONCATENATED MODULE: ./components/ds/05-pages/series/round/translations.tsx
var round_translations_translations = {
    sv: {
        pageTitle: 'Omg\xe5ng',
        pageDescription: 'Detaljer om en omg\xe5ng i N\xe4tverkspadeln'
    },
    en: {
        pageTitle: 'Omg\xe5ng',
        pageDescription: 'Detaljer om en omg\xe5ng i N\xe4tverkspadeln'
    }
};

;// CONCATENATED MODULE: ./components/ds/05-pages/series/round/layout/invite-stats.tsx

var InviteStats = function(param) {
    var round = param.round;
    var stats = [
        {
            name: 'Inbjudna',
            stat: "".concat(round.invitations)
        },
        {
            name: 'Tackat Ja',
            stat: "".concat(round.accepted)
        },
        {
            name: 'Tackat Nej',
            stat: "".concat(round.declined)
        },
        {
            name: 'V\xe4ntar p\xe5 svar',
            stat: "".concat(round.pending)
        }, 
    ];
    return(/*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
        className: "mx-auto py-12 px-4 sm:px-6 lg:px-8",
        children: [
            /*#__PURE__*/ (0,jsx_runtime.jsx)("h3", {
                className: "text-lg leading-6 font-medium text-gray-900",
                children: "Inbjudningar"
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)("dl", {
                className: "mt-5 grid grid-cols-1 gap-5 sm:grid-cols-4",
                children: stats.map(function(item) {
                    /*#__PURE__*/ return (0,jsx_runtime.jsxs)("div", {
                        className: "px-4 py-5 bg-white shadow rounded-lg overflow-hidden sm:p-6",
                        children: [
                            /*#__PURE__*/ (0,jsx_runtime.jsx)("dt", {
                                className: "text-sm font-medium text-gray-500 truncate",
                                children: item.name
                            }),
                            /*#__PURE__*/ (0,jsx_runtime.jsx)("dd", {
                                className: "mt-1 text-3xl font-semibold text-gray-900",
                                children: item.stat
                            })
                        ]
                    }, item.name);
                })
            })
        ]
    }));
};

;// CONCATENATED MODULE: ./components/ds/05-pages/series/round/layout/game-stats.tsx

var GameStats = function(param) {
    var round = param.round;
    var stats = [
        {
            name: 'Bekr\xe4ftade matcher',
            stat: "".concat(round.confirmed_matches)
        },
        {
            name: 'Spelade matcher',
            stat: "".concat(round.completed_matches)
        }, 
    ];
    return(/*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
        className: "mx-auto py-12 px-4 sm:px-6 lg:px-8",
        children: [
            /*#__PURE__*/ (0,jsx_runtime.jsx)("h3", {
                className: "text-lg leading-6 font-medium text-gray-900",
                children: "Matcher"
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)("dl", {
                className: "mt-5 grid grid-cols-1 gap-5 sm:grid-cols-3",
                children: stats.map(function(item) {
                    /*#__PURE__*/ return (0,jsx_runtime.jsxs)("div", {
                        className: "px-4 py-5 bg-white shadow rounded-lg overflow-hidden sm:p-6",
                        children: [
                            /*#__PURE__*/ (0,jsx_runtime.jsx)("dt", {
                                className: "text-sm font-medium text-gray-500 truncate",
                                children: item.name
                            }),
                            /*#__PURE__*/ (0,jsx_runtime.jsx)("dd", {
                                className: "mt-1 text-3xl font-semibold text-gray-900",
                                children: item.stat
                            })
                        ]
                    }, item.name);
                })
            })
        ]
    }));
};

;// CONCATENATED MODULE: ./components/ds/05-pages/series/round/layout/matches.tsx


var Matches = function(param) {
    var matches = param.matches, seriesContext = param.seriesContext;
    return(/*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
        className: "bg-gray-50 overflow-hidden sm:rounded-lg",
        children: /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
            className: "px-4 py-5 sm:p-6",
            children: [
                /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                    className: "pb-5 border-b border-gray-200",
                    children: [
                        /*#__PURE__*/ (0,jsx_runtime.jsx)("h3", {
                            className: "text-lg leading-6 font-medium text-gray-900",
                            children: "Matcher"
                        }),
                        /*#__PURE__*/ (0,jsx_runtime.jsx)("p", {
                            className: "mt-2 text-sm text-gray-500",
                            children: "Detta \xe4r omg\xe5ngens matcher som vi genererar utifr\xe5n rankingen ovan. Observera att det kanske inte st\xe4mmer 100% om anm\xe4lda spelare har \xe4ndrats efter att matcherna skapades."
                        })
                    ]
                }),
                matches.length > 0 ? /*#__PURE__*/ (0,jsx_runtime.jsx)(MatchResultList, {
                    matches: matches,
                    seriesContext: seriesContext,
                    compact: true
                }) : null
            ]
        })
    }));
};

;// CONCATENATED MODULE: ./components/ds/05-pages/series/round/layout/ranking.tsx


var Ranking = function(param) {
    var players = param.players;
    return(/*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
        className: "bg-gray-50 overflow-hidden sm:rounded-lg",
        children: /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
            className: "px-4 py-5 sm:p-6",
            children: [
                /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                    className: "pb-5 border-b border-gray-200",
                    children: [
                        /*#__PURE__*/ (0,jsx_runtime.jsx)("h3", {
                            className: "text-lg leading-6 font-medium text-gray-900",
                            children: "Ranking"
                        }),
                        /*#__PURE__*/ (0,jsx_runtime.jsx)("p", {
                            className: "mt-2 text-sm text-gray-500",
                            children: "Detta \xe4r rankingen som vi genererar matcher utifr\xe5n. Observera att det kanske inte st\xe4mmer 100% om anm\xe4lda spelare har \xe4ndrats efter att matcherna skapades."
                        })
                    ]
                }),
                players.length > 0 ? /*#__PURE__*/ (0,jsx_runtime.jsx)(RankingList, {
                    players: players
                }) : null
            ]
        })
    }));
};

;// CONCATENATED MODULE: ./components/ds/05-pages/series/round/layout/index.tsx









var RoundPageLayout = function(param) {
    var round = param.round, seriesContext = param.seriesContext, matches = param.matches, players = param.players;
    var ref = (0,react.useState)(false), sidebarOpen = ref[0], setSidebarOpen = ref[1];
    (0,react.useEffect)(function() {
        if (document) {
            var htmlEl = document.querySelector('html');
            if (htmlEl) {
                htmlEl.classList.add('h-full');
                htmlEl.classList.add('bg-white');
            }
            var bodyEl = document.querySelector('body');
            if (bodyEl) {
                bodyEl.classList.add('h-full');
                bodyEl.classList.add('overflow-hidden');
            }
            var nextWrapperEl = document.querySelector('#__next');
            if (nextWrapperEl) {
                nextWrapperEl.classList.add('h-full');
                nextWrapperEl.classList.add('overflow-hidden');
            }
        }
    });
    return(/*#__PURE__*/ (0,jsx_runtime.jsx)(jsx_runtime.Fragment, {
        children: /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
            className: "h-full flex",
            children: [
                /*#__PURE__*/ (0,jsx_runtime.jsx)(header/* Header */.h, {
                    sidebarOpen: sidebarOpen,
                    setSidebarOpen: setSidebarOpen,
                    incomingSeriesId: seriesContext.id,
                    seriesContext: seriesContext
                }),
                /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                    className: "flex flex-col w-0 flex-1 overflow-hidden",
                    children: [
                        /*#__PURE__*/ (0,jsx_runtime.jsx)(search_header/* SearchHeader */.s, {
                            sidebarOpen: sidebarOpen,
                            setSidebarOpen: setSidebarOpen
                        }),
                        /*#__PURE__*/ (0,jsx_runtime.jsx)(RoundBreadcrumbs, {
                            seriesContext: seriesContext,
                            round: round
                        }),
                        /*#__PURE__*/ (0,jsx_runtime.jsxs)("main", {
                            className: "flex-1 relative z-0 overflow-y-auto focus:outline-none bg-gray-50",
                            children: [
                                /*#__PURE__*/ (0,jsx_runtime.jsx)(InviteStats, {
                                    round: round
                                }),
                                /*#__PURE__*/ (0,jsx_runtime.jsx)(Ranking, {
                                    players: players
                                }),
                                /*#__PURE__*/ (0,jsx_runtime.jsx)(Matches, {
                                    seriesContext: seriesContext,
                                    matches: matches
                                }),
                                /*#__PURE__*/ (0,jsx_runtime.jsx)(GameStats, {
                                    round: round
                                })
                            ]
                        })
                    ]
                })
            ]
        })
    }));
};

;// CONCATENATED MODULE: ./components/ds/05-pages/series/round/index.tsx







var RoundPage = function(param) {
    var round = param.round, seriesContext = param.seriesContext, matches = param.matches, players = param.players;
    var router = (0,next_router.useRouter)();
    var locale = (0,utils_locale/* makeLocale */.W)(router.locale, router.defaultLocale) || 'sv';
    var translation = round_translations_translations[locale];
    return(/*#__PURE__*/ (0,jsx_runtime.jsxs)(jsx_runtime.Fragment, {
        children: [
            /*#__PURE__*/ (0,jsx_runtime.jsx)(components/* Head */.Fb, {
                title: translation.pageTitle,
                description: translation.pageDescription
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)(RoundPageLayout, {
                round: round,
                seriesContext: seriesContext,
                matches: matches,
                players: players
            })
        ]
    }));
};

;// CONCATENATED MODULE: ./components/ds/05-pages/series/index.ts










;// CONCATENATED MODULE: ./components/ds/05-pages/resultat-h21/translations.tsx
var resultat_h21_translations_translations = {
    sv: {
        pageTitle: 'Summering av \xd6NP s\xe4song 1',
        pageDescription: 'F\xf6rsta s\xe4songen av \xd6-viks N\xe4tverkspadel \xe4r avslutad och vi summerar vad vi gjort samt vad vi tror om framtiden.'
    },
    en: {
        pageTitle: 'A summary of \xd6NP season 1',
        pageDescription: 'F\xf6rsta s\xe4songen av \xd6-viks N\xe4tverkspadel \xe4r avslutad och vi summerar vad vi gjort samt vad vi tror om framtiden.'
    }
};

;// CONCATENATED MODULE: ./components/ds/05-pages/resultat-h21/cta.tsx

var CTA = function() {
    return(/*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
        className: "bg-white",
        children: /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
            className: "mx-auto max-w-7xl py-16 px-4 sm:px-6 lg:px-8",
            children: /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                className: "overflow-hidden rounded-lg bg-indigo-700 shadow-xl lg:grid lg:grid-cols-2 lg:gap-4",
                children: [
                    /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                        className: "px-6 pt-10 pb-12 sm:px-16 sm:pt-16 lg:py-16 lg:pr-0 xl:py-20 xl:px-20",
                        children: /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                            className: "lg:self-center",
                            children: [
                                /*#__PURE__*/ (0,jsx_runtime.jsxs)("h2", {
                                    className: "text-3xl font-extrabold text-white sm:text-4xl",
                                    children: [
                                        /*#__PURE__*/ (0,jsx_runtime.jsx)("span", {
                                            className: "block",
                                            children: "Vill du vara med?"
                                        }),
                                        /*#__PURE__*/ (0,jsx_runtime.jsx)("span", {
                                            className: "block",
                                            children: "H\xf6r av dig idag."
                                        })
                                    ]
                                }),
                                /*#__PURE__*/ (0,jsx_runtime.jsx)("p", {
                                    className: "mt-4 text-lg leading-6 text-indigo-200",
                                    children: "N\xe4sta s\xe4song sker till h\xf6sten. Skicka ett meddelande till oss s\xe5 ber\xe4ttar vi mer."
                                }),
                                /*#__PURE__*/ (0,jsx_runtime.jsx)("a", {
                                    href: "https://forms.reform.app/gLNw4a/kontaktformular/jo0zn1",
                                    target: "_blank",
                                    className: "mt-8 inline-flex items-center rounded-md border border-transparent bg-white px-5 py-3 text-base font-medium text-indigo-600 shadow hover:bg-indigo-50",
                                    rel: "noopener noreferrer",
                                    children: "Kontakta oss"
                                })
                            ]
                        })
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                        className: "aspect-w-5 aspect-h-3 -mt-6 md:aspect-w-2 md:aspect-h-1",
                        children: /*#__PURE__*/ (0,jsx_runtime.jsx)("img", {
                            className: "translate-x-6 translate-y-6 transform rounded-md object-cover object-right-top sm:translate-x-16 lg:translate-y-20",
                            src: "/assets/martin-hitting-the-ball.jpg",
                            alt: "Martin hitting the ball"
                        })
                    })
                ]
            })
        })
    }));
};

;// CONCATENATED MODULE: ./components/ds/05-pages/resultat-h21/final-list.tsx

var players = [
    {
        name: 'Fredrik Bylin',
        final_points: 114.24,
        mexicano_points: 102,
        boost: 12
    },
    {
        name: 'Marcus Sj\xf6berg',
        final_points: 103.5,
        mexicano_points: 90,
        boost: 15
    },
    {
        name: 'Oscar Steen',
        final_points: 101,
        mexicano_points: 101,
        boost: 0
    },
    {
        name: 'Joel Baudin',
        final_points: 99.36,
        mexicano_points: 92,
        boost: 8
    },
    {
        name: 'Erik Nilsson',
        final_points: 97.76,
        mexicano_points: 94,
        boost: 4
    },
    {
        name: 'P\xe4r Edblom',
        final_points: 97.65,
        mexicano_points: 93,
        boost: 5
    },
    {
        name: 'H\xe5kan Martinell',
        final_points: 93.28,
        mexicano_points: 88,
        boost: 6
    },
    {
        name: 'Victor Hansson',
        final_points: 90.2,
        mexicano_points: 82,
        boost: 10
    },
    {
        name: 'Gabriel Baudin',
        final_points: 89,
        mexicano_points: 89,
        boost: 0
    },
    {
        name: 'Mikael Nordstrand',
        final_points: 85.85,
        mexicano_points: 85,
        boost: 1
    },
    {
        name: 'Johan Lindgren',
        final_points: 83,
        mexicano_points: 83,
        boost: 0
    },
    {
        name: 'Viktor Andersson',
        final_points: 78,
        mexicano_points: 78,
        boost: 0
    },
    {
        name: 'Andreas Cherif Fj\xe4llstr\xf6m',
        final_points: 77.25,
        mexicano_points: 75,
        boost: 3
    },
    {
        name: 'Martin Carstedt',
        final_points: 76,
        mexicano_points: 76,
        boost: 0
    },
    {
        name: 'Dennis Edlund',
        final_points: 76,
        mexicano_points: 76,
        boost: 0
    },
    {
        name: 'Hanna Sj\xf6berg',
        final_points: 72,
        mexicano_points: 72,
        boost: 0
    },
    {
        name: 'Tommy Nilsson',
        final_points: 67,
        mexicano_points: 67,
        boost: 0
    },
    {
        name: '\xc5ke \xd6dling',
        final_points: 58,
        mexicano_points: 58,
        boost: 0
    },
    {
        name: 'Daniel Strand',
        final_points: 0,
        mexicano_points: 92,
        boost: 0,
        comment: 'Deltog inte i seriespelet.'
    },
    {
        name: 'Stefan Lyng',
        final_points: 0,
        mexicano_points: 87,
        boost: 0,
        comment: 'Deltog inte i seriespelet.'
    },
    {
        name: 'Fredrik Furevik',
        final_points: 0,
        mexicano_points: 0,
        boost: 0,
        comment: 'Deltog inte i slutspelet.'
    },
    {
        name: 'Kasper Hellstr\xf6m',
        final_points: 0,
        mexicano_points: 0,
        boost: 0,
        comment: 'Deltog inte i slutspelet.'
    },
    {
        name: 'Mats Myrsell',
        final_points: 0,
        mexicano_points: 0,
        boost: 0,
        comment: 'Deltog inte i slutspelet.'
    },
    {
        name: 'Lars Winqvist',
        final_points: 0,
        mexicano_points: 0,
        boost: 0,
        comment: 'Deltog inte i slutspelet.'
    },
    {
        name: 'Mattias Modig',
        final_points: 0,
        mexicano_points: 0,
        boost: 0,
        comment: 'Deltog inte i slutspelet.'
    },
    {
        name: 'Johan Edlund',
        final_points: 0,
        mexicano_points: 0,
        boost: 0,
        comment: 'Deltog inte i slutspelet.'
    },
    {
        name: 'David Rocks\xe9n',
        final_points: 0,
        mexicano_points: 0,
        boost: 0,
        comment: 'Deltog inte i slutspelet.'
    },
    {
        name: 'Lucas Lundberg',
        final_points: 0,
        mexicano_points: 0,
        boost: 0,
        comment: 'Deltog inte i slutspelet.'
    },
    {
        name: 'Thomas Pettersson',
        final_points: 0,
        mexicano_points: 0,
        boost: 0,
        comment: 'Deltog inte i slutspelet.'
    },
    {
        name: 'Stefan Bergstr\xf6m',
        final_points: 0,
        mexicano_points: 0,
        boost: 0,
        comment: 'Deltog inte i slutspelet.'
    },
    {
        name: 'Niclas Sj\xf6str\xf6m',
        final_points: 0,
        mexicano_points: 0,
        boost: 0,
        comment: 'Deltog inte i slutspelet.'
    },
    {
        name: 'Tilde Nording',
        final_points: 0,
        mexicano_points: 0,
        boost: 0,
        comment: 'Deltog inte i slutspelet.'
    },
    {
        name: 'Johnny K\xf6ster',
        final_points: 0,
        mexicano_points: 0,
        boost: 0,
        comment: 'Deltog inte i slutspelet.'
    },
    {
        name: 'Anders L\xf6nn',
        final_points: 0,
        mexicano_points: 0,
        boost: 0,
        comment: 'Deltog inte i slutspelet.'
    },
    {
        name: 'Fredrik Sj\xf6berg',
        final_points: 0,
        mexicano_points: 0,
        boost: 0,
        comment: 'Deltog inte i slutspelet.'
    },
    {
        name: 'Karoline Bergstr\xf6m',
        final_points: 0,
        mexicano_points: 0,
        boost: 0,
        comment: 'Deltog inte i slutspelet.'
    },
    {
        name: 'Carl S\xf6derstr\xf6m',
        final_points: 0,
        mexicano_points: 0,
        boost: 0,
        comment: 'Deltog inte i slutspelet.'
    },
    {
        name: 'Anders J\xe4ger',
        final_points: 0,
        mexicano_points: 0,
        boost: 0,
        comment: 'Deltog inte i slutspelet.'
    },
    {
        name: 'Martin S\xf6derstr\xf6m',
        final_points: 0,
        mexicano_points: 0,
        boost: 0,
        comment: 'Deltog inte i slutspelet.'
    }, 
];
var FinalList = function() {
    return(/*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
        className: "flex flex-col",
        children: /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
            className: "-my-2 overflow-x-auto sm:-mx-6 lg:-mx-8",
            children: /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                className: "py-2 align-middle inline-block min-w-full sm:px-6 lg:px-8",
                children: /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                    className: "shadow overflow-hidden border-b border-gray-200 sm:rounded-lg",
                    children: /*#__PURE__*/ (0,jsx_runtime.jsxs)("table", {
                        className: "min-w-full divide-y divide-gray-200",
                        children: [
                            /*#__PURE__*/ (0,jsx_runtime.jsx)("thead", {
                                className: "bg-gray-50",
                                children: /*#__PURE__*/ (0,jsx_runtime.jsxs)("tr", {
                                    children: [
                                        /*#__PURE__*/ (0,jsx_runtime.jsx)("th", {
                                            scope: "col",
                                            className: "px-6 py-3 text-left text-xs font-medium text-gray-500 uppercase tracking-wider",
                                            children: "Rank"
                                        }),
                                        /*#__PURE__*/ (0,jsx_runtime.jsx)("th", {
                                            scope: "col",
                                            className: "px-6 py-3 text-left text-xs font-medium text-gray-500 uppercase tracking-wider",
                                            children: "Namn"
                                        }),
                                        /*#__PURE__*/ (0,jsx_runtime.jsx)("th", {
                                            scope: "col",
                                            className: "px-6 py-3 text-right text-xs font-medium text-gray-500 uppercase tracking-wider",
                                            children: "Slutpo\xe4ng i \xd6NP"
                                        }),
                                        /*#__PURE__*/ (0,jsx_runtime.jsx)("th", {
                                            scope: "col",
                                            className: "px-6 py-3 text-right text-xs font-medium text-gray-500 uppercase tracking-wider",
                                            children: "Totala po\xe4ng i Mexicano"
                                        }),
                                        /*#__PURE__*/ (0,jsx_runtime.jsx)("th", {
                                            scope: "col",
                                            className: "px-6 py-3 text-right text-xs font-medium text-gray-500 uppercase tracking-wider",
                                            children: "Boost"
                                        }),
                                        /*#__PURE__*/ (0,jsx_runtime.jsx)("th", {
                                            scope: "col",
                                            className: "px-6 py-3 text-right text-xs font-medium text-gray-500 uppercase tracking-wider",
                                            children: "Kommentar"
                                        })
                                    ]
                                })
                            }),
                            /*#__PURE__*/ (0,jsx_runtime.jsx)("tbody", {
                                children: players.map(function(person, personIdx) {
                                    /*#__PURE__*/ return (0,jsx_runtime.jsxs)("tr", {
                                        className: personIdx % 2 === 0 ? 'bg-white' : 'bg-gray-50',
                                        children: [
                                            /*#__PURE__*/ (0,jsx_runtime.jsx)("td", {
                                                className: "px-6 py-4 whitespace-nowrap text-sm text-gray-500",
                                                children: personIdx + 1
                                            }),
                                            /*#__PURE__*/ (0,jsx_runtime.jsx)("td", {
                                                className: "px-6 py-4 whitespace-nowrap text-sm font-medium text-gray-900",
                                                children: person.name
                                            }),
                                            /*#__PURE__*/ (0,jsx_runtime.jsx)("td", {
                                                className: "px-6 py-4 whitespace-nowrap text-sm text-gray-500 text-right",
                                                children: person.final_points
                                            }),
                                            /*#__PURE__*/ (0,jsx_runtime.jsx)("td", {
                                                className: "px-6 py-4 whitespace-nowrap text-sm text-gray-500 text-right",
                                                children: person.mexicano_points
                                            }),
                                            /*#__PURE__*/ (0,jsx_runtime.jsxs)("td", {
                                                className: "px-6 py-4 whitespace-nowrap text-sm text-gray-500 text-right",
                                                children: [
                                                    person.boost,
                                                    "%"
                                                ]
                                            }),
                                            /*#__PURE__*/ (0,jsx_runtime.jsx)("td", {
                                                className: "px-6 py-4 whitespace-nowrap text-sm text-gray-500 text-right",
                                                children: person.comment
                                            })
                                        ]
                                    }, person.name);
                                })
                            })
                        ]
                    })
                })
            })
        })
    }));
};

;// CONCATENATED MODULE: ./components/ds/05-pages/resultat-h21/full-content.tsx



var FullContent = function() {
    return(/*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
        className: "relative overflow-hidden bg-white py-16",
        children: [
            /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                className: "hidden lg:absolute lg:inset-y-0 lg:block lg:h-full lg:w-full",
                children: /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                    className: "relative mx-auto h-full max-w-prose text-lg",
                    "aria-hidden": "true",
                    children: [
                        /*#__PURE__*/ (0,jsx_runtime.jsxs)("svg", {
                            className: "absolute top-12 left-full translate-x-32 transform",
                            width: 404,
                            height: 384,
                            fill: "none",
                            viewBox: "0 0 404 384",
                            children: [
                                /*#__PURE__*/ (0,jsx_runtime.jsx)("defs", {
                                    children: /*#__PURE__*/ (0,jsx_runtime.jsx)("pattern", {
                                        id: "74b3fd99-0a6f-4271-bef2-e80eeafdf357",
                                        x: 0,
                                        y: 0,
                                        width: 20,
                                        height: 20,
                                        patternUnits: "userSpaceOnUse",
                                        children: /*#__PURE__*/ (0,jsx_runtime.jsx)("rect", {
                                            x: 0,
                                            y: 0,
                                            width: 4,
                                            height: 4,
                                            className: "text-gray-200",
                                            fill: "currentColor"
                                        })
                                    })
                                }),
                                /*#__PURE__*/ (0,jsx_runtime.jsx)("rect", {
                                    width: 404,
                                    height: 384,
                                    fill: "url(#74b3fd99-0a6f-4271-bef2-e80eeafdf357)"
                                })
                            ]
                        }),
                        /*#__PURE__*/ (0,jsx_runtime.jsxs)("svg", {
                            className: "absolute top-1/2 right-full -translate-y-1/2 -translate-x-32 transform",
                            width: 404,
                            height: 384,
                            fill: "none",
                            viewBox: "0 0 404 384",
                            children: [
                                /*#__PURE__*/ (0,jsx_runtime.jsx)("defs", {
                                    children: /*#__PURE__*/ (0,jsx_runtime.jsx)("pattern", {
                                        id: "f210dbf6-a58d-4871-961e-36d5016a0f49",
                                        x: 0,
                                        y: 0,
                                        width: 20,
                                        height: 20,
                                        patternUnits: "userSpaceOnUse",
                                        children: /*#__PURE__*/ (0,jsx_runtime.jsx)("rect", {
                                            x: 0,
                                            y: 0,
                                            width: 4,
                                            height: 4,
                                            className: "text-gray-200",
                                            fill: "currentColor"
                                        })
                                    })
                                }),
                                /*#__PURE__*/ (0,jsx_runtime.jsx)("rect", {
                                    width: 404,
                                    height: 384,
                                    fill: "url(#f210dbf6-a58d-4871-961e-36d5016a0f49)"
                                })
                            ]
                        }),
                        /*#__PURE__*/ (0,jsx_runtime.jsxs)("svg", {
                            className: "absolute bottom-12 left-full translate-x-32 transform",
                            width: 404,
                            height: 384,
                            fill: "none",
                            viewBox: "0 0 404 384",
                            children: [
                                /*#__PURE__*/ (0,jsx_runtime.jsx)("defs", {
                                    children: /*#__PURE__*/ (0,jsx_runtime.jsx)("pattern", {
                                        id: "d3eb07ae-5182-43e6-857d-35c643af9034",
                                        x: 0,
                                        y: 0,
                                        width: 20,
                                        height: 20,
                                        patternUnits: "userSpaceOnUse",
                                        children: /*#__PURE__*/ (0,jsx_runtime.jsx)("rect", {
                                            x: 0,
                                            y: 0,
                                            width: 4,
                                            height: 4,
                                            className: "text-gray-200",
                                            fill: "currentColor"
                                        })
                                    })
                                }),
                                /*#__PURE__*/ (0,jsx_runtime.jsx)("rect", {
                                    width: 404,
                                    height: 384,
                                    fill: "url(#d3eb07ae-5182-43e6-857d-35c643af9034)"
                                })
                            ]
                        })
                    ]
                })
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                className: "relative px-4 sm:px-6 lg:px-8",
                children: [
                    /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                        className: "mx-auto max-w-prose text-lg",
                        children: [
                            /*#__PURE__*/ (0,jsx_runtime.jsxs)("h1", {
                                children: [
                                    /*#__PURE__*/ (0,jsx_runtime.jsx)("span", {
                                        className: "block text-center text-base font-semibold uppercase tracking-wide text-indigo-600",
                                        children: "Summering"
                                    }),
                                    /*#__PURE__*/ (0,jsx_runtime.jsx)("span", {
                                        className: "mt-2 block text-center text-3xl font-extrabold leading-8 tracking-tight text-gray-900 sm:text-4xl",
                                        children: "\xd6rnsk\xf6ldsviks N\xe4tverkspadel h\xf6sten 2021"
                                    })
                                ]
                            }),
                            /*#__PURE__*/ (0,jsx_runtime.jsxs)("p", {
                                className: "mt-8 text-xl leading-8 text-gray-500",
                                children: [
                                    "Fredag den 17e december genomf\xf6rde vi den f\xf6rsta s\xe4songsavslutningen av \xd6-viks N\xe4tverkspadel. Det innefattade 90 minuter Mexicano-turnering med efterf\xf6ljande finalmatch. Efter spel f\xf6ljde en after work/padel uppe p\xe5 ",
                                    /*#__PURE__*/ (0,jsx_runtime.jsx)("em", {
                                        children: "hyllan"
                                    }),
                                    " samt prisutdelning. Kv\xe4llen avslutades p\xe5 House Be d\xe4r vi \xe5t julbord och alternerade mellan att se Modo \xe5ka p\xe5 en tung f\xf6rlust i Ume\xe5 samt WPTs Master-slutspel fr\xe5n Madrid, d\xe4r Paquito/Di Nenno kunde skicka hem sj\xe4lvaste Bela i en \xf6vertygande semifinal."
                                ]
                            })
                        ]
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                        className: "prose prose-lg prose-indigo mx-auto mt-6 text-gray-500",
                        children: [
                            /*#__PURE__*/ (0,jsx_runtime.jsx)("p", {
                                children: "Jag (Joel) och Gabriel best\xe4mde oss f\xf6r att f\xf6rs\xf6ka f\xe5 ihop \xd6NP med v\xe4ldigt kort varsel, inte l\xe5ngt f\xf6re den f\xf6rsta bollen studsade den f\xf6rsta onsdagen i oktober. Vi har inget annat \xe4n tacksamhet och f\xf6rundran till alla er padelentusiaster som valde att prova p\xe5 denna id\xe9! Tack!"
                            }),
                            /*#__PURE__*/ (0,jsx_runtime.jsxs)("p", {
                                children: [
                                    "Nu har vi tagit denna s\xe4song i m\xe5l och kunnat kr\xf6na ",
                                    /*#__PURE__*/ (0,jsx_runtime.jsx)("strong", {
                                        children: "Placerum"
                                    }),
                                    " (Victor & Andreas) som b\xe4sta f\xf6retag samt ",
                                    /*#__PURE__*/ (0,jsx_runtime.jsx)("strong", {
                                        children: "Fredrik Bylin"
                                    }),
                                    " (Nybergs) som b\xe4sta spelare. Fredrik bj\xf6d p\xe5 ett dominerande slutspel d\xe4r",
                                    ' ',
                                    /*#__PURE__*/ (0,jsx_runtime.jsx)("a", {
                                        href: "#standings",
                                        children: "han samlade ihop hela 102 po\xe4ng"
                                    }),
                                    "."
                                ]
                            }),
                            /*#__PURE__*/ (0,jsx_runtime.jsxs)("figure", {
                                children: [
                                    /*#__PURE__*/ (0,jsx_runtime.jsx)("img", {
                                        className: "w-full rounded-lg",
                                        src: "/assets/fredrik-striking-ball.jpg",
                                        alt: "Fredrik sl\xe5r bollen",
                                        width: 1310,
                                        height: 873
                                    }),
                                    /*#__PURE__*/ (0,jsx_runtime.jsx)("figcaption", {
                                        children: "Fredrik i en av m\xe5nga matcher."
                                    })
                                ]
                            }),
                            /*#__PURE__*/ (0,jsx_runtime.jsx)("h2", {
                                children: "Vad h\xe4nder nu?"
                            }),
                            /*#__PURE__*/ (0,jsx_runtime.jsx)("p", {
                                children: "Nu \xe4r det paus fram till den 19 januari n\xe4r vi gladeligen v\xe4lkomnar er alla tillbaka f\xf6r starten av s\xe4song 2. Vi kan redan meddela att flertalet platser \xe4r bokade och det har g\xe5tt fort hittills. V\xe5r l\xe5ngsiktiga m\xe5ls\xe4ttning \xe4r att 4-5 matcher spelas b\xe5de morgon och lunch."
                            }),
                            /*#__PURE__*/ (0,jsx_runtime.jsx)("p", {
                                children: "H\xe4r \xe4r n\xe5gra f\xe5 av alla de f\xf6rb\xe4ttringar vi planerar:"
                            }),
                            /*#__PURE__*/ (0,jsx_runtime.jsxs)("ul", {
                                role: "list",
                                children: [
                                    /*#__PURE__*/ (0,jsx_runtime.jsx)("li", {
                                        children: "En uppdaterad spelmodell som ska leda till j\xe4mnare matcher."
                                    }),
                                    /*#__PURE__*/ (0,jsx_runtime.jsx)("li", {
                                        children: "Det tillkommer 3 olika sallader till lunch-valen, ut\xf6ver de wraps som vi haft denna s\xe4song."
                                    }),
                                    /*#__PURE__*/ (0,jsx_runtime.jsx)("li", {
                                        children: "Vi kommer ocks\xe5, i samarbete med H\xe4lsobaren, ta frukosten till n\xe4sta niv\xe5 med goda sm\xf6rg\xe5sar och fr\xe4scha, nygjorda, smoothies."
                                    })
                                ]
                            })
                        ]
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)(CTA, {}),
                    /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                        className: "prose prose-lg prose-indigo mx-auto mt-6 text-gray-500",
                        children: [
                            /*#__PURE__*/ (0,jsx_runtime.jsx)("h2", {
                                children: "N\xe5gra r\xf6ster om N\xe4tverkspadeln"
                            }),
                            /*#__PURE__*/ (0,jsx_runtime.jsxs)("p", {
                                children: [
                                    "Vi \xe4lskar att spela padel och har genom \xd6NP l\xe4rt k\xe4nna m\xe5nga fler som k\xe4nner samma sak. F\xf6r att vet hur spelarna k\xe4nner skickade vi ut n\xe5gra fr\xe5gor. Det som gjorde oss extra glad \xe4r att",
                                    ' ',
                                    /*#__PURE__*/ (0,jsx_runtime.jsx)("strong", {
                                        children: "80% har rekommenderat N\xe4tverkspadeln till n\xe5gon i sin n\xe4rhet"
                                    }),
                                    "."
                                ]
                            }),
                            /*#__PURE__*/ (0,jsx_runtime.jsxs)("p", {
                                children: [
                                    "H\xe4r \xe4r ett svar p\xe5 fr\xe5gan",
                                    ' ',
                                    /*#__PURE__*/ (0,jsx_runtime.jsx)("em", {
                                        children: "\"Vad \xe4r det huvudsakliga v\xe4rdet du har f\xe5tt fr\xe5n \xd6NP?\""
                                    })
                                ]
                            }),
                            /*#__PURE__*/ (0,jsx_runtime.jsx)("blockquote", {
                                children: /*#__PURE__*/ (0,jsx_runtime.jsx)("p", {
                                    children: "Motion, starkare kontakt med nyckelpersoner i min bransch och en h\xe4rlig k\xe4nsla av gemenskap."
                                })
                            }),
                            /*#__PURE__*/ (0,jsx_runtime.jsx)("p", {
                                children: "H\xe4r \xe4r n\xe5gra fler"
                            }),
                            /*#__PURE__*/ (0,jsx_runtime.jsx)("blockquote", {
                                children: /*#__PURE__*/ (0,jsx_runtime.jsx)("p", {
                                    children: "Tr\xe4ffat nya trevliga personer som jag inte skulle kommit i kontakt med annars."
                                })
                            }),
                            /*#__PURE__*/ (0,jsx_runtime.jsx)("blockquote", {
                                children: /*#__PURE__*/ (0,jsx_runtime.jsx)("p", {
                                    children: "Roligt att spela padel och g\xf6ra nya bekantskaper. Eventuellt bli det n\xe5gra aff\xe4rer framledes."
                                })
                            }),
                            /*#__PURE__*/ (0,jsx_runtime.jsx)("h2", {
                                children: "N\xe4tverkspadelns framtid"
                            }),
                            /*#__PURE__*/ (0,jsx_runtime.jsxs)("p", {
                                children: [
                                    "V\xe5r l\xe5ngsiktiga vision \xe4r att etablera en modell d\xe4r f\xf6retagande/entrepren\xf6rskap och padel m\xf6ts p\xe5 ett \xf6msesidigt gynnsamt s\xe4tt. Denna modell hoppas vi sedan kunna",
                                    ' ',
                                    /*#__PURE__*/ (0,jsx_runtime.jsx)("em", {
                                        children: "exportera"
                                    }),
                                    " till fler st\xe4der i Sverige och i f\xf6rl\xe4ngning ha en nationell uppg\xf6relse kring vilket f\xf6retag som \xe4r b\xe4st. P\xe5 en l\xe4ttsamt s\xe4tt f\xf6rst\xe5s."
                                ]
                            }),
                            /*#__PURE__*/ (0,jsx_runtime.jsxs)("p", {
                                children: [
                                    "L\xe5ter det intressant?",
                                    ' ',
                                    /*#__PURE__*/ (0,jsx_runtime.jsx)("a", {
                                        href: "https://forms.reform.app/gLNw4a/kontaktformular/jo0zn1",
                                        target: "_blank",
                                        rel: "noopener noreferrer",
                                        children: /*#__PURE__*/ (0,jsx_runtime.jsx)("a", {
                                            children: "Kontakta oss"
                                        })
                                    }),
                                    ' ',
                                    "s\xe5 ber\xe4ttar vi mer."
                                ]
                            })
                        ]
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                        className: "mx-auto mt-12 max-w-7xl px-4 sm:px-6 lg:px-8",
                        id: "standings",
                        children: /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                            className: "mx-auto max-w-5xl",
                            children: [
                                /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                    className: "my-5 border-b border-gray-200 pb-5",
                                    children: /*#__PURE__*/ (0,jsx_runtime.jsx)("h3", {
                                        className: "text-lg font-medium leading-6 text-gray-900 sm:text-xl lg:text-3xl",
                                        children: "Slutresultat \xd6-viks N\xe4tverkspadel h\xf6sten 2021"
                                    })
                                }),
                                /*#__PURE__*/ (0,jsx_runtime.jsx)(FinalList, {})
                            ]
                        })
                    })
                ]
            })
        ]
    }));
};

;// CONCATENATED MODULE: ./components/ds/05-pages/resultat-h21/banner.tsx

/* import { XIcon } from '@heroicons/react/outline' */ var ResultBanner = function() {
    return(/*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
        className: "relative bg-indigo-600",
        children: /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
            className: "max-w-7xl mx-auto py-3 px-3 sm:px-6 lg:px-8",
            children: /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                className: "pr-16 sm:text-center sm:px-16",
                children: /*#__PURE__*/ (0,jsx_runtime.jsxs)("p", {
                    className: "font-medium text-white",
                    children: [
                        /*#__PURE__*/ (0,jsx_runtime.jsx)("span", {
                            className: "md:hidden",
                            children: "Sverige, vi har ett resultat!"
                        }),
                        /*#__PURE__*/ (0,jsx_runtime.jsx)("span", {
                            className: "hidden md:inline",
                            children: "Sverige, vi har ett resultat!"
                        }),
                        /*#__PURE__*/ (0,jsx_runtime.jsx)("span", {
                            className: "block sm:ml-2 sm:inline-block",
                            children: /*#__PURE__*/ (0,jsx_runtime.jsxs)("a", {
                                href: "#standings",
                                className: "text-white font-bold underline",
                                children: [
                                    "Se tabellen h\xe4r ",
                                    /*#__PURE__*/ (0,jsx_runtime.jsx)("span", {
                                        "aria-hidden": "true",
                                        children: "→"
                                    })
                                ]
                            })
                        })
                    ]
                })
            })
        })
    }));
};

;// CONCATENATED MODULE: ./components/ds/05-pages/resultat-h21/index.tsx







var ResultH21Page = function(param) {
    var series = param.series;
    var router = (0,next_router.useRouter)();
    var locale = (0,utils_locale/* makeLocale */.W)(router.locale, router.defaultLocale) || 'sv';
    var translation = resultat_h21_translations_translations[locale];
    return(/*#__PURE__*/ (0,jsx_runtime.jsxs)(jsx_runtime.Fragment, {
        children: [
            /*#__PURE__*/ (0,jsx_runtime.jsx)(Head, {
                title: translation.pageTitle,
                description: translation.pageDescription
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                children: [
                    /*#__PURE__*/ (0,jsx_runtime.jsx)(Header, {
                        series: series
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsxs)("main", {
                        children: [
                            /*#__PURE__*/ (0,jsx_runtime.jsx)(ResultBanner, {}),
                            /*#__PURE__*/ (0,jsx_runtime.jsx)(FullContent, {})
                        ]
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)(Footer, {})
                ]
            })
        ]
    }));
};

;// CONCATENATED MODULE: ./components/ds/05-pages/resultat-v22/translations.tsx
var resultat_v22_translations_translations = {
    sv: {
        pageTitle: 'Summering av N\xe4tverkspadel s\xe4song 2',
        pageDescription: 'Andra s\xe4songen av \xd6-viks N\xe4tverkspadel \xe4r avslutad och vi summerar vad vi gjort samt vad vi tror om framtiden.'
    },
    en: {
        pageTitle: 'A summary of N\xe4tverkspadel season 2',
        pageDescription: 'Andra s\xe4songen av \xd6-viks N\xe4tverkspadel \xe4r avslutad och vi summerar vad vi gjort samt vad vi tror om framtiden.'
    }
};

;// CONCATENATED MODULE: ./components/ds/05-pages/resultat-v22/cta.tsx


var cta_CTA = function() {
    return(/*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
        className: "bg-white",
        children: /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
            className: "mx-auto max-w-7xl py-16 px-4 sm:px-6 lg:px-8",
            children: /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                className: "overflow-hidden rounded-lg bg-indigo-700 shadow-xl lg:grid lg:grid-cols-2 lg:gap-4",
                children: [
                    /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                        className: "px-6 pt-10 pb-12 sm:px-16 sm:pt-16 lg:py-16 lg:pr-0 xl:py-20 xl:px-20",
                        children: /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                            className: "lg:self-center",
                            children: [
                                /*#__PURE__*/ (0,jsx_runtime.jsxs)("h2", {
                                    className: "text-3xl font-extrabold text-white sm:text-4xl",
                                    children: [
                                        /*#__PURE__*/ (0,jsx_runtime.jsx)("span", {
                                            className: "block",
                                            children: "Vill du vara med?"
                                        }),
                                        /*#__PURE__*/ (0,jsx_runtime.jsx)("span", {
                                            className: "block",
                                            children: "H\xf6r av dig idag."
                                        })
                                    ]
                                }),
                                /*#__PURE__*/ (0,jsx_runtime.jsx)("p", {
                                    className: "mt-4 text-lg leading-6 text-indigo-200",
                                    children: "N\xe4sta s\xe4song startar 21 September. Skicka ett meddelande till oss s\xe5 ber\xe4ttar vi mer."
                                }),
                                /*#__PURE__*/ (0,jsx_runtime.jsx)("a", {
                                    href: "/kontakt",
                                    target: "_blank",
                                    className: "mt-8 inline-flex items-center rounded-md border border-transparent bg-white px-5 py-3 text-base font-medium text-indigo-600 shadow hover:bg-indigo-50",
                                    rel: "noopener noreferrer",
                                    children: "Kontakta oss"
                                })
                            ]
                        })
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                        className: "aspect-w-5 aspect-h-3 -mt-6 md:aspect-w-2 md:aspect-h-1",
                        children: /*#__PURE__*/ (0,jsx_runtime.jsx)(next_image["default"], {
                            className: "translate-x-6 translate-y-6 transform rounded-md object-cover object-right-top sm:translate-x-16 lg:translate-y-20",
                            src: "/assets/martin-hitting-the-ball.jpg",
                            alt: "Martin hitting the ball",
                            layout: "fill"
                        })
                    })
                ]
            })
        })
    }));
};

;// CONCATENATED MODULE: ./components/ds/05-pages/resultat-v22/final-list.tsx

var final_list_players = [
    {
        name: 'Hans Persson',
        final_points: 126.5,
        mexicano_points: 110,
        boost: 15
    },
    {
        name: 'Josip Pavic',
        final_points: 125.08,
        mexicano_points: 118,
        boost: 6
    },
    {
        name: 'Fredrik Bylin',
        final_points: 113.4,
        mexicano_points: 105,
        boost: 8
    },
    {
        name: 'Johan Edlund',
        final_points: 113.22,
        mexicano_points: 111,
        boost: 2
    },
    {
        name: 'Erik Nilsson',
        final_points: 112.2,
        mexicano_points: 102,
        boost: 10
    },
    {
        name: 'Fredrik Furevik',
        final_points: 112,
        mexicano_points: 100,
        boost: 12
    },
    {
        name: 'Marcus Sj\xf6berg',
        final_points: 109.08,
        mexicano_points: 108,
        boost: 1
    },
    {
        name: 'P\xe4r Edblom',
        final_points: 104.03,
        mexicano_points: 101,
        boost: 3
    },
    {
        name: 'Micke Selin',
        final_points: 103.95,
        mexicano_points: 99,
        boost: 5
    },
    {
        name: 'Gabriel Baudin',
        final_points: 100,
        mexicano_points: 100,
        boost: 0
    },
    {
        name: 'Joel Baudin',
        final_points: 96,
        mexicano_points: 96,
        boost: 0
    },
    {
        name: 'Martin Carstedt',
        final_points: 96,
        mexicano_points: 96,
        boost: 0
    },
    {
        name: 'Tobias Sj\xf6din',
        final_points: 94.64,
        mexicano_points: 91,
        boost: 4
    },
    {
        name: 'Johan Lindgren',
        final_points: 92,
        mexicano_points: 92,
        boost: 0
    },
    {
        name: 'Niclas Grundstr\xf6m',
        final_points: 92,
        mexicano_points: 92,
        boost: 0
    },
    {
        name: 'Michael Lindroth',
        final_points: 92,
        mexicano_points: 92,
        boost: 0
    },
    {
        name: 'Per-Olof Bj\xf6rklund',
        final_points: 90,
        mexicano_points: 90,
        boost: 0
    },
    {
        name: '\xc5ke \xd6dling',
        final_points: 89,
        mexicano_points: 89,
        boost: 0
    },
    {
        name: 'Thomas Pettersson',
        final_points: 86,
        mexicano_points: 86,
        boost: 0
    },
    {
        name: 'Tilde Nording',
        final_points: 82,
        mexicano_points: 82,
        boost: 0
    },
    {
        name: 'Mattias Modig',
        final_points: 122,
        mexicano_points: 0,
        boost: 0,
        comment: 'Deltog inte i slutspelet.'
    },
    {
        name: 'Alexander Larsson',
        final_points: 116,
        mexicano_points: 0,
        boost: 0,
        comment: 'Deltog inte i slutspelet.'
    },
    {
        name: 'Andreas Fj\xe4llstr\xf6m',
        final_points: 113,
        mexicano_points: 0,
        boost: 0,
        comment: 'Deltog inte i slutspelet.'
    },
    {
        name: 'Peter Selin',
        final_points: 112,
        mexicano_points: 0,
        boost: 0,
        comment: 'Deltog inte i slutspelet.'
    },
    {
        name: 'Mikael Selin',
        final_points: 111,
        mexicano_points: 0,
        boost: 0,
        comment: 'Deltog inte i slutspelet.'
    },
    {
        name: 'Bj\xf6rn Sundin',
        final_points: 111,
        mexicano_points: 0,
        boost: 0,
        comment: 'Deltog inte i slutspelet.'
    },
    {
        name: 'J\xf6rgen N\xe4slund',
        final_points: 110,
        mexicano_points: 0,
        boost: 0,
        comment: 'Deltog inte i slutspelet.'
    },
    {
        name: 'Tomislav Lovric',
        final_points: 108,
        mexicano_points: 0,
        boost: 0,
        comment: 'Deltog inte i slutspelet.'
    },
    {
        name: 'Ida Nyberg',
        final_points: 108,
        mexicano_points: 0,
        boost: 0,
        comment: 'Deltog inte i slutspelet.'
    },
    {
        name: 'Mikael Nordstrand',
        final_points: 107,
        mexicano_points: 0,
        boost: 0,
        comment: 'Deltog inte i slutspelet.'
    },
    {
        name: 'H\xe5kan Martinell',
        final_points: 106,
        mexicano_points: 0,
        boost: 0,
        comment: 'Deltog inte i slutspelet.'
    },
    {
        name: 'Stefan Lyng',
        final_points: 105,
        mexicano_points: 0,
        boost: 0,
        comment: 'Deltog inte i slutspelet.'
    },
    {
        name: 'Bjarte Trauthaug',
        final_points: 105,
        mexicano_points: 0,
        boost: 0,
        comment: 'Deltog inte i slutspelet.'
    },
    {
        name: 'Gustav H\xe4ggstr\xf6m',
        final_points: 105,
        mexicano_points: 0,
        boost: 0,
        comment: 'Deltog inte i slutspelet.'
    },
    {
        name: 'Mikael S\xf6derberg',
        final_points: 105,
        mexicano_points: 0,
        boost: 0,
        comment: 'Deltog inte i slutspelet.'
    },
    {
        name: 'Mari Pettersson',
        final_points: 105,
        mexicano_points: 0,
        boost: 0,
        comment: 'Deltog inte i slutspelet.'
    },
    {
        name: 'Mikael H\xfcbinette',
        final_points: 104,
        mexicano_points: 0,
        boost: 0,
        comment: 'Deltog inte i slutspelet.'
    },
    {
        name: 'Hampus Sj\xf6berg',
        final_points: 103,
        mexicano_points: 0,
        boost: 0,
        comment: 'Deltog inte i slutspelet.'
    },
    {
        name: 'Victor Hansson',
        final_points: 103,
        mexicano_points: 0,
        boost: 0,
        comment: 'Deltog inte i slutspelet.'
    },
    {
        name: 'Martin Dahlberg',
        final_points: 103,
        mexicano_points: 0,
        boost: 0,
        comment: 'Deltog inte i slutspelet.'
    },
    {
        name: 'Tove Sarri Carstedt',
        final_points: 102,
        mexicano_points: 0,
        boost: 0,
        comment: 'Deltog inte i slutspelet.'
    },
    {
        name: 'Annica \xc5slund Ols\xe9n',
        final_points: 101,
        mexicano_points: 0,
        boost: 0,
        comment: 'Deltog inte i slutspelet.'
    },
    {
        name: 'Johannes Brorsson',
        final_points: 99,
        mexicano_points: 0,
        boost: 0,
        comment: 'Deltog inte i slutspelet.'
    },
    {
        name: 'Peter Granholm',
        final_points: 98,
        mexicano_points: 0,
        boost: 0,
        comment: 'Deltog inte i slutspelet.'
    },
    {
        name: 'Fredrik Sj\xf6berg',
        final_points: 97,
        mexicano_points: 0,
        boost: 0,
        comment: 'Deltog inte i slutspelet.'
    },
    {
        name: 'Johan Als\xe9n',
        final_points: 97,
        mexicano_points: 0,
        boost: 0,
        comment: 'Deltog inte i slutspelet.'
    },
    {
        name: 'Hanna \xd6hman',
        final_points: 97,
        mexicano_points: 0,
        boost: 0,
        comment: 'Deltog inte i slutspelet.'
    },
    {
        name: 'Carl S\xf6derstr\xf6m',
        final_points: 97,
        mexicano_points: 0,
        boost: 0,
        comment: 'Deltog inte i slutspelet.'
    },
    {
        name: 'Sam Gunnarsson',
        final_points: 97,
        mexicano_points: 0,
        boost: 0,
        comment: 'Deltog inte i slutspelet.'
    },
    {
        name: 'Mats Hilli',
        final_points: 97,
        mexicano_points: 0,
        boost: 0,
        comment: 'Deltog inte i slutspelet.'
    },
    {
        name: 'Tina Bostedt',
        final_points: 97,
        mexicano_points: 0,
        boost: 0,
        comment: 'Deltog inte i slutspelet.'
    },
    {
        name: 'Tommy Nilsson',
        final_points: 96,
        mexicano_points: 0,
        boost: 0,
        comment: 'Deltog inte i slutspelet.'
    },
    {
        name: 'Mattias Westman',
        final_points: 96,
        mexicano_points: 0,
        boost: 0,
        comment: 'Deltog inte i slutspelet.'
    },
    {
        name: 'Mats Myrsell',
        final_points: 96,
        mexicano_points: 0,
        boost: 0,
        comment: 'Deltog inte i slutspelet.'
    },
    {
        name: 'Cecilia H\xe4ggstr\xf6m',
        final_points: 96,
        mexicano_points: 0,
        boost: 0,
        comment: 'Deltog inte i slutspelet.'
    },
    {
        name: 'Hanna Sj\xf6berg',
        final_points: 94,
        mexicano_points: 0,
        boost: 0,
        comment: 'Deltog inte i slutspelet.'
    },
    {
        name: 'Jon Moraeus',
        final_points: 92,
        mexicano_points: 0,
        boost: 0,
        comment: 'Deltog inte i slutspelet.'
    },
    {
        name: 'Peter H\xf6rnell',
        final_points: 91,
        mexicano_points: 0,
        boost: 0,
        comment: 'Deltog inte i slutspelet.'
    },
    {
        name: 'Dennis Edlund',
        final_points: 87,
        mexicano_points: 0,
        boost: 0,
        comment: 'Deltog inte i slutspelet.'
    },
    {
        name: 'Martin S\xf6derstr\xf6m',
        final_points: 82,
        mexicano_points: 0,
        boost: 0,
        comment: 'Deltog inte i slutspelet.'
    }, 
];
var final_list_FinalList = function() {
    return(/*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
        className: "flex flex-col",
        children: /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
            className: "-my-2 overflow-x-auto sm:-mx-6 lg:-mx-8",
            children: /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                className: "py-2 align-middle inline-block min-w-full sm:px-6 lg:px-8",
                children: /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                    className: "shadow overflow-hidden border-b border-gray-200 sm:rounded-lg",
                    children: /*#__PURE__*/ (0,jsx_runtime.jsxs)("table", {
                        className: "min-w-full divide-y divide-gray-200",
                        children: [
                            /*#__PURE__*/ (0,jsx_runtime.jsx)("thead", {
                                className: "bg-gray-50",
                                children: /*#__PURE__*/ (0,jsx_runtime.jsxs)("tr", {
                                    children: [
                                        /*#__PURE__*/ (0,jsx_runtime.jsx)("th", {
                                            scope: "col",
                                            className: "px-6 py-3 text-left text-xs font-medium text-gray-500 uppercase tracking-wider",
                                            children: "Rank"
                                        }),
                                        /*#__PURE__*/ (0,jsx_runtime.jsx)("th", {
                                            scope: "col",
                                            className: "px-6 py-3 text-left text-xs font-medium text-gray-500 uppercase tracking-wider",
                                            children: "Namn"
                                        }),
                                        /*#__PURE__*/ (0,jsx_runtime.jsx)("th", {
                                            scope: "col",
                                            className: "px-6 py-3 text-right text-xs font-medium text-gray-500 uppercase tracking-wider",
                                            children: "Slutpo\xe4ng i \xd6NP"
                                        }),
                                        /*#__PURE__*/ (0,jsx_runtime.jsx)("th", {
                                            scope: "col",
                                            className: "px-6 py-3 text-right text-xs font-medium text-gray-500 uppercase tracking-wider",
                                            children: "Totala po\xe4ng i Mexicano"
                                        }),
                                        /*#__PURE__*/ (0,jsx_runtime.jsx)("th", {
                                            scope: "col",
                                            className: "px-6 py-3 text-right text-xs font-medium text-gray-500 uppercase tracking-wider",
                                            children: "Boost"
                                        }),
                                        /*#__PURE__*/ (0,jsx_runtime.jsx)("th", {
                                            scope: "col",
                                            className: "px-6 py-3 text-right text-xs font-medium text-gray-500 uppercase tracking-wider",
                                            children: "Kommentar"
                                        })
                                    ]
                                })
                            }),
                            /*#__PURE__*/ (0,jsx_runtime.jsx)("tbody", {
                                children: final_list_players.map(function(person, personIdx) {
                                    /*#__PURE__*/ return (0,jsx_runtime.jsxs)("tr", {
                                        className: personIdx % 2 === 0 ? 'bg-white' : 'bg-gray-50',
                                        children: [
                                            /*#__PURE__*/ (0,jsx_runtime.jsx)("td", {
                                                className: "px-6 py-4 whitespace-nowrap text-sm text-gray-500",
                                                children: personIdx + 1
                                            }),
                                            /*#__PURE__*/ (0,jsx_runtime.jsx)("td", {
                                                className: "px-6 py-4 whitespace-nowrap text-sm font-medium text-gray-900",
                                                children: person.name
                                            }),
                                            /*#__PURE__*/ (0,jsx_runtime.jsx)("td", {
                                                className: "px-6 py-4 whitespace-nowrap text-sm text-gray-500 text-right",
                                                children: person.final_points
                                            }),
                                            /*#__PURE__*/ (0,jsx_runtime.jsx)("td", {
                                                className: "px-6 py-4 whitespace-nowrap text-sm text-gray-500 text-right",
                                                children: person.mexicano_points
                                            }),
                                            /*#__PURE__*/ (0,jsx_runtime.jsxs)("td", {
                                                className: "px-6 py-4 whitespace-nowrap text-sm text-gray-500 text-right",
                                                children: [
                                                    person.boost,
                                                    "%"
                                                ]
                                            }),
                                            /*#__PURE__*/ (0,jsx_runtime.jsx)("td", {
                                                className: "px-6 py-4 whitespace-nowrap text-sm text-gray-500 text-right",
                                                children: person.comment
                                            })
                                        ]
                                    }, person.name);
                                })
                            })
                        ]
                    })
                })
            })
        })
    }));
};

;// CONCATENATED MODULE: ./components/ds/05-pages/resultat-v22/winners.tsx


var winners_people = [
    {
        name: 'Erik Nilsson',
        company: '\xd6vikshem',
        imageUrl: '/assets/s3/vinnare-foretag.jpg',
        twitterUrl: '#',
        linkedinUrl: '#'
    },
    {
        name: 'Hans Persson',
        company: 'Hamek Verkstad',
        imageUrl: '/assets/s3/vinnare-spelare.jpg',
        twitterUrl: '#',
        linkedinUrl: '#'
    },
    {
        name: 'Johan Edlund & Marcus Sj\xf6berg',
        company: 'H\xf6ga Kusten Assistans & Sj\xf6bergs Entreprenad',
        imageUrl: '/assets/s3/vinnare-mexicano.jpg',
        twitterUrl: '#',
        linkedinUrl: '#'
    },
    {
        name: 'Josip Pavic',
        company: 'Pavic Friskv\xe5rdskonsulting',
        imageUrl: '/assets/s3/mest-poang-mexicano.jpg',
        twitterUrl: '#',
        linkedinUrl: '#'
    }, 
];
var Winners = function() {
    return(/*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
        className: "bg-white",
        children: /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
            className: "mx-auto py-12 px-4 max-w-7xl sm:px-6 lg:px-8 lg:py-24",
            children: /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                className: "space-y-12",
                children: [
                    /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                        className: "space-y-5 sm:space-y-4 md:max-w-xl lg:max-w-3xl xl:max-w-none",
                        children: [
                            /*#__PURE__*/ (0,jsx_runtime.jsx)("h2", {
                                className: "text-3xl font-extrabold tracking-tight sm:text-4xl",
                                children: "S\xe4songens vinnare"
                            }),
                            /*#__PURE__*/ (0,jsx_runtime.jsxs)("p", {
                                className: "text-xl text-gray-500",
                                children: [
                                    "Nu har vi tagit denna andra s\xe4song i m\xe5l och kunnat kr\xf6na ",
                                    /*#__PURE__*/ (0,jsx_runtime.jsx)("strong", {
                                        children: "\xd6vikshem"
                                    }),
                                    ' ',
                                    "(Erik Nilsson) som b\xe4sta f\xf6retag samt ",
                                    /*#__PURE__*/ (0,jsx_runtime.jsx)("strong", {
                                        children: "Hans Persson"
                                    }),
                                    " (Hamek Verkstad) som b\xe4sta spelare."
                                ]
                            })
                        ]
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)("ul", {
                        role: "list",
                        className: "space-y-12 sm:grid sm:grid-cols-2 sm:gap-x-6 sm:gap-y-12 sm:space-y-0 lg:gap-x-8",
                        children: winners_people.map(function(person) {
                            /*#__PURE__*/ return (0,jsx_runtime.jsx)("li", {
                                children: /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                                    className: "space-y-4",
                                    children: [
                                        /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                            className: "aspect-w-3 aspect-h-3",
                                            children: /*#__PURE__*/ (0,jsx_runtime.jsx)(next_image["default"], {
                                                className: "object-cover shadow-lg rounded-lg",
                                                src: person.imageUrl,
                                                alt: "".concat(person.name, " fr\xe5n ").concat(person.company),
                                                layout: "fill"
                                            })
                                        }),
                                        /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                            className: "space-y-2",
                                            children: /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                                                className: "text-lg leading-6 font-medium space-y-1",
                                                children: [
                                                    /*#__PURE__*/ (0,jsx_runtime.jsx)("h3", {
                                                        children: person.name
                                                    }),
                                                    /*#__PURE__*/ (0,jsx_runtime.jsx)("p", {
                                                        className: "text-indigo-600",
                                                        children: person.company
                                                    })
                                                ]
                                            })
                                        })
                                    ]
                                })
                            }, person.name);
                        })
                    })
                ]
            })
        })
    }));
};

;// CONCATENATED MODULE: ./components/ds/05-pages/resultat-v22/full-content.tsx





var full_content_FullContent = function() {
    return(/*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
        className: "relative overflow-hidden bg-white py-16",
        children: [
            /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                className: "hidden lg:absolute lg:inset-y-0 lg:block lg:h-full lg:w-full",
                children: /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                    className: "relative mx-auto h-full max-w-prose text-lg",
                    "aria-hidden": "true",
                    children: [
                        /*#__PURE__*/ (0,jsx_runtime.jsxs)("svg", {
                            className: "absolute top-12 left-full translate-x-32 transform",
                            width: 404,
                            height: 384,
                            fill: "none",
                            viewBox: "0 0 404 384",
                            children: [
                                /*#__PURE__*/ (0,jsx_runtime.jsx)("defs", {
                                    children: /*#__PURE__*/ (0,jsx_runtime.jsx)("pattern", {
                                        id: "74b3fd99-0a6f-4271-bef2-e80eeafdf357",
                                        x: 0,
                                        y: 0,
                                        width: 20,
                                        height: 20,
                                        patternUnits: "userSpaceOnUse",
                                        children: /*#__PURE__*/ (0,jsx_runtime.jsx)("rect", {
                                            x: 0,
                                            y: 0,
                                            width: 4,
                                            height: 4,
                                            className: "text-gray-200",
                                            fill: "currentColor"
                                        })
                                    })
                                }),
                                /*#__PURE__*/ (0,jsx_runtime.jsx)("rect", {
                                    width: 404,
                                    height: 384,
                                    fill: "url(#74b3fd99-0a6f-4271-bef2-e80eeafdf357)"
                                })
                            ]
                        }),
                        /*#__PURE__*/ (0,jsx_runtime.jsxs)("svg", {
                            className: "absolute top-1/2 right-full -translate-y-1/2 -translate-x-32 transform",
                            width: 404,
                            height: 384,
                            fill: "none",
                            viewBox: "0 0 404 384",
                            children: [
                                /*#__PURE__*/ (0,jsx_runtime.jsx)("defs", {
                                    children: /*#__PURE__*/ (0,jsx_runtime.jsx)("pattern", {
                                        id: "f210dbf6-a58d-4871-961e-36d5016a0f49",
                                        x: 0,
                                        y: 0,
                                        width: 20,
                                        height: 20,
                                        patternUnits: "userSpaceOnUse",
                                        children: /*#__PURE__*/ (0,jsx_runtime.jsx)("rect", {
                                            x: 0,
                                            y: 0,
                                            width: 4,
                                            height: 4,
                                            className: "text-gray-200",
                                            fill: "currentColor"
                                        })
                                    })
                                }),
                                /*#__PURE__*/ (0,jsx_runtime.jsx)("rect", {
                                    width: 404,
                                    height: 384,
                                    fill: "url(#f210dbf6-a58d-4871-961e-36d5016a0f49)"
                                })
                            ]
                        }),
                        /*#__PURE__*/ (0,jsx_runtime.jsxs)("svg", {
                            className: "absolute bottom-12 left-full translate-x-32 transform",
                            width: 404,
                            height: 384,
                            fill: "none",
                            viewBox: "0 0 404 384",
                            children: [
                                /*#__PURE__*/ (0,jsx_runtime.jsx)("defs", {
                                    children: /*#__PURE__*/ (0,jsx_runtime.jsx)("pattern", {
                                        id: "d3eb07ae-5182-43e6-857d-35c643af9034",
                                        x: 0,
                                        y: 0,
                                        width: 20,
                                        height: 20,
                                        patternUnits: "userSpaceOnUse",
                                        children: /*#__PURE__*/ (0,jsx_runtime.jsx)("rect", {
                                            x: 0,
                                            y: 0,
                                            width: 4,
                                            height: 4,
                                            className: "text-gray-200",
                                            fill: "currentColor"
                                        })
                                    })
                                }),
                                /*#__PURE__*/ (0,jsx_runtime.jsx)("rect", {
                                    width: 404,
                                    height: 384,
                                    fill: "url(#d3eb07ae-5182-43e6-857d-35c643af9034)"
                                })
                            ]
                        })
                    ]
                })
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                className: "relative px-4 sm:px-6 lg:px-8",
                children: [
                    /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                        className: "mx-auto max-w-prose text-lg",
                        children: [
                            /*#__PURE__*/ (0,jsx_runtime.jsxs)("h1", {
                                children: [
                                    /*#__PURE__*/ (0,jsx_runtime.jsx)("span", {
                                        className: "block text-center text-base font-semibold uppercase tracking-wide text-indigo-600",
                                        children: "Summering"
                                    }),
                                    /*#__PURE__*/ (0,jsx_runtime.jsx)("span", {
                                        className: "mt-2 block text-center text-3xl font-extrabold leading-8 tracking-tight text-gray-900 sm:text-4xl",
                                        children: "\xd6rnsk\xf6ldsviks N\xe4tverkspadel v\xe5ren 2022"
                                    })
                                ]
                            }),
                            /*#__PURE__*/ (0,jsx_runtime.jsxs)("p", {
                                className: "mt-8 text-xl leading-8 text-gray-500",
                                children: [
                                    "Fredag den 25e Mars genomf\xf6rde vi det andra slutspelet av \xd6-viks N\xe4tverkspadel. Det innefattade Mexicano-turnering med efterf\xf6ljande finalmatch. Efter spel f\xf6ljde en after work/padel uppe p\xe5 ",
                                    /*#__PURE__*/ (0,jsx_runtime.jsx)("em", {
                                        children: "hyllan"
                                    }),
                                    " samt prisutdelning. Kv\xe4llen avslutades p\xe5 Strandkaj k\xf6k & bar d\xe4r vi \xe5t gott och nj\xf6t av h\xe4rliga konversationer."
                                ]
                            })
                        ]
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)(Winners, {}),
                    /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                        className: "prose prose-lg prose-indigo mx-auto mt-6 text-gray-500",
                        children: [
                            /*#__PURE__*/ (0,jsx_runtime.jsxs)("figure", {
                                children: [
                                    /*#__PURE__*/ (0,jsx_runtime.jsx)("img", {
                                        className: "w-full rounded-lg",
                                        src: "/assets/fredrik-striking-ball.jpg",
                                        alt: "Fredrik sl\xe5r bollen",
                                        width: 1310,
                                        height: 873
                                    }),
                                    /*#__PURE__*/ (0,jsx_runtime.jsx)("figcaption", {
                                        children: "Fredrik i en av m\xe5nga matcher."
                                    })
                                ]
                            }),
                            /*#__PURE__*/ (0,jsx_runtime.jsx)("h2", {
                                children: "Vad h\xe4nder nu?"
                            }),
                            /*#__PURE__*/ (0,jsx_runtime.jsx)("p", {
                                children: "Nu \xe4r det paus fram till den 21 September n\xe4r vi gladeligen v\xe4lkomnar alla tillbaka f\xf6r starten av s\xe4song 3. Vi kan redan meddela att flertalet platser \xe4r bokade och det har g\xe5tt fort. V\xe5r l\xe5ngsiktiga m\xe5ls\xe4ttning \xe4r att 5 matcher spelas b\xe5de frukost och lunch."
                            })
                        ]
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)(cta_CTA, {}),
                    /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                        className: "prose prose-lg prose-indigo mx-auto mt-6 text-gray-500",
                        children: [
                            /*#__PURE__*/ (0,jsx_runtime.jsx)("h2", {
                                children: "N\xe5gra r\xf6ster om N\xe4tverkspadeln"
                            }),
                            /*#__PURE__*/ (0,jsx_runtime.jsxs)("p", {
                                children: [
                                    "Vi \xe4lskar att spela padel och har genom N\xe4tverkspadeln l\xe4rt k\xe4nna m\xe5nga fler som k\xe4nner samma sak. F\xf6r att vet hur spelarna k\xe4nner skickade vi ut n\xe5gra fr\xe5gor. Det som gjorde oss extra glad \xe4r att",
                                    ' ',
                                    /*#__PURE__*/ (0,jsx_runtime.jsx)("strong", {
                                        children: "80% har rekommenderat N\xe4tverkspadeln till n\xe5gon i sin n\xe4rhet"
                                    }),
                                    "."
                                ]
                            }),
                            /*#__PURE__*/ (0,jsx_runtime.jsxs)("p", {
                                children: [
                                    "H\xe4r \xe4r ett svar p\xe5 fr\xe5gan",
                                    ' ',
                                    /*#__PURE__*/ (0,jsx_runtime.jsx)("em", {
                                        children: "\"Vad \xe4r det huvudsakliga v\xe4rdet du har f\xe5tt fr\xe5n \xd6NP?\""
                                    })
                                ]
                            }),
                            /*#__PURE__*/ (0,jsx_runtime.jsx)("blockquote", {
                                children: /*#__PURE__*/ (0,jsx_runtime.jsx)("p", {
                                    children: "Motion, starkare kontakt med nyckelpersoner i min bransch och en h\xe4rlig k\xe4nsla av gemenskap."
                                })
                            }),
                            /*#__PURE__*/ (0,jsx_runtime.jsx)("p", {
                                children: "H\xe4r \xe4r n\xe5gra fler"
                            }),
                            /*#__PURE__*/ (0,jsx_runtime.jsx)("blockquote", {
                                children: /*#__PURE__*/ (0,jsx_runtime.jsx)("p", {
                                    children: "Tr\xe4ffat nya trevliga personer som jag inte skulle kommit i kontakt med annars."
                                })
                            }),
                            /*#__PURE__*/ (0,jsx_runtime.jsx)("blockquote", {
                                children: /*#__PURE__*/ (0,jsx_runtime.jsx)("p", {
                                    children: "Roligt att spela padel och g\xf6ra nya bekantskaper. Eventuellt bli det n\xe5gra aff\xe4rer framledes."
                                })
                            }),
                            /*#__PURE__*/ (0,jsx_runtime.jsx)("h2", {
                                children: "N\xe4tverkspadelns framtid"
                            }),
                            /*#__PURE__*/ (0,jsx_runtime.jsxs)("p", {
                                children: [
                                    "V\xe5r l\xe5ngsiktiga vision \xe4r att etablera en modell d\xe4r f\xf6retagande/entrepren\xf6rskap och padel m\xf6ts p\xe5 ett \xf6msesidigt gynnsamt s\xe4tt. Denna modell hoppas vi sedan kunna",
                                    ' ',
                                    /*#__PURE__*/ (0,jsx_runtime.jsx)("em", {
                                        children: "exportera"
                                    }),
                                    " till fler st\xe4der i Sverige och i f\xf6rl\xe4ngning ha en nationell uppg\xf6relse kring vilket f\xf6retag som \xe4r b\xe4st. P\xe5 ett l\xe4ttsamt s\xe4tt f\xf6rst\xe5s."
                                ]
                            }),
                            /*#__PURE__*/ (0,jsx_runtime.jsxs)("p", {
                                children: [
                                    "L\xe5ter det intressant?",
                                    ' ',
                                    /*#__PURE__*/ (0,jsx_runtime.jsx)(next_link["default"], {
                                        href: "/signup?utm_campaign=s3&utm_source=season-review-page&utm_medium=textlink",
                                        children: /*#__PURE__*/ (0,jsx_runtime.jsx)("a", {
                                            children: "Anm\xe4l er nu"
                                        })
                                    }),
                                    ' ',
                                    "s\xe5 ber\xe4ttar vi mer."
                                ]
                            })
                        ]
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                        className: "mx-auto mt-12 max-w-7xl px-4 sm:px-6 lg:px-8",
                        id: "standings",
                        children: /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                            className: "mx-auto max-w-5xl",
                            children: [
                                /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                    className: "my-5 border-b border-gray-200 pb-5",
                                    children: /*#__PURE__*/ (0,jsx_runtime.jsx)("h3", {
                                        className: "text-lg font-medium leading-6 text-gray-900 sm:text-xl lg:text-3xl",
                                        children: "Slutresultat \xd6-viks N\xe4tverkspadel v\xe5ren 2022"
                                    })
                                }),
                                /*#__PURE__*/ (0,jsx_runtime.jsx)(final_list_FinalList, {})
                            ]
                        })
                    })
                ]
            })
        ]
    }));
};

;// CONCATENATED MODULE: ./components/ds/05-pages/resultat-v22/banner.tsx

/* import { XIcon } from '@heroicons/react/outline' */ var banner_ResultBanner = function() {
    return(/*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
        className: "relative bg-indigo-600",
        children: /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
            className: "max-w-7xl mx-auto py-3 px-3 sm:px-6 lg:px-8",
            children: /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                className: "pr-16 sm:text-center sm:px-16",
                children: /*#__PURE__*/ (0,jsx_runtime.jsxs)("p", {
                    className: "font-medium text-white",
                    children: [
                        /*#__PURE__*/ (0,jsx_runtime.jsx)("span", {
                            className: "md:hidden",
                            children: "Sverige, vi har ett resultat!"
                        }),
                        /*#__PURE__*/ (0,jsx_runtime.jsx)("span", {
                            className: "hidden md:inline",
                            children: "Sverige, vi har ett resultat!"
                        }),
                        /*#__PURE__*/ (0,jsx_runtime.jsx)("span", {
                            className: "block sm:ml-2 sm:inline-block",
                            children: /*#__PURE__*/ (0,jsx_runtime.jsxs)("a", {
                                href: "#standings",
                                className: "text-white font-bold underline",
                                children: [
                                    "Se tabellen h\xe4r ",
                                    /*#__PURE__*/ (0,jsx_runtime.jsx)("span", {
                                        "aria-hidden": "true",
                                        children: "→"
                                    })
                                ]
                            })
                        })
                    ]
                })
            })
        })
    }));
};

;// CONCATENATED MODULE: ./components/ds/05-pages/resultat-v22/index.tsx







var ResultV22Page = function(param) {
    var series = param.series;
    var router = (0,next_router.useRouter)();
    var locale = (0,utils_locale/* makeLocale */.W)(router.locale, router.defaultLocale) || 'sv';
    var translation = resultat_v22_translations_translations[locale];
    return(/*#__PURE__*/ (0,jsx_runtime.jsxs)(jsx_runtime.Fragment, {
        children: [
            /*#__PURE__*/ (0,jsx_runtime.jsx)(Head, {
                title: translation.pageTitle,
                description: translation.pageDescription
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                children: [
                    /*#__PURE__*/ (0,jsx_runtime.jsx)(Header, {
                        series: series
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsxs)("main", {
                        children: [
                            /*#__PURE__*/ (0,jsx_runtime.jsx)(banner_ResultBanner, {}),
                            /*#__PURE__*/ (0,jsx_runtime.jsx)(full_content_FullContent, {})
                        ]
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)(Footer, {})
                ]
            })
        ]
    }));
};

;// CONCATENATED MODULE: ./components/ds/05-pages/index.ts






;// CONCATENATED MODULE: ./components/ds/index.ts
/* export * from './01-atoms' */ 





/***/ }),

/***/ 339:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "b4": function() { return /* reexport safe */ _ds__WEBPACK_IMPORTED_MODULE_0__.b4; },
/* harmony export */   "hW": function() { return /* reexport safe */ _ds__WEBPACK_IMPORTED_MODULE_0__.hW; },
/* harmony export */   "Fb": function() { return /* reexport safe */ _ds__WEBPACK_IMPORTED_MODULE_0__.Fb; },
/* harmony export */   "Ik": function() { return /* reexport safe */ _ds__WEBPACK_IMPORTED_MODULE_0__.Ik; }
/* harmony export */ });
/* harmony import */ var _ds__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(7524);



/***/ }),

/***/ 8507:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "g": function() { return /* binding */ Locale; }
/* harmony export */ });

var Locale;
(function(Locale) {
    Locale["sv"] = "sv";
    Locale["en"] = "en";
})(Locale || (Locale = {}));


/***/ }),

/***/ 1864:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "A": function() { return /* binding */ classNames; }
/* harmony export */ });
function classNames() {
    for(var _len = arguments.length, classes = new Array(_len), _key = 0; _key < _len; _key++){
        classes[_key] = arguments[_key];
    }
    return classes.filter(Boolean).join(' ');
}


/***/ }),

/***/ 1895:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "W": function() { return /* binding */ makeLocale; }
/* harmony export */ });
/* harmony import */ var _types__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(8507);

function _arrayLikeToArray(arr, len) {
    if (len == null || len > arr.length) len = arr.length;
    for(var i = 0, arr2 = new Array(len); i < len; i++)arr2[i] = arr[i];
    return arr2;
}
function _arrayWithHoles(arr) {
    if (Array.isArray(arr)) return arr;
}
function _iterableToArrayLimit(arr, i) {
    var _i = arr == null ? null : typeof Symbol !== "undefined" && arr[Symbol.iterator] || arr["@@iterator"];
    if (_i == null) return;
    var _arr = [];
    var _n = true;
    var _d = false;
    var _s, _e;
    try {
        for(_i = _i.call(arr); !(_n = (_s = _i.next()).done); _n = true){
            _arr.push(_s.value);
            if (i && _arr.length === i) break;
        }
    } catch (err) {
        _d = true;
        _e = err;
    } finally{
        try {
            if (!_n && _i["return"] != null) _i["return"]();
        } finally{
            if (_d) throw _e;
        }
    }
    return _arr;
}
function _nonIterableRest() {
    throw new TypeError("Invalid attempt to destructure non-iterable instance.\\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method.");
}
function _slicedToArray(arr, i) {
    return _arrayWithHoles(arr) || _iterableToArrayLimit(arr, i) || _unsupportedIterableToArray(arr, i) || _nonIterableRest();
}
function _unsupportedIterableToArray(o, minLen) {
    if (!o) return;
    if (typeof o === "string") return _arrayLikeToArray(o, minLen);
    var n = Object.prototype.toString.call(o).slice(8, -1);
    if (n === "Object" && o.constructor) n = o.constructor.name;
    if (n === "Map" || n === "Set") return Array.from(n);
    if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return _arrayLikeToArray(o, minLen);
}
var removeRegion = function(locale) {
    var ref = _slicedToArray(locale.split('-'), 1), noRegion = ref[0];
    return noRegion;
};
var validateLocale = function(locale, defaultLocale) {
    if (locale === _types__WEBPACK_IMPORTED_MODULE_0__/* .Locale.sv */ .g.sv || locale === _types__WEBPACK_IMPORTED_MODULE_0__/* .Locale.en */ .g.en) {
        return locale;
    } else {
        return defaultLocale;
    }
};
var makeLocale = function() {
    var locale = arguments.length > 0 && arguments[0] !== void 0 ? arguments[0] : 'sv', defaultLocale = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : 'sv';
    if (!locale) {
        return defaultLocale;
    }
    if (locale.includes('-')) {
        var noRegion = removeRegion(locale);
        return validateLocale(noRegion, defaultLocale);
    } else {
        return validateLocale(locale, defaultLocale);
    }
};


/***/ })

}]);